/*! digital-design-library - 2.2.0 - Last updated: 2017-08-10. Copyright (c) 2017 AT&T Services, Inc. */ 
angular.module("ddh.att.tpls", ['template/breadcrumbs/breadcrumbs.html', 'template/calendar/datepicker-popup.html', 'template/calendar/datepicker.html', 'template/colorAndDataCapacity/capacityItem.html', 'template/colorAndDataCapacity/capacityWrapper.html', 'template/dropdownVariations/ddhDropdownVariations.html', 'template/dropdowns/ddhDropdownDesktop.html', 'template/dropdowns/ddhDropdownGroupDesktop.html', 'template/dropdowns/ddhDropdownListDesktop.html', 'template/expandCollapse/expandCollapse-group.html', 'template/expandCollapse/expandCollapse-table.html', 'template/expandCollapse/expandCollapse.html', 'template/filmstrip/ddhFilmstrip.html', 'template/filmstrip/ddhFilmstripContent.html', 'template/filters/ddhFiltersSimple.html', 'template/filtersComplex/ddhfiltersComplex.html', 'template/leftNavigation/leftNavigation.html', 'template/marquees/marquee.html', 'template/marquees/marqueeImagesWrapper.html', 'template/marquees/marqueeTabs.html', 'template/modalsAndAlerts/backdrop.html', 'template/modalsAndAlerts/window.html', 'template/pagination/pagination.html', 'template/productTile/productTileContainer.html', 'template/productTile/productTiles.html', 'template/searchField/searchField.html', 'template/selectQuantity/selectQuantity.html', 'template/socialShareThis/socialShareThis.html', 'template/starRating/starRating.html', 'template/stepIndicator/stepIndicator.html', 'template/strengthMeter/strengthMeter.html', 'template/switches/switches-spanish.html', 'template/switches/switches.html', 'template/tables/ddhResponsiveRow.html', 'template/tables/ddhResponsiveRowSummary.html', 'template/tables/ddhTable.html', 'template/tables/ddhTableBody.html', 'template/tables/ddhTableHeaderSortable.html', 'template/tables/ddhTableHeaderUnsortable.html', 'template/tabs/ddhTab.html', 'template/tabs/ddhTabset.html', 'template/usageBar/usageBar.html']);angular.module("ddh.att", ["ddh.att.tpls", 'ddh.att.achInput','ddh.att.addressInput','ddh.att.arrows','ddh.att.badgesForAlerts','ddh.att.bellybandLinks','ddh.att.bodyCopy','ddh.att.breadcrumbs','ddh.att.bulletedList','ddh.att.buttonGroups','ddh.att.buttons','ddh.att.calendar','ddh.att.cardSpace','ddh.att.checkboxes','ddh.att.colorAndDataCapacity','ddh.att.confirmationProcess','ddh.att.creditCard','ddh.att.dropdowns','ddh.att.expandCollapse','ddh.att.filmstrip','ddh.att.filters','ddh.att.filtersComplex','ddh.att.formsWithinProcess','ddh.att.headings','ddh.att.inpageMessaging','ddh.att.leftNavigation','ddh.att.legalCopy','ddh.att.links','ddh.att.loaderAnimation','ddh.att.marquees','ddh.att.modalsAndAlerts','ddh.att.pageLevelMessaging','ddh.att.pagination','ddh.att.pivotLinks','ddh.att.pricing','ddh.att.productTile','ddh.att.promoBadge','ddh.att.promoCards','ddh.att.radioProductSelect','ddh.att.radios','ddh.att.searchField','ddh.att.selectQuantity','ddh.att.selectionMenu','ddh.att.separators','ddh.att.socialFollowUs','ddh.att.socialShareThis','ddh.att.starRating','ddh.att.stepIndicator','ddh.att.strengthMeter','ddh.att.switches','ddh.att.tables','ddh.att.tabs','ddh.att.termsAndConditions','ddh.att.textArea','ddh.att.textFields','ddh.att.tooltipsForForms','ddh.att.usageBar',]);angular.module('ddh.att.utilities', [])

.constant('ddhUtilitiesConfig', {
    prev: '37',
    up: '38',
    next: '39',
    down: '40',
    type: 'list',
    columns: 1,
    enableSearch: false,
    searchTimer: 1000,
    circularTraversal: false
})

// All breakpoints ranges from >= min and < max
.constant('ddhAwdBreakpoints', {
    breakpoints: {
        mobile: {
            min: 1,
            max: 768
        },
        tablet: {
            min: 768,
            max: 1025
        },
        desktop: {
            min: 1025,
            max: 1920
        }
    }
})

.filter('ddhUnsafe', ['$sce', function ($sce) {
    return function (text) {
        return $sce.trustAsHtml(text);
    };
}])

.filter('ddhHighlight', function () {
    function escapeRegexp(queryToEscape) {
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }
    return function (matchItem, query, className) {
        return query && matchItem ? matchItem.replace(new RegExp(escapeRegexp(query), 'gi'), '<span class=\"' + className + '\">$&</span>') : matchItem;
    };
})

.filter('ddhLimitTo', function() {
    return function(actualArray, _limit, _begin) {
        var finalArray = [];
        var limit = _limit;
        var begin = _begin;
        if(isNaN(begin)) {
            begin = 0;
        }
        if(actualArray && !isNaN(limit)) {
            finalArray = actualArray.slice(begin, begin+limit);
        } else {
            finalArray = actualArray;
        }
        return finalArray;
    };
})

.directive('ddhKey', ['ddhUtilitiesConfig', '$timeout', 'keymap', function (ddhUtilitiesConfig, $timeout, keymap) {
    return {
        restrict: 'EA',
        controller: ['$scope', '$attrs', function ($scope, attr) {
            this.childElements = [];
            this.disableNodes = {};
            this.enableSearch = attr.enableSearch !== undefined ? true : ddhUtilitiesConfig.enableSearch;
            this.circularTraversal = attr.circularTraversal !== undefined ? true : ddhUtilitiesConfig.circularTraversal;
            this.counter = -1;
            if (this.enableSearch) {
                this.searchKeys = [];
            }
            var searchString = '';
            this.registerElement = function (childElement, searchKey, order) {
                var object = {};
                object.element = childElement;
                object.order = order;
                this.childElements.push(object);
                if (this.enableSearch) {
                    this.searchKeys.push(searchKey);
                }
                var count = this.childElements.length - 1;
                this.maxLength = count + 1;
            };
            this.registerElementReorder = function () {
                var firstArray = [];
                var lastArray = [];
                var indexArray = [];

                // store unique orders
                for (var i = 0; i < this.childElements.length; i++){
                    if (isNumeric(this.childElements[i].order)){
                        indexArray.push(this.childElements[i]);
                    }
                    else if (this.childElements[i].order === "FIRST"){
                        firstArray.push(this.childElements[i]);
                    }
                    else if (this.childElements[i].order === "LAST"){
                        lastArray.push(this.childElements[i]);
                    }
                }

                //remove unique orders
                for (var i = 0; i < this.childElements.length; i++){
                    if (this.childElements[i].order !== "M"){
                        this.childElements.splice(i, 1);
                    }
                }

                //have them stored in correct order
                this.childElements = firstArray.reverse().concat(this.childElements);

                for (var i = 0; i < indexArray.length; i++){
                    this.childElements.splice(indexArray[i].order, 0, indexArray[i]);
                }

                this.childElements = this.childElements.concat(lastArray);
            };

            function isNumeric(num){
                return !isNaN(num)
            }

            this.hasUniqueOrder = function(){
                for (var i = 0; i < this.childElements.length; i++){
                    if (this.childElements[i].order !== 'M'){
                        return true;
                    }
                }
                return false;
            }

            this.getCount = function (childElement) {
                for (var i = 0; i < this.childElements.length; i++){
                    if (childElement === this.childElements[i].element){
                        return i;
                    }
                }
                return null;
            };
            this.toggleDisable = function (count, state) {
                this.disableNodes[count] = state;
            };
            this.searchElement = function (searchExp) {
                var regex = new RegExp("\\b" + searchExp, "gi");
                var position = this.searchKeys.regexIndexOf(regex, this.counter + 1, true);
                if (position > -1) {
                    this.counter = position;
                    this.moveFocus(this.counter);
                }
            };
            this.startTimer = function (time) {
                if (searchString === '') {
                    $timeout(function () {
                        searchString = '';
                    }, time);
                }
            };
            this.resetCounter = function (count) {
                this.counter = count;
            };
            this.moveNext = function (count) {
                this.counter = (this.counter + count) < this.maxLength ? this.counter + count : (this.circularTraversal ? 0 : this.counter);
                if (this.disableNodes[this.counter]) {
                    if ((this.counter + count) < this.maxLength) {
                        this.moveNext(count);
                    }
                } else {
                    this.moveFocus(this.counter);
                }
            };
            this.movePrev = function (count) {
                this.counter = (this.counter - count) > -1 ? this.counter - count : (this.circularTraversal ? this.maxLength-1 : this.counter);
                if (this.disableNodes[this.counter]) {
                    if ((this.counter - count) > -1) {
                        this.movePrev(count);
                    }
                } else {
                    this.moveFocus(this.counter);
                }
            };
            this.moveFocus = function (index) {
                this.childElements[index].element[0].focus();
            };

            this.keyDownHandler = function (ev, count) {
                if (angular.isDefined(count) && !isNaN(count) && count !== this.counter) {
                    this.resetCounter(count);
                }
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                }
                if (ev.keyCode) {
                    if (this.prev && this.prev.indexOf(ev.keyCode.toString()) > -1) {
                        this.movePrev(1);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (this.next && this.next.indexOf(ev.keyCode.toString()) > -1) {
                        this.moveNext(1);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (this.up && this.up.indexOf(ev.keyCode.toString()) > -1) {
                        if (this.type === 'table') {
                            this.movePrev(this.columns);
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                    } else if (this.down && this.down.indexOf(ev.keyCode.toString()) > -1) {
                        if (this.type === 'table') {
                            this.moveNext(this.columns);
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                    } else if (ev.keyCode === keymap.KEY.HOME) {
                        var firstIndex = 0;
                        while (this.disableNodes[firstIndex] !== false) {
                            firstIndex++;
                        };
                        var count = this.counter - firstIndex;
                        this.movePrev(count);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (ev.keyCode === keymap.KEY.END) {
                        var lastIndex = this.childElements.length - 1;
                        while (this.disableNodes[lastIndex] !== false) {
                            lastIndex--;
                        };
                        var count = lastIndex - this.counter;
                        this.moveNext(count);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (ev.keyCode >= 48 && ev.keyCode <= 105) {
                        if (this.enableSearch) {
                            this.startTimer(ddhUtilitiesConfig.searchTimer);
                            searchString = searchString + (keymap.MAP[ev.keyCode] || '');
                            this.searchElement(searchString);
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                    }
                }
            };
        }],
        link: function (scope, elem, attr, ctrl) {
            ctrl.prev = attr.prev ? attr.prev.split(',') : ddhUtilitiesConfig.prev.split(',');
            ctrl.next = attr.next ? attr.next.split(',') : ddhUtilitiesConfig.next.split(',');
            ctrl.type = attr.type ? attr.type : ddhUtilitiesConfig.type;
            if (ctrl.type === 'table') {
                ctrl.up = attr.up ? attr.up.split(',') : ddhUtilitiesConfig.up.split(',');
                ctrl.down = attr.down ? attr.down.split(',') : ddhUtilitiesConfig.down.split(',');
                ctrl.columns = attr.columns ? parseInt(attr.columns, 10) : ddhUtilitiesConfig.columns;
            }

            elem.bind('keydown', function (ev) {
                ctrl.keyDownHandler(ev);
            });
        }
    };
}])

.directive('ddhKeyItem', [function () {
    return {
        restrict: 'EA',
        link: function (scope, elem, attr, ctrl) {
            var parentCtrl = (elem.parent() && elem.parent().controller('ddhKey')) || undefined;
            if (angular.isDefined(parentCtrl)) {
                if (angular.isDefined(attr.ddhKeyItemOrder)){
                    parentCtrl.registerElement(elem, attr.searchKey, attr.ddhKeyItemOrder);
                }
                else {
                    parentCtrl.registerElement(elem, attr.searchKey, 'M');
                }

                if (parentCtrl.hasUniqueOrder()){
                    parentCtrl.registerElementReorder();
                }

                elem.bind('keydown', function (ev) {
                    parentCtrl.keyDownHandler(ev, parentCtrl.getCount(elem));
                });
                scope.$watch(attr.ddhKeyItem, function (value) {
                    value = value === undefined ? true : value;
                    parentCtrl.toggleDisable(parentCtrl.getCount(elem), !value);
                });
                scope.$on('$destroy', function () {
                    parentCtrl.toggleDisable(parentCtrl.getCount(elem), true);
                });
            }
        }
    };
}])

.directive('ddhAccessibilityClick', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            var keyCode = [];
            attr.$observe('ddhAccessibilityClick', function (value) {
                if (value) {
                    keyCode = value.split(',');
                }
            });
            elem.bind('keydown keypress', function (ev) {
                var keyCodeCondition = function () {
                    var flag = false;
                    if (!(ev.keyCode)) {
                        if (ev.which) {
                            ev.keyCode = ev.which;
                        } else if (ev.charCode) {
                            ev.keyCode = ev.charCode;
                        }
                    }
                    if ((ev.keyCode && keyCode.indexOf(ev.keyCode.toString()) > -1)) {
                        flag = true;
                    }
                    return flag;
                };
                if (keyCode.length > 0 && keyCodeCondition()) {
                    elem[0].click();
                    ev.preventDefault();
                }
            });
        }
    };
}])

.directive('ddhKeyupClick', [ function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            var keyCode = [];
            attr.$observe('ddhKeyupClick', function (value) {
                if (value) {
                    keyCode = value.split(',');
                }
            });
            elem.bind('keydown keyup', function (ev) {
                var keyCodeCondition = function () {
                    var flag = false;
                    if (!(ev.keyCode)) {
                        if (ev.which) {
                            ev.keyCode = ev.which;
                        } else if (ev.charCode) {
                            ev.keyCode = ev.charCode;
                        }
                    }
                    if ((ev.keyCode && keyCode.indexOf(ev.keyCode.toString()) > -1)) {
                        flag = true;
                    }
                    return flag;
                };
                if (ev.type === 'keydown' && keyCodeCondition()) {
                    ev.preventDefault();
                }
                else if (ev.type === 'keyup' && keyCodeCondition()) {
                    elem[0].click();
                }
            });
        }
    };
}])

.factory('$documentBind', ['$document', '$timeout', function ($document, $timeout) {
    var _click = function (flag, callbackFunc, scope) {
        scope.$watch(flag, function (val) {
            $timeout(function () {
                if (val) {
                    $document.bind('click', callbackFunc);
                } else {
                    $document.unbind('click', callbackFunc);
                }
            });
        });
    };

    var _scroll = function (flag, callbackFunc, scope) {
        scope.$watch(flag, function (val) {
            $timeout(function () {
                if (val) {
                    $document.bind('scroll', callbackFunc);
                } else {
                    $document.unbind('scroll', callbackFunc);
                }
            });
        });
    };

    var _event = function (event, flag, callbackFunc, scope, timeoutFlag, timeoutValue) {
        if (timeoutFlag) {
            if (!(timeoutValue)) {
                timeoutValue = 0;
            }
            scope.$watch(flag, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    $timeout(function () {
                        if (newVal) {
                            $document.bind(event, callbackFunc);
                        } else {
                            $document.unbind(event, callbackFunc);
                        }
                    }, timeoutValue);
                }
            });
        } else {
            scope.$watch(flag, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (newVal) {
                        $document.bind(event, callbackFunc);
                    } else {
                        $document.unbind(event, callbackFunc);
                    }
                }
            });
        }
    };

    return {
        click: _click,
        scroll: _scroll,
        event: _event
    };
}])

.factory('$isElement', [function () {
    var isElement = function (currentElem, targetElem, alternateElem) {
        if (currentElem[0] === targetElem[0]) {
            return true;
        } else if (currentElem[0] === alternateElem[0]) {
            return false;
        } else {
            return isElement((currentElem.parent()[0] && currentElem.parent()) || targetElem, targetElem, alternateElem);
        }
    };

    return isElement;
}])

.factory('userAgent', [function () {
    var _isMobile = function () {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    var _notMobile = function () {
        return !_isMobile();
    };
    var _isIE = function () {
        return /msie|trident/i.test(navigator.userAgent);
    };

    var _isIOS = function () {
        return /iPhone|iPod/i.test(navigator.userAgent);
    };
    return {
        isMobile: _isMobile,
        notMobile: _notMobile,
        isIE: _isIE,
        isIOS: _isIOS
    };
}])

.factory('keymap', function () {
    return {
        KEY: {
            TAB: 9,
            ENTER: 13,
            ESC: 27,
            SPACE: 32,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            SHIFT: 16,
            CTRL: 17,
            ALT: 18,
            PAGE_UP: 33,
            PAGE_DOWN: 34,
            HOME: 36,
            END: 35,
            BACKSPACE: 8,
            DELETE: 46,
            COMMAND: 91
        },
        MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
        },
        isControl: function (e) {
            var k = e.keyCode;
            switch (k) {
            case this.KEY.COMMAND:
            case this.KEY.SHIFT:
            case this.KEY.CTRL:
            case this.KEY.ALT:
                return true;
            default:;
            }

            if (e.metaKey) {
                return true;
            }

            return false;
        },
        isFunctionKey: function (k) {
            k = k.keyCode ? k.keyCode : k;
            return k >= 112 && k <= 123;
        },
        isVerticalMovement: function (k) {
            return ~[this.KEY.UP, this.KEY.DOWN].indexOf(k);
        },
        isHorizontalMovement: function (k) {
            return ~[this.KEY.LEFT, this.KEY.RIGHT, this.KEY.BACKSPACE, this.KEY.DELETE].indexOf(k);
        },
        isAllowedKey: function (k) {
            return (~[this.KEY.SPACE, this.KEY.ESC, this.KEY.ENTER].indexOf(k)) || this.isHorizontalMovement(k) || this.isVerticalMovement(k);
        },
        isNumericKey: function (e) {
            var k = e.keyCode;
            if ((k >= 48 && k <= 57) || (k >= 96 && k <= 105)) {
                return true;
            } else {
                return false;
            }
        },
        isAlphaNumericKey: function (e) {
            var k = e.keyCode;
            if ((k >= 48 && k <= 57) || (k >= 96 && k <= 105) || (k >= 65 && k <= 90)) {
                return true;
            } else {
                return false;
            }
        }
    };
})

.factory('windowOrientation', ['$window', function ($window) {
    var _isPotrait = function () {
        if ($window.innerHeight > $window.innerWidth) {
            return true;
        } else {
            return false;
        }
    };
    var _isLandscape = function () {
        if ($window.innerHeight < $window.innerWidth) {
            return true;
        } else {
            return false;
        }
    };

    return {
        isPotrait: _isPotrait,
        isLandscape: _isLandscape
    };
}])

.directive('ddhReset', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        require: ['?ngModel', 'ddhReset'],
        controller: ['$scope', function ($scope) {
            var resetButton = angular.element('<button type="button" class="reset-field" tabindex="-1" aria-label="Click to reset" aria-hidden="true" role="button"></button>');

            this.getResetButton = function () {
                return resetButton;
            };
        }],
        link: function (scope, element, attrs, ctrls) {

            var ngModelCtrl = ctrls[0];
            var ctrl = ctrls[1];

            var resetButton = ctrl.getResetButton();


            resetButton.on('touchstart click', function () {
                element[0].value = '';

                if (ngModelCtrl) {
                    if (attrs.ddhReset) {
                        ngModelCtrl.$setViewValue(attrs.ddhReset);
                    } else {
                        ngModelCtrl.$setViewValue('');
                    }
                    element[0].value = ngModelCtrl.$viewValue;
                    ngModelCtrl.$render();
                    scope.$digest();
                }
                element[0].focus();
                element[0].select();
            });
            
            element.after(resetButton);
        }
    };
}])

.factory('events', function () {
    var _stopPropagation = function (evt) {
        if (evt.stopPropagation) {
            evt.stopPropagation();
        } else {
            evt.returnValue = false;
        }
    };
    var _preventDefault = function (evt) {
        if (evt.preventDefault) {
            evt.preventDefault();
        } else {
            evt.returnValue = false;
        }
    }
    return {
        stopPropagation: _stopPropagation,
        preventDefault: _preventDefault
    };
})

.factory('DOMHelper', function () {

    var _isTabable = function (node) {
        var element = angular.element(node);
        var tagName = element[0].tagName.toUpperCase();

        if (isHidden(element)) {
            return false;
        }
        if (element.attr('tabindex') !== undefined) {
            return (parseInt(element.attr('tabindex'), 10) >= 0);
        }
        if (tagName === 'A' || tagName === 'AREA' || tagName === 'BUTTON' || tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') {
            if (tagName === 'A' || tagName === 'AREA') {
                // anchors/areas without href are not focusable
                return (element[0].href !== '');
            }
            return !(element[0].disabled || element[0].readOnly);
        }
        return false;
    };

    function isValidChild(child) {
        return child.nodeType == 1 && child.nodeName != 'SCRIPT' && child.nodeName != 'STYLE';
    }

    function isHidden(obj) {
        var elem = angular.element(obj);
        var style;
        try {
            style = window.getComputedStyle(obj);
        }
        catch(err) {
            style = window.getComputedStyle(obj[0]);
        }

        // getComputedStyle() for Zepto object returns null
        if (style === null){
            return elem.hasClass('ng-hide') || elem.css('display') === 'none';
        }

        return elem.hasClass('ng-hide') || elem.css('display') === 'none' || style.display === 'none' || style.visibility === 'hidden' || elem.css('visibility') === 'hidden';
    }

    function traverse(obj, fromTop) {
        var obj = obj || document.getElementsByTagName('body')[0];

        if (isValidChild(obj) && _isTabable(obj)) {
			//for edge case when modal has multiple foccusable elements
            if(!angular.element(obj).hasClass("modal-body")){			
				return obj;
			}
        }

        // If object is hidden, skip it's children
        if (isValidChild(obj) && isHidden(obj)) {
            return undefined;
        }
        // If object is hidden, skip it's children
        if (angular.element(obj).hasClass('ng-hide')) {
            return undefined;
        }

        if (obj.hasChildNodes()) {
            var child;
            if (fromTop) {
                child = obj.firstChild;
            } else {
                child = obj.lastChild;
            }
            while (child) {
                var res = traverse(child, fromTop);
                if (res) {
                    return res;
                } else {
                    if (fromTop) {
                        child = child.nextSibling;
                    } else {
                        child = child.previousSibling;
                    }
                }
            }
        } else {
            return undefined;
        }
    }

    var _lastTabableElement = function (el) {
        /* This will return the last tabable element from the parent el */
        var elem = el;
        if (el.hasOwnProperty('length')) {
            elem = el[0];
        }

        return traverse(elem, false);
    };

    var _firstTabableElement = function (el) {
        /* This will return the first tabable element from the parent el */
        var elem = el;
        if (el.hasOwnProperty('length')) {
            elem = el[0];
        }

        return traverse(elem, true);
    };

    return {
        firstTabableElement: _firstTabableElement,
        lastTabableElement: _lastTabableElement,
        isTabable: _isTabable
    };
})

.factory('trapFocusInElement', ['$document', '$isElement', 'DOMHelper', 'keymap', '$interval', function ($document, $isElement, DOMHelper, keymap, $interval) {
    var elementStack = [];
    var stackHead = undefined;
    var stopInterval = undefined;
    var intervalRequired = false;
    var interval = 1000;
    var firstTabableElement, lastTabableElement;

    var trapKeyboardFocusInFirstElement = function (e) {
        if (!e.keyCode) {
            e.keyCode = e.which;
        }

        if (e.shiftKey === true && e.keyCode === keymap.KEY.TAB) {
            lastTabableElement[0].focus();
            e.preventDefault(e);
            e.stopPropagation(e);
        }

    };

    var trapKeyboardFocusInLastElement = function (e) {
        if (!e.keyCode) {
            e.keyCode = e.which;
        }

        if (e.shiftKey === false && e.keyCode === keymap.KEY.TAB) {
            firstTabableElement[0].focus();
            e.preventDefault(e);
            e.stopPropagation(e);
        }
    };

    var trapFocusInElement = function (flag, firstTabableElementParam, lastTabableElementParam) {
        var bodyElements = $document.find('body').children();

        firstTabableElement = firstTabableElementParam ? firstTabableElementParam : angular.element(DOMHelper.firstTabableElement(stackHead));
        lastTabableElement = lastTabableElementParam ? lastTabableElementParam : angular.element(DOMHelper.lastTabableElement(stackHead));
        if (flag) {
            for (var i = 0; i < bodyElements.length; i++) {
                if (bodyElements[i] !== stackHead[0]) {
                    bodyElements.eq(i).attr('aria-hidden', true);
                }
            }
            firstTabableElement.bind('keydown', trapKeyboardFocusInFirstElement);
            lastTabableElement.bind('keydown', trapKeyboardFocusInLastElement);
        } else {
            for (var j = 0; j < bodyElements.length; j++) {
                if (bodyElements[j] !== stackHead[0]) {
                    bodyElements.eq(j).removeAttr('aria-hidden');
                }
            }
            firstTabableElement.unbind('keydown', trapKeyboardFocusInFirstElement);
            lastTabableElement.unbind('keydown', trapKeyboardFocusInLastElement);
        }

        if (intervalRequired && flag) {
            stopInterval = $interval(function () {
                var firstTabableElementTemp = angular.element(DOMHelper.firstTabableElement(stackHead));
                var lastTabableElementTemp = angular.element(DOMHelper.lastTabableElement(stackHead));
                if (firstTabableElementTemp[0] !== firstTabableElement[0] || lastTabableElementTemp[0] !== lastTabableElement[0]) {
                    $interval.cancel(stopInterval);
                    stopInterval = undefined;
                    trapFocusInElement(false, firstTabableElement, lastTabableElement);
                    trapFocusInElement(true, firstTabableElementTemp, lastTabableElementTemp);
                }
            }, interval);
        } else {
            if (stopInterval) {
                $interval.cancel(stopInterval);
                stopInterval = undefined;
            }
        }
    };
    var toggleTrapFocusInElement = function (flag, element, intervalRequiredParam, intervalParam) {
        intervalRequired = intervalRequiredParam ? intervalRequiredParam : intervalRequired;
        interval = intervalParam ? intervalParam : interval;
        if (angular.isDefined(flag) && angular.isDefined(element)) {
            if (flag && angular.isUndefined(stackHead)) {
                stackHead = element;
                trapFocusInElement(flag);
            } else {
                if (flag) {
                    trapFocusInElement(false);
                    elementStack.push(stackHead);
                    stackHead = element;
                    trapFocusInElement(true);
                } else {
                    if (angular.isDefined(stackHead) && (stackHead[0] === element[0])) {
                        trapFocusInElement(false);
                        stackHead = elementStack.pop();
                        if (angular.isDefined(stackHead)) {
                            trapFocusInElement(true);
                        }
                    }
                }
            }
        } else {
            if (angular.isDefined(stackHead)) {
                trapFocusInElement(false, firstTabableElement, lastTabableElement);
                trapFocusInElement(true);
            }
        }
    };

    return toggleTrapFocusInElement;
}])

.directive('ddhElementFocus', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            scope.$watch(attr.ddhElementFocus, function (value) {
                if (value === true) {
                    elem[0].focus();
                }
            });
        }
    };
}])

.directive('ddhAppendElement', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            var parameters = attr.ddhAppendElement.split(':');
            if (parameters.length === 1) {
                elem.append(scope.$eval(parameters[0]));
            } else if (parameters.length === 2) {
                if (parameters[1] === 'compile') {
                    var element = angular.element('<span>' + scope.$eval(parameters[0]) + '</span>');
                    elem.append($compile(element)(scope));
                }
            }

        }
    };
}])

.directive('ddhOnlyDigits', ['keymap', function (keymap) {
        return {
            restrict: 'A',  
            scope:{ msize:'='},
            link: function (scope, elm, attrs, ctrl) {              
                if(attrs.maxlength)
                {
                    scope.msize = attrs.maxlength;
                }               
                elm.on('keydown', function (event) {
                    if (elm.val().length > scope.msize) {
                        if ((event.which === 37) 
                             || (event.which === 38)
                             || (event.which === 39) 
                             || (event.which === 40) 
                             || (event.which === 46) 
                             || (event.which === 8) 
                             || (event.which === 9)) {
                            return true;
                        } else {
                            event.preventDefault();
                            return false;
                        }
                    }
                    if (event.shiftKey && event.keyCode!==keymap.KEY.TAB) {
                        event.preventDefault();
                        return false;
                    }
                    if ((keymap.isNumericKey(event) === true) 
                             ||(event.which === 37) 
                             || (event.which === 38)
                             || (event.which === 39) 
                             || (event.which === 40) 
                             || (event.which == 46) 
                             || (event.which === 8) 
                             || (event.which === 9)) {
                        return true;
                    } else {
                        event.preventDefault();
                        return false;
                    }
                });
            }
        }
    }])

.factory('isHighContrast', function () {
    var _isHighContrast = function (idval) {
        var objDiv, objImage, strColor, strWidth, strReady;
        var strImageID = idval; // ID of image on the page

        // Create a test div
        objDiv = document.createElement('div');

        //Set its color style to something unusual
        objDiv.style.color = 'rgb(31, 41, 59)';

        // Attach to body so we can inspect it
        document.body.appendChild(objDiv);

        // Read computed color value
        strColor = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).color : objDiv.currentStyle.color;
        strColor = strColor.replace(/ /g, '');

        // Delete the test DIV
        document.body.removeChild(objDiv);

        // Check if we get the color back that we set. If not, we're in
        // high contrast mode.
        if (strColor !== 'rgb(31,41,59)') {
            return true;
        } else {
            return false;
        }
    };

    return _isHighContrast;
})

.run(['isHighContrast', '$document', 'userAgent', function (isHighContrast, $document, userAgent) {
    var html = $document.find('html').eq(0);
    if (isHighContrast()) {
        html.addClass('ds2-no-colors');
    } else {
        html.removeClass('ds2-no-colors');
    }
    if (userAgent.isIE()) {
        html.addClass('isIE');
    } else {
        html.removeClass('isIE');
    }
    if (userAgent.isMobile()) {
        html.addClass('isMobile');
    } else {
        html.removeClass('isMobile');
    }
    if (userAgent.isIOS()) {
        html.addClass('isIOS');
    } else {
        html.removeClass('isIOS');
    }

}])


.directive('ddhSelected', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            scope.$watch(attr.ddhSelected, function (value) {
                if (value === true) {
                    elem.attr('selected', 'selected');
                } else {
                    elem.removeAttr('selected');
                }
            });
        }
    };
}])

.directive('ddhMobileAttr', ['userAgent', function (userAgent) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {

            elem.removeAttr('ddh-mobile-attr');

            if(!attr.ddhMobileAttr && !(attr.ddhMobileAttr.indexOf('|') > -1)) {
                return;
            }

            var ddhMobileAttrArray = attr.ddhMobileAttr.split('|');
            var attrKey = ddhMobileAttrArray[0];
            var attrValue = ddhMobileAttrArray[1];

            if(userAgent.isMobile()) {
                elem.attr(attrKey, attrValue);
            }
        }
    };
}])

.directive('ddhBodyTimeoutElement', ['$timeout', '$document', '$compile', function ($timeout, $document, $compile) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {

            var msgElem = angular.copy(elem);
            elem.attr('aria-hidden', 'true');
            msgElem.removeAttr('ddh-body-timeout-element');
			msgElem.attr('aria-live', 'polite');
            msgElem.text('');
            msgElem = $compile(msgElem)(scope);
            var body = angular.element($document[0].body);

            var timeoutInstance = null;
            var timeoutInstanceRemove = null;
            var timeoutInstanceGap = parseInt(attr.ddhBodyTimeoutElement) || 1000;

            scope.$watch(function () {return elem.text();},function(newValue) {
                if (timeoutInstance) {
                    $timeout.cancel(timeoutInstance);
                }
                if (timeoutInstanceRemove) {
                    $timeout.cancel(timeoutInstanceRemove);
                }
                else {
                    body.append(msgElem);
                }

                timeoutInstance = $timeout(function () {
                    msgElem.text(newValue);

                    timeoutInstanceRemove = $timeout(function () {
                        msgElem.text('');
                        msgElem.remove();
                        timeoutInstanceRemove = null;
                    }, 1000);

                    timeoutInstance = null;
                }, timeoutInstanceGap);
            });
        }
    };
}])

.service('$ddhSetKeyValueOnAllArrayItems', [function () {
    var _setKeyValueOnAllArrayItems = function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            for (var j = 0; j < key.length; j++) {
                array[i][key[j]] = value[j];
            }
        }
    };
    return _setKeyValueOnAllArrayItems;
}]);

(function () {
    String.prototype.toSnakeCase = function () {
        return this.replace(/([A-Z])/g, function ($1) {
            return "-" + $1.toLowerCase();
        });
    };
    var concat = function (character, times) {
        character = character || '';
        times = (!isNaN(times) && times) || 0;
        var finalChar = '';
        for (var i = 0; i < times; i++) {
            finalChar += character;
        }
        return finalChar;
    };

    // direction: true for left and false for right
    var pad = function (actualString, width, character, direction) {
        actualString = actualString || '';
        width = (!isNaN(width) && width) || 0;
        character = character || '';
        if (width > actualString.length) {
            if (direction) {
                return concat(character, (width - actualString.length)) + actualString;
            } else {
                return actualString + concat(character, (width - actualString.length));
            }
        }
        return actualString;
    };

    String.prototype.lPad = function (width, character) {
        return pad(this, width, character, true);
    };

    String.prototype.rPad = function (width, character) {
        return pad(this, width, character, false);
    };

    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (val) {
            for (var index = 0; index < this.length; index++) {
                if (this[index] === val) {
                    return index;
                }
            }
            return -1;
        };
    }

    if (!Array.prototype.regexIndexOf) {
        Object.defineProperty(Array.prototype, 'regexIndexOf', {
            enumerable: false,
            value: function (regex, startIndex, loop) {
                startIndex = startIndex && startIndex > -1 ? startIndex : 0;
                for (var index = startIndex; index < this.length; index++) {
                    if (this[index].toString().match(regex)) {
                        return index;
                    }
                }
                if (loop) {
                    for (var index = 0; index < startIndex; index++) {
                        if (this[index].toString().match(regex)) {
                            return index;
                        }
                    }
                }
                return -1;
            }
        })
    }
})();
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:buttonGroups
 *
 * @description
 *  <file src="src/buttonGroups/docs/readme.md" />
 *
 * @usage
<h2>Radio Aproach</h2>
<div class="btn-group" ddh-key prev="37,38" next="39,40" circular-traversal role="radiogroup">
    <button type="button" class="btn btn-secondary" ddh-key-item ng-focus="radioModel='Button 1'" ng-model="radioModel" ddh-btn-radio="'Button 1'" tabindex="{{(!radioModel || 'Button 1'===radioModel)?0:-1}}">Button 1</button>
    <button type="button" class="btn btn-secondary" ddh-key-item ng-focus="radioModel='Button 2'" ng-model="radioModel" ddh-btn-radio="'Button 2'" tabindex="{{(!radioModel || 'Button 2'===radioModel)?0:-1}}">Button 2</button>
    <button type="button" class="btn btn-secondary" ddh-key-item ng-focus="radioModel='Button 3'" ng-model="radioModel" ddh-btn-radio="'Button 3'" tabindex="{{(!radioModel || 'Button 3'===radioModel)?0:-1}}">Button 3</button>
</div>

<h2>Checkbox Aproach</h2>
<span ddh-button-group class="btn-group btn-fullwidth" role="group" max-select="3" ng-model="checkModel1">
    <button type="button" class="btn btn-secondary" ng-model="checkModel1.Button1" ddh-btn-checkbox>Button1</button>
    <button type="button" class="btn btn-secondary" ng-model="checkModel1.Button2" ddh-btn-checkbox>Button2</button>
    <button type="button" class="btn btn-secondary" ng-model="checkModel1.Button3" ddh-btn-checkbox>Button3</button>
    <button type="button" class="btn btn-secondary" ng-model="checkModel1.Button4" ddh-btn-checkbox>Button4</button>
    <button type="button" class="btn btn-secondary" ng-model="checkModel1.Button5" ddh-btn-checkbox>Button5</button>
</span>
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/buttonGroups/docs/demo.html" />
            <file src="src/buttonGroups/docs/demo.js" />
       </example>
        </section>
 *
 */
angular.module('ddh.att.buttonGroups', ['ddh.att.utilities'])
    .constant('buttonConfig', {
        activeClass: 'active',
        toggleEvent: 'click'
    })
    .directive('ddhBtnRadio', ['buttonConfig', function (buttonConfig) {
        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var notMobile = !/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

                if (notMobile) {
                    element.bind('focus', function () {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(scope.$eval(attrs.ddhBtnRadio));
                            ngModelCtrl.$render();
                        });
                    });
                }

                element.attr('role', 'radio');

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.ddhBtnRadio)));
                    if (angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.ddhBtnRadio))) {
                        element.attr("aria-checked", true);
                    } else {
                        element.attr("aria-checked", false);
                    }
                };

                //ui->model
                element.bind(toggleEvent, function () {
                    if (!element.hasClass(activeClass)) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(scope.$eval(attrs.ddhBtnRadio));
                            ngModelCtrl.$render();
                        });
                    }
                });
            }
        };
    }])
    .directive('ddhBtnCheckbox', ['buttonConfig', function (buttonConfig) {
        var activeClass = buttonConfig.activeClass || 'active';
        var toggleEvent = buttonConfig.toggleEvent || 'click';

        return {
            require: ['ngModel', '^^ddhButtonGroup'],
            link: function (scope, element, attrs, ctrls) {

                var ngModelCtrl = ctrls[0];
                var parentCtrl = ctrls[1];

                element.attr('role', 'checkbox');
                element.attr('aria-describedby', parentCtrl.getStateDescriptionElemId());

                function getTrueValue() {
                    var trueValue = scope.$eval(attrs.ddhBtnCheckboxTrue);
                    return angular.isDefined(trueValue) ? trueValue : true;
                }

                function getFalseValue() {
                    var falseValue = scope.$eval(attrs.ddhBtnCheckboxFalse);
                    return angular.isDefined(falseValue) ? falseValue : false;
                }

                //model -> UI
                ngModelCtrl.$render = function () {
                    element.toggleClass(activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
                    if ((angular.equals(ngModelCtrl.$modelValue, getTrueValue()))) {
                        element.attr("aria-checked", true);
                    } else {
                        element.attr("aria-checked", false);
                    }
                };

                //ui->model
                element.bind(toggleEvent, function () {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.hasClass(activeClass) ? getFalseValue() : getTrueValue());
                        ngModelCtrl.$render();
                    });
                });
            }
        };
    }])
    .directive('ddhButtonGroup', ['$timeout', '$compile', function ($timeout, $compile) {
        return {
            restrict: 'A',
            scope: {
                maxSelect: "=",
                ngModelButtonState: '=ngModel'
            },
            controller: ['$scope', '$element', function ($scope, $element) {
                $scope.nSel = 0;

                var stateDescriptionElem = angular.element('<span id="ddh_button_group_' + $scope.$id + '" class="hide" >{{maxSelect-nSel}} choices remaining.</span>');
                $compile(stateDescriptionElem)($scope);
                $element.after(stateDescriptionElem);

                this.getStateDescriptionElemId = function () {
                    return stateDescriptionElem.attr('id');
                };
            }],
            link: function (scope, element) {


                var executeFxn = function () {
                    scope.nSel = 0;
                    angular.forEach(scope.ngModelButtonState, function (value, key) {
                        if (value === true) {
                            scope.nSel += 1;
                        }
                    });

                    if (scope.nSel >= scope.maxSelect) {
                        angular.forEach(element.children(), function (chd) {
                            if (chd.className.indexOf('active') < 0) {
                                chd.disabled = true;
                                chd.setAttribute('aria-disabled', true);
                            }
                            
                            //Fix for refreshing NVDA readout on FF
                            chd.setAttribute('aria-hidden', true);
                            chd.removeAttribute('aria-hidden');
                        });
                    } else {
                        angular.forEach(element.children(), function (chd) {
                            chd.disabled = false;
                            chd.setAttribute('aria-disabled', false);
                            
                            //Fix for refreshing NVDA readout on FF
                            chd.setAttribute('aria-hidden', true);
                            chd.removeAttribute('aria-hidden');
                        });
                    }
                    scope.$digest();
                };

                $timeout(function () {
                    executeFxn();
                });
                element.bind('click', executeFxn);
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name Forms.att:achInput
 *
 * @description
 *  <file src="src/achInput/docs/readme.md" />
 *
 * @usage
 * 
 *
 *
 * @example
 <section id="code">
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/achInput/docs/demo.html" />
 <file src="src/achInput/docs/demo.js" />
 </example>
 </section>
 */
angular.module('ddh.att.achInput', ['ddh.att.buttonGroups', 'ddh.att.utilities'])
        .directive('validateAccountNumber', ['$timeout', function($timeout) {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function(scope, elem, attr, ngModelCtrl) {
                        function setMaskValue(value) {
                            if (value) {
                                return value.replace(/.(?=.{4})/g, 'x');
                            }
                        }
                        elem.bind('focus', function() {
                            if (ngModelCtrl.$modelValue) {
                                elem[0].value = ngModelCtrl.$modelValue;
                            }
                            else {
                                elem[0].value = ngModelCtrl.$viewValue;
                            }

                        });
                        elem.bind('blur', function() {

                            if (ngModelCtrl.$modelValue) {
                                elem[0].value = setMaskValue(ngModelCtrl.$modelValue);
                            }
                            else {

                                elem[0].value = setMaskValue(ngModelCtrl.$viewValue);
                            }

                        });
                        ngModelCtrl.$formatters.push(function(value){
                            $timeout(function(){
                                elem[0].value = setMaskValue(value);
                            });
                            return value;
                        });
                    }
                };
            }]);
angular.module('ddh.att.position', [])

.factory('$position', ['$document', '$window', function ($document, $window) {
    function getStyle(el, cssprop) {
        if (el.currentStyle) { //IE
            return el.currentStyle[cssprop];
        } else if ($window.getComputedStyle) {
            return $window.getComputedStyle(el)[cssprop];
        }
        // finally try and get inline style
        return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
        return (getStyle(element, "position") || 'static') === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function (element) {
        var docDomEl = $document[0];
        var offsetParent = element.offsetParent || docDomEl;
        while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
            offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || docDomEl;
    };

    return {
        /**
         * Provides read-only equivalent of jQuery's position function:
         * http://api.jquery.com/position/
         */
        position: function (element) {
            var elBCR = this.offset(element);
            var offsetParentBCR = {
                top: 0,
                left: 0
            };
            var offsetParentEl = parentOffsetEl(element[0]);
            if (offsetParentEl !== $document[0]) {
                offsetParentBCR = this.offset(angular.element(offsetParentEl));
                offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
                offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
            }

            return {
                width: element.prop('offsetWidth'),
                height: element.prop('offsetHeight'),
                top: elBCR.top - offsetParentBCR.top,
                left: elBCR.left - offsetParentBCR.left
            };
        },

        /**
         * Provides read-only equivalent of jQuery's offset function:
         * http://api.jquery.com/offset/
         */
        offset: function (element) {
            var boundingClientRect = element[0].getBoundingClientRect();
            return {
                width: element.prop('offsetWidth'),
                height: element.prop('offsetHeight'),
                top: boundingClientRect.top + ($window.pageYOffset || $document[0].body.scrollTop || $document[0].documentElement.scrollTop),
                left: boundingClientRect.left + ($window.pageXOffset || $document[0].body.scrollLeft || $document[0].documentElement.scrollLeft)
            };
        },
		
		 /**
         * Provides functionality to check whether an element is in view port.
         */
        isElementInViewport: function (element) {
            if (element) {
                var rect = element[0].getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.top <= ($window.innerHeight || $document[0].documentElement.clientHeight) &&
                    rect.left <= ($window.innerWidth || $document[0].documentElement.clientWidth)
                );
            } else {
                return false;
            }
        }
    };
}])

.factory('$isElement', [function () {
    var isElement = function (currentElem, targetElem, alternateElem) {
        if (currentElem[0] === targetElem[0]) {
            return true;
        } else if (currentElem[0] === alternateElem[0]) {
            return false;
        } else {
            return isElement((currentElem.parent()[0] && currentElem.parent()) || targetElem, targetElem, alternateElem);
        }
    };

    return isElement;
}])

.directive('attPosition', ['$position', function ($position) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {
            scope.$watchCollection(function () {
                return $position.position(elem);
            }, function (value) {
                scope[attr.attPosition] = value;
            });
        }
    };
}]);

var duScrollDefaultEasing = function (x) {
  'use strict';

  if(x < 0.5) {
    return Math.pow(x*2, 2)/2;
  }
  return 1-Math.pow((1-x)*2, 2)/2;
};

var duScroll = angular.module('ds2Scroll', [  
  'duScroll.smoothScroll',
  'duScroll.scrollContainer',  
  'duScroll.scrollHelpers'
])
  //Default animation duration for smoothScroll directive
  .value('duScrollDuration', 350)
  //Wether or not multiple scrollspies can be active at once
  .value('duScrollGreedy', false)
  //Default offset for smoothScroll directive
  .value('duScrollOffset', 0)
  //Default easing function for scroll animation
  .value('duScrollEasing', duScrollDefaultEasing)
  //Which events on the container (such as body) should cancel scroll animations
  .value('duScrollCancelOnEvents', 'scroll mousedown mousewheel touchmove keydown')
  //Whether or not to activate the last scrollspy, when page/container bottom is reached
  .value('duScrollBottomSpy', false)
  //Active class name
  .value('duScrollActiveClass', 'active');

if (typeof module !== 'undefined' && module && module.exports) {
  module.exports = duScroll;
}
angular.module('duScroll.scrollHelpers', ['duScroll.requestAnimation'])
.run(["$window", "$q", "cancelAnimation", "requestAnimation", "duScrollEasing", "duScrollDuration", "duScrollOffset", "duScrollCancelOnEvents", function($window, $q, cancelAnimation, requestAnimation, duScrollEasing, duScrollDuration, duScrollOffset, duScrollCancelOnEvents) {
  'use strict';

  var proto = {};

  var isDocument = function(el) {
    return (typeof HTMLDocument !== 'undefined' && el instanceof HTMLDocument) || (el.nodeType && el.nodeType === el.DOCUMENT_NODE);
  };

  var isElement = function(el) {
    return (typeof HTMLElement !== 'undefined' && el instanceof HTMLElement) || (el.nodeType && el.nodeType === el.ELEMENT_NODE);
  };

  var unwrap = function(el) {
    return isElement(el) || isDocument(el) ? el : el[0];
  };

  proto.duScrollTo = function(left, top, duration, easing) {
    var aliasFn;
    if(angular.isElement(left)) {
      aliasFn = this.duScrollToElement;
    } else if(angular.isDefined(duration)) {
      aliasFn = this.duScrollToAnimated;
    }
    if(aliasFn) {
      return aliasFn.apply(this, arguments);
    }
    var el = unwrap(this);
    if(isDocument(el)) {
      return $window.scrollTo(left, top);
    }
    el.scrollLeft = left;
    el.scrollTop = top;
  };

  var scrollAnimation, deferred;
  proto.duScrollToAnimated = function(left, top, duration, easing) {
    if(duration && !easing) {
      easing = duScrollEasing;
    }
    var startLeft = this.duScrollLeft(),
        startTop = this.duScrollTop(),
        deltaLeft = Math.round(left - startLeft),
        deltaTop = Math.round(top - startTop);

    var startTime = null, progress = 0;
    var el = this;

    var cancelScrollAnimation = function($event) {
      if (!$event || (progress && $event.which > 0)) {
        if(duScrollCancelOnEvents) {
          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
        }
        cancelAnimation(scrollAnimation);
        deferred.reject();
        scrollAnimation = null;
      }
    };

    if(scrollAnimation) {
      cancelScrollAnimation();
    }
    deferred = $q.defer();

    if(duration === 0 || (!deltaLeft && !deltaTop)) {
      if(duration === 0) {
        el.duScrollTo(left, top);
      }
      deferred.resolve();
      return deferred.promise;
    }

    var animationStep = function(timestamp) {
      if (startTime === null) {
        startTime = timestamp;
      }

      progress = timestamp - startTime;
      var percent = (progress >= duration ? 1 : easing(progress/duration));

      el.scrollTo(
        startLeft + Math.ceil(deltaLeft * percent),
        startTop + Math.ceil(deltaTop * percent)
      );
      if(percent < 1) {
        scrollAnimation = requestAnimation(animationStep);
      } else {
        if(duScrollCancelOnEvents) {
          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
        }
        scrollAnimation = null;
        deferred.resolve();
      }
    };

    //Fix random mobile safari bug when scrolling to top by hitting status bar
    el.duScrollTo(startLeft, startTop);

    if(duScrollCancelOnEvents) {
      el.bind(duScrollCancelOnEvents, cancelScrollAnimation);
    }

    scrollAnimation = requestAnimation(animationStep);
    return deferred.promise;
  };

  proto.duScrollToElement = function(target, offset, duration, easing) {
    var el = unwrap(this);
    if(!angular.isNumber(offset) || isNaN(offset)) {
      offset = duScrollOffset;
    }
    var top = this.duScrollTop() + unwrap(target).getBoundingClientRect().top - offset;
    if(isElement(el)) {
      top -= el.getBoundingClientRect().top;
    }
    return this.duScrollTo(0, top, duration, easing);
  };

  proto.duScrollLeft = function(value, duration, easing) {
    if(angular.isNumber(value)) {
      return this.duScrollTo(value, this.duScrollTop(), duration, easing);
    }
    var el = unwrap(this);
    if(isDocument(el)) {
      return $window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
    }
    return el.scrollLeft;
  };
  proto.duScrollTop = function(value, duration, easing) {
    if(angular.isNumber(value)) {
      return this.duScrollTo(this.duScrollLeft(), value, duration, easing);
    }
    var el = unwrap(this);
    if(isDocument(el)) {
      return $window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    }
    return el.scrollTop;
  };

  proto.duScrollToElementAnimated = function(target, offset, duration, easing) {
    return this.duScrollToElement(target, offset, duration || duScrollDuration, easing);
  };

  proto.duScrollTopAnimated = function(top, duration, easing) {
    return this.duScrollTop(top, duration || duScrollDuration, easing);
  };

  proto.duScrollLeftAnimated = function(left, duration, easing) {
    return this.duScrollLeft(left, duration || duScrollDuration, easing);
  };

  angular.forEach(proto, function(fn, key) {
    angular.element.prototype[key] = fn;

    //Remove prefix if not already claimed by jQuery / ui.utils
    var unprefixed = key.replace(/^duScroll/, 'scroll');
    if(angular.isUndefined(angular.element.prototype[unprefixed])) {
      angular.element.prototype[unprefixed] = fn;
    }
  });

}]);

angular.module('duScroll.polyfill', [])
.factory('polyfill', ["$window", function($window) {
  'use strict';

  var vendors = ['webkit', 'moz', 'o', 'ms'];

  return function(fnName, fallback) {
    if($window[fnName]) {
      return $window[fnName];
    }
    var suffix = fnName.substr(0, 1).toUpperCase() + fnName.substr(1);
    for(var key, i = 0; i < vendors.length; i++) {
      key = vendors[i]+suffix;
      if($window[key]) {
        return $window[key];
      }
    }
    return fallback;
  };
}]);

angular.module('duScroll.requestAnimation', ['duScroll.polyfill'])
.factory('requestAnimation', ["polyfill", "$timeout", function(polyfill, $timeout) {
  'use strict';

  var lastTime = 0;
  var fallback = function(callback, element) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = $timeout(function() { callback(currTime + timeToCall); },
      timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };

  return polyfill('requestAnimationFrame', fallback);
}])
.factory('cancelAnimation', ["polyfill", "$timeout", function(polyfill, $timeout) {
  'use strict';

  var fallback = function(promise) {
    $timeout.cancel(promise);
  };

  return polyfill('cancelAnimationFrame', fallback);
}]);

angular.module('duScroll.scrollContainerAPI', [])
.factory('scrollContainerAPI', ["$document", function($document) {
  'use strict';

  var containers = {};

  var setContainer = function(scope, element) {
    var id = scope.$id;
    containers[id] = element;
    return id;
  };

  var getContainerId = function(scope) {
    if(containers[scope.$id]) {
      return scope.$id;
    }
    if(scope.$parent) {
      return getContainerId(scope.$parent);
    }
    return;
  };

  var getContainer = function(scope) {
    var id = getContainerId(scope);
    return id ? containers[id] : $document;
  };

  var removeContainer = function(scope) {
    var id = getContainerId(scope);
    if(id) {
      delete containers[id];
    }
  };

  return {
    getContainerId:   getContainerId,
    getContainer:     getContainer,
    setContainer:     setContainer,
    removeContainer:  removeContainer
  };
}]);

angular.module('duScroll.smoothScroll', ['duScroll.scrollHelpers', 'duScroll.scrollContainerAPI'])
.directive('duSmoothScroll', ["duScrollDuration", "duScrollOffset", "scrollContainerAPI", function(duScrollDuration, duScrollOffset, scrollContainerAPI) {
  'use strict';

  return {
    link : function($scope, $element, $attr) {
      $element.on('click', function(e) {
        if((!$attr.href || $attr.href.indexOf('#') === -1) && $attr.duSmoothScroll === '') return;

        var id = $attr.href ? $attr.href.replace(/.*(?=#[^\s]+$)/, '').substring(1) : $attr.duSmoothScroll;

        var target = document.getElementById(id) || document.getElementsByName(id)[0];
        if(!target || !target.getBoundingClientRect) return;

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();

        var offset    = $attr.offset ? parseInt($attr.offset, 10) : duScrollOffset;
        var duration  = $attr.duration ? parseInt($attr.duration, 10) : duScrollDuration;
        var container = scrollContainerAPI.getContainer($scope);

        container.duScrollToElement(
          angular.element(target),
          isNaN(offset) ? 0 : offset,
          isNaN(duration) ? 0 : duration
        );
      });
    }
  };
}]);


angular.module('duScroll.scrollContainer', ['duScroll.scrollContainerAPI'])
.directive('duScrollContainer', ["scrollContainerAPI", function(scrollContainerAPI){
  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function compile(tElement, tAttrs, transclude) {
      return {
        pre: function preLink($scope, iElement, iAttrs, controller) {
          iAttrs.$observe('duScrollContainer', function(element) {
            if(angular.isString(element)) {
              element = document.getElementById(element);
            }

            element = (angular.isElement(element) ? angular.element(element) : iElement);
            scrollContainerAPI.setContainer($scope, element);
            $scope.$on('$destroy', function() {
              scrollContainerAPI.removeContainer($scope);
            });
          });
        }
      };
    }
  };
}]);


angular.module('ddh.att.transition', ['ds2Scroll'])

.factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {

  var $transition = function(element, trigger, options) {
    options = options || {};
    var deferred = $q.defer();
    var endEventName = $transition[options.animation ? "animationEndEventName" : "transitionEndEventName"];

    var transitionEndHandler = function() {
      $rootScope.$apply(function() {
        element.unbind(endEventName, transitionEndHandler);
        deferred.resolve(element);
      });
    };

    if (endEventName) {
      element.bind(endEventName, transitionEndHandler);
    }

    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
    $timeout(function() {
      if ( angular.isString(trigger) ) {
        element.addClass(trigger);
      } else if ( angular.isFunction(trigger) ) {
        trigger(element);
      } else if ( angular.isObject(trigger) ) {
        element.css(trigger);
      }
      //If browser does not support transitions, instantly resolve
      if ( !endEventName ) {
        deferred.resolve(element);
      }
    }, 100);

    // Add our custom cancel function to the promise that is returned
    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
    // i.e. it will therefore never raise a transitionEnd event for that transition
    deferred.promise.cancel = function() {
      if ( endEventName ) {
        element.unbind(endEventName, transitionEndHandler);
      }
      deferred.reject('Transition cancelled');
    };

    return deferred.promise;
  };

  // Work out the name of the transitionEnd event
  var transElement = document.createElement('trans');
  var transitionEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'transition': 'transitionend'
  };
  var animationEndEventNames = {
    'WebkitTransition': 'webkitAnimationEnd',
    'MozTransition': 'animationend',
    'OTransition': 'oAnimationEnd',
    'transition': 'animationend'
  };
  function findEndEventName(endEventNames) {
    for (var name in endEventNames){
      if (transElement.style[name] !== undefined) {
        return endEventNames[name];
      }
    }
  }
  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
  return $transition;
}])

.factory('$scrollToView', ['$window', '$position', '$document', function ($window, $position, $document) {
    var _vertical = function (targetElem, additionalPadding) {
        var scrollTOPTarget = targetElem[0].getBoundingClientRect().top + $position.offset(targetElem).height - $window.innerHeight + 2;
        if (scrollTOPTarget > 0) {
//            $document.find('body')[0].scrollTop = $window.pageYOffset + scrollTOPTarget + additionalPadding;
//            
//            // for Firefox and IE
//            $document.find('html')[0].scrollTop = $window.pageYOffset + scrollTOPTarget + additionalPadding;
			var pixelsUp = $window.pageYOffset + scrollTOPTarget + additionalPadding;
			$document.scrollTop(pixelsUp, 800);
        }
    };
    return {
      vertical: _vertical
    };
}])

.factory('$scrollTo', ['$window','$document', function($window, $document) {
    var $scrollTo = function(offsetLeft, offsetTop, duration) {    	
		$document.scrollTop(offsetTop, 500);
    };
    return $scrollTo;
}])

.factory('$scrollToHostElement', ['$document', function($document) {
    var $scrollToHostElement = function(hostElement, offsetLeft, offsetTop, duration) {
        if (!hostElement) {
			$document.scrollTo(offsetLeft, offsetTop, 500);
        }
        else {
			angular.element(hostElement).eq(0).scrollTo(offsetLeft, offsetTop, 500);
		}
    };
    return $scrollToHostElement;
}])

.factory('$height', function(){
  var heightAnimation = function(element,duration,height,alpha){
    TweenMax.to(element,
      duration,
      {height:height, autoAlpha:alpha},
      0);
  };
  return heightAnimation;
});
/**
 * @ngdoc directive
 * @name Forms.att:dropdowns
 *
 * @description
 *  <file src="src/dropdowns/docs/readme.md" />
 * @usage
 *  <select name="dropdown1" ddh-dropdown ng-model="dropdownValue1.value">
        <option ddh-dropdown-list option-repeat="d in dropdownOptions1" value="{{d.value}}">{{d.text}}</option>
    </select>
 *
 * @example
   <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
     <file src="src/dropdowns/docs/demo.html" />
     <file src="src/dropdowns/docs/demo.js" />
    </example>
   </section>
 */
angular.module('ddh.att.dropdowns', ['ddh.att.utilities', 'ddh.att.position', 'ddh.att.transition', 'ngSanitize'])

.constant('ddhDropdownConfig', {
    prev: '38',
    next: '40',
    menuDropdownKeyword: 'menu',
    menuKeyword: 'selector-menu',
    linkMenuKeyword: 'link-menu',
    largeKeyword: 'large',
    smallKeyword: 'small'
})

.directive("ddhDropdown", ['$timeout', '$compile', '$templateCache', 'userAgent', 'ddhDropdownConfig', '$position', function ($timeout, $compile, $templateCache, userAgent, ddhDropdownConfig, $position) {
    return {
        restrict: 'A',
        scope: true,
        require: 'ngModel',
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            scope.isInputDropdown = true;
             scope.isMobile = false;

            if (userAgent.isMobile()){
                scope.isMobile = true;
            }

            if (attr.type) {
                if (attr.type.indexOf(ddhDropdownConfig.menuKeyword) > -1 || attr.type.indexOf(ddhDropdownConfig.linkMenuKeyword) > -1 || attr.type.indexOf(ddhDropdownConfig.menuDropdownKeyword) > -1) {
                    scope.isInputDropdown = false;
                    if (attr.type.indexOf(ddhDropdownConfig.linkMenuKeyword) > -1) {
                        scope.dropdownType = ddhDropdownConfig.linkMenuKeyword;
                    } else if (attr.type.indexOf(ddhDropdownConfig.menuKeyword) > -1) {
                        scope.dropdownType = ddhDropdownConfig.menuKeyword;
                    } else if (attr.type.indexOf(ddhDropdownConfig.menuDropdownKeyword) > -1) {
                        scope.dropdownType = ddhDropdownConfig.menuDropdownKeyword;
                    }
                }
                if (attr.type.indexOf(ddhDropdownConfig.largeKeyword) > -1) {
                    scope.dropdownSize = ddhDropdownConfig.largeKeyword;
                } else if (attr.type.indexOf(ddhDropdownConfig.smallKeyword) > -1) {
                    scope.dropdownSize = ddhDropdownConfig.smallKeyword;
                }
            }

            scope.labelText = attr.labelText;
            scope.searchByValue = attr.searchByValue !== undefined ? true : false;

            scope.setBlur = function () {
                if (!scope.toggleFlag){
                    scope.setTouched();
                }
            };

            if ((scope.isInputDropdown && userAgent.notMobile()) || (!scope.isInputDropdown)) {
                var formCtrl = elem.controller('form');
                scope.setNgModelController = function (name, ngModelCtrl) {
                    if (name && formCtrl && ngModelCtrl) {
                        formCtrl[name] = ngModelCtrl;
                    }
                };
                scope.setOptionalCta = function (optionalCta) {
                    scope.optionalCta = optionalCta;
                };
                var innerHtml = angular.element('<div></div>').append(elem.html());
                innerHtml = ($compile(innerHtml)(scope)).html();
                var template = angular.element($templateCache.get('template/dropdowns/ddhDropdownDesktop.html'));
                template.find('ul').eq(0).append(innerHtml);
                template = $compile(template)(scope);
                elem.replaceWith(template);
            } else if (scope.isInputDropdown && userAgent.isMobile()) {
                elem.css({
                    'opacity': '0',
                    'filter': 'alpha(opacity=0)'
                });
                elem.addClass('awd-select isWrapped');
                elem.wrap('<span class="selectWrap"></span>');
                var cover = angular.element('<span aria-hidden="true"><i class="icon-down" aria-hidden="true"></i></span>');
                elem.parent().append(cover);
                var set = function () {
                    var sel = elem[0] ? elem[0] : elem;
                    var selectedText = "";
                    var selIndex = sel.selectedIndex;
                    if (typeof selIndex !== 'undefined') {
                        selectedText = sel.options[selIndex].text;
                    }
                    cover.text(selectedText).append('<i class="icon-down" aria-hidden="true"></i>');
                };
                var update = function (value) {
                    $timeout(set, 100);
                };

                if (attr.ngModel) {
                    scope.$watch(attr.ngModel, function (newVal, oldVal) {
                        update();
                        scope.setRequired(newVal);
                    });
                }
                elem.bind('keyup', function () {
                    set();
                });
            }
        }],
        link: function (scope, elem, attr, ctrl) {
            if ((scope.isInputDropdown && userAgent.notMobile()) || (!scope.isInputDropdown)) {
                scope.updateModel = function () {
                    ctrl.$setViewValue(scope.currentSelected.value);
                    if (scope.dropdownRequired && scope.currentSelected.value === '') {
                        scope.setRequired(false);
                    } else {
                        scope.setRequired(true);
                    }

                    if (scope.dropdownType === ddhDropdownConfig.linkMenuKeyword) {
                        $timeout(function () {
                            scope.appendCaretPositionStyle();
                        }, 100);
                    }
                };
                ctrl.$render = function () {
                    $timeout(function () {
                        scope.dropdownLists[ctrl.$viewValue || ''] && scope.dropdownLists[ctrl.$viewValue || ''][0].updateDropdownValue();
                    }, 100);
                };
                scope.disabled = false;
                scope.dropdownName = attr.name;
                scope.dropdownId = attr.id;
                scope.labelId = attr.ariaLabelledby;
                scope.dropdownDescribedBy = attr.ariaDescribedby;
                if (attr.required) {
                    scope.dropdownRequired = true;
                } else {
                    scope.dropdownRequired = false;
                }
                elem.removeAttr('name');
                elem.removeAttr('id');
                scope.$parent.$watch(attr.ngDisabled, function (val) {
                    scope.disabled = val;
                });
            }
            else if (scope.isInputDropdown && userAgent.isMobile()){
                elem.bind("blur", function () {
                    ctrl.$touched2 = true;
                });
                scope.setRequired = function (value) {
                    if (attr.required !== undefined && (value === undefined || value === '')) {
                        ctrl.$setValidity('required2', false);
                    } else {
                        ctrl.$setValidity('required2', true);
                    }
                };
            }
        }
    };
}])

.directive("ddhDropdownToggle", ['$document', '$documentBind', '$isElement', 'ddhDropdownConfig', 'keymap', 'ddhUtilitiesConfig', '$timeout', '$position', '$window', '$scrollToView', function ($document, $documentBind, $isElement, ddhDropdownConfig, keymap, ddhUtilitiesConfig, $timeout, $position, $window, $scrollToView) {
    return {
        restrict: 'A',
        require: '?^ddhKey',
        link: function (scope, elem, attr, ctrl) {
            scope.appendCaretPositionStyle = function (leftCheck) {
                while (document.querySelector('style#ddhDropdownCaret')) {
                    document.querySelector('style#ddhDropdownCaret').remove();
                };
                var caretPosition = $position.position(elem).width - 26;
                var afterCaretPosition = caretPosition -2;
				if(leftCheck !== undefined ) {
						caretPosition = caretPosition + leftCheck;
						afterCaretPosition = afterCaretPosition + leftCheck;
					}
                if (scope.dropdownType === ddhDropdownConfig.linkMenuKeyword) {
                    var template = angular.element("<style id='ddhDropdownCaret' type='text/css'>.linkSelectionMenu .active+.menuWrapper:before{left:" + caretPosition + "px;} .linkSelectionMenu .active+.menuWrapper:after{left:" + afterCaretPosition + "px;}</style>");                       
                    $document.find('head').append(template);
                }
            };

            if (scope.isInputDropdown && (scope.labelText !== undefined)) {
                elem.attr('aria-label', scope.labelText);
            }

            scope.toggleFlag = false;
            scope.dropdownLists = {};
            scope.dropdownListValues = [];
            scope.dropdownListSearchValues = [];
            scope.dropdown = {
                totalIndex: -1
            };
            scope.currentSelected = {
                value: '',
                text: '',
                label: '',
                index: -1
            };
            var searchString = '';
            var searchElement = function (searchExp) {
                var regex = new RegExp("\\b" + searchExp, "gi");
                var position = scope.dropdownListSearchValues.regexIndexOf(regex, scope.currentSelected.index + 1, true);
                if (position > -1) {
                    return position;
                }
                return undefined;
            };
            var startTimer = function (time) {
                if (searchString === '') {
                    $timeout(function () {
                        searchString = '';
                    }, time);
                }
            };
            scope.toggleDropdown = function (toggleFlag) {
                if (!scope.disabled) {
                    if (angular.isDefined(toggleFlag)) {
                        scope.toggleFlag = toggleFlag;
                    } else {
                        scope.toggleFlag = !scope.toggleFlag;
                    }
                    
                    if (!scope.toggleFlag) {
                        if (scope.isInputDropdown) {
                            elem.parent().find('input')[0].focus();
                        } else {
                            elem.parent().find('button')[0].focus();
                        }
                    } else {
                        scope.dropdown.highlightedValue = scope.currentSelected.value;
                        if (ctrl && ctrl.enableSearch) {
                            if (angular.isNumber(scope.currentSelected.index)) {
                                ctrl.resetCounter(scope.currentSelected.index);
                            }
                        }
                        $timeout(function () {
                            (scope.dropdownLists[scope.currentSelected.value][1])[0].focus();
                        }, 200);
                        if (scope.dropdownType === ddhDropdownConfig.linkMenuKeyword) {
							// when selector menu open out of viewport
							var wrapperWidth = angular.element(elem.parent()[0].querySelector('.awd-menu-list'))[0].offsetWidth,
							left = elem.parent()[0].querySelector('.awd-menu-list').getBoundingClientRect().left,
							docWidth = $window.innerWidth,
							btnWidth = elem.parent()[0].offsetWidth;
							if (!(docWidth - left >= wrapperWidth)) {
								targetLeft = docWidth - left - wrapperWidth - 5;
								scope.appendCaretPositionStyle(Math.abs(targetLeft));
							} else {
								scope.appendCaretPositionStyle();
							}
                            
                        }
                    }
                }
            };

            scope.$watch('toggleFlag', function (val) {
                var moduleDiv = elem.parent()[0].querySelector('.awd-menu-list'),
                selectDiv = elem.parent()[0].querySelector('.awd-select-list');
                if (val) {
                    if(moduleDiv){
						
						var wrapperWidth = elem.parent()[0].querySelector('.awd-menu-list').outerWidth;
						
                        $timeout(function () {
							
                        var optionList = elem.parent()[0].querySelector('.awd-menu-list ul');
                        var h = (window.getComputedStyle(optionList).height).replace('px', '');
                        if(parseInt(h) >= 360){
                           angular.element(optionList).addClass('scrollblur') ;
                        }
                        $scrollToView.vertical(angular.element(moduleDiv), 40);

						var wrapperWidth = angular.element(elem.parent()[0].querySelector('.awd-menu-list'))[0].offsetWidth,
							left = moduleDiv.getBoundingClientRect().left,
							docWidth = $window.innerWidth,
							btnWidth = elem.parent()[0].offsetWidth;
							if (!(docWidth - left >= wrapperWidth)) {
								// when selector menu open out of viewport
								targetLeft = docWidth - left - wrapperWidth - 5;
								angular.element(elem.parent()[0].querySelector('.awd-menu-list')).parent().css({
									'left': targetLeft+'px'
								});
								scope.appendCaretPositionStyle(Math.abs(targetLeft));
							};
                    }, 300);
                    }
                    if(selectDiv){
                        $timeout(function () {
                            var optionList = selectDiv.querySelector('ul');
                            angular.element(optionList).css({'max-height':'320px'});
                            $scrollToView.vertical(angular.element(selectDiv), 40);
                        },300);
                    }

                }else{
                    if(moduleDiv){
                        $timeout(function () {
                            var optionList = elem.parent()[0].querySelector('.awd-menu-list ul');
                            var h = (window.getComputedStyle(optionList).height).replace('px', '');
                            angular.element(optionList).removeClass('scrollblur') ;
							angular.element(moduleDiv).parent().removeAttr('style');
                        }, 300);
                    }
                }
            });            
            var move = function (currentIndex, step) {
                if (angular.isDefined(scope.dropdownListValues[currentIndex + step])) {
                    if (!scope.dropdownLists[scope.dropdownListValues[currentIndex + step]][3]) {
                        scope.dropdownLists[scope.dropdownListValues[currentIndex + step]][0].updateDropdownValue();
                    } else {
                        move(currentIndex + step, step);
                    }
                } else {
                    angular.noop();
                }
            };

            elem.bind('keydown', function (ev) {
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                }
                if (!scope.toggleFlag) {
                    if (ev.keyCode) {
                        var currentIndex = scope.currentSelected.index;
                        if (ev.altKey === true && ev.keyCode === keymap.KEY.DOWN) {
                            scope.toggleDropdown(true);
                            ev.preventDefault();
                            ev.stopPropagation();
                        } else if (ddhDropdownConfig.prev.split(',').indexOf(ev.keyCode.toString()) > -1) {
                            move(currentIndex, -1);
                            ev.preventDefault();
                            ev.stopPropagation();
                        } else if (ddhDropdownConfig.next.split(',').indexOf(ev.keyCode.toString()) > -1) {
                            move(currentIndex, 1);
                            ev.preventDefault();
                            ev.stopPropagation();
                        } else if (ev.keyCode >= 48 && ev.keyCode <= 105) {
                            startTimer(ddhUtilitiesConfig.searchTimer);
                            searchString = searchString + (keymap.MAP[ev.keyCode] || '');
                            var position = searchElement(searchString);
                            angular.isDefined(scope.dropdownListValues[position]) ? scope.dropdownLists[scope.dropdownListValues[position]][0].updateDropdownValue() : angular.noop();
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                    }
                } else {
                    if (ev.altKey === true && ev.keyCode === keymap.KEY.UP) {
                        scope.toggleDropdown(false);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (ev.keyCode === keymap.KEY.TAB || ev.keyCode === keymap.KEY.ESC) {
                        scope.toggleDropdown(false);
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                }
                scope.$apply();
            });
            var outsideClick = function (e) {
                var isElement = $isElement(angular.element(e.target), elem.parent(), $document);
                if (e.target.tagName === 'LABEL' && e.target.getAttribute('for') === scope.dropdownId) { 
                    isElement = true;
                }
                if (!isElement) {
                    scope.toggleDropdown(false);
                    scope.$apply();
                }
            };
            $documentBind.click('toggleFlag', outsideClick, scope);
        }
    };
}])

.directive("ddhDropdownGroup", ['$compile', '$templateCache', 'userAgent', function ($compile, $templateCache, userAgent) {
    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            if ((scope.isInputDropdown && userAgent.notMobile()) || (!scope.isInputDropdown)) {
                var innerHtml = angular.element('<div></div>').append(elem.html());
                innerHtml = ($compile(innerHtml)(scope)).html();
                var template = angular.element($templateCache.get('template/dropdowns/ddhDropdownGroupDesktop.html'));
                template.attr('ng-repeat', attr.optGroupRepeat);
                template.attr('label', elem.attr('label'));
                template.find('ul').append(innerHtml);
                elem.replaceWith(template);
            } else if (scope.isInputDropdown && userAgent.isMobile()) {
                if (attr.optGroupRepeat) {
                    var template = angular.element(elem.prop('outerHTML'));
                    template.attr('ng-repeat', attr.optGroupRepeat);
                    template.removeAttr('ddh-dropdown-group');
                    template.removeAttr('opt-group-repeat');
                    template = $compile(template)(scope);
                    elem.replaceWith(template);
                }
            }
        }]
    };
}])

.directive("ddhDropdownGroupDesktop", [function () {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, elem, attr, ctrl) {
            scope.groupHeader = attr.label;
        }
    };
}])

.directive("ddhDropdownList", ['$compile', '$templateCache', 'userAgent', function ($compile, $templateCache, userAgent) {
    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            if ((scope.isInputDropdown && userAgent.notMobile()) || (!scope.isInputDropdown)) {
                var innerHtml = angular.element('<div></div>').append(elem.html());
                innerHtml = ($compile(innerHtml)(scope)).html();
                var template = angular.element($templateCache.get('template/dropdowns/ddhDropdownListDesktop.html'));
                template.attr('ng-repeat', attr.optionRepeat);
                template.attr('value', elem.attr('value'));
                template.attr('search-key', scope.searchByValue ? elem.attr('value') : elem.text());
                if (elem.attr('aria-describedby')) {
                    template.attr('aria-describedby', attr.ariaDescribedby);
                }

                if (elem.attr('ng-disabled')) {
                    template.attr('ng-disabled', elem.attr('ng-disabled'));
                }

                if (elem.attr('imgsrc')) {
                    if (elem.attr('imgalt')) {
                        template.append('<img role="presentation" ng-src="' + elem.attr('imgsrc') + '" alt="' + elem.attr('imgalt') + '"/>');
                    } else {
                        template.append('<img role="presentation" ng-src="' + elem.attr('imgsrc') + '" alt=""/>');
                    }
                }
                template.append(innerHtml);
                elem.replaceWith(template);
            } else if (scope.isInputDropdown && userAgent.isMobile()) {
                if (attr.optionRepeat) {
                    var template = angular.element(elem.prop('outerHTML'));
                    template.attr('ng-repeat', attr.optionRepeat);
                    if (elem.attr('aria-describedby')) {
                        template.attr('aria-describedby', attr.ariaDescribedby);
                    }
                    template.removeAttr('ddh-dropdown-list');
                    template.removeAttr('option-repeat');
                    template = $compile(template)(scope);
                    elem.replaceWith(template);
                }
            }
        }]
    };
}])

.directive("ddhDropdownListDesktop", ['$sce', 'keymap', 'ddhDropdownConfig', function ($sce, keymap, ddhDropdownConfig) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, elem, attr, ctrl) {
            var dropdownListValue = scope.dropdownListValue = attr.value;
            scope.dropdown.totalIndex++;
            var dropdownListIndex = scope.dropdown.totalIndex;
            scope.disabled = false;
            scope.dropdownListValues.push(dropdownListValue);
            scope.dropdownListSearchValues.push(attr.searchKey);
            scope.dropdownLists[dropdownListValue] = [];
            scope.dropdownLists[dropdownListValue][0] = scope;
            scope.dropdownLists[dropdownListValue][1] = elem;
            scope.dropdownLists[dropdownListValue][2] = dropdownListIndex;
            scope.dropdownLists[dropdownListValue][3] = scope.disabled;
            scope.updateDropdownValue = function () {
                if (!scope.disabled) {
                    scope.currentSelected.value = dropdownListValue;
                    if (scope.isInputDropdown) {
                        scope.currentSelected.text = elem.text();
                    } else if ((scope.dropdownType === ddhDropdownConfig.linkMenuKeyword) || (scope.dropdownType === ddhDropdownConfig.menuKeyword && scope.dropdownSize === ddhDropdownConfig.smallKeyword)) {
                        scope.currentSelected.text = dropdownListValue;
                    } else if (scope.dropdownType === ddhDropdownConfig.menuKeyword || scope.dropdownType === ddhDropdownConfig.menuDropdownKeyword) {
                        scope.currentSelected.text = $sce.trustAsHtml(elem.html());
                    }
                    if (scope.isInputDropdown) {
                        scope.currentSelected.label = elem.text();
                    } else if (scope.dropdownType === ddhDropdownConfig.linkMenuKeyword) {
                        scope.currentSelected.label = dropdownListValue;
                    } else if (scope.dropdownType === ddhDropdownConfig.menuKeyword || scope.dropdownType === ddhDropdownConfig.menuDropdownKeyword) {
                        scope.currentSelected.label = elem.text();
                    }
                    scope.currentSelected.index = getDropdownListIndex();
                    scope.updateModel();
                }
            };
            scope.selectDropdownItem = function () {
                if (!scope.disabled) {
                    scope.setDirty();
                    scope.updateDropdownValue();
                    scope.toggleDropdown(false);
                }
            };
            scope.highlightDropdown = function () {
                scope.dropdown.highlightedValue = dropdownListValue;
            };
            var getDropdownListIndex = function () {
                return scope.dropdownListValues.indexOf(dropdownListValue);
            };
            elem.bind('mouseover', function (ev) {
                elem[0].focus();
            });
            elem.bind('keydown', function (ev) {
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                } 
                if (ev.keyCode === keymap.KEY.ESC || (ev.altKey === true && ev.keyCode === keymap.KEY.UP) ) {
                    scope.toggleDropdown(false);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                scope.$apply();
            });
            
            scope.$parent.$watch(attr.ngDisabled, function (val) {
                scope.disabled = val;
                scope.dropdownLists[dropdownListValue][3] = scope.disabled;
            });
            
            scope.$on('$destroy', function () {
                scope.dropdownListValues.splice(getDropdownListIndex(), 1);
                scope.dropdownListSearchValues.splice(getDropdownListIndex(), 1);
                delete scope.dropdownLists[dropdownListValue];
            });
        }
    };
}])

.directive("ddhDropdownRepeat", ['$compile', 'userAgent', function ($compile, userAgent) {
    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            if ((scope.isInputDropdown && userAgent.notMobile()) || (!scope.isInputDropdown)) {
                var innerHtml = angular.element('<div></div>').append(elem.html());
                innerHtml = ($compile(innerHtml)(scope)).html();
                var template = angular.element('<div></div>');
                template.attr('ng-repeat', attr.ddhDropdownRepeat);
                template.append(innerHtml);
                elem.replaceWith(template);
            } else if (scope.isInputDropdown && userAgent.isMobile()) {
                angular.noop();
            }
        }]
    };
}])

.directive("ddhDropdownValidation", ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            $timeout(function () {
                scope.setNgModelController(attr.name, ctrl);
            }, 100);
            scope.setDirty = function () {
                if (ctrl.$dirty === false) {
                    ctrl.$dirty = true;
                    ctrl.$pristine = false;
                }
            };
            scope.setTouched = function () {
                ctrl.$touched2 = true;
                ctrl.$pristine = false;
            };
            scope.setRequired = function (flag) {
                ctrl.$setValidity('required2', flag);
            };
        }
    };
}])

.directive('ddhDropdownOptionalCta', [function () {
    return {
        restrict: 'EA',
        transclude: true,
        replace: true,
        template: '',
        compile: function (elem, attr, transclude) {
            return function link(scope, elem, attr, ctrl) {
                if (scope.setOptionalCta) {
                    scope.setOptionalCta(transclude(scope, function () {}));
                }
                elem.remove();
            };
        }
    };
}]).directive('ddhCtaFocus', ['keymap', '$timeout', function (keymap, $timeout) {
    return {
        restrict: 'A',
        link: function (scope,elem) {
            scope.onFocus  = function(){
				$timeout(function(){
					elem[0].querySelector('a').focus();
				}, 200);                
            };
            elem.bind('keydown', function (ev) {
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                }
                if (scope.toggleFlag) {
                    if (ev.keyCode === keymap.KEY.TAB || ev.keyCode === keymap.KEY.ESC) {
                        scope.toggleDropdown(false);
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                }
                scope.$apply();
            });
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Forms.att:addressInput
 *
 * @description
 *  <file src="src/addressInput/docs/readme.md" />
 *
 * @usage
 *      <!-- See below examples for address Input implementation -->
 *
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/addressInput/docs/demo.html" />
 <file src="src/addressInput/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.addressInput', ['ddh.att.dropdowns','ddh.att.utilities'])
.directive('errorMsg', function() {
  return {
    restrict: 'C',

    link: function (scope, element, attrs, ctrl) {
    	var errorIcon = angular.element('<i class="icon-badgealert" aria-hidden="true"></i>');
    	element.prepend(errorIcon);
    }
  };
});
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:arrows
 *
 * @description
 *  <file src="src/arrows/docs/readme.md" />
 *
 * @usage
 *   Please refer demo.html tab in Example section below.
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/arrows/docs/demo.html" />
            <file src="src/arrows/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.arrows', ['ddh.att.utilities']);
/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:badgesForAlerts
 *
 * @description
 *  <file src="src/badgesForAlerts/docs/readme.md" />
 *
 * @usage
 *  Single digit badge
    <a href="javascript:void(0);"><span class="badge badge-urgent">2</span>Alerts</a>
    Double digit badge
    <a href="javascript:void(0);"><span class="badge badge-urgent">10</span>Alerts</a>
    Maximum digit (99+) badge
    <a href="javascript:void(0);"><span class="badge badge-urgent">+99</span>Alerts</a>
    Showing zero alerts
    <a href="javascript:void(0);"><span class="badge">0</span>Alerts</a>
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/badgesForAlerts/docs/demo.html" />
            <file src="src/badgesForAlerts/docs/demo.js" />
       </example>
        </section>
 *
 */
angular.module('ddh.att.badgesForAlerts', []);
/**
 * @ngdoc directive
 * @name Navigation.att:bellybandLinks
 *
 * @description
 *  <file src="src/bellybandLinks/docs/readme.md" />
 *
 * @usage
 *   <div class="bellyband-container autoSize" bellyband-autosize-what=".bellyband-link">
            <div class="bellyband-group span12 span6-sm span12-xsm">
                <div class="span4 span12-sm bellyband-link">
                    <a href="patterns.html">
                        <i class="icon-misc-puzzleL visible-desktop"></i>
                        <i class="icon-misc-puzzle hidden-desktop"></i>
                        <div>
                            <span>Pattern library</span>
                            <p class="hidden-phone">Review our digital design standards and patterns for creating AT&amp;T digital assets. </p>
                        </div>
                    </a>
                </div>
                <div class="span4 span12-sm bellyband-link">
                    <a href="support-development-overview.html">
                        <i class="icon-datanetwork-cloudL visible-desktop"></i>
                        <i class="icon-datanetwork-cloud hidden-desktop"></i>
                        <div>
                            <span>Development overview</span>
                            <p class="hidden-phone">Set up your environment, access the code snippets, and follow our standards for creating a digital code base.</p>
                        </div>
                    </a>
                </div>
                <div class="span4 span12-sm bellyband-link">
                    <a href="getstarted-design-principles.html">
                        <i class="icon-misc-bulbL visible-desktop"></i>
                        <i class="icon-misc-bulb hidden-desktop"></i>
                        <div>
                            <span>Design principles</span>
                            <p class="hidden-phone">Great design is built on an even greater foundation. Learn the ins and outs of our design philosophy.</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
 
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/bellybandLinks/docs/demo.html" />
 <file src="src/bellybandLinks/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.bellybandLinks', [])
        .directive('bellybandAutosizeWhat', ['$window', function($window) {
                return {
                    restrict: 'EA',
                    link: function(scope, ele, attr) {
                        var bellyBandGroupElement;
                        var sizeWhat = attr.bellybandAutosizeWhat;
                        var haveBellybandGgroupClass = ele.hasClass('bellyband-group');

                        if (haveBellybandGgroupClass) {
                            bellyBandGroupElement = ele[0];
                        }
                        else {
                            bellyBandGroupElement = ele[0].querySelectorAll('.bellyband-group');
                        }

                        var bellyBandCssCalculation = function() {
                            angular.forEach(ele[0].querySelectorAll('.bellyband-link'), function(value, key) {
                                var newElement = angular.element(value);
                                if ($window.innerWidth <= '479') {
                                    newElement.removeAttr('style');
                                    angular.element(bellyBandGroupElement).removeAttr('style');
                                }
                                if ($window.innerWidth > '479' && $window.innerWidth < '768') {

                                    var lnkHeight = getComputedStyle(value, null).height.split("px");

                                    lnkMar = getComputedStyle(value, null).marginBottom.split("px");

                                    var bblink;

                                    if (ele[0].querySelectorAll('.bellyband-link').length === 2) {
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 1) + 'px';
                                    }

                                    else if ((ele[0].querySelectorAll('.bellyband-link').length === 3) || (ele[0].querySelectorAll('.bellyband-link').length === 4)){
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 2) + 'px';
                                    }

                                    else if (ele[0].querySelectorAll('.bellyband-link').length >= 5) {
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 3) + 'px';
                                    }

                                    angular.element(bellyBandGroupElement).css({
                                        'max-height': bblink
                                    });

                                } else if ($window.innerWidth >= '768') {
                                    
                                   for(var i = 0;i<angular.element(bellyBandGroupElement).length;i++){
                                       
                                        angular.element(bellyBandGroupElement[i]).css({
                                        'max-height': 'inherit'
                                    });
                                       
                                   }
                                    if (angular.element(bellyBandGroupElement).length && angular.element(bellyBandGroupElement)[0].querySelectorAll('.bellyband-link').length === 6) {
                                        newElement.css(
                                                {'flex': '1 1 0'}
                                        );
                                    }
                                }
                            });
                        };

                        function tallestSize() {

                            var maxInnerHeight = -1;
                            angular.forEach(ele[0].querySelectorAll(sizeWhat), function(value, key) {
                                if (maxInnerHeight < value.clientHeight) {
                                    maxInnerHeight = value.clientHeight;
                                }
                            });
                            return maxInnerHeight;
                        }
                        var setautoSize = function() {
                            var autoSize2 = tallestSize() + "px";
                            angular.forEach(ele[0].querySelectorAll('.autoSize .bellyband-link'), function(value, key) {
                                var newElement = angular.element(value);
                                newElement.css({
                                    'height': autoSize2
                                });
                            });
                        };
                        // setautoSize();
                        bellyBandCssCalculation();

                        angular.element($window).bind('resize', function() {
                            angular.element(ele[0].querySelectorAll('.bellyband-link')).removeAttr('style');
                            // setautoSize();
                            bellyBandCssCalculation();
                        });
                    }
                };
            }]);
/**
 * @ngdoc directive
 * @name Headings & copy.att:Body Copy
 *
 * @description
 *  <file src="src/bodyCopy/docs/readme.md" />
 * @usage
 *      <!-- See below examples for link implementation -->
 *      
 * @example
       <section id="code">              
           <b>HTML + AngularJS</b>
           <example module="ddh.att">
           <file src="src/bodyCopy/docs/demo.html" />
            <file src="src/bodyCopy/docs/demo.js" />            
          </example>          
        </section>
 */
angular.module('ddh.att.bodyCopy', []);
/**
 * @ngdoc directive
 * @name Navigation.att:breadcrumbs
 *
 * @description
 *  <file src="src/breadcrumbs/docs/readme.md" />
 * @usage
    <div ddh-breadcrumb link-obj="obj"></div>
 * @example
 <example module="ddh.att">
 <file src="src/breadcrumbs/docs/demo.html" />
 <file src="src/breadcrumbs/docs/demo.js" />
 </example>
 */
angular.module('ddh.att.breadcrumbs',[])
        .directive('ddhBreadcrumb',function(){
            return{
                restrict:'A',
                templateUrl:'template/breadcrumbs/breadcrumbs.html',
                scope: {
                    linkObj: "="
                }
            };
});
/**
 * @ngdoc directive
 * @name Headings & copy.att:bulletedList
 *
 * @description
 *  <file src="src/bulletedList/docs/readme.md" />
 * @usage
 *      <!-- See below examples for link implementation -->
 *      
 * @example
       <section id="code">              
           <b>HTML + AngularJS</b>
           <example module="ddh.att">
           <file src="src/bulletedList/docs/demo.html" />
            <file src="src/bulletedList/docs/demo.js" />            
          </example>          
        </section>
 */
angular.module('ddh.att.bulletedList', []);
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:buttons
 * @element input
 * @function
 *
 * @description
 *  <file src="src/buttons/docs/readme.md" />
 * @usage
 *
Button shape
<button class="btn" type="button">Button</button> button.btn (button shape only)
<button aria-label="Custom aria label" class="btn" type="button">Button</button> button.btn (button shape only) with custom aria label
<button aria-label="Click on button/Press enter" class="btn" type="button" onclick="javascript:alert('It works!');">Click on button/Press enter</button> button.btn with click functionality
<a ddh-keyup-click="32" href="javascript:void(0)" class="btn" role="button">Button</a> a.btn (button shape only)
<button class="btn btn-primary">Button</button> .btn-primary
<a ddh-keyup-click="32" href="javascript:void(0)" class="btn btn-primary" role="button">Button</a> a.btn-primary

5 Button colors
<button class="btn btn-secondary">Button</button> .btn-secondary
<a ddh-keyup-click="32" href="javascript:void(0)" class="btn btn-secondary" role="button">Button</a> a.btn-secondary
<button class="btn btn-alt">Button</button> .btn-alt
<a ddh-keyup-click="32" href="javascript:void(0)" class="btn btn-alt" role="button">Button</a> a.btn-alt
<button class="btn btn-specialty">Button</button> .btn-specialty
<a ddh-keyup-click="32" href="javascript:void(0)" class="btn btn-specialty" role="button">Button</a> a.btn-specialty
<button class="btn btn-specialty" disabled="">Button</button> disabled="disabled"
<a ddh-keyup-click="32" aria-disabled="true" href="javascript:void(0)" class="btn btn-primary disabled" role="button">Button</a> a.disabled

3 button heights
<button class="btn btn-secondary">Button</button> .btn is default and 46px height
<button class="btn btn-secondary btn-medium">Button</button> .btn-medium is 42px
<button class="btn btn-secondary btn-small">Button</button> .btn-small is 36px

.row-nowrap 2 up buttons
<div class="row-nowrap">
    <button class="btn btn-secondary btn-fullwidth" type="button">Cancel</button>
    <button class="btn btn-primary btn-fullwidth" type="button">Continue</button>
</div>

.row 2 up buttons (desktop) stacked (mobile) (different order)
<div class="row cta-button-group">
    <button class="span btn btn-secondary btn-fullwidth hidden-phone" type="button">Cancel</button>
    <button class="span btn btn-primary btn-fullwidth" type="button">Continue</button>
    <button class="span btn btn-secondary btn-fullwidth visible-phone" type="button">Cancel</button>
</div>

 * @example
 *  <section id="code">
               <b>HTML + AngularJS</b>
 *             	<example module="ddh.att">
 *  	        <file src="src/buttons/docs/demo.html" />
                 <file src="src/buttons/docs/demo.js" />
 *              </example>
            </section>
 *
 */
angular.module('ddh.att.buttons', ['ddh.att.utilities']);
angular.module('ddh.att.lazyLoad', [])

.constant('ddhLazyLoadConfig', {
    lazyLoad: true,
    lazyLoadCss: {
        'accordion': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-accordion.min.css',
        'calendar': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-bootstrap-datepicker.min.css',
        'creditCard': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-cc-input-field.min.css',
        'filmstrip': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-filmstrip.min.css',
        'filter': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-filters.css',
        'marquee': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-marquee.min.css',
        'pagination': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-pagination.min.css',
        'progressBar': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-progressbar.min.css',
        'tooltip': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-tooltip.min.css',
        'stepIndicator': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-step-indicator.min.css',
        'modal': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/ds2-modal.min.css',
        'icon-arrows': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-arrows.css',
        'icon-building': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-buildings.css',
        'icon-content': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-content.css',
        'icon-controls': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-controls.css',
        'icon-datanetwork': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-datanetwork.css',
        'icon-devices': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-devices.css',
        'icon-documents': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-documents.css',
        'icon-healthcare': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-healthcare.css',
        'icon-location': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-location.css',
        'icon-misc': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-misc.css',
        'icon-numslets': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-numslets.css',
        'icon-people': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-people.css',
        'icon-retail': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-retail.css',
        'icon-securityalerts': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-securityalerts.css',
        'icon-social': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-social.css',
        'icon-bubble': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-speechbubbles.css',
        'icon-trans': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-transportation.css',
        'icon-weather': '/ui/frameworks/rwd/2017.07/styles/2.2.0/css/icon-weather.css'
    },
    lazyLoadCache: []
})

.factory('ddhLazyLoad', ['ddhLazyLoadConfig', function (ddhLazyLoadConfig) {
    var _js = function (url) {
        var fileScript = document.createElement('script');
        fileScript.setAttribute('type', 'text/javascript');
        fileScript.setAttribute('src', url);
        if (typeof fileScript !== 'undefined') {
            document.getElementsByTagName('head')[0].appendChild(fileScript);
        }
    };
    var _css = function (url) {
        var fileScript = document.createElement('link');
        fileScript.setAttribute('rel', 'stylesheet');
        fileScript.setAttribute('type', 'text/css');
        fileScript.setAttribute('href', url);
        if (typeof fileScript !== 'undefined') {
            document.getElementsByTagName('head')[0].appendChild(fileScript);
        }
    };
    var _getLoader = function (type) {
        if (type === 'js') {
            return require ? require : _js;
        } else if (type === 'css') {
            return _css;
        }
    };
    var _load = function (urlKey, type) {
        if (ddhLazyLoadConfig.lazyLoad && ddhLazyLoadConfig.lazyLoadCache.indexOf(urlKey) === -1) {
            _getLoader(type)(ddhLazyLoadConfig.lazyLoadCss[urlKey]);
            ddhLazyLoadConfig.lazyLoadCache.push(urlKey);
            return true;
        } else {
            return false;
        }
    };
    var _clearLazyLoadCache = function () {
        ddhLazyLoadConfig.lazyLoadCache = [];
    };

    return {
        load: _load,
        clearLazyLoadCache: _clearLazyLoadCache
    };
}])

.run(['$rootScope', 'ddhLazyLoad', '$timeout', function ($rootScope, ddhLazyLoad, $timeout) {
    $rootScope.$on("$routeChangeSuccess", function () {
        $timeout(function () {
            if (document.querySelectorAll('[class*="icon-social-"]').length > 0) {
                ddhLazyLoad.load('icon-social', 'css');
            }
            if (document.querySelectorAll('[class*="icon-arrows-"]').length > 0) {
                ddhLazyLoad.load('icon-arrows', 'css');
            }
            if (document.querySelectorAll('[class*="icon-building-"]').length > 0) {
                ddhLazyLoad.load('icon-building', 'css');
            }
            if (document.querySelectorAll('[class*="icon-content-"]').length > 0) {
                ddhLazyLoad.load('icon-content', 'css');
            }
            if (document.querySelectorAll('[class*="icon-controls-"]').length > 0) {
                ddhLazyLoad.load('icon-controls', 'css');
            }
            if (document.querySelectorAll('[class*="icon-datanetwork-"]').length > 0) {
                ddhLazyLoad.load('icon-datanetwork', 'css');
            }
            if (document.querySelectorAll('[class*="icon-devices-"]').length > 0) {
                ddhLazyLoad.load('icon-devices', 'css');
            }
            if (document.querySelectorAll('[class*="icon-documents-"]').length > 0) {
                ddhLazyLoad.load('icon-documents', 'css');
            }
            if (document.querySelectorAll('[class*="icon-healthcare-"]').length > 0) {
                ddhLazyLoad.load('icon-healthcare', 'css');
            }
            if (document.querySelectorAll('[class*="icon-location-"]').length > 0) {
                ddhLazyLoad.load('icon-location', 'css');
            }
            if (document.querySelectorAll('[class*="icon-misc-"]').length > 0) {
                ddhLazyLoad.load('icon-misc', 'css');
            }
            if (document.querySelectorAll('[class*="icon-numslets-"]').length > 0) {
                ddhLazyLoad.load('icon-numslets', 'css');
            }
            if (document.querySelectorAll('[class*="icon-people-"]').length > 0) {
                ddhLazyLoad.load('icon-people', 'css');
            }
            if (document.querySelectorAll('[class*="icon-retail-"]').length > 0) {
                ddhLazyLoad.load('icon-retail', 'css');
            }
            if (document.querySelectorAll('[class*="icon-securityalerts-"]').length > 0) {
                ddhLazyLoad.load('icon-securityalerts', 'css');
            }
            if (document.querySelectorAll('[class*="icon-bubble-"]').length > 0) {
                ddhLazyLoad.load('icon-bubble', 'css');
            }
            if (document.querySelectorAll('[class*="icon-trans-"]').length > 0) {
                ddhLazyLoad.load('icon-trans', 'css');
            }
            if (document.querySelectorAll('[class*="icon-weather-"]').length > 0) {
                ddhLazyLoad.load('icon-weather', 'css');
            }
            if (document.querySelectorAll('[class*="modalwrapper"]').length > 0) { // for Loader Animation
                ddhLazyLoad.load('modal', 'css');
            }
        }, 100);
    });
}]);

/**
 * @ngdoc directive
 * @name Forms.att:calendar
 *
 * @description
 *  <file src="src/calendar/docs/readme.md" />
 * @usage
 *  <input type="text" ng-model="dt" ddh-datepicker>
 *
 * @example
   <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
     <file src="src/calendar/docs/demo.html" />
     <file src="src/calendar/docs/demo.js" />
    </example>
   </section>
 */
angular.module('ddh.att.calendar', ['ddh.att.position', 'ddh.att.utilities', 'ddh.att.lazyLoad', 'ddh.att.transition'])
.constant('ddhDatepickerConfig', {
    dateFormat: 'MM/dd/yyyy',
    dayFormat: 'd',
    monthFormat: 'MMMM',
    yearFormat: 'yyyy',
    dayHeaderFormat: 'EEEE',
    dayTitleFormat: 'MMMM yyyy',
    disableWeekend: false,
    disableSunday: false,
    disableDates: null,
    onSelectClose: null,
    startingDay: 0,
    minDate: null,
    maxDate: null,
    dueDate: null,
    fromDate: null,
    calendarDisabled: false,
    collapseWait: 0,
    range: null,
    datepickerLabel: 'Calendar',
    orientation: 'left',
    inline: false,
    helperText: 'The date you selected is $date. Activate to open calendar and select a date to close.',
    datepickerEvalAttributes: ['dateFormat', 'dayFormat', 'monthFormat', 'yearFormat', 'dayHeaderFormat', 'dayTitleFormat', 'disableWeekend', 'disableSunday', 'startingDay', 'collapseWait', 'orientation', 'range', 'datepickerLabel'],
    datepickerWatchAttributes: ['min', 'max', 'due', 'from', 'ngDisabled'],
    datepickerFunctionAttributes: ['disableDates', 'onSelectClose']
})

.factory('ddhDatepickerService', ['ddhDatepickerConfig', 'dateFilter', function (ddhDatepickerConfig, dateFilter) {
    var setAttributes = function (attr, elem) {
        if (angular.isDefined(attr) && attr !== null && angular.isDefined(elem) && elem !== null) {
            var attributes = ddhDatepickerConfig.datepickerEvalAttributes.concat(ddhDatepickerConfig.datepickerWatchAttributes, ddhDatepickerConfig.datepickerFunctionAttributes);
            for (var key in attr) {
                var val = attr[key];
                if (attributes.indexOf(key) !== -1 && angular.isDefined(val)) {
                    elem.attr(key.toSnakeCase(), key);
                }
            }
        }
    };

    var bindScope = function (attr, scope) {
        if (angular.isDefined(attr) && attr !== null && angular.isDefined(scope) && scope !== null) {
            var evalFunction = function (key, val) {
                scope[key] = scope.$parent.$eval(val);
            };

            var watchFunction = function (key, val) {
                scope.$parent.$watch(val, function (value) {
                    scope[key] = value;
                });
                scope.$watch(key, function (value) {
                    scope.$parent[val] = value;
                });
            };

            var evalAttributes = ddhDatepickerConfig.datepickerEvalAttributes;
            var watchAttributes = ddhDatepickerConfig.datepickerWatchAttributes;
            for (var key in attr) {
                var val = attr[key];
                if (evalAttributes.indexOf(key) !== -1 && angular.isDefined(val)) {
                    evalFunction(key, val);
                } else if (watchAttributes.indexOf(key) !== -1 && angular.isDefined(val)) {
                    watchFunction(key, val);
                }
            }
        }
    };

    return {
        setAttributes: setAttributes,
        bindScope: bindScope
    };
}])

.controller('ddhDatepickerController', ['$scope', '$attrs', 'dateFilter', '$element', '$position', 'ddhDatepickerConfig', function ($scope, $attrs, dateFilter, $element, $position, dtConfig) {
    var format = {
            date: getValue($attrs.dateFormat, dtConfig.dateFormat),
            day: getValue($attrs.dayFormat, dtConfig.dayFormat),
            month: getValue($attrs.monthFormat, dtConfig.monthFormat),
            year: getValue($attrs.yearFormat, dtConfig.yearFormat),
            dayHeader: getValue($attrs.dayHeaderFormat, dtConfig.dayHeaderFormat),
            dayTitle: getValue($attrs.dayTitleFormat, dtConfig.dayTitleFormat),
            disableWeekend: getValue($attrs.disableWeekend, dtConfig.disableWeekend),
            disableSunday: getValue($attrs.disableSunday, dtConfig.disableSunday),
            disableDates: getValue($attrs.disableDates, dtConfig.disableDates)
        },
        startingDay = getValue($attrs.startingDay, dtConfig.startingDay);

    $scope.minDate = dtConfig.minDate ? $scope.resetTime(dtConfig.minDate) : null;
    $scope.maxDate = dtConfig.maxDate ? $scope.resetTime(dtConfig.maxDate) : null;
    $scope.dueDate = dtConfig.dueDate ? $scope.resetTime(dtConfig.dueDate) : null;
    $scope.fromDate = dtConfig.fromDate ? $scope.resetTime(dtConfig.fromDate) : null;
    $scope.ngDisabled = dtConfig.calendarDisabled ? dtConfig.calendarDisabled : null;
    $scope.collapseWait = getValue($attrs.collapseWait, dtConfig.collapseWait);
    $scope.range = getValue($attrs.range, dtConfig.range);
    $scope.datepickerLabel = getValue($attrs.datepickerLabel, dtConfig.datepickerLabel);
    $scope.orientation = getValue($attrs.orientation, dtConfig.orientation);
    $scope.onSelectClose = getValue($attrs.onSelectClose, dtConfig.onSelectClose);

    $scope.inline = $attrs.inline === 'true' ? true : dtConfig.inline;

    function getValue(value, defaultValue) {
        return angular.isDefined(value) ? $scope.$parent.$eval(value) : defaultValue;
    }

    function getDaysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }

    function getDates(startDate, n) {
        var dates = new Array(n);
        var current = startDate,
            i = 0;
        while (i < n) {
            dates[i++] = new Date(current);
            current.setDate(current.getDate() + 1);
        }
        return dates;
    }

    this.updatePosition = function (ddhDatepickerPopupTemplate) {
        $scope.position = $position.offset($element);
        $scope.position.top = $scope.position.top + $element.find('input').prop('offsetHeight');
        if ($scope.orientation === 'right') {
            $scope.position.left = $scope.position.left - (((ddhDatepickerPopupTemplate && ddhDatepickerPopupTemplate.prop('offsetWidth')) || 290) - $element.find('input').prop('offsetWidth'));
        }
    };

    function isSelected(dt) {
        if (dt && angular.isDate($scope.currentDate) && compare(dt, $scope.currentDate) === 0) {
            return true;
        }
        return false;
    }

    function isFromDate(dt) {
        if (dt && angular.isDate($scope.fromDate) && compare(dt, $scope.fromDate) === 0) {
            return true;
        }
        return false;
    }

    function isDateRange(dt) {
        if (dt && $scope.fromDate && angular.isDate($scope.currentDate) && (compare(dt, $scope.fromDate) >= 0) && (compare(dt, $scope.currentDate) <= 0)) {
            return true;
        }
        return false;
    }

    function isOld(date, currentMonthDate) {
        if (date && currentMonthDate && (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime() < new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), 1, 0, 0, 0).getTime())) {
            return true;
        } else {
            return false;
        }
    }

    function isNew(date, currentMonthDate) {
        if (date && currentMonthDate && (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime() > new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), 1, 0, 0, 0).getTime())) {
            return true;
        } else {
            return false;
        }
    }

    function isPastDue(dt) {
        if ($scope.dueDate) {
            return (dt > $scope.dueDate);
        }
        return false;
    }

    function isDueDate(dt) {
        if ($scope.dueDate) {
            return (dt.getTime() === $scope.dueDate.getTime());
        }
        return false;
    }

    var isDisabled = function (date, currentMonthDate) {
        if ($attrs.from && !angular.isDate($scope.fromDate)) {
            return true;
        }
        if (format.disableWeekend === true && (dateFilter(date, format.dayHeader) === "Saturday" || dateFilter(date, format.dayHeader) === "Sunday")) {
            return true;
        }
        if (format.disableSunday === true && (dateFilter(date, format.dayHeader) === "Sunday")) {
            return true;
        }
        if (isOld(date, currentMonthDate) || isNew(date, currentMonthDate)) {
            return true;
        }
        return (($scope.minDate && compare(date, $scope.minDate) < 0) || ($scope.maxDate && compare(date, $scope.maxDate) > 0) || (format.disableDates && format.disableDates({
            date: date
        })));
    };

    var compare = function (date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
    };

    function isMinDateAvailable(startDate, endDate) {
        if (($scope.minDate && $scope.minDate.getTime() >= startDate.getTime()) && ($scope.minDate.getTime() <= endDate.getTime())) {
            $scope.disablePrev = true;
            $scope.visibilityPrev = "hidden";
        } else {
            $scope.disablePrev = false;
            $scope.visibilityPrev = "visible";
        }
    }

    function isMaxDateAvailable(startDate, endDate) {
        if (($scope.maxDate && $scope.maxDate.getTime() >= startDate.getTime()) && ($scope.maxDate.getTime() <= endDate.getTime())) {
            $scope.disableNext = true;
            $scope.visibilityNext = "hidden";
        } else {
            $scope.disableNext = false;
            $scope.visibilityNext = "visible";
        }
    }

    function getLabel(label) {
        if (label) {
            var labelObj = {
                pre: label.substr(0, 1).toUpperCase(),
                post: label
            };
            return labelObj;
        }
        return;
    }

    function makeDate(date, dayFormat, dayHeaderFormat, isSelected, isFromDate, isDateRange, isOld, isNew, isDisabled, dueDate, pastDue) {
        return {
            date: date,
            label: dateFilter(date, dayFormat),
            header: dateFilter(date, dayHeaderFormat),
            selected: !!isSelected,
            fromDate: !!isFromDate,
            dateRange: !!isDateRange,
            oldMonth: !!isOld,
            nextMonth: !!isNew,
            disabled: !!isDisabled,
            dueDate: !!dueDate,
            pastDue: !!pastDue,
            focusable: !((isDisabled && !(isSelected || isDateRange)) || (isOld || isNew))
        };
    }

    this.modes = [
        {
            name: 'day',
            getVisibleDates: function (date) {
                var year = date.getFullYear(),
                    month = date.getMonth(),
                    firstDayOfMonth = new Date(year, month, 1),
                    lastDayOfMonth = new Date(year, month + 1, 0);
                var difference = startingDay - firstDayOfMonth.getDay(),
                    numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : -difference,
                    firstDate = new Date(firstDayOfMonth),
                    numDates = 0;

                if (numDisplayedFromPreviousMonth > 0) {
                    firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
                    numDates += numDisplayedFromPreviousMonth; // Previous
                }
                numDates += getDaysInMonth(year, month + 1); // Current
                numDates += (7 - numDates % 7) % 7; // Next

                var days = getDates(firstDate, numDates),
                    labels = new Array(7);
                for (var i = 0; i < numDates; i++) {
                    var dt = new Date(days[i]);
                    days[i] = makeDate(dt,
                        format.day,
                        format.dayHeader,
                        isSelected(dt),
                        isFromDate(dt),
                        isDateRange(dt),
                        isOld(dt, date),
                        isNew(dt, date),
                        isDisabled(dt, date),
                        isDueDate(dt),
                        isPastDue(dt));
                }
                for (var j = 0; j < 7; j++) {
                    labels[j] = getLabel(dateFilter(days[j].date, format.dayHeader));
                }
                isMinDateAvailable(firstDayOfMonth, lastDayOfMonth);
                isMaxDateAvailable(firstDayOfMonth, lastDayOfMonth);
                return {
                    objects: days,
                    title: dateFilter(date, format.dayTitle),
                    labels: labels
                };
            },
            split: 7,
            step: {
                months: 1
            }
        }
    ];
}])

.directive('ddhDatepickerPopup', ['$parse', '$log', '$timeout', '$document', '$documentBind', '$isElement', '$templateCache', '$compile', 'trapFocusInElement', '$position', '$window', '$scrollToView', '$scrollToHostElement', function ($parse, $log, $timeout, $document, $documentBind, $isElement, $templateCache, $compile, trapFocusInElement, $position, $window, $scrollToView, $scrollToHostElement) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        templateUrl: function (elem, attr) {
            if (attr.inline === 'true') {
                return 'template/calendar/datepicker-popup.html';
            } else {
                return 'template/calendar/datepicker.html';
            }
        },
        scope: {},
        require: ['ddhDatepickerPopup', 'ngModel', '?^ddhDatepickerGroup'],
        controller: 'ddhDatepickerController',
        link: function (scope, element, attrs, ctrls) {
            var datepickerCtrl = ctrls[0],
                ngModel = ctrls[1],
                ddhDatepickerGroupCtrl = ctrls[2];
            var ddhDatepickerPopupTemplate;

            if (!ngModel) {
                $log.error("ng-model is required.");
                return; // do nothing if no ng-model
            }

            // Configuration parameters
            var mode = 0,
                selected;
            scope.isOpen = false;

            scope.headers = [];
            scope.footers = [];
            scope.legendDue;
            scope.legendSelected;
            scope.legendDueSelected;

            if (ddhDatepickerGroupCtrl) {
                ddhDatepickerGroupCtrl.registerDatepickerScope(scope);
            }

            element.find('button').bind('click', function () {
                element.find('input')[0].click();
            });

            element.find('input').bind('click', function () {
                if (!scope.ngDisabled) {
                    scope.isOpen = !scope.isOpen;
                    toggleCalendar(scope.isOpen);
                    datepickerCtrl.updatePosition(ddhDatepickerPopupTemplate);
                    scope.$apply();
                }
            });

            var toggleCalendar = function (flag) {
                if (!scope.inline) {
                    if (flag) {
                        ddhDatepickerPopupTemplate = angular.element($templateCache.get('template/calendar/datepicker-popup.html'));
                        ddhDatepickerPopupTemplate = $compile(ddhDatepickerPopupTemplate)(scope);
                        $document.find('body').append(ddhDatepickerPopupTemplate);
                        ddhDatepickerPopupTemplate.bind('keydown', keyPress);
                        $timeout(function () {
                            if (modalContainer.length > 0){
                                var scrollTopParentElement;
                                if (modalContainer.hasClass('modal-docked')){
                                    scrollTopParentElement = angular.element(modalBodyContainer);
                                }
                                else {
                                    scrollTopParentElement = angular.element(modalContainer);
                                }
                                $scrollToHostElement(scrollTopParentElement, 0, element[0].offsetTop);
                            }
                            else {
                                $scrollToView.vertical(ddhDatepickerPopupTemplate);
                            }

                            scope.getFocus = true;
                            trapFocusInElement(flag, ddhDatepickerPopupTemplate);
                            scope.$apply();
                            $timeout(function () {
                                scope.getFocus = false;
                                scope.$apply();
                            }, 100);
                        });
                    } else {
                        ddhDatepickerPopupTemplate.unbind('keydown', keyPress);
                        ddhDatepickerPopupTemplate.remove();
                        element.find('button')[0].focus();
                        scope.getFocus = false;
                        trapFocusInElement(flag, ddhDatepickerPopupTemplate);
                    }
                }
            };

            var outsideClick = function (e) {
                var isElement = $isElement(angular.element(e.target), element, $document);
                var isDdhDatepickerPopupTemplate = $isElement(angular.element(e.target), ddhDatepickerPopupTemplate, $document);
                if (!(isElement || isDdhDatepickerPopupTemplate)) {
                    scope.isOpen = false;
                    toggleCalendar(scope.isOpen);
                    scope.$apply();
                }
            };

            scope.changeMonthOnArrow = function (ev) {
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                }

                if (ev.keyCode) {
                    if (ev.keyCode === 37 && this.dt.firstAvailableDate) {
                        if (!scope.disablePrev){
                            scope.move(-1);
                        
                            $timeout(function () {
                                var table = document.querySelectorAll('.datepicker');

                                table = table[table.length-1];

                                var tdList = table.querySelectorAll('table tbody tr:last-child td');
     
                                for (var i = tdList.length - 1; i >=0; i--){
                                    if (!angular.element(tdList[i]).hasClass('disabled')){
                                         angular.element(tdList[i])[0].focus();
                                         break;
                                    }
                                }

                            }, 100);
                        }

                    } else if (ev.keyCode === 39 && this.dt.lastAvailableDate) {
                        !scope.disableNext && scope.move(1);
                    } 
                }
            };

            var keyPress = function (ev) {
                if (!ev.keyCode) {
                    if (ev.which) {
                        ev.keyCode = ev.which;
                    } else if (ev.charCode) {
                        ev.keyCode = ev.charCode;
                    }
                }
                if (ev.keyCode) {
                    if (ev.keyCode === 27) {
                        scope.isOpen = false;
                        toggleCalendar(scope.isOpen);
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (ev.keyCode === 33) {
                        !scope.disablePrev && scope.move(-1);
                        $timeout(function () {
                            scope.getFocus = true;
                            scope.$apply();
                            $timeout(function () {
                                scope.getFocus = false;
                                scope.$apply();
                            }, 100);
                        });
                        ev.preventDefault();
                        ev.stopPropagation();
                    } else if (ev.keyCode === 34) {
                        !scope.disableNext && scope.move(1);
                        $timeout(function () {
                            scope.getFocus = true;
                            scope.$apply();
                            $timeout(function () {
                                scope.getFocus = false;
                                scope.$apply();
                            }, 100);
                        });
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    scope.$apply();
                }
            };

            $documentBind.click('isOpen', outsideClick, scope);

            var modalContainer = angular.element(document.querySelector('.modalwrapper'));
            var modalBodyContainer = angular.element(document.querySelector('.modal-body'));
            if (modalContainer.length > 0) {
                modalContainer.bind('scroll', function () {
                    if (ddhDatepickerPopupTemplate) {
                        datepickerCtrl.updatePosition(ddhDatepickerPopupTemplate);
                        scope.$apply();
                    }
                });
            }
            if (modalBodyContainer.length > 0) {
                modalBodyContainer.bind('scroll', function () {
                    if (ddhDatepickerPopupTemplate) {
                        datepickerCtrl.updatePosition(ddhDatepickerPopupTemplate);
                        var datepickerTextfield = $position.offset(element.find('input'));
                        var modalBodyPosition = $position.offset(modalBodyContainer);

                        if (((datepickerTextfield.top + datepickerTextfield.height) < modalBodyPosition.top || datepickerTextfield.top > (modalBodyPosition.top + modalBodyPosition.height)) && scope.isOpen) {
                            scope.isOpen = false;
                            toggleCalendar(scope.isOpen);
                        }
                        scope.$apply();
                    }
                });
            }
            var window = angular.element($window);
            window.bind('resize', function () {
                if (ddhDatepickerPopupTemplate) {
                    datepickerCtrl.updatePosition(ddhDatepickerPopupTemplate);
                    scope.$apply();
                }
            });

            scope.$on('$destroy', function () {
                if (scope.isOpen) {
                    scope.isOpen = false;
                    toggleCalendar(scope.isOpen);
                }
            });

            scope.resetTime = function (date) {
                if (typeof date === 'string') {
                    date = date + 'T12:00:00';
                }
                var dt;
                if (!isNaN(new Date(date))) {
                    dt = new Date(date);
                } else {
                    return null;
                }
                return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
            };

            if (attrs.min) {
                scope.$parent.$watch($parse(attrs.min), function (value) {
                    scope.minDate = value ? scope.resetTime(value) : null;
                    refill();
                });
            }
            if (attrs.max) {
                scope.$parent.$watch($parse(attrs.max), function (value) {
                    scope.maxDate = value ? scope.resetTime(value) : null;
                    refill();
                });
            }
            if (attrs.due) {
                scope.$parent.$watch($parse(attrs.due), function (value) {
                    scope.dueDate = value ? scope.resetTime(value) : null;
                    refill();
                });
            }
            if (attrs.from) {
                scope.$parent.$watch($parse(attrs.from), function (value) {
                    scope.fromDate = value ? scope.resetTime(value) : null;
                    refill();
                });
            }
            
            if (attrs.ngDisabled) {
                scope.$parent.$watch(attrs.ngDisabled, function (value) {
                    scope.ngDisabled = value ? value : null;
                });
            }

            // Split array into smaller arrays
            function split(arr, size) {
                var arrays = [];
                while (arr.length > 0) {
                    arrays.push(arr.splice(0, size));
                }
                return arrays;
            }

            function refill(date) {
                if (angular.isDate(date) && !isNaN(date)) {
                    selected = new Date(date);
                } else {
                    if (!selected) {
                        selected = new Date();
                    }
                }

                if (selected) {
                    var currentMode = datepickerCtrl.modes[mode],
                        data = currentMode.getVisibleDates(selected);
                    scope.rows = split(data.objects, currentMode.split);
                    var flag = false;
                    var startFlag = false;
                    var firstSelected = false;
                    var firstAvailable = false;
                    for (var i = 0; i < scope.rows.length; i++) {
                        for (var j = 0; j < scope.rows[i].length; j++) {

                            if (scope.rows[i][j].label === "1" && !firstSelected) {
                                firstSelected = true;
                                var firstDay = scope.rows[i][j];
                            }

                            if (!firstAvailable && !scope.rows[i][j].disabled) {
                                firstAvailable = true;
                                scope.rows[i][j].firstAvailableDate = true;
                            }

                            if (scope.rows[i][j].selected === true) {
                                flag = true;
                                break;
                            }
                        }
                        if (flag) {
                            break;
                        }
                    }
                    if (!flag) {
                        firstDay.firstFocus = true;
                    }

                    scope.labels = data.labels || [];
                    scope.title = data.title;

                    datepickerCtrl.updatePosition(ddhDatepickerPopupTemplate);
                }

                lastFunction:
                for (var i = scope.rows.length - 1; i >= 0; i--) {
                    for (var j = scope.rows[i].length - 1; j >= 0; j--) {
                        if (!scope.rows[i][j].disabled) {
                            scope.rows[i][j].lastAvailableDate = true;
                            break lastFunction;
                        }
                    }
                }
            }

            scope.select = function (date) {
                $timeout(function () {
                    var dt = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    if (!scope.onSelectClose || (scope.onSelectClose && scope.onSelectClose({
                            date: dt
                        }) !== false)) {
                        scope.currentDate = dt;
                        if (angular.isNumber(scope.collapseWait)) {
                            $timeout(function () {
                                scope.isOpen = false;
                                toggleCalendar(scope.isOpen);
                            }, scope.collapseWait);
                        } else {
                            scope.isOpen = false;
                            toggleCalendar(scope.isOpen);
                        }
                    }
                },200);
            };

            scope.move = function (direction) {
                var step = datepickerCtrl.modes[mode].step;
                selected.setDate(1);
                selected.setMonth(selected.getMonth() + direction * (step.months || 0));
                selected.setFullYear(selected.getFullYear() + direction * (step.years || 0));
                refill();

                $timeout(function () {
                    trapFocusInElement();
                }, 100);
            };

            scope.trapFocus = function () {
                $timeout(function () {
                    trapFocusInElement();
                }, 100);
            };

            scope.$watch('currentDate', function (value) {
                if (angular.isDefined(value) && value !== null) {
                    refill(value);
                } else {
                    refill();
                }
                ngModel.$setViewValue(value);
            });

            ngModel.$render = function () {
                scope.currentDate = ngModel.$viewValue;
            };

            var stringToDate = function (value) {
                if (!isNaN(new Date(value))) {
                    value = new Date(value);
                }
                return value;
            };
            ngModel.$formatters.unshift(stringToDate);
        }
    };
}])

.directive('ddhDatepicker', ['$compile', '$log', 'ddhDatepickerConfig', 'ddhDatepickerService', 'ddhLazyLoad', function ($compile, $log, ddhDatepickerConfig, ddhDatepickerService, ddhLazyLoad) {
    return {
        restrict: 'A',
        scope: {
            disableDates: '&',
            onSelectClose: '&'
        },
        require: 'ngModel',
        compile: function (elem, attr) {
            ddhLazyLoad.load('calendar', 'css');

            return this.link;
        },
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            var dateFormatString = angular.isDefined(attr.dateFormat) ? scope.$parent.$eval(attr.dateFormat) : ddhDatepickerConfig.dateFormat;
            var helperText = angular.isDefined(attr.helperText) ? scope.$parent.$eval(attr.helperText) : ddhDatepickerConfig.helperText;
            helperText = helperText.replace('$date', '{{dt | date : \'' + dateFormatString + '\'}}');

            var inline = false;
            if (elem.prop('nodeName') !== 'INPUT') {
                inline = true;
            }

            var btnID = attr.id;
            var spanID = attr.id + "_span";

            var inputID = attr.id + "_input";
            elem.attr('id', inputID);



            var calendarIcon = '<i class="icon-calendar" aria-hidden="true"></i>'
            var selectedDateMessage;

            if (attr.ariaLabel){
                selectedDateMessage = '<button id="' + btnID + '" type="button" class="span12 faux-input" ng-disabled="ngDisabled" aria-label="'+ attr.ariaLabel + '"  aria-describedby="'+ spanID +'"><span id="'+ spanID +'"class="hidden-spoken">' + helperText + '</span></button>';
            }
            else {
                selectedDateMessage = '<button id="' + btnID + '" type="button" class="span12 faux-input" ng-disabled="ngDisabled" aria-describedby="'+ spanID +'"><span id="'+ spanID +'"class="hidden-spoken">' + helperText + '</span></button>';
            }

            elem.removeAttr('ddh-datepicker');
            elem.removeAttr('ng-model');
            elem.removeAttr('ng-disabled');
            elem.addClass('datepicker-input');
            elem.attr('ng-model', 'dt');
            elem.attr('aria-describedby', 'datepicker');
            elem.attr('aria-hidden', 'true');
            elem.attr('tabindex', '-1');
            elem.attr('readonly', 'true');
            elem.attr('ng-disabled', 'ngDisabled');
            elem.attr('ddh-format-date', dateFormatString);

            var wrapperElement = angular.element('<div></div>');
            wrapperElement.attr('ddh-datepicker-popup', '');
            wrapperElement.attr('ng-model', 'dt');
            if (inline) {
                wrapperElement.attr('inline', inline);
            }
            if (scope.datepickerLabel) {
                wrapperElement.attr('datepicker-label', scope.datepickerLabel);
            }

            ddhDatepickerService.setAttributes(attr, wrapperElement);
            ddhDatepickerService.bindScope(attr, scope);

            wrapperElement.html('');
            wrapperElement.append(calendarIcon);
            wrapperElement.append(selectedDateMessage);
            wrapperElement.append(elem.prop('outerHTML'));

            var elm = wrapperElement.prop('outerHTML');
            elm = $compile(elm)(scope);
            elem.replaceWith(elm);
        }],
        link: function (scope, elem, attr, ctrl) {
            if (!ctrl) {
                $log.error("ng-model is required.");
                return; // do nothing if no ng-model
            }

            scope.$watch('dt', function (value) {
                ctrl.$setViewValue(value);
            });
            ctrl.$render = function () {
                scope.dt = ctrl.$modelValue;
            };
        }
    };
}])

.directive('ddhDatepickerGroup', [function () {
    return {
        restrict: 'EA',
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {
            this.$$headers = [];
            this.$$footers = [];
            this.legendDue;
            this.legendSelected;
            this.legendDueSelected;
            this.registerDatepickerScope = function (datepickerScope) {
                datepickerScope.headers = this.$$headers;
                datepickerScope.footers = this.$$footers;
                datepickerScope.legendDue = this.legendDue;
                datepickerScope.legendSelected = this.legendSelected;
                datepickerScope.legendDueSelected = this.legendDueSelected;
            };
        }],
        link: function (scope, elem, attr, ctrl) {
            elem.addClass('icon-calendar');
        }
    };
}])

.directive('ddhFormatDate', ['dateFilter', function (dateFilter) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            var ddhFormatDate = "";
            attr.$observe('ddhFormatDate', function (value) {
                ddhFormatDate = value;
            });
            var dateToString = function (value) {
                if (!isNaN(new Date(value))) {
                    return dateFilter(new Date(value), ddhFormatDate);
                }
                return value;
            };
            ctrl.$formatters.unshift(dateToString);
        }
    };
}])

.directive('ddhDatepickerHeader', [function () {
    return {
        restrict: 'EA',
        require: '^ddhDatepickerGroup',
        transclude: true,
        replace: true,
        template: '',
        compile: function (elem, attr, transclude) {
            return function link(scope, elem, attr, ctrl) {
                if (ctrl) {
                    ctrl.$$headers.push(transclude(scope, function () {}));
                }
                elem.remove();
            };
        }
    };
}])

.directive('ddhDatepickerFooter', [function () {
    return {
        restrict: 'EA',
        scope: true,
        require: '^ddhDatepickerGroup',
        transclude: true,
        replace: true,
        template: '',
        compile: function (elem, attr, transclude) {
            return function link(scope, elem, attr, ctrl) {
                if (ctrl) {
                    ctrl.$$footers.push(transclude(scope, function () {}));

                    ctrl.legendDue = scope.legendDue;
                    ctrl.legendSelected = scope.legendSelected;
                    ctrl.legendDueSelected = scope.legendDueSelected;
                }
                elem.remove();
            };
        }
    };
}])

.directive('ddhDatepickerLegendDue', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            scope.legendDue = attr.id;
        }
    };
}])

.directive('ddhDatepickerLegendSelected', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            scope.legendSelected = attr.id;
        }
    };
}])

.directive('ddhDatepickerLegendDueSelected', [function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attr, ctrl) {
            scope.legendDueSelected = attr.id;
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:Star Rating
 *
 * @description
 *  <file src="src/starRating/docs/readme.md" />
 * @usage
 *      <ddh-star-rating class="star-20" avg="{{value from 0 to 100}}" reviews="{{no of reviews}}">
 *          <a href="javascript:void(0);" class="final-rating pull-left">{{ as per developer needs  }}</a>
 *          <a href="javascript:void(0);" ng-show="{{preferably show when review is present}}" class="pull-left rev-divider">{{ as per developer needs  }}</a>
 *      </ddh-star-rating>
 *      <ddh-star-rating class="star-20" data-star-color="yellow" avg="{{value from 0 to 100}}" reviews="{{no of reviews}}">
 *          <a href="javascript:void(0);" class="final-rating pull-left">{{ as per developer needs  }}</a>
 *          <a href="javascript:void(0);" ng-show="{{preferably show when review is present}}" class="pull-left rev-divider">{{ as per developer needs  }}</a>
 *      </ddh-star-rating>
 *      
 * @example
       <section id="code">              
           <b>HTML + AngularJS</b>
           <example module="ddh.att">
           <file src="src/starRating/docs/demo.html" />
            <file src="src/starRating/docs/demo.js" />            
          </example>          
        </section>
 */
angular.module('ddh.att.starRating', [])
    .directive("ddhStarRating",function(){
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                avg: '=',
                reviews: '=',
                ratingText: '@',
                ratingUrl: '@',
                disabled:'@',
                ratingId:'@'
            },
            templateUrl: 'template/starRating/starRating.html',
            link: function (scope, element, attrs){
                var rate = function () {
                            var eachCompoPercntg = scope.avg,
                                    starsToFilled = eachCompoPercntg / 20, // Divided Entire Percentage to per Star Instance
                                    svgWrap = element[0].querySelector('.svgwrap'),
                                    w = svgWrap.clientWidth,
                                    h = svgWrap.clientHeight,
                                    emptyStar = element[0].querySelector('.emptystar'),
                                    filledStar = element[0].querySelector('.filledstar');                            
                                    
                                    
                             // ask dev to provide text
                            if (scope.ratingText !== undefined) {
                                scope.CATOText = scope.ratingText;
                            } else if (scope.reviews !== undefined && scope.reviews !== null) {
                                scope.CATOText = 'Average star rating of this product is ' + starsToFilled.toFixed(1) + ' based on ' + scope.reviews + ' reviews';
                            } else {
                                scope.CATOText = 'Average star rating of this product is ' + starsToFilled.toFixed(1);
                            }        
                            
                            // Decode base64
                            if(angular.element(emptyStar).attr('src')){
                                var decodedsvgEmpty = atob(angular.element(emptyStar).attr('src').substring(26)),
                                    decodedsvgFilled = atob(angular.element(filledStar).attr('src').substring(26));
                            //Insert Back
                                angular.element(svgWrap).html(decodedsvgEmpty);
                                angular.element(svgWrap).append(decodedsvgFilled);
                            }
                            var svgElm = svgWrap.querySelectorAll('svg');
                            angular.element(svgElm[0]).addClass('emptystar');
                            angular.element(svgElm[1]).addClass('filledstar');

                            //Filling
                            var emptyStarPath = svgElm[0].querySelector('path'),
                            filledStarPath = svgElm[1].querySelector('path');
                            if (element.attr('data-stars-color') == "yellow") {
                                angular.element(emptyStarPath).attr({'stroke': '#FFB81C','fill':'none'});
                                angular.element(filledStarPath).attr({'fill': '#FFB81C', 'stroke': '#FFB81C'});
                            } else if (element.attr('data-stars-color') == "black") {
                                angular.element(emptyStarPath).attr({'stroke':'#191919','fill':'none'});
                                angular.element(filledStarPath).attr({'fill': '#191919', 'stroke': '#191919'});
                            } else if (element.attr('data-stars-color') == "white") {
                                angular.element(emptyStarPath).attr({'stroke': '#ffffff','fill':'none'});
                                angular.element(filledStarPath).attr({'fill': '#ffffff', 'stroke': '#ffffff'});
                            } else {
                                angular.element(emptyStarPath).attr({'stroke':'#ea7400','fill':'none'});
                                angular.element(filledStarPath).attr({'fill': '#ea7400', 'stroke': '#ea7400'});
                            }

                            //Clipping
                            if (element.hasClass('star-15')) {
                                mply = parseInt(eachCompoPercntg) * ('.103') / 10;
                            } else if (element.hasClass('star-20')) {
                                mply = parseInt(eachCompoPercntg) * ('.104') / 10;
                            } else {
                                mply = parseInt(eachCompoPercntg) * ('.101') / 10;
                            }

                            var clipVal = parseInt(w) * (mply) + 'px';
                            angular.element(element[0].querySelector('.emptystar')).css({'width': w, 'height': h, 'background-size': w + 'px ' + h + 'px'});
                            angular.element(element[0].querySelector('.filledstar')).css({'width': w, 'height': h, 'clip': 'rect(0, ' + clipVal + ', 100px, 0)'});
                        }
                if(!scope.disabled){
                    element.attr('href',scope.ratingUrl);
                    element.removeAttr('tabindex');
                    element.removeAttr('aria-disabled');
                }else{
                     element.removeAttr('href');
                     element.attr('tabindex','-1');
                     element.attr('aria-disabled','true');
                }
                scope.$watchGroup(['avg','reviews'], function(){
                    rate();
                });
            }            
        };
});
/**
 * @ngdoc directive
 * @name Layouts.att:cardSpace
 * @element input
 * @function
 *
 * @description
 *  <file src="src/cardSpace/docs/readme.md" />
 * @usage
 *
 * @example
 *  <section id="code">
               <b>HTML + AngularJS</b>
 *             	<example module="ddh.att">
 *  	        <file src="src/cardSpace/docs/demo.html" />
                 <file src="src/cardSpace/docs/demo.js" />
 *              </example>
            </section>
 *
 */
angular.module('ddh.att.cardSpace', ['ddh.att.starRating']);
/**
 * @ngdoc directive
 * @name Forms.att:checkboxes
 *
 * @description
 *  <file src="src/checkboxes/docs/readme.md" />
 * @usage
 *  <!-- Imlementation provided below -->
 * @example
 <example module="ddh.att">
 <file src="src/checkboxes/docs/demo.html" />
 <file src="src/checkboxes/docs/demo.js" />
 </example>
 */
angular.module('ddh.att.checkboxes', ['ddh.att.utilities']).directive('ddhSelectGroup', [function (){
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                checkboxes: "=",
                checkboxesState: "="
            },
            link: function (scope, elem, attr, ctrl) {
                elem.addClass('checkbox-selectall');
                elem.bind('change', function () {
                    var isChecked = elem.prop('checked');
                    angular.forEach(scope.checkboxes, function (item) {
                        item.isSelected = isChecked;
                    });
                    scope.$apply();
                });
                scope.$watch('checkboxes', function () {
                    var allSet = true, allClear = true;
                    angular.forEach(scope.checkboxes, function (item) {
                        if (item.isSelected) {
                            allClear = false;
                        } else {
                            allSet = false;
                        }
                    });
                    if (allSet) {
                        ctrl.$setViewValue(true);
                        elem.prop({'indeterminate': false});
                        elem.removeClass('indeterminate');
                        elem.removeAttr('indeterminate');
                        scope.checkboxesState = 'true';
                    } else if (allClear) {
                        ctrl.$setViewValue(false);
                        elem.prop({'indeterminate': false});
                        elem.removeClass('indeterminate');
                        elem.removeAttr('indeterminate');
                        scope.checkboxesState = 'false';
                    } else {
                        ctrl.$setViewValue(false);
                        elem.prop({'indeterminate': true});
                        elem.addClass('indeterminate');
                        elem.attr('indeterminate', true);
                        scope.checkboxesState = 'mixed';
                    }
                    ctrl.$render();
                }, true);
            }
        };
    }])

.directive('ddhCheckboxExpand', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {

            var timeoutInstance = null;
            var timeoutInstanceRemove = null;
            var msgText = 'Additional fields are ';

            var msgElemString = '<div aria-live="polite"  class="hidden-spoken"></div>';
            
            var msgElem = angular.element(msgElemString);

            scope.$watch(attr.ngModel,function(newValue) {
                if (timeoutInstance) {
                    $timeout.cancel(timeoutInstance);
                }
                if (timeoutInstanceRemove) {
                    $timeout.cancel(timeoutInstanceRemove);
                }
                else {
                    elem.parent().after(msgElem);
                }

                timeoutInstance = $timeout(function () {
                    if(newValue) {
                        msgElem.text(msgText + 'displayed');
                    }
                    else {
                        msgElem.text(msgText + 'collapsed');
                    }

                    timeoutInstanceRemove = $timeout(function () {
                        msgElem.text('');
                        msgElem.remove();
                        timeoutInstanceRemove = null;
                    }, 1000);
                    
                    timeoutInstance = null;
                }, 500);
            });
        }
    };
    }]);
/**
 * @ngdoc directive
 * @name Product selection.att:colorAndDataCapacity
 *
 * @description
 *  <file src="src/colorAndDataCapacity/docs/readme.md" />
 *
 * @usage
 *   Please refer demo.html tab in Example section below.
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/colorAndDataCapacity/docs/demo.html" />
            <file src="src/colorAndDataCapacity/docs/demo.js" />
        </example>
    </section>
 *
 */
angular.module('ddh.att.colorAndDataCapacity', ['ddh.att.utilities'])
    .directive('ddhColorAndDataCapacity',['$compile', function ($compile) {
        return {
            restrict: 'A',
            transclude: true,
            templateUrl: 'template/colorAndDataCapacity/capacityWrapper.html',
            replace: true,
            scope: {
                ddhColorAndDataCapacity: '='
            },
            controller: ['$scope', function ($scope) {
                this.setItemIdSelected = function (item) {
                    $scope.ddhColorAndDataCapacity = item.id;
                };
                this.getActiveItem = function(){
                    return $scope.ddhColorAndDataCapacity;
                };
            }]
        };
    }])
    .directive('ddhColorAndDataCapacityItem', ['userAgent','$document','$timeout','$compile', function (userAgent,$document,$timeout,$compile) {
        return {
            restrict: 'A',
            require: '^ddhColorAndDataCapacity',
            templateUrl: 'template/colorAndDataCapacity/capacityItem.html',
            replace: true,
            scope: {
                ddhColorAndDataCapacityItem: "=",
                selectorType:"@"
            },
            link: function (scope, element, attr, ddhColorAndDataCapacityCtrl) {
                scope.ddhColorAndDataCapacityCtrl = ddhColorAndDataCapacityCtrl;
                var addCustomStyle = function(activeElm){
                    if(element.parent().parent().hasClass('underlined')){
                        var group = element[0].parentElement.offsetLeft,
                        groupId = element[0].parentElement.getAttribute('id'),
                        newPos = group + activeElm.offsetLeft,
                        newActivePos  = (newPos - group)-2,
                        newActiveW     = activeElm.clientWidth + 4;
                        if(document.querySelectorAll('style#' + groupId + '_CSS').length == 0 && groupId!== undefined){
                            angular.element($document.find('head')).append('<style id="' + groupId + '_CSS">' + '#' + groupId + ':after{left:' + newActivePos + 'px;width:' + newActiveW + 'px;}</style>');
                        }else{
                            document.querySelector('style#' + groupId + '_CSS').innerHTML = '#' + groupId + ':after{left:' + newActivePos + 'px;width:' + newActiveW + 'px;}';
                        }
                    };
                };
                
                if (userAgent.notMobile()) {
                    element.bind('focus', function () {
                        ddhColorAndDataCapacityCtrl.setItemIdSelected(scope.ddhColorAndDataCapacityItem);
                        scope.$apply();
                    });
                };
                
                element.bind('click', function () {
                    ddhColorAndDataCapacityCtrl.setItemIdSelected(scope.ddhColorAndDataCapacityItem);
                    scope.$apply();
                });
                
                scope.$watch('ddhColorAndDataCapacityCtrl.getActiveItem()',function(){
                    $timeout(function(){
                        addCustomStyle(element[0].parentElement.querySelector('button.active'));
                    },100);
                });
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name Progress & usage indicators.att:stepIndicator
 *
 * @description
 *  <file src="src/stepIndicator/docs/readme.md" />
 *
 * @usage
 * <div ng-controller="stepIndicatorController">
    <section id="overview" class="bottom-space">
        <div class="span12">
            <div ddh-step-indicator steps-items-object="stepsObject" current-index="currentStepIndex" step-indicator-heading="stepHeading">
                <div class="row-nowrap step-confirmation" ng-show="{{currentStepIndex === stepsObject.length}}">
                    <i class="icon-approval"></i>
                    <div>
                        <h3><strong>Lorem success!</strong></h3>
                        <p>Lorem message of confirmation that process has been complete.</p>
                    </div>
                </div>
            </div>
        </div>
        <hr>
         <div class="span12">
            <div ddh-step-indicator steps-items-object="stepsObject2" current-index="currentStepIndex2" step-indicator-heading='stepHeading2'>
                <div class="row-nowrap step-confirmation" ng-show="{{currentStepIndex2 === stepsObject2.length}}">
                    <i class="icon-approval"></i>
                    <div>
                        <h3><strong>success!</strong></h3>
                        <p>You've created your AT&T Access ID.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/stepIndicator/docs/demo.html" />
 <file src="src/stepIndicator/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.stepIndicator', ['ddh.att.utilities', 'ddh.att.lazyLoad']).
        directive('ddhStepIndicator', ['ddhLazyLoad', function(ddhLazyLoad) {
                return {
                    restrict: 'EA',
                    transclude: true,
                    scope:{
                        stepsItemsObject:"=",
                        currentIndex:"=",
                        stepIndicatorHeading:"="
                        
                    },
                    templateUrl: 'template/stepIndicator/stepIndicator.html',
                    compile: function (elem, attr) {
                        ddhLazyLoad.load('stepIndicator', 'css');

                        return this.link;
                    },
                    link: function(scope, ele, attr) {
                       
                    }

                };

            }]);
     
/**
 * @ngdoc directive
 * @name Layouts.att:Confirmation within a Process
 *
 * @description
 *  <file src="src/confirmationProcess/docs/readme.md" />
 *
 * @usage
 * <h2 class="ds2 heading-group">Confirmation with in Process</h2>
 * <p>
 * .....
 * </p> 
 *
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
		<file src="src/confirmationProcess/docs/demo.html" />
		<file src="src/confirmationProcess/docs/demo.js" />
	</example>
</section>
 */

var ddhLegalCopy = angular.module('ddh.att.confirmationProcess', ['ddh.att.stepIndicator']);
/**
 * @ngdoc directive
 * @name Forms.att:creditCard
 *
 * @description
 *  <file src="src/creditCard/docs/readme.md" />
 *
 * @usage
 * <form name="ccForm" ng-controller="ddhCreditCardFormController">
 *  <label for="ccForm.card" class="pull-left" data-credit-card-image="ccForm.card.$card.type">Card number</label> 
 *  <input type="tel" role="textbox" id="ccForm.card" maxlength="16" autocomplete="off" placeholder="Enter up to 16 digits" aria-describedby="cardPlaceholder {{ccErrorlabel}}" class="span12 formspacing-bottom-normal" ng-model="card" ddh-reset name="card" validate-card="card" required payments-type-model="type" ddh-only-digits />
 * </form>
 * @example
 *  <section id="code">
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/creditCard/docs/demo.html" />
 <file src="src/creditCard/docs/demo.js" />
 </example>
 </section>
 *
 */

angular.module('ddh.att.creditCard', ['ddh.att.dropdowns', 'ddh.att.utilities', 'ddh.att.lazyLoad'])
.factory('Cards', [function () {
    var defaultFormat = /(\d{1,4})/g;
    var defaultInputFormat = /(?:^|\s)(\d{4})$/;
    var cards = [
        {
            type: 'discover',
            pattern: /^(6011|65|64[4-9]|622)/,
            format: defaultFormat,
            inputFormat: defaultInputFormat,
            length: [16,19],
            cvcLength: [3],
            cvcSecurityImg: 'visaI',
            zipLength: [5],
            luhn: true
        },
        {
            type: 'mc',
            pattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/,
            format: defaultFormat,
            inputFormat: defaultInputFormat,
            length: [16],
            cvcLength: [3],
            cvcSecurityImg: 'visaI',
            zipLength: [5],
            luhn: true
        },
        {
            type: 'amex',
            pattern: /^3[47]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            inputFormat: /^(\d{4}|\d{4}\s\d{6})$/,
            length: [15],
            cvcLength: [4],
            cvcSecurityImg: 'amexI',
            zipLength: [5],
            luhn: true
        },
        {
            type: 'visa',
            pattern: /^4/,
            format: defaultFormat,
            inputFormat: defaultInputFormat,
            length: [13,16,19],
            cvcLength: [3],
            cvcSecurityImg: 'visaI',
            zipLength: [5],
            luhn: true
        },
        {
            type: 'dinersclub',
            pattern: /^(36|38|30[0-5])/,
            format: defaultFormat,
            inputFormat: defaultInputFormat,
            length: [14],
            cvcLength: [3],
            cvcSecurityImg: 'visa-I',
            zipLength: [5],
            luhn: true
        }
    ];

    var _fromNumber = function (num) {
        var card, i, len;

        num = (num + '').replace(/\D/g, '');

        for (i = 0, len = cards.length; i < len; i++) {

            card = cards[i];

            if (card.pattern.test(num)) {
                return card;
            }

        }
    };

    var _fromType = function (type) {
        var card, i, len;

        for (i = 0, len = cards.length; i < len; i++) {

            card = cards[i];

            if (card.type === type) {
                return card;
            }

        }
    };

    return {
        fromNumber: function (val) {
            return _fromNumber(val);
        },
        fromType: function (val) {
            return _fromType(val);
        },
        defaultFormat: function () {
            return defaultFormat;
        },
        defaultInputFormat: function () {
            return defaultInputFormat;
        }
    };

}])
.factory('_Validate', ['Cards', '$parse', function (Cards, $parse) {
    var __indexOf = [].indexOf || function (item) {
        for (var i = 0, l = this.length; i < l; i++) {
            if (i in this && this[i] === item) {
                return i;
            }
        }
        return -1;
    };

    var _luhnCheck = function (num) {
        var digit, digits, odd, sum, i, len;

        odd = true;
        sum = 0;
        digits = (num + '').split('').reverse();

        for (i = 0, len = digits.length; i < len; i++) {

            digit = digits[i];
            digit = parseInt(digit, 10);

            if ((odd = !odd)) {
                digit *= 2;
            }

            if (digit > 9) {
                digit -= 9;
            }

            sum += digit;

        }

        return sum % 10 === 0;
    };

    var _validators = {};
    
    _validators['card'] = function (num, ctrl, scope, attr) {
        var card, ref, typeModel;

        if (attr.paymentsTypeModel) {
            typeModel = $parse(attr.paymentsTypeModel);
        }

        var clearCard = function () {
            if (typeModel) {
                typeModel.assign(scope, null);
            }
            ctrl.$card = null;
        };

        // valid if empty - let ng-required handle empty
        if ((angular.isUndefined(num)) || (num === null) || (num.length === 0)) {
            clearCard();
            return true;
        }

        num = (num + '').replace(/\s+|-/g, '');

        if (!/^\d+$/.test(num)) {
            clearCard();
            return false;
        }

        card = Cards.fromNumber(num);
        if (!card) {
            clearCard();
            return false;
        }
        ctrl.$card = angular.copy(card);

        if (typeModel) {
            typeModel.assign(scope, card.type);
        }

        return (ref = num.length, __indexOf.call(card.length, ref) >= 0) && (card.luhn === false || _luhnCheck(num));
    };
    return function (type, val, ctrl, scope, attr) {
        if (!_validators[type]) {

            var types = Object.keys(_validators);

            var errstr = 'Unknown type for validation: "' + type + '". ';
            errstr += 'Should be one of: "' + types.join('", "') + '"';

            throw errstr;
        }
        return _validators[type](val, ctrl, scope, attr);
    };
}])
.factory('_ValidateWatch', ['_Validate', function (_Validate) {

    var _validatorWatches = {};
    return function (type, ctrl, scope, attr) {
        if (_validatorWatches[type]) {
            return _validatorWatches[type](type, ctrl, scope, attr);
        }
    };
}])
.directive('validateCard', ['$window', '_Validate', '_ValidateWatch', 'ddhLazyLoad', function ($window, _Validate, _ValidateWatch, ddhLazyLoad) {
    return {
        restrict: 'A',
        require: 'ngModel',
        compile: function (elem, attr) {
            ddhLazyLoad.load('creditCard', 'css');

            return this.link;
        },
        link: function (scope, elem, attr, ctrl) {
            var type = attr.validateCard;
            _ValidateWatch(type, ctrl, scope, attr);
            var valid;
            var validateFn = function (val) {
                valid = _Validate(type, val, ctrl, scope, attr);
                if (type === 'card') {   
                    if(!val) 
                    {
                        ctrl.$setValidity('required', false);
                        ctrl.$setValidity('valid', true);
                    }                
                    else if (!valid ) {
                        ctrl.$setValidity('required', true);
                        ctrl.$setValidity('valid', false);
                    } else {
                        ctrl.$setValidity('required', true);
                        ctrl.$setValidity('valid', true);
                    }     
                }
                return valid ? val : undefined;
            };

            ctrl.$formatters.push(validateFn);
            ctrl.$parsers.push(validateFn);
        }
    };
}])
.directive('creditCardImage', function () {
    return {
        replace: false,
        transclude: false,
        link: function (scope, element, attr) {
            scope.$watch(attr.creditCardImage, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    scope.cvc = '';
                    if (!angular.isUndefined(newVal) && newVal !== null) {
                        scope.newValCCI = 'show-' + newVal;
                        if(newVal === 'amex')
                        {
                            scope.cvcMaxlength = 4;
                            scope.cvcPlaceholder = "4 digits";
                            scope.showvisa = ({'display': 'none'});
                            scope.showamex = ({'display': 'inline'});
                        }
                        else
                        {
                            scope.cvcMaxlength = 3;
                            scope.cvcPlaceholder = "3 digits";                            
                            scope.showvisa = ({'display': 'inline'});
                            scope.showamex = ({'display': 'none'});
                        }
                    }
                    if (newVal === null || newVal === "" || angular.isUndefined(newVal)) {
                        scope.newValCCI = '';
                        scope.cvcMaxlength = 4;
                        scope.cvcPlaceholder = "3 or 4 digits";
                        scope.showvisa = ({'display': 'inline'});
                        scope.showamex = ({'display': 'inline'});
                    }
                }
            });
        }
    };
})
.directive('validateZip', function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, elm, attrs, ctrl) {
            var zipChar = /^[a-zA-Z0-9\- ]*$/
            var zipReg = /^\d{5}$|^\d{5}(-\d{4})$|^\d{9}?$|^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[a-zA-Z]{1} *\d{1}[a-zA-Z]{1}\d{1}$/
            var validateZip = function () {
                var eVal = elm.val();
                if (!eVal) {
                    ctrl.$setValidity('required', false);
                    ctrl.$setValidity('invalidZip', true);
                    ctrl.$setValidity('invalidChar', true);
                }
                else if (!zipChar.test(eVal)) {
                    ctrl.$setValidity('required', true);
                    ctrl.$setValidity('invalidZip', true);
                    ctrl.$setValidity('invalidChar', false);
                }
                else if (!zipReg.test(eVal)) {
                    ctrl.$setValidity('required', true);
                    ctrl.$setValidity('invalidZip', false);
                    ctrl.$setValidity('invalidChar', true);
                }
                else if(/[0-9]/.test(eVal) && eVal.length === 9){                    
                    scope.zip = eVal.replace(/(\d{5})(\d{4})/, '$1-$2');
                    ctrl.$setValidity('required', true);
                    ctrl.$setValidity('invalidZip', true);
                    ctrl.$setValidity('invalidChar', true);
                }
                else {
                    ctrl.$setValidity('required', true);
                    ctrl.$setValidity('invalidZip', true);
                    ctrl.$setValidity('invalidChar', true);
                }    
                return scope.zip;
            };

            ctrl.$formatters.push(validateZip);
            ctrl.$parsers.push(validateZip);
        }
    };
});

angular.module('ddh.att.collapse', ['ngAnimate'])

// The collapsible directive indicates a block of html that will expand and collapse
.directive('ddhCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
	var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	return {
		link: function (scope, element, attrs) {
			var expandingExpr = $parse(attrs.expanding),
				expandedExpr = $parse(attrs.expanded),
				collapsingExpr = $parse(attrs.collapsing),
				collapsedExpr = $parse(attrs.collapsed),
				isTabs = false,
				css = {},
				cssTo = {};
			init();

			
			function init() {
				isTabs = (element.parent().parent().hasClass('tiny-tabs')) ? true : false;
				if (isTabs) {
					css = {
						opacity: ''
					};
					cssTo = {
						opacity: '0'
					};
				} else {
					css = {
						height: ''
					};
					cssTo = {
						height: '0'
					};
				}

				if (!scope.$eval(attrs.ddhCollapse)) {
					element.addClass('in')
						.addClass('ddh-collapse')
						.attr('aria-hidden', false)
						.css(css);
				}
			}

			function getScrollFromElement(element) {
				if (isTabs) {
					return {
						opacity: 1
					};
				}
				return {
					height: element.scrollHeight + 'px'
				};
			}

			function expand() {
				if (element.hasClass('ddh-collapse') && element.hasClass('in')) {
					return;
				}

				$q.resolve(expandingExpr(scope))
					.then(function () {
						element.removeClass('ddh-collapse')
							.addClass('collapsing')
							.attr('aria-hidden', false);

						if ($animateCss) {
							$animateCss(element, {
								addClass: 'in',
								easing: 'ease',
								css: {
									overflow: 'hidden'
								},
								to: getScrollFromElement(element[0])
							}).start()['finally'](expandDone);
						} else {
							$animate.addClass(element, 'in', {
								css: {
									overflow: 'hidden'
								},
								to: getScrollFromElement(element[0])
							}).then(expandDone);
						}
					}, angular.noop);
			}

			function expandDone() {
				element.removeClass('collapsing')
					.addClass('ddh-collapse')
					.css(css);
				expandedExpr(scope);
			}

			function collapse() {
				if (!element.hasClass('ddh-collapse') && !element.hasClass('in')) {
					return collapseDone();
				}

				$q.resolve(collapsingExpr(scope))
					.then(function () {
						element
							.css(getScrollFromElement(element[0]))
							.removeClass('ddh-collapse')
							.addClass('collapsing')
							.attr('aria-hidden', true);

						if ($animateCss) {
							$animateCss(element, {
								removeClass: 'in',
								to: cssTo
							}).start()['finally'](collapseDone);
						} else {
							$animate.removeClass(element, 'in', {
								to: cssTo
							}).then(collapseDone);
						}
					}, angular.noop);
			}

			function collapseDone() {
				element.css(cssTo);
				element.removeClass('collapsing')
					.addClass('ddh-collapse');
				collapsedExpr(scope);
			}

			scope.$watch(attrs.ddhCollapse, function (shouldCollapse) {
				if (shouldCollapse) {
					collapse();
				} else {
					expand();
				}
			});
		}
	};
}]);
/**
 * @ngdoc directive
 * @name Tabs, tables & accordions.att:expandCollapse
 *
 * @description
 *  <file src="src/expandCollapse/docs/readme.md" />
 *
 * @usage
 *   <ddh-accordion close-others="true" scroll-top="false">
 *       <ddh-accordion-group heading="Heading goes here">
 *           Content will be placed here
 *       </ddh-accordion-group>     
 *   </ddh-accordion> 
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/expandCollapse/docs/demo.html" />
            <file src="src/expandCollapse/docs/demo.js" />
        </example>
    </section>
 *
 */

angular.module('ddh.att.expandCollapse', ['ddh.att.collapse','ddh.att.transition','ddh.att.position','ddh.att.utilities', 'ddh.att.lazyLoad'])     
.constant('ddhAccordionConfig', {
    closeOthers: false,
    scrollTop: true,
    scrollTopParentId: null,
    hasNested: false
})
.controller('ddhAccordionController', ['$scope', '$attrs', 'ddhAccordionConfig', '$log','$element',
    function ($scope, $attrs, accordionConfig, $log,$element) {
    // This array keeps track of the accordion groups
    this.groups = [];
    this.index = -1;
    // Keep reference to user's scope to properly assign `is-open`
    this.scope = $scope;
    // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
    $scope.forceExpand = false;
    this.closeOthers = function (openGroup) {
        var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
        if (closeOthers) {
            angular.forEach(this.groups, function (group) {
                if (group !== openGroup) {
                    group.isOpen = false;
                }
            });
        }
    };    
    this.expandAll = function () {
        $scope.forceExpand = true;
        angular.forEach(this.groups, function (group) {
            group.isOpen = true;
        });
    };
    this.collapseAll = function () {
        angular.forEach(this.groups, function (group) {
            group.isOpen = false;
        });
    };        
    this.isCloseOthers = function () {
        var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
        return closeOthers;
    };
    this.scrollTop = function () {
        var scrollTop = angular.isDefined($attrs.scrollTop) ? $scope.$eval($attrs.scrollTop) : accordionConfig.scrollTop;
        return scrollTop;
    };
    this.scrollTopParentId = function () {
        var scrollTopParentId = angular.isDefined($attrs.scrollTopParentId) && $attrs.scrollTopParentId !== "" ? $attrs.scrollTopParentId : accordionConfig.scrollTopParentId;
        return scrollTopParentId;
    };
    this.hasNested = function () {
        var hasNested = angular.isDefined($attrs.hasNested) ? $scope.$eval($attrs.hasNested) : accordionConfig.hasNested;
        return hasNested;
    };
    /**
     *
     * function focus
     * @param focusGroup
     */
    this.focus = function (focusGroup) {
        var self = this;
        angular.forEach(this.groups, function (group, index) {
            if (group !== focusGroup) {
                group.focused = false;
            } else {
                self.index = index;
                group.focused = true;
            }
        });
    };
    /**
     *
     * @param blurGroup
     */
    this.blur = function (blurGroup) {
        blurGroup.focused = false;
        this.index = -1;
    };
    /**
     *
     * @param group - the group in current focus
     * @param down - cycling down
     */
    this.cycle = function (group, down, noRecycle) {
        if (!down) {
            if (this.index <= 0 && !noRecycle) {
                this.index = this.groups.length - 1;
            } else {
                this.index--;
            }
        } else {
            if (this.index >= (this.groups.length - 1) && !noRecycle) {
                this.index = 0;
            } else {
                this.index++;
            }
        }
        group.focused = false;
        this.groups[this.index].focused = true;
        $scope.$apply();
    };
    // This is called from the accordion-group directive to add itself to the accordion
    this.addGroup = function (groupScope) {
        var that = this;
        groupScope.index = this.groups.length;
        groupScope.focused = false;
        groupScope.acId = $attrs.id;
        this.groups.push(groupScope);        
        groupScope.$on('$destroy', function () {
            that.removeGroup(groupScope);
        });
    };
    // This is called from the accordion-group directive when to remove itself
    this.removeGroup = function (group) {
        var index = this.groups.indexOf(group);
        if (index !== -1) {
            this.groups.splice(this.groups.indexOf(group), 1);
        }
    };
    this.getSize=function(){
        return this.groups.length;
    };
	
    this.setHeight = function(val){
       $scope.elemHeight = val + 'px';
	   $scope.tabHeight = (val-10)+'px';
    };
	    
	this.isTabs = function () {
		if($element.hasClass('tiny-tabs')){
			return true;
		}
		else {
			return false;
		}
	}
		
    this.elemClass = function(name){
        return $element.hasClass(name);
    };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('ddhAccordion', ['ddhLazyLoad', function (ddhLazyLoad) {
    return {
        restrict: 'EA',
        controller: 'ddhAccordionController',
        transclude: true,
        replace: true,
        scope: {
            cClass: '@css',
            expandAll: "=?",
            collapseAll: "=?"
        },
        compile: function (elem, attr) {
            ddhLazyLoad.load('accordion', 'css');

            return this.link;
        },
        templateUrl: 'template/expandCollapse/expandCollapse.html',
        link: function (scope, elem, attribute, ctrl) {
        scope.isMultiselect = ctrl.isCloseOthers();
        //scope.tSize = ctrl.getSize();
            scope.$watch("expandAll", function (value) {
                if (value) {
                    ctrl.expandAll();
                    scope.expandAll = false;
                }
            });
            scope.$watch("collapseAll", function (value) {
                if (value) {
                    ctrl.collapseAll();
                    scope.collapseAll = false;
                }
            });
            scope.$watch("elemHeight", function (newVal,oldVal) {
                if(newVal!==oldVal){
                    if(!elem.hasClass('tiny-accordion')){
                        elem.css({'min-height':scope.tabHeight});
                    }
                }				
            });


            if (attribute.iconPosition === "left"){
                elem.addClass("iconleft");
            }

        }
    };
}])

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('ddhAccordionGroup', ['$parse', '$transition', '$scrollTo', '$timeout', '$log', '$position', 'keymap', '$window', '$document', '$scrollToHostElement',
    function ($parse, $transition, $scrollTo, $timeout, $log, $position, keymap, $window, $document, $scrollToHostElement) {
    return {
        // We need this directive to be inside an accordion
        require:['^ddhAccordion', '?^^modalWrapper'],
        restrict: 'EA', transclude: true, replace: true,
        templateUrl: 'template/expandCollapse/expandCollapse-group.html',
        scope: {heading: '@', isOpen: '=?', isDisabled: '=?', onExpand:'&', onCollapse:'&', hasNested:'@'},
        controller: [function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            }],
        link: function (scope, element, attrs, accordionCtrl) {
            scope.isMobile   = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            scope.onDark = false;
            if(accordionCtrl[0].elemClass('on-dark')){
                scope.onDark = true;
            }

//            scope.hasNested = false;
//            if(accordionCtrl[0].hasNested()){
//                scope.hasNested = true;
//            }

            scope.tSize = function(){
                return accordionCtrl[0].getSize();
            }
			if(accordionCtrl[0].isTabs()){
				scope.horizontal = true;
			}
            var tab = element.children().eq(0);
            var panel = element.children().eq(1);
            var handleKeydown = function (ev) {
                var boolFlag = true;
                switch (ev.keyCode) {
                    case keymap.KEY.ENTER:
                        ev.preventDefault();
                        scope.toggle();
                        scope.$apply();
                        break;
                    case keymap.KEY.UP:
                    case keymap.KEY.LEFT:
                        accordionCtrl[0].cycle(scope, false);
                        ev.preventDefault();
                        break;
                    case keymap.KEY.DOWN:
                    case keymap.KEY.RIGHT:
                        accordionCtrl[0].cycle(scope, true);
                        ev.preventDefault();
                        break;
                    default:
                        break;
                }
                return boolFlag;
            };
            var swallowKeypress = function (e) {
                if (e.altKey)
                {
                    return true;
                }
                var boolFlag = true;
                switch (e.keyCode)
                {
                    case keymap.KEY.PAGE_UP:
                    case keymap.KEY.PAGE_DOWN:
                        if (!e.ctrlKey) {
                            boolFlag = true;
                            break;
                        }
                        e.stopPropagation();
                        boolFlag = false;
                        break;
                    default:                       
                        break;
                }
                return boolFlag;
            };
            if (angular.isUndefined(scope.isOpen)) {
                scope.isOpen = false;
            }
            panel.bind("keypress", swallowKeypress);
            tab.bind("keydown", handleKeydown);
            accordionCtrl[0].addGroup(scope);			
            scope.onfocus = function(){				
				accordionCtrl[0].focus(scope);				
			};

            scope.toggle = function () {
                if (!scope.isDisabled) {                 
                    if(accordionCtrl[0].elemClass('tiny-tabs')){
						scope.isOpen = true;
                    }
					else if(accordionCtrl[0].elemClass('tiny-accordion-to-tabs')) {
						if($window.innerWidth < 767) {
							scope.isOpen = !scope.isOpen;
						}
						else {
							scope.isOpen = true;
						}						
					}
                    else {
                        scope.isOpen = !scope.isOpen;
                    }
                    										
                    accordionCtrl[0].focus(scope);
                    if (scope.isOpen && accordionCtrl[0].scrollTop()) {
                        var scrollTopParentElement = angular.element($document[0].getElementById(accordionCtrl[0].scrollTopParentId()));
                        if (angular.isDefined(scrollTopParentElement[0])) {
                            if ((accordionCtrl[1] !== null) && !accordionCtrl[1].isDockedModal()){
                                scrollTopParentElement = accordionCtrl[1].getModalWrapper();
                            }
                            if (accordionCtrl[0].isCloseOthers()) {
                                $timeout(function () {
                                    $scrollToHostElement(scrollTopParentElement, 0, element[0].offsetTop);
                                }, 1000);
                            } else {
                                $scrollToHostElement(scrollTopParentElement, 0, element[0].offsetTop);
                            }
                        } else {
                            if (accordionCtrl[0].isCloseOthers()) {
                                $timeout(function () {
                                    $scrollTo(0, $position.offset(element).top);
                                }, 1000);
                            } else {
                                $scrollTo(0, $position.offset(element).top);
                            }
                        }
                    }
					if(scope.isOpen){ 
						if(scope.onExpand)scope.onExpand();
					}
					else
					{
						if(scope.onCollapse)scope.onCollapse();
					}					
                }								
            };
            scope.$watch('isOpen', function (value) {
                if (value) {
                    accordionCtrl[0].closeOthers(scope);
                    //setting non focusable till further instructions come
                    panel.attr("tabindex", "-1"); 
                    if(accordionCtrl[0].elemClass('tiny-tabs') || accordionCtrl[0].elemClass('tiny-accordion-to-tabs')){					
						$timeout(function () {                          
							var panelheight =  panel[0].offsetHeight;
							panelheight = panelheight + 80;
							accordionCtrl[0].setHeight(panelheight);					
						}, 300);
					}
					
                } else {
                    panel.attr("tabindex", "-1");  
					if(accordionCtrl[0].elemClass('tiny-accordion-to-tabs') && $window.innerWidth < 767){
						accordionCtrl[0].setHeight(0);
					}
                } 
								
            });
            scope.$watch("focused", function (value) {				
				if (!!value) {
                    $timeout(function () {
                        tab[0].focus(); 
						
                    }, 0);
                }
            });
            scope.$watch("index", function (value) {
                if(value === 0)
                {
                    tab.attr("tabindex", "0");
                }

            });
        }
    };
}])


.directive('ddhAccordionTable', ['$parse', '$transition', '$scrollTo', '$timeout', '$log', '$position', 'keymap', '$document', '$scrollToHostElement',
    function ($parse, $transition, $scrollTo, $timeout, $log, $position, keymap, $document ,$scrollToHostElement) {
    return {
        // We need this directive to be inside an accordion
        require: '^ddhAccordion',
        restrict: 'EA', transclude: true, replace: true,
        templateUrl: 'template/expandCollapse/expandCollapse-table.html',
        scope: {column1: '@', column2: '@', isOpen: '=?', isDisabled: '=?', onExpand:'&', onCollapse:'&'},
        controller: [function () {
                this.setHeading = function (element) {
                    this.heading = element;
                };
            }],
        link: function (scope, element, attrs, accordionCtrl) {
            //scope.tSize = accordionCtrl.getSize();
            if(angular.isDefined(attrs.noColorColumn2)){
                scope.colorStyle= {'background-color':'transparent'};
            }else{
                scope.colorStyle= {};
            }
            scope.tSize = function(){
                return accordionCtrl.getSize();
            }
            var tab = element.children().eq(0);
            var panel = element.children().eq(1);
            var handleKeydown = function (ev) {
                var boolFlag = true;
                switch (ev.keyCode) {
                    case keymap.KEY.ENTER:
                        ev.preventDefault();
                        scope.toggle();
                        scope.$apply();
                        break;
                    case keymap.KEY.UP:
                    case keymap.KEY.LEFT:
                        accordionCtrl.cycle(scope, false);
                        ev.preventDefault();
                        break;
                    case keymap.KEY.DOWN:
                    case keymap.KEY.RIGHT:
                        accordionCtrl.cycle(scope, true);
                        ev.preventDefault();
                        break;
                    default:                        
                        break;
                }
                return boolFlag;
            };
			
            var swallowKeypress = function (e) {
                if (e.altKey)
                {
                    return true;
                }
                var boolFlag = true;
                switch (e.keyCode)
                {
                    case keymap.KEY.PAGE_UP:
                    case keymap.KEY.PAGE_DOWN:
                        if (!e.ctrlKey) {
                            boolFlag = true;
                            break;
                        }
                        e.stopPropagation();
                        boolFlag = false;
                        break;
                    default:
                        break;
                }
                return boolFlag;
            };			
            if (angular.isUndefined(scope.isOpen)) {
                scope.isOpen = false;
            }
            panel.bind("keypress", swallowKeypress);
            tab.bind("keydown", handleKeydown);
            accordionCtrl.addGroup(scope);
            scope.toggle = function () {
                if (!scope.isDisabled) {
                    //tab.attr('aria-live', 'polite');
                    //tab.attr('aria-atomic', 'false');
                    scope.isOpen = !scope.isOpen;
                    accordionCtrl.focus(scope);
                    if (scope.isOpen && accordionCtrl.scrollTop()) {
                        var scrollTopParentElement = angular.element($document[0].getElementById(accordionCtrl.scrollTopParentId()));
                        if (scrollTopParentElement) {
                            if (accordionCtrl.isCloseOthers()) {
                                $timeout(function () {
                                    $scrollToHostElement(scrollTopParentElement, 0, element[0].offsetTop);
                                }, 1000);
                            } else {
                                $scrollToHostElement(scrollTopParentElement, 0, element[0].offsetTop);
                            }
                        } else {
                            if (accordionCtrl.isCloseOthers()) {
                                $timeout(function () {
                                    $scrollTo(0, $position.offset(element).top);
                                }, 1000);
                            } else {
                                $scrollTo(0, $position.offset(element).top);
                            }
                        }
                    }
					if(scope.isOpen){
						if(scope.onExpand)scope.onExpand();
					}
					else
					{
						if(scope.onCollapse)scope.onCollapse();
					}
                    calculateTableCellLines();														
                }
            };
            scope.$watch('isOpen', function (value) {
                if (value) {
                    accordionCtrl.closeOthers(scope);
                    //setting non focusable till further instructions come
                    panel.attr("tabindex", "-1");   
                } else {
                    panel.attr("tabindex", "-1"); 
                }
            });
            scope.$watch("focused", function (value) {
                if (!!value) {
                    $timeout(function () {
                        tab[0].focus();
                    }, 0)
                            ;
                }
            });
            scope.$watch("index", function (value) {
                if(value === 0)
                {
                    tab.attr("tabindex", "0");
                }

            });			


            function calculateTableCellLines(){
                $timeout(function () {
                    var fauxTableCell = element[0].querySelectorAll('.accordion-content .faux-table-cell');
                    for (var i = 0; i < fauxTableCell.length; i++){
                        var cellHeight = fauxTableCell[i].clientHeight - 17;
                        angular.element(fauxTableCell[i]).css("background-position", "0px " + cellHeight + "px");
                    }

                }, 50);
            }
        }
    };
}])

.directive('ddhAccordionHeading', function () {
    return {
        restrict: 'EA', transclude: true, template: '', replace: true,
        require: '^ddhAccordionGroup',
        compile: function (element, attr, transclude) {
            var link = function (scope, element, attr, accordionGroupCtrl) {
                // Pass the heading to the accordion-group controller
                // so that it can be transcluded into the right place in the template
                // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
                accordionGroupCtrl.setHeading(transclude(scope, function () {
                }));
            };
            return link;
        }
    };
})

.directive('ddhAccordionTransclude', function () {
    return {
        require: '^ddhAccordionGroup',
        link: function (scope, element, attr, controller) {
            scope.$watch(function () {
                return controller[attr.ddhAccordionTransclude];
            }, function (heading) {
                if (heading) {
                    element.find("span").html('');
                    element.find("span").append(heading);
                }
            });
        }
    };
});


/**
 * @ngdoc directive
 * @name Banners, marquees & tiles.ddh:filmstrip
 *
 * @description
 *  <file src="src/filmstrip/docs/readme.md" />
 * @usage
 *  <div ddh-filmstrip filmstrip-type="{{filmstripType1}}">
		<div ddh-filmstrip-content ng-repeat="item in items1">
			<a ng-href="{{item.linkUrl}}" class="fs-items">
				<img ng-src="{{item.imageUrl}}" class="fs-item-image" alt="{{item.altText}}">
				<div class="fs-item-desc">
					<p class="fs-icon-label" ng-bind="item.label">
						<span class="hidden-spoken">.</span>
					</p>
				</div>
			</a>
		</div>
		<!-- extra link to full list -->
		<div ddh-filmstrip-content>
			<a class="fs-items view-more" ng-href="{{categoryLink1}}">View more</a>
		</div>
	</div>
 *
 * @example
 <section id="code">
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/filmstrip/docs/demo.html" />
 <file src="src/filmstrip/docs/demo.js" />
 </example>
 </section>
 */
angular.module('ddh.att.filmstrip', ['ddh.att.position', 'ddh.att.utilities', 'ddh.att.lazyLoad', 'ds2Scroll'])
        .directive('ddhFilmstrip', ['$document', '$window', '$timeout', 'keymap', 'userAgent', 'ddhLazyLoad', function ($document, $window, $timeout, keymap, userAgent, ddhLazyLoad) {
                return {
                    restrict: 'EA',
                    transclude: true,
                    replace: true,
                    scope: {
                        filmstripType: '@',
                        filmstripHeading: '@'
                    },
                    templateUrl: 'template/filmstrip/ddhFilmstrip.html',
                    compile: function (elem, attr) {
                        ddhLazyLoad.load('filmstrip', 'css');

                        return this.link;
                    },
                    controller: ['$scope', '$timeout', '$position', '$element', '$window', function ($scope, $timeout, $position, $element, $window) {
                            this.groups = [];
                            this.index = 0;

                            this.addGroup = function (groupScope) {
                                var that = this;
                                groupScope.index = this.groups.length;
                                groupScope.focused = false;
                                this.groups.push(groupScope);
                                groupScope.$on('$destroy', function () {
                                    that.removeGroup(groupScope);
                                });
                                return groupScope.index;
                            };

                            this.removeGroup = function (group) {
                                var index = this.groups.indexOf(group);
                                if (index !== -1) {
                                    this.groups.splice(this.groups.indexOf(group), 1);
                                }
                            };

                            this.registerElement = function (elem) {
                                $scope.iwidth = elem[0].clientWidth;
                                var window = angular.element($window);
                                var showFilmstripContent = function () {
                                    if ($position.isElementInViewport($element)) {
                                        $timeout(function () {																				
                                            var container = $element[0].querySelector(".contents");
											angular.element(container).addClass('items-in');											
											/*enable right arrow button only when container has scrollable content*/
											if(container.scrollWidth > container.clientWidth){
												angular.element($element[0].querySelector('.right-arrow')).attr('disabled', null);
											}											
                                        }, 100);
                                        $timeout(function () {
                                            window.unbind('scroll', showFilmstripContent);
                                            window.unbind('orientationchange', showFilmstripContent);
                                            window.unbind('resize', showFilmstripContent);
                                        });
                                    }
                                    $scope.$apply();
                                };
                                window.bind('scroll', showFilmstripContent);
                                window.bind('orientationchange', showFilmstripContent);
                                window.bind('resize', showFilmstripContent);
                                $timeout(showFilmstripContent, 500);
                            };

                            this.cycle = function (group, down, noRecycle) {
                                if (!down) {
                                    if (this.index <= 0 && !noRecycle) {
                                        this.index = this.groups.length - 1;
                                    } else {
                                        this.index--;
                                    }
                                } else {
                                    if (this.index >= (this.groups.length - 1) && !noRecycle) {
                                        this.index = 0;
                                    } else {
                                        this.index++;
                                    }
                                }
                                group.focused = false;
                                this.groups[this.index].focused = true;
                                $scope.$apply();
                            };

                            this.setId = function (id) {
                                $scope.cfsId = id;
                            };

                            this.getId = function () {
                                return $scope.cfsId;
                            };
                        }],
                    link: function (scope, elem, attr, ctrl) {
                        var fsContent = elem[0].querySelector('.contents'),
						rightArrow = elem[0].querySelector('.right-arrow'),
						leftArrow = elem[0].querySelector('.left-arrow');								
						if(fsContent.scrollLeft === 0){						
							angular.element(leftArrow).attr('disabled', true);
							angular.element(rightArrow).attr('disabled', true);
						};
                        scope.fsId = attr.id ? attr.id : "";
                        ctrl.setId(scope.fsId);
                        scope.count = 0;
                        scope.isMobile = userAgent.isMobile();
						fsContent.addEventListener('scroll',function(e){							
							var csl = e.currentTarget.scrollLeft;
							var msl = (e.currentTarget.scrollWidth - e.currentTarget.offsetWidth);
							if( csl === 0){
								angular.element(leftArrow).attr('disabled', true);
								angular.element(rightArrow).attr('disabled', null);
							}
							else if( csl > 0 & csl < msl){
								angular.element(leftArrow).attr('disabled', null);
								angular.element(rightArrow).attr('disabled', null);
							}
							else if((msl - csl) < 5){
								angular.element(leftArrow).attr('disabled', null);
								angular.element(rightArrow).attr('disabled', true);
							}
						});			
						fsContent.addEventListener('dragstart', function(e) { 
							e.preventDefault();
						});						
                        var viewerWidth = function (){									
							item_width = fsContent.querySelectorAll('.item')[0].clientWidth;
							scroll_unit = itemQty(fsContent);	
							return (item_width * scroll_unit);
                        };                        
                        scope.moveright = function (){																		
							var offsetL = fsContent.scrollLeft + viewerWidth();
							angular.element(fsContent).eq(0).scrollTo(offsetL, 0, 800);
						};                        
						scope.moveleft = function (){						
							var offsetL = fsContent.scrollLeft - viewerWidth();
							angular.element(fsContent).eq(0).scrollTo(offsetL, 0, 800);
                        };					
                        // returns the number of visible items in the filmstrip
                        var itemQty = function (obj){
                            var item = obj.querySelectorAll('.item')[1],
                            width = item.offsetWidth + 25;
                            return Math.floor(obj.clientWidth / width);
                        };                       
                        elem.on('keydown', function (e){
                            var code = e.keyCode,
                                    RIGHT = 39 === code, LEFT = 37 === code, SPACE = 32 === code, ENTER = 13 === code,
                                    tar = angular.element(e.target);
                            // if left or right arrow on the keyboard is pressed
                            if (LEFT || RIGHT) {
                                e.preventDefault()
                                // if focus on ul.contents, go to first list item
                                if (tar.hasClass('contents')) 
                                {
                                    var first = tar.children(':first-child')
                                    tar.attr({
                                        'tabindex': '-1',
                                        'aria-activedescendant': first.attr('id')
                                    })
                                    first.attr({
                                        'tabindex': '0',
                                        'aria-selected': 'true'
                                    }).focus()
                                } else if (tar.hasClass('item') || e.target.tagName.toLowerCase === 'a') {
                                    var li = e.target.tagName.toLowerCase === 'a' ? e.target.parentElement : e.target;
                                    var item;
                                    // skip hidden item
                                    if (RIGHT && li.nextElementSibling) {
                                        if (window.getComputedStyle(li.nextElementSibling).display === "none") {
                                            item = li.nextElementSibling.nextElementSibling;
                                        } else {
                                            item = li.nextElementSibling;
                                        }
                                        ctrl.index++;
                                        if(ctrl.index % itemQty(fsContent) === 0){
                                            scope.count++;
                                            angular.element(leftArrow).attr('disabled', null);
                                        }                                        
                                    } else if (LEFT && li.previousElementSibling) {
                                        if (window.getComputedStyle(li.previousElementSibling).display === "none") {
                                            item = li.previousElementSibling.previousElementSibling;
                                        } else {
                                            item = li.previousElementSibling;
                                        }
                                        ctrl.index--;
                                        if(ctrl.index % itemQty(fsContent) === 0){
                                            scope.count--;
                                        }
                                    }
                                    if (angular.element(item).length && window.getComputedStyle(item).display !== "none") {
                                        angular.element(li).attr({
                                            'tabindex': '-1',
                                            'aria-selected': 'false'
                                        }).parent().attr('aria-activedescendant', angular.element(item).attr('id'));

                                        angular.element(item).attr({
                                            'tabindex': '0',
                                            'aria-selected': 'true'
                                        });
                                        angular.element(item)[0].focus();
                                    }
                                }
                            }
                            else if ((ENTER || SPACE) && tar.hasClass('item')) {
                                e.preventDefault();
                                tar.children('a')[0].click();
                            }
                        });                    									
						if(!userAgent.isMobile()) {														
							scope.mouseEvent={};
							angular.element(fsContent).on('mousedown', function(e){							
								if(!!fsContent){																
									scope.mouseEvent.mouseDown = true
									scope.mouseEvent.pageX = e.pageX
									scope.mouseEvent.pageY = e.pageY
								}							
							});
							
							$document.on('mouseup', function(e){							
								// check only mouseDown is set
								if(scope.mouseEvent.mouseDown) {               
								   // if mouse motion acting as drag, stop click
								   if(scope.mouseEvent.trace && scope.mouseEvent.trace.length > 3){									  
										e.preventDefault(); 									  
								   }					   
								   // reset variables 
								   scope.mouseEvent.mouseDown = false
								   scope.mouseEvent.trace = scope.mouseEvent.fsc = scope.mouseEvent.pageX = scope.mouseEvent.pageY = undefined
								}
												
							});							
							
							elem.on('mousemove', function(e){							
								if(scope.mouseEvent.mouseDown) {
								   // recording the delta of movements
								   scope.mouseEvent.movementX = e.pageX - scope.mouseEvent.pageX;
								   scope.mouseEvent.movementY = e.pageY - scope.mouseEvent.pageY;
								   scope.mouseEvent.pageX = e.pageX;
								   scope.mouseEvent.pageY = e.pageY;
								   var moved = scope.mouseEvent.movementX;
								   scope.mouseEvent.fsc = {};
								   scope.mouseEvent.fsc.tar = elem[0].querySelector('.contents');
								   scope.mouseEvent.fsc.scrolled = fsContent.scrollLeft || 0;
								   fsContent.scrollLeft = (scope.mouseEvent.fsc.scrolled - moved);
								   //scope.mouseEvent.fsc.tar.scrollLeft(scope.mouseEvent.fsc.scrolled - moved);
								   // a variable to track if mouse travel far enough to be determine as drag/swipe
								   scope.mouseEvent.trace = scope.mouseEvent.trace || [];
								   scope.mouseEvent.trace.push(scope.mouseEvent.movementX);
								}
							});		
							
						}
						
						
					 }
                };
            }])
        .directive('ddhFilmstripContent', ['$timeout', 'keymap', function ($timeout, keymap) {
                return {
                    restrict: 'EA',
                    transclude: true,
                    replace: true,
                    scope: {},
                    require: '^ddhFilmstrip',
                    templateUrl: 'template/filmstrip/ddhFilmstripContent.html',
                    link: function (scope, elem, attr, ctrl) {
                        ctrl.registerElement(elem);
                        scope.cFsId = ctrl.getId();
                        scope.isSelected = false;
                        scope.fsIndex = ctrl.addGroup(scope);
                        elem.css('left','0px');

                        if (scope.$parent.$first) {
                            elem.attr('tabindex', 0);
                        }
                        else {
                            elem.attr('tabindex', -1);
                        }

                        scope.$watch("focused", function (value) {
                            if (!!value) {
                                $timeout(function () {
                                    elem[0].focus();
                                    scope.isSelected = true;
                                }, 0);
                            }
                            else
                            {
                                scope.isSelected = false;
                            }
                        });

                    }
                };
            }])
		.directive('ddhFilmstripViewmore', [function() {
			return {
				restrict: 'A',
				transclude: false,		
				link: function (scope, elem, attr) {			
					elem.bind('click', function(){				
						elem.remove();
					});
				}
			};		
		}])
			
        .filter('split', function () {
            return function (input) {
                // do some bounds checking here to ensure it has that index
                var a = input.split(":");
                if (a.length == 3) {
                    return a[0] + 'hours' + a[1] + 'minutes' + a[2] + 'seconds';
                } else {
                    return a[0] + 'minutes' + a[1] + 'seconds';

                }

            };
        });

angular.module('ddh.att.expander', [])
.constant('ddhExpanderConfig', { 
    msDelay: 300, 
    transitionTimingFunction: 'ease' 
}) 
 
// The expandible/collapsible directive that causes  indicates a block of html that will expand and collapse 
.directive('ddhExpand', ['$timeout', 'ddhExpanderConfig', function($timeout, ddhExpanderConfig) { 

    var props = { 
        open: { 
            marginTop: null, 
            marginBottom: null, 
            paddingTop: null, 
            paddingBottom: null 
        }, 
        closed: { 
            marginTop: 0, 
            marginBottom: 0, 
            paddingTop: 0, 
            paddingBottom: 0  
        } 
    }; 

    var fixUpCSS = function(scope, element, cssObject) { 
        element.css(cssObject); 
    }; 

    return { 
        link: function(scope, element, attrs) { 
            var msDelay = attrs.msDelay ? attrs.msDelay : ddhExpanderConfig.msDelay; 
            var transitionTimingFunction = attrs.transitionTimingFunction ? attrs.transitionTimingFunction : ddhExpanderConfig.transitionTimingFunction; 

            var transition = 'all ' + msDelay + 'ms ' + transitionTimingFunction; 
            var transitionStyle = { 
                '-webkit-transition': transition, 
                '-moz-transition': transition, 
                '-ms-transition': transition, 
                '-o-transition': transition, 
                transition: transition 
            }; 

            element.css(transitionStyle); 

            var whichTransitionEvent = function () { 
                var transitionsItem; 
                var el = document.createElement('fakeelement'); 
                var transitions = { 
                    'transition': 'transitionend', 
                    'OTransition': 'oTransitionEnd', 
                    'MozTransition': 'transitionend', 
                    'WebkitTransition': 'webkitTransitionEnd' 
                }; 
                for (transitionsItem in transitions) { 
                    if (el.style[transitionsItem] !== undefined) { 
                        return transitions[transitionsItem]; 
                    } 
                } 
            }; 
            /* Listen for a transition! */ 
            var transitionEvent = whichTransitionEvent(); 

            var isCollapsed = false; 
            var expandCollapseEnd = function () { 
                fixUpCSS(scope, element, {'overflow': ''}); 
                if(isCollapsed) { 
                    fixUpCSS(scope, element, {'display': 'none'}); 
                } 
                else { 
                    fixUpCSS(scope, element, {'maxHeight': 'none'}); 
                } 
            }; 

            transitionEvent && element[0].addEventListener(transitionEvent, function (e) { 
                expandCollapseEnd(); 
            });

            if(!scope.$eval(attrs.ddhExpand)) { 
                isCollapsed = true; 
            } 
            expandCollapseEnd(); 

            scope.$watch(attrs.ddhExpand, function(newValue, oldValue) { 
                if(newValue !== oldValue) { 
                    if (newValue) { 
                        expand(); 
                    } else { 
                        collapse(); 
                    } 

                    if(msDelay === 0) { 
                        expandCollapseEnd(); 
                    } 
                } 
            }); 

            var expand = function() { 
                fixUpCSS(scope, element, angular.extend({'overflow':'hidden', 'display': 'block', 'max-height': 0}, props.open)); 
                isCollapsed = false; 
                $timeout(function() { 
                    fixUpCSS(scope, element, angular.extend({'max-height': element[0].scrollHeight + 'px'}, props.open)); 
                }); 
            }; 

            var collapse = function() { 
                fixUpCSS(scope, element, {'overflow':'hidden', 'display': 'block'}); 
                isCollapsed = true; 
                fixUpCSS(scope, element, {'maxHeight':element[0].scrollHeight + 'px'}); 
                $timeout(function() { 
                    fixUpCSS(scope, element, angular.extend({'max-height': 0}, props.closed)); 
                }, 100); 
            }; 
        } 
    }; 
}])

.directive('ddhExpanderGroup', function () {
    return {
        restrict: 'A',
        controller: ['$scope', '$attrs', function ($scope, $attrs) {
            this.groups = [];
            this.index = -1;
            this.scope = $scope;

            this.addGroup = function (groupScope) {
                var that = this;
                groupScope.index = this.groups.length;
                this.groups.push(groupScope);
                if (this.groups.length > 0) {
                    this.index = 0;
                }
                groupScope.$on('$destroy', function () {
                    that.removeGroup(groupScope);
                });
            };

            this.closeOthers = function (openGroup) {
                var closeOthers = angular.isDefined($attrs.closeOthers);
                if (closeOthers && !$scope.forceExpand) {
                    angular.forEach(this.groups, function (group) {
                        if (group !== openGroup) {
                            group.isOpen = false;
                        }
                    });
                }
                if (this.groups.indexOf(openGroup) === (this.groups.length - 1) && $scope.forceExpand) {
                    $scope.forceExpand = false;
                }
            };
            this.removeGroup = function (group) {
                var index = this.groups.indexOf(group);
                if (index !== -1) {
                    this.groups.splice(this.groups.indexOf(group), 1);
                }
            };
        }]

    };

})

.directive('ddhExpanders', function () {
    return {
        restrict: 'A',
        require: ['ddhExpanders', '?^ddhExpanderGroup'],
        scope: {
            isOpen: '=?'
        },
        controller: ['$scope', function ($scope) {
            var bodyScope = null;
            var expanderScope = null;
            this.isOpened = function () {
                if ($scope.isOpen) {
                    return true;
                } else {
                    return false;
                }
            };
            this.setScope = function (scope) {
                bodyScope = scope;
                bodyScope.isOpen = $scope.isOpen;
            };
            this.setExpanderScope = function (scope) {
                expanderScope = scope;
            };
            this.toggle = function () {
                $scope.isOpen = bodyScope.isOpen = !bodyScope.isOpen;
                return bodyScope.isOpen;

            };
            this.watchToggle = function (io) {
                bodyScope.isOpen = io;
                expanderScope.updateIcons(io);
            };
            }],
        link: function (scope, elem, attr, myCtrl) {
            //scope.isOpen = false; 
            if (myCtrl[1]) {
                myCtrl[1].addGroup(scope);
            }
            scope.$watch('isOpen', function (val) {
                myCtrl[0].watchToggle(scope.isOpen);
                if (val && myCtrl[1]) {
                    myCtrl[1].closeOthers(scope);
                }
            });
        }
    };
})

.directive('ddhExpanderHeading', function () {
    return {
        require: "^ddhExpanders",
        restrict: 'A',
        scope: true
    };
})

.directive('ddhExpanderBody', ['$compile', '$timeout', function ($compile, $timeout) {
    return {
        restrict: 'A',
        require: "^ddhExpanders",
        scope: {},
        compile: function (elem, attr) {
            return {
                pre: function (scope, elem) {
                    elem[0].removeAttribute('ddh-expander-body');
                    elem[0].setAttribute('ddh-collapse', '!isOpen');
                    $compile(elem)(scope);
                },
                post: function (scope, elem, attr, myCtrl) {
                    scope.isOpen = false;
                    myCtrl.setScope(scope);
                }
            };
        }
    };
}])

.directive('ddhExpanderToggle', function () {
    return {
        restrict: 'A',
        require: '^ddhExpanders',
        scope: {
            expandIcon: '@?',
            collapseIcon: '@?'
        },

        link: function (scope, element, attr, myCtrl) {

            element.attr('role', 'button');

            var iconElement = element;

            if (attr.expandIcon && attr.collapseIcon && !attr.ddhExpanderToggleIcon) {
                var tempIconElement = element[0].querySelector('[ddh-expander-toggle-icon]');
                if (tempIconElement) {
                    iconElement = angular.element(tempIconElement);
                }
            }

            myCtrl.setExpanderScope(scope);
            var isOpen = myCtrl.isOpened();

            scope.setIcon = function () {

                if (scope.expandIcon && scope.collapseIcon) {
                    if (isOpen) {
                        iconElement.removeClass(scope.expandIcon);
                        iconElement.addClass(scope.collapseIcon);

                        element.attr("aria-expanded", "true");
                    } else {
                        iconElement.removeClass(scope.collapseIcon);
                        iconElement.addClass(scope.expandIcon);

                        element.attr("aria-expanded", "false");
                    }
                }
            };

            element.bind('click', function () {
                scope.toggleit();
            });
            scope.updateIcons = function (nStat) {
                isOpen = nStat;
                scope.setIcon();
            };
            scope.toggleit = function () {
                isOpen = myCtrl.toggle();
                scope.setIcon();
                scope.$apply();
            };
            scope.setIcon();
        }
    };
})

/**
 * @ngdoc directive
 * @name Navigation.att:filters - simple asyncronous
 *
 * @description
 *  <file src="src/filters/docs/readme.md" />
 *
 * @usage
 *  <!-- Imlementation provided below -->
 *
 * @example
 * 	<section id="code">
	   <b>HTML + AngularJS</b>
	    <example module="ddh.att">
            <file src="src/filters/docs/demo.html" />
            <file src="src/filters/docs/demo.js" />
       </example>
	</section>
 * 
 */
angular.module('ddh.att.filters', ['ddh.att.utilities', 'ddh.att.expander', 'ddh.att.expandCollapse', 'ddh.att.lazyLoad'])
    .filter('filtersSelectedItemsFilter', [function () {
        return function (listOfItemsArray) {

            if (!listOfItemsArray) {
                listOfItemsArray = [];
            }

            var returnArray = [];

            for (var i = 0; i < listOfItemsArray.length; i++) {
                for (var j = 0; j < listOfItemsArray[i].filterTypeItems.length; j++) {
                    if (listOfItemsArray[i].filterTypeItems[j].selected && !listOfItemsArray[i].filterTypeItems[j].inProgress) {
                        returnArray.push(listOfItemsArray[i].filterTypeItems[j]);
                    }
                }
            }

            return returnArray;
        };
    }])

.directive('ddhFiltersSimple', ['$document', '$compile', '$timeout', '$window', '$q', '$ddhSetKeyValueOnAllArrayItems', 'ddhLazyLoad', function ($document, $compile, $timeout, $window, $q, $ddhSetKeyValueOnAllArrayItems, ddhLazyLoad) {
    return {
        restrict: 'A',
        transclude: true,
        replace: true,
        scope: true,
        templateUrl: 'template/filters/ddhFiltersSimple.html',
        compile: function (elem, attr) {
            ddhLazyLoad.load('filter', 'css');
            ddhLazyLoad.load('icon-controls', 'css');

            return this.link;
        },
        link: function (scope, element, attr) {
            scope.mainHeading = attr.mainHeading || 'Filters';
            scope.selectedFiltersHeading = attr.selectedFiltersHeading || 'Selected filters';

            var selectedFiltersArrayParentKey = attr.ddhFiltersSimple || 'selectedFiltersArray';
            scope.$watch('selectedFiltersArray', function (newVal) {
                scope.$parent[selectedFiltersArrayParentKey] = newVal;
            });

            scope.displayComponent = true;
            scope.$watch('displayComponent',function(newVal){
                scope.$parent.displayComponent = newVal;
            });
            
            scope.largeViewport = true;

            var backdropElement = angular.element('<div class="filter-backdrop fade in" ng-click="hideFiltersPanel($event)"></div>');
            var body = angular.element($document[0].body);

            scope.setDisplayComponentFlag = function (value) {

                if (scope.largeViewport) {
                    value = scope.displayComponent = true;
                }

                if (!scope.largeViewport && value) {
                    body.addClass('filter-displayed');
                    body.append($compile(backdropElement)(scope));
                    $timeout(function () {
                        $document[0].getElementById('filtersMainHeading').focus();
                    }, 500);
                } else {
                    angular.element($document[0].body).removeClass('filter-displayed');
                    backdropElement.remove();
                }
                scope.displayComponent = value;
            };

            scope.showFiltersPanel = function (evt) {
                if (evt) {
                    evt.preventDefault();
                    scope.showFiltersPanelButton = evt.target;
                }
                scope.setDisplayComponentFlag(true);
            };
            scope.$parent.showFiltersPanel = scope.showFiltersPanel;

            scope.hideFiltersPanel = function (evt) {
                if (evt) {
                    evt.preventDefault();
                }

                scope.setDisplayComponentFlag(false);

                $timeout(function () {
                    if (!scope.largeViewport && scope.showFiltersPanelButton) {
                        scope.showFiltersPanelButton.focus();
                        scope.showFiltersPanelButton = undefined;
                    }
                });
            };


            var resizeFixtures = function () {
                if ($window.innerWidth < 1024) {
                    if (scope.largeViewport) {
                        scope.displayComponent = false;
                    }
                    scope.largeViewport = false;
                } else {
                    scope.largeViewport = true;
                    scope.displayComponent = true;
                }
                scope.setDisplayComponentFlag(scope.displayComponent);
            };

            if ($window.innerWidth < 1024) {
                scope.displayComponent = false;
            }
            resizeFixtures();

            angular.element($window).bind('resize', function () {
                resizeFixtures();
                scope.$apply();
            });


            //--------CODE TO EXPOSE API FOR FILTER HANDLES--------

            //clearAllFilterSelection FXN
            var clearAllFxn = attr.clearAllFxn || 'clearAllFilterSelection';
            scope.clearAllFilterSelection = function (selectedFiltersArray) {
                if (!selectedFiltersArray || selectedFiltersArray.length === 0) {
                    //No filters applied
                    return;
                }

                //setting the loading state of checkbox
                $ddhSetKeyValueOnAllArrayItems(selectedFiltersArray, ['inProgress'], [true]);

                //CALL the real fxn handle, if it is defined
                if (scope.$parent[clearAllFxn]) {
                    $q.resolve(scope.$parent[clearAllFxn](selectedFiltersArray))
                        .then(function (selectedFiltersArray) {
                            //un-setting the loading state of checkboxs
                            $ddhSetKeyValueOnAllArrayItems(selectedFiltersArray, ['inProgress', 'selected'], [false, false]);
                            //setting focus to the header, when all filters are removed
                            $document[0].getElementById('filtersMainHeading').focus();
                        }, angular.noop());
                } else {
                    //un-setting the loading state of checkboxs
                    $ddhSetKeyValueOnAllArrayItems(selectedFiltersArray, ['inProgress', 'selected'], [false, false]);
                }

            };

            //removeFilter FXN
            var removeFilterFxn = attr.removeFilterFxn || 'removeFilter';
            scope.removeFilter = function (selectedFilter) {
                //setting the loading state of checkbox
                selectedFilter.inProgress = true;

                //CALL the real fxn handle, if it is defined
                if (scope.$parent[removeFilterFxn]) {
                    $q.resolve(scope.$parent[removeFilterFxn](selectedFilter))
                        .then(function (selectedFilter) {
                            //un-setting the loading state of checkbox
                            selectedFilter.inProgress = false;
                            selectedFilter.selected = false;

                            //setting focus to the header, when a filter is removed
                            $timeout(function () {
                                scope.$digest();
                                if (scope.selectedFiltersArray && scope.selectedFiltersArray.length !== 0) {
                                    $document[0].getElementById('selectedFilters').focus();
                                } else {
                                    $document[0].getElementById('filtersMainHeading').focus();
                                }
                            });
                        }, angular.noop());
                } else {
                    //un-setting the loading state of checkbox
                    selectedFilter.inProgress = false;
                    selectedFilter.selected = false;

                    //setting focus to the header, when a filter is removed
                    $timeout(function () {
                        scope.$digest();
                        if (scope.selectedFiltersArray && scope.selectedFiltersArray.length !== 0) {
                            $document[0].getElementById('selectedFilters').focus();
                        } else {
                            $document[0].getElementById('filtersMainHeading').focus();
                        }
                    });
                }
            };
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Navigation.att:filters - complex content
 *
 * @description
 *  <file src="src/filtersComplex/docs/readme.md" />
 *
 * @usage
 *  <!-- Imlementation provided below -->
 *
 * @example
 * 	<section id="code">
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/filtersComplex/docs/demo.html" />
 <file src="src/filtersComplex/docs/demo.js" />
 </example>
 </section>
 * 
 */
angular.module('ddh.att.filtersComplex', ['ddh.att.utilities', 'ddh.att.expander', 'ddh.att.expandCollapse', 'ddh.att.lazyLoad', 'ddh.att.filters'])
    .directive('ddhFiltersComplex', ['$window', '$document', '$timeout','$compile','ddhLazyLoad','filtersSelectedItemsFilterFilter', function ($window, $document, $timeout,$compile,ddhLazyLoad,filtersSelectedItemsFilterFilter) {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'template/filtersComplex/ddhfiltersComplex.html',
            transclude: true,
            compile: function (elem, attr) {
                ddhLazyLoad.load('filter', 'css');
                ddhLazyLoad.load('icon-controls', 'css');

                return this.link;
            },
            link: function (scope, elem, attr) {
                scope.mainHeading = attr.mainHeading || 'Filters';
                scope.selectedFiltersHeading = attr.selectedFiltersHeading || 'Selected filters';
                
                var selectedFiltersArrayParentKey = attr.ddhFiltersComplex || 'selectedFiltersArray';
                scope.$watch('selectedFiltersArray', function (newVal) {
                    scope.$parent[selectedFiltersArrayParentKey] = newVal;
                });
                
                scope.displayComponent = true;
                scope.$watch('displayComponent',function(newVal){
                    scope.$parent.displayComponent = newVal;
                });
                
                scope.largeViewport = true;
                scope.mediumViewport = false;

                var backdropElement = angular.element('<div class="filter-backdrop fade in" ng-click="hideFiltersPanel($event)"></div>');
                var body = angular.element($document[0].body);

                scope.setDisplayComponentFlag = function (value) {
                    if (scope.largeViewport) {
                        value = scope.displayComponent = true;
                    }
                    if (!scope.largeViewport && value) {
                        body.addClass('filter-displayed');
                        body.append($compile(backdropElement)(scope));
                        $timeout(function () {
                            $document[0].getElementById('filtersMainHeading').focus();
                        }, 500);
                    }
                    else {
                        angular.element($document[0].body).removeClass('filter-displayed');
                        backdropElement.remove();
                    }
                    scope.displayComponent = value;
                };

                scope.showFiltersPanel = function (evt) {
                    if (evt) {
                        evt.preventDefault();
                        scope.showFiltersPanelButton = evt.target;
                    }
                    scope.setDisplayComponentFlag(true);
                };
                scope.$parent.showFiltersPanel = scope.showFiltersPanel;
                
                scope.hideFiltersPanel = function (evt) {
                    if (evt) {
                        evt.preventDefault();
                    }

                    scope.setDisplayComponentFlag(false);

                    $timeout(function () {
                        if (!scope.largeViewport && scope.showFiltersPanelButton) {
                            scope.showFiltersPanelButton.focus();
                            scope.showFiltersPanelButton = undefined;
                        }
                    });
                };
                
                
                /********** Remove Filter Function ************/
                var removeFilterFxn = attr.removeFilterFxn || 'removeFilter';
                scope.removeFilter = function (selectedFilter) {
                    selectedFilter.selected = false;
                    scope.selectedFiltersArray = filtersSelectedItemsFilterFilter(scope.availableFiltersArray);

                    if (scope.$parent[removeFilterFxn]) {
                        scope.$parent[removeFilterFxn](selectedFilter);
                    }
                    
                    //setting focus to the header, when a filter is removed
                    if (scope.selectedFiltersArray && scope.selectedFiltersArray.length !== 0) {
                        $document[0].getElementById('selectedFilters').focus();
                    }
                    else {
                        $document[0].getElementById('filtersMainHeading').focus();
                    }
                };
                
                /********** Clear Filter Function ************/
                var clearAllFxn = attr.clearAllFxn || 'clearAllFilterSelection';
                scope.clearAllFilterSelection = function (selectedFiltersArray) {
                    if (!selectedFiltersArray || selectedFiltersArray.length === 0) {
                        return;
                    }
                    for (var i = 0; i < selectedFiltersArray.length; i++) {
                        selectedFiltersArray[i].selected = false;
                    }
                    scope.selectedFiltersArray = filtersSelectedItemsFilterFilter(scope.availableFiltersArray);
                    if (scope.$parent[clearAllFxn]) {
                        scope.$parent[clearAllFxn](selectedFiltersArray);
                    }
                    
                    //setting focus to the header, when all filters are removed
                    $document[0].getElementById('filtersMainHeading').focus();
                };

                /*** Apply Filter ***/
                scope.applyFilter = function (evt) {
                    if (!scope.availableFiltersArray) {
                        scope.availableFiltersArray = [];
                    }
                    scope.selectedFiltersArray = filtersSelectedItemsFilterFilter(scope.availableFiltersArray);
                    scope.hideFiltersPanel(evt);
                };

                /***** Cancel Filter ******/
                scope.cancelFilter = function (evt) {
                    for (var i = 0; i < scope.availableFiltersArray.length; i++) {
                        for (var j = 0; j < scope.availableFiltersArray[i].filterTypeItems.length; j++) {
                            if (scope.availableFiltersArray[i].filterTypeItems[j].selected && scope.selectedFiltersArray.indexOf(scope.availableFiltersArray[i].filterTypeItems[j]) === -1) {
                                scope.availableFiltersArray[i].filterTypeItems[j].selected = false;
                            } else if (!scope.availableFiltersArray[i].filterTypeItems[j].selected && scope.selectedFiltersArray.indexOf(scope.availableFiltersArray[i].filterTypeItems[j]) !== -1) {
                                scope.availableFiltersArray[i].filterTypeItems[j].selected = true;
                            }
                        }
                    }
                    scope.hideFiltersPanel(evt);
                    scope.showCancelMsg = true;
                    scope.$parent.showCancelMsg = true;
                };

                /*********** Window Resize ****************/
                var resizeFixtures = function () {
                    if ($window.innerWidth < 1024) {
                        if (scope.largeViewport) {
                            scope.displayComponent = false;
                        } else if ($window.innerWidth < 585) {
                            var height = $window.innerHeight - 77;
                            scope.mediumViewport = false;
                            scope.setHeight = ({'height': height + 'px', 'overflow-y': 'auto'});
                        } else if ($window.innerWidth > 585) {
                            scope.mediumViewport = true;
                            scope.setHeight = ({'overflow-y': 'auto'});
                        }
                        scope.largeViewport = false;
                    }
                    else {
                        scope.largeViewport = true;
                        scope.displayComponent = true;
                    }
                    scope.setDisplayComponentFlag(scope.displayComponent);
                };

                if ($window.innerWidth < 1024) {
                    scope.displayComponent = false;
                }
                resizeFixtures();

                angular.element($window).bind('resize', function () {
                    resizeFixtures();
                    scope.$apply();
                });
            }
        };
    }]);
    
/**
 * @ngdoc directive
 * @name Layouts.att:formInputsWithinAProcess
 *
 * @description
 *  <file src="src/formsWithinProcess/docs/readme.md" />
 *
 * @usage

 *
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/formsWithinProcess/docs/demo.html" />
 <file src="src/formsWithinProcess/docs/demo.js" />
 </example>
 </section>
 *
 */

angular.module('ddh.att.formsWithinProcess', []);
/**
 * @ngdoc directive
 * @name Headings & copy.att:headings
 *
 * @description
 *  <file src="src/headings/docs/readme.md" />
 *
 * @usage
	<h1 class="heading-page">38px page heading</h1>
	<h2 class="heading-major-section">30px major section heading</h2>
	<h3 class="heading-sub-section">24px sub-section heading</h3>
	<h2 class="heading-medium">20px medium heading</h2>
	<h2 class="heading-medium-emphasis">20px medium emphasis heading</h2>
	<h3 class="heading-small">18px small heading</h3>
	<h3 class="heading-small-emphasis">18px small emphasis heading</h3>
	<h3 class="heading-micro">13px micro heading</h3>

	<h2 class="heading-group">Lead</h2>
	<h1 class="heading-page">This is 38px heading</h1>
	<h2 class="lead">This is lead text...The next big thing since the last big thing we announced.</h2>
	<h2 class="heading-group">Eyebrow</h2>
	<h3 class="eyebrow">EYEBROW TEXT</h3>
	<h2 class="heading-major-section">This is a 30px heading</h2>
	<h3 class="eyebrow">EYEBROW TEXT</h3>
	<h3 class="heading-sub-section">24px sub-section heading</h3>
	<h2 class="heading-group">Subheading</h2>
	<h2 class="heading-major-section">This is a 30px heading</h2>
	<h3 class="subheading">A subheading here to support what was said above</h3>
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
    <file src="src/headings/docs/demo.html" />
</example>
</section>
 */

var ddhLegalCopy = angular.module('ddh.att.headings', []);
/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:in-pageMessaging
 *
 * @description
 *  <file src="src/inpageMessaging/docs/readme.md" />
 *
 * @usage
 *  <!-- Implementation provided below -->
 *
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
    <file src="src/inpageMessaging/docs/demo.html" />
    <file src="src/inpageMessaging/docs/demo.js" />
</example>
</section>
 */

angular.module('ddh.att.inpageMessaging', []);
/**
 * @ngdoc directive
 * @name Navigation.att:leftNavigation
 *
 * @description
 *  <file src="src/leftNavigation/docs/readme.md" />
 *
 * @usage
 *  <ddh-left-navigation data-menu="menuData"></ddh-left-navigation> 
 *
 *  <!-- For filtering navigation--> 
 *  <ddh-left-navigation data-menu="menuData" search-for="string"></ddh-left-navigation> 
 *
 *  <!-- For pre-selected, You need to add "active" == true property in JSON -->
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/leftNavigation/docs/demo.html" />
            <file src="src/leftNavigation/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.leftNavigation', [])
  .directive('ddhNavP', [function() {
    return function(scope, element) {
      scope.menu.isOpen = false;
      if (scope.menu.active == true) {
        scope.menu.isOpen = true;
      }
      
      element.bind('click', function() {
        if (!element.find('i').eq(0).hasClass('icon-expanded')) {
          scope.menu.isOpen = true;
        } else {
          scope.menu.isOpen = false;
        }
        scope.$apply();
      });
    };
  }])
  .directive('ddhNavC', [function() {
    return {
      require: '^ddhLeftNavigation',
      link: function(scope, element, attr, ctrl) {

        if (scope.menuItem.active == true) {
          scope.$parent.$parent.openCIdx = scope.$index;
          scope.$parent.$parent.openPIdx = scope.$parent.$index;
        }
        element.bind('click', function(e) {
          scope.$parent.$parent.openCIdx = scope.$index;
          scope.$parent.$parent.openPIdx = scope.$parent.$index;
          e.stopPropagation();
          scope.$apply();

        });
        scope.onClick = function(item) {
          ctrl.onChildClick(item);
        }
      }
    }
  }])
  .directive('ddhLeftNavigation', [function() {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'template/leftNavigation/leftNavigation.html',
      scope: {
        menuData: '=',
        searchFor: '='
      },
      controller: ['$scope', '$element', function($scope, $element) {
        this.onChildClick = function(item) {
          $scope.filteredItems.forEach(function(fItem) {
            if (fItem.menuItems.indexOf(item) === -1) {
              fItem.isOpen = false;
            }
          });
        }
      }],
      link: function(scope, elem) {
        scope.openPIdx = -1;
        scope.openCIdx = -1;
        scope.$watch('searchFor', function(newVal, oldVal) {
          if (newVal !== oldVal) {
            for (var i = 0; i < scope.filteredItems.length; i++) {
              for (var j = 0; j < scope.filteredItems[i].menuItems.length; j++) {
                if (scope.filteredItems[i].menuItems[j].name.match(new RegExp('^' + newVal, 'gi')) && newVal !== "") {
                  scope.filteredItems[i].menuItems[j].boldTxt = true;
                  scope.filteredItems[i].isOpen = true;
                } else {
                  scope.filteredItems[i].menuItems[j].boldTxt = false;
                  if (scope.filteredItems[i].isOpen && newVal == "") {
                    scope.filteredItems[i].isOpen = false;
                  }
                }
              }
            }
          }
        });
      }
    };
  }]);

/**
 * @ngdoc directive
 * @name Headings & copy.att:Legal Copy
 *
 * @description
 *  <file src="src/legalCopy/docs/readme.md" />
 *
 * @usage
 * <h2 class="ds2 heading-group">.text-legal</h2>
 * <p class="text-legal">
 * .....
 * </p> 
 *
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
    <file src="src/legalCopy/docs/demo.html" />
</example>
</section>
 */

var ddhLegalCopy = angular.module('ddh.att.legalCopy', []);
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:links
 *
 * @description
 *  <file src="src/links/docs/readme.md" />
 * @usage
 *      <!-- See below examples for link implementation -->
 *      
 * @example
       <section id="code">              
           <b>HTML + AngularJS</b>
           <example module="ddh.att">
           <file src="src/links/docs/demo.html" />
            <file src="src/links/docs/demo.js" />            
          </example>          
        </section>
 */
angular.module('ddh.att.links', []);
/**
 * @ngdoc directive
 * @name Videos & animation.att:loaderAnimation
 *
 * @description
 *  <file src="src/loaderAnimation/docs/readme.md" />
 *
 * @usage
 *   <!-- Below demo js shows-->
 *   Angular library uses Global.css's icon-spinner.
 *	 Additionally, Angular includes custom promises or http service based spinners
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/loaderAnimation/docs/demo.html" />
            <file src="src/loaderAnimation/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.loaderAnimation', [])
    .constant('ddhSpinnerConfig', {
        loadingText: 'Loading...',
        startEvent: 'startButtonSpinner',
        stopEvent: 'stopButtonSpinner'
    })
    .constant("progressTrackerConfig", {
        loadingText: 'Loading...',
        minDuration: "",
        activationDelay: "",
        minDurationPromise: "",
        activationDelayPromise: ""
    })

.provider('progressTracker', function () {
    this.$get = ['$q', '$timeout', function ($q, $timeout) {
        function cancelTimeout(promise) {
            if (promise) {
                $timeout.cancel(promise);
            }
        }
        return function ProgressTracker(options) {
            //do new if user doesn't
            if (!(this instanceof ProgressTracker)) {
                return new ProgressTracker(options);
            }

            options = options || {};
            //Array of promises being tracked
            var tracked = [];
            var self = this;
            //Allow an optional "minimum duration" that the tracker has to stay active for.
            var minDuration = options.minDuration;
            //Allow a delay that will stop the tracker from activating until that time is reached
            var activationDelay = options.activationDelay;
            var minDurationPromise;
            var activationDelayPromise;
            self.active = function () {
                //Even if we have a promise in our tracker, we aren't active until delay is elapsed
                if (activationDelayPromise) {
                    return false;
                }
                return tracked.length > 0;
            };
            self.tracking = function () {
                //Even if we aren't active, we could still have a promise in our tracker
                return tracked.length > 0;
            };
            self.destroy = self.cancel = function () {
                minDurationPromise = cancelTimeout(minDurationPromise);
                activationDelayPromise = cancelTimeout(activationDelayPromise);
                for (var i = tracked.length - 1; i >= 0; i--) {
                    tracked[i].resolve();
                }
                tracked.length = 0;
            };
            //Create a promise that will make our tracker active until it is resolved.
            // @return deferred - our deferred object that is being tracked
            self.createPromise = function () {
                var deferred = $q.defer();
                tracked.push(deferred);
                //If the tracker was just inactive and this the first in the list of promises, we reset our delay and minDuration again.
                if (tracked.length === 1) {
                    if (activationDelay) {
                        activationDelayPromise = $timeout(function () {
                            activationDelayPromise = cancelTimeout(activationDelayPromise);
                            startMinDuration();
                        }, activationDelay);
                    } else {
                        startMinDuration();
                    }
                }
                deferred.promise.then(onDone(false), onDone(true));
                return deferred;

                function startMinDuration() {
                    if (minDuration) {
                        minDurationPromise = $timeout(angular.noop, minDuration);
                    }
                }
                //Create a callback for when this promise is done. It will remove our tracked promise from the array if once minDuration is complete
                function onDone() {
                    return function () {
                        (minDurationPromise || $q.when()).then(function () {
                            var index = tracked.indexOf(deferred);
                            tracked.splice(index, 1);
                            //If this is the last promise, cleanup the timeouts for activationDelay
                            if (tracked.length === 0) {
                                activationDelayPromise = cancelTimeout(activationDelayPromise);
                            }
                        });
                    };
                }
            };
            self.addPromise = function (promise) {
                
//                we cannot assign then function in other var and then add the resolve and reject 
                var thenFxn = promise && (promise.then || promise.$then || (promise.$promise && promise.$promise.then));                
                if (!thenFxn) {
                    throw new Error("progressTracker expects a promise object :: Not found");
                }
                var deferred = self.createPromise();
                //When given promise is done, resolve our created promise
                //Allow $then for angular-resource objects

                promise.then(function (value) {
                        deferred.resolve(value);
                        return value;
                    }, function (value) {
                        deferred.reject(value);
                        return $q.reject(value);
                    }
                );
                return deferred;
            };
        };
    }];
})

.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push(['$q', 'progressTracker', function ($q) {
        return {
            request: function (config) {
                if (config.tracker) {
                    if (!angular.isArray(config.tracker)) {
                        config.tracker = [config.tracker];
                    }
                    config.$promiseTrackerDeferred = config.$promiseTrackerDeferred || [];

                    angular.forEach(config.tracker, function (tracker) {
                        var deferred = tracker.createPromise();
                        config.$promiseTrackerDeferred.push(deferred);
                    });
                }
                return $q.when(config);
            },
            response: function (response) {
                if (response.config && response.config.$promiseTrackerDeferred) {
                    angular.forEach(response.config.$promiseTrackerDeferred, function (deferred) {
                        deferred.resolve(response);
                    });
                }
                return $q.when(response);
            },
            responseError: function (response) {
                if (response.config && response.config.$promiseTrackerDeferred) {
                    angular.forEach(response.config.$promiseTrackerDeferred, function (deferred) {
                        deferred.reject(response);
                    });
                }
                return $q.reject(response);
            }
        };
    }]);
}])

.directive('ddhClickSpin', ['$timeout', '$parse', '$rootScope', 'progressTracker', function ($timeout, $parse, $rootScope, progressTracker) {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs) {
            var fn = $parse(attrs.ddhClickSpin);
            elm.on('click', function (event) {
                var promise = $timeout(function () {
					//dummy promise
				}, 5000);
                scope.$apply(function () {
                    fn(scope, {
                        $event: event
                    });
                });
                //comment this line if not running unit test
                $rootScope.loadingTracker = progressTracker({
                    minDuration: 750
                });
                $rootScope.loadingTracker.addPromise(promise);
                angular.forEach("$routeChangeSuccess $viewContentLoaded $locationChangeSuccess".split(" "), function (event) {
                    $rootScope.$on(event, function () {
                        $timeout.cancel(promise);
                    });
                });
            });
        }
    };
}])

.directive('ddhProgressTracker', ['progressTrackerConfig', function (ptc) {
    return {
        restrict: 'EA',
        replace: true,
        template: '<div>'
					+'<div role="alert" ng-show="loadingTracker.active()" style="width:100%; text-align:center">'
					+'<i class=\"icon-spinner\"></i>'
					+'<span class="hidden-spoken">'+ptc.loadingText+'</span>'
				+'</div>'
				+'<div ng-show="loadingTracker.active()" style="width:100%;margin-top:10px; text-align:center">'+ ptc.loadingText+'</div></div>'
    };
}])

.directive('ddhLoadButton', ['ddhSpinnerConfig', '$timeout', function (spinnerConfig, $timeout) {
    var spinButton = function (state, element, data) {
        
        var attr = element.html() ? 'html' : 'val';
        state = state + 'Text';
        if (state === 'loadingText') {
            element[attr](data[state]);
            element.attr("disabled",'disabled');
            element.addClass('disabled');
        } else if (state === 'resetText') {
            element[attr](data[state]);
            element.removeAttr("disabled");
            element.removeClass('disabled');
        }
    };

    return {
        restrict: 'A',
        replace: false,
        scope: {
            promise: '=promise',
            startEvent: '@startEvent',
            stopEvent: '@stopEvent'
        },
        link: function (scope, element, attr) {
            var validAttr = element.html() ? 'html' : 'val';
            var data = {
                loadingText: '',
                resetText: ''
            };

            var updateLoadingText = function (val) {
                var loadingText = val;
                if (!angular.isDefined(loadingText) || loadingText === "") {
                    loadingText = spinnerConfig.loadingText;
                }
                data.loadingText = validAttr === 'html' ? "<i class=\"icon-spinner small\"></i>" + loadingText : loadingText;
            };
            var updateResetText = function (val) {
                data.resetText = val;
            };

            attr.$observe('ddhLoadButton', function (val) {
                updateLoadingText(val);
            });
            $timeout(function () {
                updateResetText(element[validAttr]());
            }, 500);

            if (!angular.isDefined(scope.startEvent) || scope.startEvent === "") {
                scope.startEvent = spinnerConfig.startEvent;
            }

            if (!angular.isDefined(scope.stopEvent) || scope.stopEvent === "") {
                scope.stopEvent = spinnerConfig.stopEvent;
            }

            scope.$watch('promise', function () {
                if (angular.isDefined(scope.promise) && angular.isFunction(scope.promise.then)) {
                    spinButton('loading', element, data);
                    scope.promise.then(function () {
                        spinButton('reset', element, data);
						element[0].focus();
                    }, function () {
                        spinButton('reset', element, data);
						element[0].focus();
                    });
                }
            });

            scope.$on(scope.startEvent, function () {
                spinButton('loading', element, data);
                scope.$on(scope.stopEvent, function () {
                    spinButton('reset', element, data);
					element[0].focus();
                });
            });
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:modalsAndAlerts
 *
 * @description
 *  <file src="src/modalsAndAlerts/docs/readme.md" />
 *
 * @usage
 *  <button class="btn" ddh-modal="template/modalsAndAlerts/demo_modal.html" modal-ok="ok()" modal-cancel="cancel()">Launch demo modal</button>
 *
 * @example
 *  <section id="code">
     <example module="ddh.att">
      <file src="src/modalsAndAlerts/docs/demo.html" />
      <file src="src/modalsAndAlerts/docs/demo.js" />
     </example>
    </section>
 *
 */
angular.module('ddh.att.modalsAndAlerts', ['ddh.att.position', 'ddh.att.transition', 'ddh.att.utilities', 'ddh.att.lazyLoad'])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
.factory('$$stackedMap', function () {
    return {
        createNew: function () {
            var stack = [];

            return {
                add: function (key, value) {
                    stack.push({
                        key: key,
                        value: value
                    });
                },
                get: function (key) {
                    for (var i = 0; i < stack.length; i++) {
                        if (key === stack[i].key) {
                            return stack[i];
                        }
                    }
                },
                keys: function () {
                    var keys = [];
                    for (var i = 0; i < stack.length; i++) {
                        keys.push(stack[i].key);
                    }
                    return keys;
                },
                top: function () {
                    return stack[stack.length - 1];
                },
                remove: function (key) {
                    var idx = -1;
                    for (var i = 0; i < stack.length; i++) {
                        if (key === stack[i].key) {
                            idx = i;
                            break;
                        }
                    }
                    return stack.splice(idx, 1)[0];
                },
                removeTop: function () {
                    return stack.splice(stack.length - 1, 1)[0];
                },
                length: function () {
                    return stack.length;
                }
            };
        }
    };
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
.directive('modalBackdrop', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        templateUrl: 'template/modalsAndAlerts/backdrop.html',
        link: function (scope, element, attrs) {
            scope.close = function (evt) {
                var modal = $modalStack.getTop();
                if (modal && modal.value.backdrop && modal.value.backdrop !== 'static') {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $modalStack.dismiss(modal.key, 'backdrop click');
                }
            };
        }
    };
}])

.directive('modalWindow', ['$timeout', 'windowOrientation', '$window', 'ddhLazyLoad', function ($timeout, windowOrientation, $window, ddhLazyLoad) {
    return {
        restrict: 'EA',
        scope: {
            index: '@'
        },
        replace: true,
        transclude: true,
        templateUrl: 'template/modalsAndAlerts/window.html',
        compile: function (elem, attr) {
            ddhLazyLoad.load('modal', 'css');

            return this.link;
        },
        controller: ['$scope', '$element', '$attrs', function (scope, element, attrs) {
            scope.windowClass = attrs.windowClass || '';
            scope.sizeClass = attrs.sizeClass || '';
            scope.stayOpen = attrs.stayOpen || false; 
            scope.isNotifDialog = false;

            this.setTitle = function (title, describedby) {
                scope.title = title;
				element.attr('aria-labelledby', title);
				if(describedby){
					element.attr('aria-describedby', describedby);					
				}				
            };
            this.setContent = function (content) {
                scope.content = content;
				element.attr('aria-describedby', content);
                scope.isNotifDialog = true;
            };
            this.isDockedModal = scope.windowClass.indexOf('modal-docked') > -1;
        }],
        link: function (scope, element, attrs, ctrl) {
            if (ctrl.isDockedModal) {
                scope.isModalLandscape = false;

                var window = angular.element($window);
                scope.updateCss = function () {
                    if (windowOrientation.isPotrait()) { // Potrait Mode
                        scope.isModalLandscape = false;
                    } else if (windowOrientation.isLandscape()) { // Landscape Mode
                        scope.isModalLandscape = true;
                    }
                };

                $timeout(function () {
                    scope.updateCss();
                    scope.$apply();
                }, 100);
                window.bind('orientationchange', function () {
                    scope.updateCss();
                    scope.$apply();
                });
                window.bind('resize', function () {
                    scope.updateCss();
                    scope.$apply();
                });
                scope.$on('$destroy', function () {
                    window.unbind('orientationchange');
                    window.unbind('resize');
                });
            }
        }
    };
}])

.directive('modalWrapper', [function () {
    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$attrs', function (scope, element, attrs) {
            this.isDockedModal = function () {
                return element.hasClass('modal-docked');          
            };

            this.getModalWrapper = function(){
                return element;
            }
        }],
        link: function (scope, element, attrs, ctrl) {
        }
    };
}])

.directive('modalTitle', [function () {
    return {
        restrict: 'A',
        require: '^modalWindow',
        link: function (scope, elem, attr, ctrl) {
			if(attr.ariaDescribedby){
				ctrl.setTitle(attr.id, attr.ariaDescribedby);
			}
			else {
				ctrl.setTitle(attr.id);
			}
        }
    };
}])

.directive('modalContent', [function () {
    return {
        restrict: 'A',
        require: '^modalWindow',
        link: function (scope, elem, attr, ctrl) {
            ctrl.setContent(attr.id);
        }
    };
}])


.directive('modalBody', ['$timeout', '$position', '$document', '$window', 'windowOrientation', 'ddhAwdBreakpoints', function ($timeout, $position, $document, $window, windowOrientation, ddhAwdBreakpoints) {
    return {
        restrict: 'AC',
        scope: {
            index: '@'
        },
        require: '^modalWindow',
        link: function (scope, element, attrs, ctrl) {
            var window = angular.element($window);
            var body = $document.find('body').eq(0);
            scope.setModalHeight = function () {
                var modalHeaderHeight, modalFooterHeight, modalBodyHeight, windowHeight, windowWidth, modalHeight, modalElement;
                modalHeaderHeight = 0;
                modalFooterHeight = 0;
                windowHeight = $window.innerHeight;
                windowWidth = $window.innerWidth;
                if (ctrl.isDockedModal) {
                    var modalElements = element.parent().children();
                    for (var i = 0; i < modalElements.length; i++) {
                        if (modalElements.eq(i).hasClass('modal-header')) {
                            modalHeaderHeight = $position.position(modalElements.eq(i)).height;
                        } else if (modalElements.eq(i).hasClass('modal-footer')) {
                            modalFooterHeight = $position.position(modalElements.eq(i)).height;
                        }
                    }
                    modalElement = element.parent();
                    while (!modalElement.hasClass('modal')) {
                        modalElement = modalElement.parent();
                    };
                    modalHeight = $position.position(modalElement).height;
                    modalBodyHeight = modalHeight - (modalHeaderHeight + modalFooterHeight) + 'px';
                    if (windowOrientation.isPotrait()) { // Potrait Mode
                        element.removeAttr('style').css({
                            height: modalBodyHeight
                        });
                    } else if (windowOrientation.isLandscape() && windowWidth < ddhAwdBreakpoints.breakpoints.mobile.max) { // Landscape Mode Mobile
                        element.removeAttr('style');
                    } else if (windowOrientation.isLandscape() && windowWidth >= ddhAwdBreakpoints.breakpoints.mobile.max) { // Landscape Mode Non-Mobile
                        element.removeAttr('style').css({
                            height: modalBodyHeight
                        });
                    }
                }
            };

            $timeout(function () {
                scope.setModalHeight();
                scope.$apply();
            }, 600);
            window.bind('orientationchange', function () {
                scope.setModalHeight();
                scope.$apply();
            });
            window.bind('resize', function () {
                scope.setModalHeight();
                scope.$apply();
            });
            scope.$on('$destroy', function () {
                window.unbind('orientationchange');
                window.unbind('resize');
            });
        }
    };
}])

.directive('modalFooter', ['windowOrientation', '$window', function (windowOrientation, $window) {
    return {
        restrict: 'AC',
        scope: {
            index: '@'
        },
        link: function (scope, element, attrs) {

        }
    };
}])

.factory('$modalStack', ['$document', '$compile', '$rootScope', '$$stackedMap', '$log', '$timeout', 'trapFocusInElement', function ($document, $compile, $rootScope, $$stackedMap, $log, $timeout, trapFocusInElement) {
    var backdropjqLiteEl, backdropDomEl;
    var backdropScope = $rootScope.$new(true);
    var body = $document.find('body').eq(0);
    var html = $document.find('html').eq(0);
    var openedWindows = $$stackedMap.createNew();
    var $modalStack = {};

    function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
            if (openedWindows.get(opened[i]).value.backdrop) {
                topBackdropIndex = i;
            }
        }
        return topBackdropIndex;
    }

    $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
        backdropScope.index = newBackdropIndex;
    });

    function removeModalWindow(modalInstance) {
         var modalWindow = openedWindows.get(modalInstance).value;
         angular.element(modalWindow.modalDomEl).find('div').removeClass('in');

         //background scroll fix
         html.removeAttr('style');
         body.removeAttr('style');
         body.removeClass('styled-by-modal');
         html.removeClass('styled-by-modal');
         trapFocusInElement(false, modalWindow.modalDomEl);
         $timeout(function () {
            //clean up the stack
            openedWindows.remove(modalInstance);
            //remove window DOM element
            modalWindow.modalDomEl.remove();
            angular.element(backdropDomEl).removeClass('in');
            $timeout(function () {
                //remove backdrop if no longer needed
                if (backdropDomEl && backdropIndex() === -1) {
                    backdropDomEl.remove();
                    backdropDomEl = undefined;
                }
            }, 450);
            //destroy scope
            modalWindow.modalScope.$destroy();
        }, 350);
    };
	
    $document.bind('keydown', function (evt) {
        if (evt.which === 27){
            dismissModalFromEvent();
        }
    });
    $document.bind('click', function (evt) {
        if (angular.element(evt.target).hasClass('modalwrapper')){
            dismissModalFromEvent();
        }
    });
	
    function dismissModalFromEvent() {
           var modal = openedWindows.top();

            if (modal && modal.value.keyboard && !modal.value.modalScope.$$childHead.stayOpen){
                $rootScope.$apply(function () {
                    $modalStack.dismiss(modal.key);
                });
            }
    };
	
    $modalStack.open = function (modalInstance, modal) {
        openedWindows.add(modalInstance, {
            deferred: modal.deferred,
            modalScope: modal.scope,
            backdrop: modal.backdrop,
            keyboard: modal.keyboard
        });
        var angularDomEl = angular.element('<div modal-window></div>');
        angularDomEl.attr('window-class', modal.windowClass);
        angularDomEl.attr('size-class', modal.sizeClass);
        angularDomEl.attr('stay-open', modal.stayOpen);
        angularDomEl.attr('index', openedWindows.length() - 1);
        angularDomEl.html(modal.content);

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        //background page scroll fix
        html.addClass('styled-by-modal');
        body.addClass('styled-by-modal');
        body.append(modalDomEl);
        if (backdropIndex() >= 0 && !backdropDomEl) {
            backdropjqLiteEl = angular.element('<div modal-backdrop></div>');
            backdropDomEl = $compile(backdropjqLiteEl)(backdropScope);
            body.append(backdropDomEl);
        }

        $timeout(function () {
            if (modal.scope.$$childHead.isNotifDialog) {
				if(navigator.userAgent.match(/Android/i)) {
					var btnElem = angular.element(modalDomEl).find('button').eq(0);
					var labelby = angular.element(modalDomEl).find('h2').eq(0).attr('id');
					btnElem.attr('id', modal.scope.$id+'pbut');
					var describeby = angular.element(modalDomEl[0].querySelectorAll('div[modal-content]')).attr('id');
					describeby += ' '+modal.scope.$id+'pbut';
					
					btnElem.attr('aria-labelledby', labelby);
					btnElem.attr('aria-describedby', describeby);
				}
				else {
					modalDomEl.attr('role', 'alertdialog');
				}
                angular.element(modalDomEl).find('button')[0].focus();
            } else {
                angular.element(modalDomEl)[0].focus();
            }
            angular.element(backdropDomEl).addClass('in');
            $timeout(function () {
                angular.element(modalDomEl).find('div').eq(0).addClass('in');
                trapFocusInElement(true, angular.element(modalDomEl).eq(0));
            }, 350);
        }, 200);
    };

    $modalStack.close = function (modalInstance, result) {
        var modal = openedWindows.get(modalInstance);
        if (modal) {
            modal.value.deferred.resolve(result);
            removeModalWindow(modalInstance);
        }
    };

    $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance).value;
        if (modalWindow) {
            modalWindow.deferred.reject(reason);
            removeModalWindow(modalInstance);
        }
    };
    $modalStack.getTop = function () {
        return openedWindows.top();
    };
    return $modalStack;
}])

.provider('$modal', function () {
    var $modalProvider = {
        options: {
            backdrop: true, //can be also false or 'static'
            keyboard: true
        },
        $get: ['$injector', '$rootScope', '$q', '$http', '$templateCache', '$controller', '$modalStack', function ($injector, $rootScope, $q, $http, $templateCache, $controller, $modalStack) {
            var $modal = {};

            function getTemplatePromise(options) {
                return options.template ? $q.when(options.template) :
                    $http.get(options.templateUrl, {
                        cache: $templateCache
                    }).then(function (result) {
                        return result.data;
                    });
            };

            function getResolvePromises(resolves) {
                var promisesArr = [];
                angular.forEach(resolves, function (value, key) {
                    if (angular.isFunction(value) || angular.isArray(value)) {
                        promisesArr.push($q.when($injector.invoke(value)));
                    }
                });
                return promisesArr;
            };

            $modal.open = function (modalOptions) {
                var modalResultDeferred = $q.defer();
                var modalOpenedDeferred = $q.defer();
                //prepare an instance of a modal to be injected into controllers and returned to a caller
                var modalInstance = {
                    result: modalResultDeferred.promise,
                    opened: modalOpenedDeferred.promise,
                    close: function (result) {
                        $modalStack.close(modalInstance, result);
                    },
                    dismiss: function (reason) {
                        $modalStack.dismiss(modalInstance, reason);
                    }
                };

                //merge and clean up options
                modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                modalOptions.resolve = modalOptions.resolve || {};

                //verify options
                if (!modalOptions.template && !modalOptions.templateUrl) {
                    throw new Error('One of template or templateUrl options is required.');
                }

                var templateAndResolvePromise =
                    $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));

                templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {
                    var modalScope = (modalOptions.scope || $rootScope).$new();
                    modalScope.$close = modalInstance.close;
                    modalScope.$dismiss = modalInstance.dismiss;
                    var ctrlInstance, ctrlLocals = {};
                    var resolveIter = 1;
                    //controllers
                    if (modalOptions.controller) {
                        ctrlLocals.$scope = modalScope;
                        ctrlLocals.$modalInstance = modalInstance;
                        angular.forEach(modalOptions.resolve, function (value, key) {
                            ctrlLocals[key] = tplAndVars[resolveIter++];
                        });
                        ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                    }

                    $modalStack.open(modalInstance, {
                        scope: modalScope,
                        deferred: modalResultDeferred,
                        content: tplAndVars[0],
                        backdrop: modalOptions.backdrop,
                        keyboard: modalOptions.keyboard,
                        windowClass: modalOptions.windowClass,
                        sizeClass: modalOptions.sizeClass,
                        stayOpen: modalOptions.stayOpen
                    });

                }, function resolveError(reason) {
                    modalResultDeferred.reject(reason);
                });

                templateAndResolvePromise.then(function () {
                    modalOpenedDeferred.resolve(true);
                }, function () {
                    modalOpenedDeferred.reject(false);
                });
                return modalInstance;
            };
            return $modal;
        }]
    };
    return $modalProvider;
})

.directive("ddhModal", ["$modal", "$log", '$scrollTo', function ($modal, $log, $scrollTo) {
    return {
        restrict: 'A',
        scope: {
            ddhModal: '@',
            modalController: '@',
            modalOk: '&',
            modalCancel: '&',
            windowClass: '@',
            sizeClass: '@',
            stayOpen: '@'
        },
        link: function (scope, elm, attr) {
            elm.bind('click', function (ev) {
                var currentPosition = ev.pageY - ev.clientY;
                ev.preventDefault();
                if (angular.isDefined(elm.attr("href")) && elm.attr("href") !== "") {
                    scope.ddhModal = elm.attr("href");
                }
                $modal.open({
                    templateUrl: scope.ddhModal,
                    controller: scope.modalController,
                    windowClass: scope.windowClass,
                    sizeClass: scope.sizeClass,
                    stayOpen: scope.stayOpen
                }).result.then(function (value) {
                    scope.modalOk({
                        value: value
                    });
                    elm[0].focus();
                }, function (value) {
                    scope.modalCancel({
                        value: value
                    });
                    elm[0].focus();
                });
            });
        }
    };
}])

.directive("utilityFilter", ["$modal", "$log", '$scrollTo', function ($modal, $log, $scrollTo) {
    return {
        restrict: 'EA',
        scope: {
            utilityFilter: '@'
        },
        require: 'ngModel',
        templateUrl: 'template/modal/u-filter.html',
        link: function (scope, element, attribute, ctrl) {
            //controller to be passed to $modal service
            scope.options = angular.copy(scope.$parent.$eval(attribute.ngModel));
            scope.$parent.$watch(attribute.ngModel, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    scope.options = newVal;
                }
            });
            var modalCtrl = function ($scope, options) {
                $scope.options = angular.copy(options);
            };

            if (angular.isDefined(scope.utilityFilter)) {
                scope.templateUrl = scope.utilityFilter;
            } else {
                scope.templateUrl = 'template/modal/u-filter-window.html';
            }
            element.bind('click', function (ev) {
                var currentPosition = ev.pageY - ev.clientY;
                $modal.open({
                    templateUrl: scope.templateUrl,
                    controller: modalCtrl,
                    resolve: {
                        options: function () {
                            return scope.options;
                        }
                    }
                }).result.then(function (value) {
                    ctrl.$setViewValue(value);
                    element[0].focus();
                    $scrollTo(0, currentPosition, 0);
                }, function () {
                    element[0].focus();
                    $scrollTo(0, currentPosition, 0);
                });
            });
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Banners, marquees & tiles.att:marquees
 *
 * @description
 *  <file src="src/marquees/docs/readme.md" />
 *
 * @usage
 *  <div id="marquee" ddh-marquee config-obj="configObj">
 <ddh-marquee-tab>
 <ul  role="tablist" id="marquee-nav">
 <li ng-repeat="tab in marqueeTabs" class="control-nav-item" role="tab" aria-controls="marquee-content-01" aria-labelledby="tab_{{$index}}">
 <span id="tab_{{$index}}">{{tab.desc}}</span>
 </li>
 </ul>
 </ddh-marquee-tab>
 <ul  id="marquee_contents" ddh-marquee-images aria-label="Use left and right arrow key or swipe to navigate">
 <div class="hero-img" img-large="./style/images/marquee/HBO-Amazon-1920.jpg" img-medium="./style/images/marquee/HBO-Amazon-1024-2x.jpg" img-small="./style/images/marquee/HBO-Amazon-640-2x.jpg" title="U-verse + HBO + Amazon Prime">
 <div class="badge-wrapper span12">
 <div class="marquee-badge pull-right pull-bottom span5">
 <div class="badge-content">
 <div class="badge-content-main">
 <div class="badge-heading">Speed you need + TV + HBO<sup>&reg;</sup> + Amazon Prime</div>
 <div class="badge-bodycopy" aria-hidden="true">Bundle Internet with speeds up to 45Mbps with U-verse TV, HBO<sup>&reg;</sup>, and a year of Amazon Prime.</div>
 </div>
 <div class="badge-content-desc">
 <div><span class="badge-price"><sup>$</sup>59</span><span>/mo plus <sup>$</sup>200 in Reward Cards</span></div>
 <div class="badge-price-legal" aria-hidden="true">Online only. For 12 mos. 1-year term req'd. Geo. and sve. restr. apply.<br>Other charges apply. <a href="http://uverse.com/uverse/copyright-notices" tabindex="-1">See offer details.</a></div>
 </div>
 <div class="badge-CTA">
 <a class="btn btn-primary btn-promo" href="http://uverse.com/network/hbo" tabindex="-1">Shop now</a>
 <div class="badge-overlay" aria-hidden="true">Game of Thrones<sup>&#8480;</sup> on HBO<sup>&reg;</sup> and HBO GO<sup>&reg;</sup><br><span class="overlay-legal">HBO<sup>&reg;</sup> and related channels and services marks are the property of Home Box Office, Inc.</span>
 </div>
 </div>
 </div>
 </div>
 </div>
 <div class="badge-background"></div>
 </div>
 </ul>
 </div>
 *
 * @example
 * 	<section id="code">
 <b>HTML + jQuery</b>
 <example module="ddh.att">
 <file src="src/marquees/docs/demo.html" />
 <file src="src/marquees/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.marquees', ['ddh.att.modalsAndAlerts', 'ddh.att.lazyLoad', 'ddh.att.position'])
        .constant("ddhMarqueeConfig",
        {
            autoPlay: true,
            swipeThreshold: 150,
            transitions: {
                type: 'slide',
                duration: 800,
                speed: 6000
            },
            autoAria: false,
            isUpperFunnel: false,
            swipe: {
                threshold: 100
            }
        })
        .directive('ddhMarquee', ['ddhMarqueeConfig', '$timeout', '$document', '$window', 'ddhLazyLoad', function (ddhMarqueeConfig, $timeout, $document, $window, ddhLazyLoad) {
                return {
                    restrict: 'EAC',
                    replace: true,
                    transclude: true,
                    templateUrl: 'template/marquees/marquee.html',
                    scope: {
                        configObj: "="
                    },
                    compile: function (elem, attr) {
                        ddhLazyLoad.load('marquee', 'css');

                        return this.link;
                    },
                    controller: ['$scope', '$element', function ($scope, $element) {
                            var perPage = 4;
                            this.count = 0;
                            this.activeIdx = 0;

                            var controlNav = function (len) {
                                var itemW = $scope.tabs[0].offsetWidth;
                                var maxPos = (len - perPage) * itemW;
                                var anchor = [];
                                if (len < perPage) {
                                    return [0];
                                }
                                for (var i = 0; i < len; i++) {
                                    var pos = i * itemW;
                                    if (i % perPage === 0) {
                                        if (pos > maxPos) {
                                            anchor.push(maxPos * -1);
                                        } else {
                                            anchor.push(pos * -1);
                                        }
                                    }
                                }
                                return anchor;
                            };

                            var isSmallVP = function () {
                                return $window.outerWidth < 767;
                            };

                            var getActiveitem = function (len, idx, flag) {
                                var selectElement;
                                for (var i = 0; i < len; i++) {
                                    if (i === idx) {
                                        angular.element($scope.tabs[idx]).attr('tabindex', '0');
                                        if (!flag || flag == undefined) {
                                            angular.element($scope.reelContent[i]).addClass('active');
                                            angular.element($scope.reelContent[i]).attr('aria-hidden', 'false');
                                            angular.element($scope.tabs[idx]).addClass('active');
                                            angular.element($scope.tabs[idx]).attr('aria-selected', 'true');
                                            angular.element($scope.reelContent[i]).attr('tabindex', '0');
                                            if(flag == false)
                                            {
                                                selectElement = $scope.reelContent[i]; 
                                                $timeout(function() {                                                   
                                                    selectElement.focus();                                  
                                                }, 500); 
                                            }
                                        } else if (flag) {
                                            $scope.tabs[i].focus();
                                        }
                                    } else {
                                        angular.element($scope.tabs[i]).attr('tabindex', '-1');
                                        if (!flag || flag == undefined) {
                                            angular.element($scope.reelContent[i]).removeClass('active');
                                            angular.element($scope.reelContent[i]).attr('aria-hidden', 'true');
                                            angular.element($scope.tabs[i]).removeClass('active');
                                            angular.element($scope.tabs[i]).attr('aria-selected', 'false');
                                            angular.element($scope.reelContent[i]).attr('tabindex', '-1');
                                        }
                                    }
                                }
                            };

                            this.getTabActive = function (idx, notGetActiveflag, notToAnimateFlag, val) {
                                var len = $scope.tabs.length;
                                var tabslide = Math.ceil((idx + 1) / perPage);
                                if ((this.count + 1) < tabslide) {
                                    this.nextSlide(len);
                                }
                                else if ((this.count + 1) > tabslide)
                                {
                                    this.prevSlide(len);
                                }
                                getActiveitem(len, idx, notGetActiveflag);
                            };

                            this.getClassSelectors = function (obj, selector) {
                                return obj[0].querySelectorAll(selector);
                            };

                            this.getImagePath = function () {
                                return $scope.imgPath;
                            };

                            this.addClass = function (obj, cssClass) {
                                angular.element(obj).addClass(cssClass);
                            };

                            this.removeClass = function (obj, cssClass) {
                                angular.element(obj).removeClass(cssClass);
                            };

                            this.resetNavButtons = function (len) {
                                var arrCount = controlNav(len);
                                if (this.count === arrCount.length - 1) {
                                    this.addClass($scope.nextPageButton, 'disabled');
                                    angular.element($scope.nextPageButton).attr('tabindex', '-1');
                                    angular.element($scope.nextPageButton).attr('aria-disabled', 'true');

                                    this.removeClass($scope.prevPageButton, 'disabled');
                                    angular.element($scope.prevPageButton).attr('tabindex', '0');
                                    angular.element($scope.prevPageButton).attr('aria-disabled', 'false');
                                }
                                else if (this.count === 0) {
                                    this.removeClass($scope.nextPageButton, 'disabled');
                                    angular.element($scope.nextPageButton).attr('tabindex', '0');
                                    angular.element($scope.nextPageButton).attr('aria-disabled', 'false');

                                    this.addClass($scope.prevPageButton, 'disabled');
                                    angular.element($scope.prevPageButton).attr('tabindex', '-1');
                                    angular.element($scope.prevPageButton).attr('aria-disabled', 'true');
                                }
                            };

                            this.nextSlide = function (len, notToAnimateFlag) {
                                var arrCount = controlNav(len);
                                if (this.hasNextPage(len)) {
                                    this.count++;
                                    // flip page on larger screen only, not mobile
                                    if (!isSmallVP() && (!notToAnimateFlag || notToAnimateFlag == undefined)) {
                                        angular.element($scope.tabs).css('transform', 'translate3d(' + arrCount[this.count] + 'px, 0px, 0px)');
                                    }
                                    this.resetNavButtons(len)
                                }
                            };

                            this.prevSlide = function (len, notToAnimateFlag) {
                                var arrCount = controlNav(len);
                                if (this.hasPrevPage(len)) {
                                    this.count--;
                                    // flip page on larger screen only
                                    if (!isSmallVP() && (!notToAnimateFlag || notToAnimateFlag == undefined)) {
                                        angular.element($scope.tabs).css('transform', 'translate3d(' + arrCount[this.count] + 'px, 0px, 0px)');
                                    }
                                    this.resetNavButtons(len)
                                }
                            };

                            this.hasNextPage = function (len) {
                                var arrCount = controlNav(len);
                                return (this.count < arrCount.length - 1);
                            };

                            // return boolean if previous pagination position exists
                            this.hasPrevPage = function () {
                                return this.count > 0;
                            };

                            this.setIdx = function (val) {
                                this.activeIdx = val;
                                this.resetTabindex(val);
                            };

                            this.getIdx = function () {
                                return this.activeIdx;
                            };

                            this.setSlideCount = function (val) {
                                this.count = val;
                            };

                            this.getSlideCount = function () {
                                return this.count;
                            };

                            this.timerClass = function () {
                                return $scope.timer;
                            };

                            this.resetTabindex = function (cind) {
                                if (cind === 0) {
                                    angular.element($scope.swLeft).addClass('disabled');
                                    angular.element($scope.swRight).removeClass('disabled');
                                }
                                else if (cind > 0 && cind < ($scope.reelContent.length - 1)) {
                                    angular.element($scope.swLeft).removeClass('disabled');
                                    angular.element($scope.swRight).removeClass('disabled');
                                }
                                else if (cind === ($scope.reelContent.length - 1)) {
                                    angular.element($scope.swLeft).removeClass('disabled');
                                    angular.element($scope.swRight).addClass('disabled');
                                }
                                for (var j = 0; j < $scope.reelContent.length; j++) {
                                    angular.element($scope.reelContent[j]).attr('tabindex', (j === cind ? '0' : '-1'));
                                    var tabbableItems = $scope.reelContent[j].querySelector('.badge-content');
                                    for (x = 0; x < tabbableItems.children.length; x++) {
                                        for (y = 0; y < tabbableItems.children[x].children.length; y++) {
                                            if (tabbableItems.children[x].children[y].getAttribute('tabindex')) {
                                                angular.element(tabbableItems.children[x].children[y]).attr('tabindex', (j === cind ? '0' : '-1'));
                                            }
                                            if (tabbableItems.children[x].children[y].children.length > 0) {
                                                for (z = 0; z < tabbableItems.children[x].children[y].children.length; z++) {
                                                    if (tabbableItems.children[x].children[y].children[z].getAttribute('tabindex')) {
                                                        angular.element(tabbableItems.children[x].children[y].children[z]).attr('tabindex', (j === cind ? '0' : '-1'));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            };
                        }],
                    link: function (scope, elem, attr, ctrl) {
                        if (angular.isDefined(scope.configObj)) {
                            ddhMarqueeConfig = angular.merge(ddhMarqueeConfig, scope.configObj);
                        }
                        $timeout(function () {
                            scope.reelContent = ctrl.getClassSelectors(elem, '.marquee-reel-content');
                            scope.tabs = ctrl.getClassSelectors(elem, '.control-nav-item');
                            scope.prevPageButton = ctrl.getClassSelectors(elem, '.marquee-nav-prev-page'),
                                    scope.nextPageButton = ctrl.getClassSelectors(elem, '.marquee-nav-next-page'),
                                    scope.swLeft = ctrl.getClassSelectors(elem, '.marquee-arrow-left'),
                                    scope.swRight = ctrl.getClassSelectors(elem, '.marquee-arrow-right'),
                                    scope.timer = ctrl.getClassSelectors(elem, '.timer');
                        });
                        scope.transitionClass = ddhMarqueeConfig.transitions.type;
                        ctrl.getClassSelectors(elem, '.marquee-reel');
                        var SlideImages = (function () {
                            var breakPt01 = 767,
                                breakPt02 = 1024
                            var mediaQueryL = '@media (min-width:' + (breakPt02) + 'px) {';
                            var mediaQueryM = '@media (max-width:' + (breakPt02 - 1) + 'px) and (min-width:' + (breakPt01 + 1) + 'px){';
                            var mediaQueryS = '@media (max-width:' + breakPt01 + 'px) {';
                            var imgArr = ctrl.getClassSelectors(elem, '.hero-img');
                            [].forEach.call(imgArr, function (element, index) { 
                                var $el = angular.element(element);
                                var imgLg = $el.attr('img-large');
                                var imgMd = $el.attr('img-medium');
                                var imgSm = $el.attr('img-small');
                                var nthChild = index + 1;
                                var blurNav = imgArr.length > 1 ? ', #' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .hero-img:after ' : "";
                                mediaQueryL += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .hero-img' + blurNav + '{' +
                                        'background-image: url("' + imgLg + '");' +
                                        '}')
                                mediaQueryM += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .hero-img {' +
                                        'background-image: url("' + imgMd + '");' +
                                        '}');
                                mediaQueryS += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .hero-img {' +
                                        'background-image: url("' + imgSm + '");' +
                                        '}');

                                var isIE = /msie|trident/i.test(navigator.userAgent);
                                if (isIE){
                                    var badgeBG = $el[0].querySelector('.badge-background');
                                    angular.element(badgeBG).after('<svg class="badge-background" aria-hidden="true"><image xlink:href="' + imgLg + '" filter="url(#svgBlur' + (index + 1) + ')" x="0" y="0" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" viewBox="0 0 1440 500" /><filter id="svgBlur' + (index + 1) + '"><feGaussianBlur stdDeviation="10" /></filter></svg>').remove();
                                }
                                else {
                                    mediaQueryL += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .badge-background {' +
                                            'background-image: url("' + imgLg + '");' +
                                            '}')
                                    mediaQueryM += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .badge-background {' +
                                            'background-image: url("' + imgMd + '");' +
                                            '}');
                                    mediaQueryS += ('#' + attr.id + ' .marquee-reel-content:nth-child(' + nthChild + ') .badge-background {' +
                                            'background-image: url("' + imgSm + '");' +
                                            '}');
                                }

                            });
                            mediaQueryL += '}';
                            mediaQueryM += '}';
                            mediaQueryS += '}';
                            scope.imgPath = angular.element(imgArr[0]).attr('img-large');
                            angular.element($document.find('head')).append('<style>' + mediaQueryL + mediaQueryM + mediaQueryS + '</style>');
                        })();
                    }
                };
            }])
        .directive('ddhMarqueeTab', ['$timeout', 'ddhMarqueeConfig', '$compile', function ($timeout, ddhMarqueeConfig, $compile) {
                return {
                    restrict: 'EA',
                    transclude: true,
                    replace: true,
                    templateUrl: 'template/marquees/marqueeTabs.html',
                    require: '^ddhMarquee',
                    link: function (scope, elem, attr, ctrl) {
                        $timeout(function () {
                            var prevPageButton = ctrl.getClassSelectors(elem, '.marquee-nav-prev-page'),
                                    nextPageButton = ctrl.getClassSelectors(elem, '.marquee-nav-next-page'),
                                    tabs = ctrl.getClassSelectors(elem, '.control-nav-item'), timerClass, activeIdx, perPage = 4;
                            ctrl.addClass(tabs[0], 'active');
                            angular.element(tabs).attr('tabindex', '-1');
                            angular.element(tabs[0]).attr('tabindex', '0');
                            angular.element(prevPageButton).attr('aria-disabled', 'true');
                            angular.element(prevPageButton).attr('tabindex', '-1');

                            if (!(tabs.length == 4) && tabs.length > 4) {
                                angular.element(nextPageButton).attr('aria-disabled', 'false');
                                angular.element(nextPageButton).attr('tabindex', '0');
                            }

                            var animationEnd = function () {
                                var activeElm = ctrl.getClassSelectors(elem, '.active');
                                if (activeElm.length > 0) {
                                    var idx = angular.element(activeElm)[0].index;
                                    if (idx < tabs.length - 1) {
                                        idx++;
                                        ctrl.getTabActive(idx);
                                        if ((idx) % perPage === 0) {
                                            ctrl.nextSlide(tabs.length);
                                        }
                                    } else {
                                    }
                                }
                            };

                            //Add click event listener with TAB
                            for (var j = 0; j < tabs.length; j++) {
                                tabs[j].index = j;
                                if (ddhMarqueeConfig.autoPlay) {
                                    //add Class timer
                                    var node = $compile('<div class="timer"></div>')(scope);
                                    scope.$apply();
                                    tabs[j].appendChild(node[0]);
                                    timerClass = ctrl.getClassSelectors(elem, '.timer');
                                    angular.element(timerClass[j]).css({
                                        'animationDuration': ddhMarqueeConfig.transitions.speed / 1000 + 's'
                                    });
                                    angular.element(timerClass[tabs.length - 1]).addClass('fill');
                                } else {
                                    //Add Class timer fill
                                    var node = $compile('<div class="timer fill"></div>')(scope);
                                    scope.$apply();
                                    tabs[j].appendChild(node[0]);
                                }
                                tabs[j].addEventListener('click', function (evt) {
                                    ctrl.getTabActive(this.index, false);
                                    ctrl.setIdx(this.index);
                                    angular.element(ctrl.getClassSelectors(elem, '.timer')).addClass('fill');
                                });
                                tabs[j].addEventListener('focus', function (evt) {
                                    ctrl.getTabActive(this.index,true);
                                    ctrl.setIdx(this.index);
                                    angular.element(ctrl.getClassSelectors(elem, '.timer')).addClass('fill');
                                });
                                angular.element(timerClass[j]).bind('animationend webkitAnimationEnd', animationEnd);
                            }

                            angular.element(tabs).bind('keydown', function (evt) {
                                switch (evt.keyCode) {
                                    case 37:
                                        activeIdx = ctrl.getIdx();
                                        if (activeIdx > 0) {
                                            activeIdx--;
                                            ctrl.setIdx(activeIdx);
                                            ctrl.getTabActive(activeIdx, true, true, 'prev');
                                        }
                                        break;
                                    case 39:
                                        activeIdx = ctrl.getIdx();
                                        if (activeIdx < tabs.length - 1) {
                                            activeIdx++;
                                            ctrl.setIdx(activeIdx);
                                            ctrl.getTabActive(activeIdx, true, true, 'next');
                                        }
                                        break;
                                    case 13:
                                    case 32:
                                        ctrl.getTabActive(activeIdx, false);
                                    default:
                                        break;
                                }
                            });

                            //Click for Next Slide
                            nextPageButton[0].addEventListener('click', function () {
                                ctrl.nextSlide(tabs.length);
                                angular.element(ctrl.getClassSelectors(elem, '.timer')).addClass('fill');
                            });

                            //Click for Prev Slide
                            prevPageButton[0].addEventListener('click', function () {
                                ctrl.prevSlide(tabs.length);
                                angular.element(ctrl.getClassSelectors(elem, '.timer')).addClass('fill');
                            });
                        });
                    }
                };
            }])
        .directive('ddhMarqueeImages', ['$window', 'ddhMarqueeConfig','$timeout', '$position', function ($window, ddhMarqueeConfig,$timeout, $position) {
                return {
                    restrict: 'A',
                    require: '^ddhMarquee',
                    transclude: true,
                    templateUrl: 'template/marquees/marqueeImagesWrapper.html',
                    link: function (scope, elem, attr, ctrl) {
                        scope.leftSwipe = true;
                        scope.rightSwipe = true;
                        var slideImage = elem[0].querySelectorAll('li'), activeIdx;
                        angular.element(slideImage).css({'width': '100%', 'transition-duration': ddhMarqueeConfig.transitions.duration / 1000 + 's'});
                        var rePosition = function () {
                            var elemParent = elem[0].parentElement,
                                    marqueeH = elemParent.parentElement.offsetHeight,
                                    ctrlNavH = elemParent.children[0].offsetHeight, paddingSize = 10,
                                    badgeWrapperH = marqueeH - ctrlNavH,
                                    badgeH = badgeWrapperH - (paddingSize * 2),
                                    badgeContent = ctrl.getClassSelectors(elem, '.badge-content'),
                                    len = badgeContent.length;
                            angular.element(ctrl.getClassSelectors(elem, '.badge-wrapper')).css('height', badgeWrapperH + 'px');

                            for (var i = 0; i < len; i++) {
                                angular.element(badgeContent[i]).css('maxHeight', badgeH + 'px');
                                var $mb = ctrl.getClassSelectors(elem, '.marquee-badge')[i];
                                angular.element($mb).css('height', (badgeContent[i].offsetHeight) + 'px');
                                var badge_top = $position.offset(angular.element($mb)).top - $position.offset(angular.element($mb.parentElement.parentElement)).top,
                                        badge_width = $position.offset(angular.element($mb)).width,
                                        badge_height =  $position.offset(angular.element($mb)).height,
                                        badge_left = $position.offset(angular.element($mb)).left - $position.offset(angular.element($mb.parentElement.parentElement)).left;

                                var rectangle = 'rect(' + badge_top + 'px,' + (badge_width + badge_left) + 'px,' + (badge_top + badge_height) + 'px,' + badge_left + 'px)';
                                angular.element(ctrl.getClassSelectors(elem, '.badge-background')[i]).css('clip', rectangle);
                            }
                        };
                        $timeout(function(){
                            /* Loaded first image to get the height for reposition*/
                            var tempImage = new Image();
                            tempImage.onload = function(){
                                 rePosition();
                            }
                            tempImage.src = ctrl.getImagePath();
                        });
                        ctrl.addClass(slideImage[0], 'active');
                        angular.element(slideImage[0]).attr('tabindex', '0');
                        angular.element($window).bind('resize', function () {
                            rePosition();
                        });

                        //Add click event listener with SlideImages
                        for (var j = 0; j < slideImage.length; j++) {
                            slideImage[j].index = j;
                            slideImage[j].addEventListener('click', function (evt) {
                                ctrl.getTabActive(this.index);
                                ctrl.setIdx(this.index);
                                angular.element(ctrl.timerClass()).addClass('fill');
                            });

                        }

                        scope.mslide = function (inc) {
                            cIdx = ctrl.getIdx();
                            if (inc === 0) {
                                if (cIdx > 0) {
                                    cIdx--;
                                    ctrl.setIdx(cIdx);
                                    ctrl.getTabActive(cIdx, false, false, 'prev');
                                }
                            }
                            else {
                                if (cIdx < slideImage.length - 1) {
                                    cIdx++;
                                    ctrl.setIdx(cIdx);
                                    ctrl.getTabActive(cIdx, false, false, 'next');
                                }
                            }
                        };

                        scope.$watch("ctrl.activeIdx", function (value) {
                            if (value) {
                                scope.leftSwipe = false;
                                scope.rightSwipe = true;
                            }
                        });

                        angular.element(slideImage).bind('keydown', function (evt) {
                            switch (evt.keyCode) {
                                case 37:
                                    activeIdx = ctrl.getIdx();
                                    if (activeIdx > 0) {
                                        scope.mslide(0);
                                        slideImage[activeIdx].focus();
                                    }
                                    break;
                                case 39:
                                    activeIdx = ctrl.getIdx();
                                    if (activeIdx < slideImage.length - 1) {
                                        scope.mslide(1);
                                        slideImage[activeIdx].focus();
                                    }
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                };
            }]);
/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:page-levelMessaging
 *
 * @description
 *  <file src="src/pageLevelMessaging/docs/readme.md" />
 *
 * @usage
 *  <div class="alert">
        <div class="alert-error">
            <i class="icon-badgealert" role="img" aria-label="Error"></i>
        </div>
        <div class="alert-content">
            <h3 class="alert-heading">Your payment is past due.</h3>
            <p>
                Our records show your wireless bill is 5 days overdue. <a href="javascript:void(0)">Go to myAT&T</a>
            </p>
        </div>
    </div>
    
 *  <div class="alert" ng-if="showInfo">
        <div class="alert-info">
            <i class="icon-flat-info" role="img" aria-label="Info"></i>
        </div>
        <div class="alert-content">
            <h3 class="alert-heading" id="infoHeader1">Restocking fee</h3>
            <p>
                Your LG Watch Urbane return has a 20% restocking fee. <a href="javascript:void(0)" aria-describedby="infoHeader1">Learn more</a>
            </p>
        </div>
        <button type="button" class="close" aria-label="dismiss restocking fee" ng-click="dismissMe('showInfo')"></button>
    </div>
    
 *  <div class="alert" ng-if="showWarn">
     <div class="alert" ng-if="showWarn">
        <div class="alert-info">
            <i class="icon-alert" role="img" aria-label="Warning"></i>
        </div>
        <div class="alert-content">
            <h3 class="alert-heading">You have used 90% of your talk minutes.</h3>
            <p>
                When you have used all your talk minutes, you'll start using your Rollover Minutes.
            </p>
        </div>
        <button type="button" class="close" aria-label="dismiss you have used 90% of your talk minutes." ng-click="dismissMe('showWarn')"></button>
    </div>
    
 *  <div class="alert" ng-if="showSuccess">
        <div class="alert-success">
            <i class="icon-approval" role="img" aria-label="Checkmark"></i>
        </div>
        <div class="alert-content">
            <h3 class="alert-heading" id="successHeader1">You added a line to your Mobile Share Valueplan.</h3>
            <p>
                <a href="javascript:void(0)" aria-describedby="successHeader1">Learn more</a>
            </p>
        </div>
        <button type="button" class="close" aria-label="dismiss you added a line to your Mobile Share Valueplan." ng-click="dismissMe('showSuccess')"></button>
    </div>
    
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/pageLevelMessaging/docs/demo.html" />
            <file src="src/pageLevelMessaging/docs/demo.js" />
       </example>
        </section>
 *
 */
angular.module('ddh.att.pageLevelMessaging', []);
/**
 * @ngdoc directive
 * @name Navigation.att:pagination
 *
 * @description
 *  <file src="src/pagination/docs/readme.md" />
 *
 * @usage
 *   <div ddh-pagination="" total-pages="totalPages1" current-page="currentPage1" click-handler="customHandler" show-input="showInput"></div> 
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/pagination/docs/demo.html" />
            <file src="src/pagination/docs/demo.js" />
       </example>
        </section>
 *
 */
angular.module('ddh.att.pagination', ['ddh.att.utilities', 'ddh.att.lazyLoad'])
    .directive('ddhPagination', ['userAgent', '$window', '$timeout', 'ddhLazyLoad', function(userAgent, $window, $timeout, ddhLazyLoad) {
        return {
            restrict: 'A',
            scope: {
                totalPages: '=',
                currentPage: '=',
                showInput: '=',
                clickHandler: '=?',
                skipLinkMobileShow: '=?'
            },
            replace: true,
            templateUrl: 'template/pagination/pagination.html',
            compile: function (elem, attr) {
                ddhLazyLoad.load('pagination', 'css');

                return this.link;
            },
            link: function(scope, elem) {
                scope.checkMobile = function() {
                    if ($window.innerWidth <= 767) {
                        scope.isMobile = true;
                    } else {
                        scope.isMobile = false;
                    }
                }

                scope.checkMobile();
                angular.element($window).on('resize', function() {
                    scope.checkMobile();
                    currentPageChanged(scope.currentPage);
                    scope.$apply();
                });

                scope.focusedPage;
                scope.meanVal = 3;
                scope.w, scope.el, scope.l;
                scope.firstPlay = true;
                scope.$watch('totalPages', function(value) {
                    if (!scope.firstPlay) {
                        if (scope.currentPage === undefined || scope.currentPage === 1 || scope.currentPage === null) {
                            currentPageChanged(1);
                        } else {
                            currentPageChanged(scope.currentPage);
                        }
                    } else {
                        scope.firstPlay = false;
                    }
                });
                scope.$watch('currentPage', function(value) {
                    if (angular.isUndefined(value) || value === null || value === '') {
                        value = 1;
                    }
                    currentPageChanged(value);
                });
                var callbackHandler = function(num) {
                    if (angular.isFunction(scope.clickHandler)) {
                        scope.clickHandler(num);
                    }
                };

                var currentPageChanged = function(value) {
                    if (angular.isDefined(value) && value !== null) {
                        if (!value || value < 1) {
                            value = 1;
                        }
                        if (value > scope.totalPages) {
                            value = scope.totalPages;
                        }
                        if (scope.currentPage !== value) {
                            scope.currentPage = value;
                            //callbackHandler(scope.currentPage);
                        }
                        scope.pages = [];
                        if (!scope.isMobile) {
                            if (scope.totalPages <= 10) {
                                for (var i = 1; i <= scope.totalPages; i++) {
                                    scope.pages.push(i);
                                }
                            }
                            if (scope.totalPages > 10) {
                                var val = parseInt(value);
                                if (val <= 6) {
                                    scope.pages = [1, 2, 3, 4, 5, 6, 7, 8];
                                } else if (val > 6 && val <= scope.totalPages - 5) {
                                    scope.pages = [val - 2, val - 1, val, val + 1, val + 2];
                                } else if (val >= scope.totalPages - 5) {
                                    scope.pages = [scope.totalPages - 7, scope.totalPages - 6, scope.totalPages - 5, scope.totalPages - 4, scope.totalPages - 3, scope.totalPages - 2, scope.totalPages - 1, scope.totalPages];
                                }
                            }
                        }



                        if (scope.isMobile) {
                            for (var i = 1; i <= scope.totalPages; i++) {
                                scope.pages.push(i);
                            }
                            $timeout(function() {
                                //elem[0].scrollLeft = 0;
                                scope.w = scope.pElement.getBoundingClientRect().width;
                                scope.l = scope.pElement.scrollLeft;
                                scope.ew = scope.pElement.querySelector('li').getBoundingClientRect().width;
                                scope.el = scope.pElement.querySelector('li.active').offsetLeft;
                                //elem[0].scrollLeft = scope.l+(scope.el-(scope.w/2));
                                scope.tween(scope.l, scope.el - (scope.w / 2), 500);
                                if ((scope.l + scope.w < scope.pElement.querySelector('ul').offsetWidth - (scope.ew / 2))) {

                                    elem[0].querySelector('.pagination-holder').classList.add('rightblur');
                                } else if (!(scope.l + scope.w < scope.pElement.querySelector('ul').offsetWidth - (scope.ew / 2))) {
                                    elem[0].querySelector('.pagination-holder').classList.remove('rightblur');
                                }
                            }, 200);
                        }
                    }
                }
                scope.pElement = elem[0].querySelector('.pagination');
                scope.pElement.onscroll = function() {
                    scope.w = scope.pElement.getBoundingClientRect().width;
                    scope.l = scope.pElement.scrollLeft;
                    scope.elemWidth = scope.pElement.querySelector('li.active').getBoundingClientRect().width / 2,
                        scope.lastScroll = scope.pElement.querySelector('li:last-child').offsetLeft;
                    scope.totwidth = scope.w + scope.elemWidth;
                    if (scope.totwidth > scope.lastScroll - scope.l) {
                        elem[0].querySelector('.pagination-holder').classList.remove('rightblur');
                    }
                    if (scope.totwidth < scope.lastScroll - scope.l) {
                        elem[0].querySelector('.pagination-holder').classList.add('rightblur');
                    }
                    if (scope.l > scope.elemWidth) {
                        elem[0].querySelector('.pagination-holder').classList.add("leftblur");
                    } else {
                        elem[0].querySelector('.pagination-holder').classList.remove("leftblur");
                    }
                }

                scope.tween = function(start, end, duration) {
                    var delta = end - start;
                    var startTime;
                    if (window.performance && window.performance.now) {
                        startTime = performance.now();
                    } else if (Date.now) {
                        startTime = Date.now();
                    } else {
                        startTime = new Date().getTime();
                    }
                    var tweenLoop = function(time) {
                        var t = (!time ? 0 : time - startTime);
                        var factor = scope.easing(null, t, 0, 1, duration);
                        scope.pElement.scrollLeft = start + delta * factor;
                        if (t < duration && scope.pElement.scrollLeft != end)
                            requestAnimationFrame(tweenLoop);
                    }
                    tweenLoop();
                };
                scope.easing = function(x, t, b, c, d) {
                    return c * (t /= d) * t + b;
                };

                scope.animationInit = function() {
                    var lastTime = 0;
                    var vendors = ['ms', 'moz', 'webkit', 'o'];
                    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
                        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
                        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
                    }
                    if (!window.requestAnimationFrame)
                        window.requestAnimationFrame = function(callback, element) {
                            var currTime = new Date().getTime();
                            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
                            lastTime = currTime + timeToCall;
                            return id;
                        };
                    if (!window.cancelAnimationFrame)
                        window.cancelAnimationFrame = function(id) {
                            clearTimeout(id);
                        };
                };

                scope.animationInit();

                scope.gotoKeyClick = function(keyEvent) {
                    if (keyEvent.which === 13 && scope.gotoPage) {
                        scope.gotoBtnClick();
                    }
                };
                scope.gotoBtnClick = function() {
                    currentPageChanged(parseInt(scope.gotoPage));
                    callbackHandler(scope.currentPage);
                    var qResult = elem[0].querySelector('button');
                    angular.element(qResult).attr('disabled', 'true');
                    angular.element(qResult).removeClass('active');
                    $timeout(function() {
                        elem[0].querySelector('li.active').focus();
                    }, 50);
                    scope.gotoPage = null;
                };
                scope.onChange = function() {
                    if (scope.gotoPage) {
                        var qResult = elem[0].querySelector('button');
                        angular.element(qResult).removeAttr('disabled');
                        angular.element(qResult).addClass('active');
                    } else {
                        var qResult = elem[0].querySelector('button');
                        angular.element(qResult).attr('disabled', 'true');
                        angular.element(qResult).removeClass('active');
                    }
                };
                scope.next = function(event) {
                    if (event !== undefined) {
                        event.preventDefault();
                    }
                    if (scope.currentPage < scope.totalPages) {
                        scope.currentPage += 1;
                        callbackHandler(scope.currentPage);
                    }
                };
                scope.prev = function(event) {
                    if (event !== undefined) {
                        event.preventDefault();
                    }
                    if (scope.currentPage > 1) {
                        scope.currentPage -= 1;
                        callbackHandler(scope.currentPage);
                    }
                };
                scope.selectPage = function(value, event) {
                    event.preventDefault();
                    scope.currentPage = value;
                    scope.focusedPage = value;
                    callbackHandler(scope.currentPage);
                };
                scope.checkSelectedPage = function(value) {
                    if (scope.currentPage === value) {
                        return true;
                    }
                    return false;
                };
                scope.isFocused = function(page) {
                    return scope.focusedPage === page;
                };

                //Skip link functionality
                if (angular.isUndefined(scope.skipLinkMobileShow)) {
                    scope.skipLinkMobileShow = true;
                }

                if (scope.skipLinkMobileShow) {
                    scope.moveFocus = function(isDown, evt) {
                        var spanTag = elem.find('span');
                        if (isDown) {
                            spanTag.eq(spanTag.length - 1)[0].focus();
                        } else {
                            spanTag.eq(0)[0].focus();
                        }
                        evt.stopImmediatePropagation();
                        evt.preventDefault();
                    };

                    scope.displaySkipLink = function(isFirst) {
                        var aTag = elem.find('a');
                        if (isFirst) {
                            aTag.eq(0).removeClass('pagi-hidden-spoken');
                        } else {
                            aTag.eq(aTag.length - 1).removeClass('pagi-hidden-spoken');
                        }
                        angular.element(elem[0].querySelector('.pagination')).css({ 'opacity': '0.3' });
                    }

                    scope.hideSkipLink = function(isFirst) {
                        var aTag = elem.find('a');
                        if (isFirst) {
                            aTag.eq(0).addClass('pagi-hidden-spoken');
                        } else {
                            aTag.eq(aTag.length - 1).addClass('pagi-hidden-spoken');
                        }
                        angular.element(elem[0].querySelector('.pagination')).css({ 'opacity': '1' });
                    }
                }


            }
        };
    }])
    .directive('onlyDigits', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                elm.on('keydown', function(event) {
                    if (event.which >= 48 && event.which <= 57) {
                        // to disallow special characters
                        if (event.shiftKey) {
                            event.preventDefault();
                            return false;
                        }
                        // to allow numbers if characters are 4 or less
                        if (elm.val().length < 2) {
                            return true;
                        } else {
                            event.preventDefault();
                            return false;
                        }
                    } else if (event.which >= 96 && event.which <= 105) {
                        // to allow numpad number if characters are 4 or less
                        if (elm.val().length < 2) {
                            return true;
                        } else {
                            event.preventDefault();
                            return false;
                        }
                    } else if ([8, 9, 13, 27, 46].indexOf(event.which) > -1) {
                        // to allow backspace, tab, enter, escape
                        return true;
                    } else if ([37, 38, 39, 40].indexOf(event.which) > -1) {
                        // to allow arrows
                        if (event.keyCode === 38 && elm.val() >= 99) {
                            event.preventDefault();
                            return false;
                        } else if (event.keyCode === 40 && elm.val() <= 1) {
                            event.preventDefault();
                            return false;
                        } else {
                            return true;
                        }

                    } else if (event.altKey || event.ctrlKey) {
                        // to allow alter, control
                        return true;
                    } else {
                        // to stop others
                        event.preventDefault();
                        return false;
                    }
                });
                elm.on('input', function(event) {
                    if (isNaN(elm.val()) || elm.val() === "") {
                        elm.val("");
                        event.preventDefault();
                        return false;
                    }
                    if (elm.val() > 99) {
                        elm.val(99);
                        return false;
                    }
                    if (elm.val() < 1) {
                        elm.val(1);
                        return false;
                    }
                });
                var validateString = function(value) {
                    if (angular.isUndefined(value) || value === null || value === '') {
                        //return ctrl.$modelValue;
                    }
                    return value;
                };
                ctrl.$parsers.unshift(validateString);
            }
        };
    });

/**
 * @ngdoc directive
 * @name Navigation.att:Pivot Links
 *
 * @description
 *  <file src="src/pivotLinks/docs/readme.md" />
 *
 * @usage
 *   <!-- HTML Imlementation provided below --> 
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/pivotLinks/docs/demo.html" />
            <file src="src/pivotLinks/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.pivotLinks', []);
/**
 * @ngdoc directive
 * @name Headings & copy.att:Pricing
 *
 * @description
 *  <file src="src/pricing/docs/readme.md" />
 *
 * @usage
 * <p class="usd" style="font-size:19px; color:#ef6f00">....</p>
 *
 * @example
   <section id="code">
        <example module="ddh.att">
            <file src="src/pricing/docs/demo.html" />
            <file src="src/pricing/docs/demo.js" />
       </example>
    </section>
 */
var ddhPricing = angular.module('ddh.att.pricing', []);
/**
 * @ngdoc directive
 * @name Product selection.att:productTile
 *
 * @description
 *  <file src="src/productTile/docs/readme.md" />
 *
 * @usage
 * <div class="product-tiles autoSize" ddh-product-tile-wrapper>
        <div ddh-product-tile ng-repeat="item in productlist" id="productTile{{$index}}">
            <ddh-tile-container>
                <div class="product-price">
                    <span class="strike">$35.00</span> <span class="price">$21.68</span>
                </div>
                <div class="product-legal" style="height: 22px;">Req 30 mo installment agmt, qual.credit &amp; svc plan. <a href="javascript:void(0);" ddh-modal="template/modalsAndAlerts/modal-demo.html" size-class="modal-medium">See price details</a></div>
            </ddh-tile-container>
            <ddh-tile-footer>
                <div class="span">
                    <label for="prod1check{{$index}}" class="checkbox">
                        <input type="checkbox" id="prod1check{{$index}}" value="">
                        <i class="skin"></i>
                        <span>Compare</span>
                    </label>
                </div>
                <div class="span">
                    <button class="btn btn-secondary btn-small pull-right">View</button>
                </div>
            </ddh-tile-footer>
        </div>
    </div>
 *
 * @example
 <example module="ddh.att">
   <file src="src/productTile/docs/demo.html" />
   <file src="src/productTile/docs/demo.js" />
 </example>
 */
angular.module('ddh.att.productTile', ['ddh.att.modalsAndAlerts', 'ddh.att.starRating'])

.constant('productTileConfig', {
    allowedTiles: [4, 12]
})

.directive('ddhProductTileWrapper', ['$timeout', '$window', 'productTileConfig', function ($timeout, $window, productTileConfig) {
    return {
        restrict: 'EA',
        scope: true,
        controller: ['$scope', function ($scope) {
            this.tileScopes = $scope.tileScopes = [];
            this.registerTile = function (tileScope) {
                this.tileScopes.push(tileScope);
            };
        }],
        link: function (scope, elem, attr, ctrl) {
            var calcHeight = function () {
                var rating = elem[0].querySelectorAll('.product-title-rating'),
                    colorSwatch = elem[0].querySelectorAll('.color-swatch'),
                    productLegal = elem[0].querySelectorAll('.product-legal'),
                    heightToFix = 0,
                    colorSwatchHeight = 0,
                    productLegalHeight = 0;
                for (var i = 0; i < rating.length; i++) {
                    if (rating[i].clientHeight > heightToFix) {
                        heightToFix = rating[i].clientHeight;
                    }
                    if (colorSwatch[i].clientHeight > colorSwatchHeight) {
                        colorSwatchHeight = colorSwatch[i].clientHeight;
                    }
                    if (productLegal[i].clientHeight > productLegalHeight) {
                        productLegalHeight = productLegal[i].clientHeight;
                    }
                }
                angular.element(rating).css({
                    'height': heightToFix + 'px'
                });
                angular.element(colorSwatch).css({
                    'height': colorSwatchHeight + 'px'
                });
                angular.element(productLegal).css({
                    'height': productLegalHeight + 'px'
                });
            };

            var removeHeight = function () {
                var rating = elem[0].querySelectorAll('.product-title-rating'),
                    colorSwatch = elem[0].querySelectorAll('.color-swatch'),
                    productLegal = elem[0].querySelectorAll('.product-legal');
                for (var i = 0; i < rating.length; i++) {
                    angular.element(rating[i]).removeAttr('style');
                    angular.element(colorSwatch[i]).removeAttr('style');
                    angular.element(productLegal[i]).removeAttr('style');
                }
            };

            var validateTiles = function () {
                var totalTiles = scope.tileScopes.length;
                var allowedTiles = angular.copy(productTileConfig.allowedTiles);
                allowedTiles.sort(function (a, b) {
                    return a - b
                });
                var validNearestTiles = allowedTiles.find(function (allowedTile) {
                    return allowedTile >= totalTiles;
                });
                var deltaTiles = validNearestTiles - totalTiles;
                while (deltaTiles > 0) {
                    elem.append('<div class="product-tile"></div>');
                    deltaTiles--;
                }
            };

            $timeout(function () {
                calcHeight();
                validateTiles();
            }, 100);

            angular.element($window).bind("resize", function () {
                $timeout(function () {
                    removeHeight();
                    calcHeight();
                }, 400);
            });
        }
    };
}])

.directive('ddhProductTile', ['$window', function ($window) {
    return {
        restrict: 'EA',
        transclude: true,
        replace: true,
        scope: true,
        require: '^ddhProductTileWrapper',
        templateUrl: 'template/productTile/productTiles.html',
        link: function (scope, elem, attr, ctrl) {
            ctrl.registerTile(scope);
            angular.element($window).bind("resize", function () {
                var secondaryBadge = elem[0].querySelector('.product-badge-secondary');
                if (elem[0].offsetWidth <= '285') {
                    angular.element(secondaryBadge).css({
                        'visibility': 'hidden'
                    });
                } else {
                    angular.element(secondaryBadge).css({
                        'visibility': 'visible'
                    });
                }
            });
        }
    };
}])

.directive('ddhTileContainer', function () {
    return {
        restrict: 'EA',
        transclude: true,
        replace: true,
        require: '^ddhProductTile',
        scope: true,
        templateUrl: 'template/productTile/productTileContainer.html',
    };
})

.directive('ddhTileFooter', function () {
    return {
        restrict: 'EA',
        transclude: true,
        replace: true,
        template: '<ng-transclude class="product-footer"></ng-transclude>'
    };
});

/**
 * @ngdoc directive
 * @name Messages, modals & alerts.att:promoBadge
 *
 * @description
 *  <file src="src/promoBadge/docs/readme.md" />
 *
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/promoBadge/docs/demo.html" />
 <file src="src/promoBadge/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.promoBadge',[]);
      
/**
 * @ngdoc directive
 * @name Banners, marquees & tiles.att:promoCards
 *
 * @description
 *  <file src="src/promoCards/docs/readme.md" />
 *
 * @usage
 *  <div ddh-promocard class="promo-card" style="background-image:url(../promo-image-path.png)">
        <div class="promo-overlay blur-overlay">
            Content in promo card.
        </div>
    </div>
 *
 * @example
 * 	<section id="code">
	   <b>HTML + AngularJS</b>
	    <example module="ddh.att">
            <file src="src/promoCards/docs/demo.html" />
            <file src="src/promoCards/docs/demo.js" />
       </example>
	</section>
 * 
 */
angular.module('ddh.att.promoCards', [])
    .directive('ddhPromocard', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'EA',
            scope: {},
            link: function (scope, elem) {

                var isIE = /msie|trident/i.test(navigator.userAgent);

                var blurOverlay = elem[0].querySelector('.blur-overlay');

                var getProperties = function (e, p, g) {
                    g = $window.getComputedStyle;
                    return (g ? g(e) : e.currentStyle)[p.replace(/-(\w)/gi, function (w, l) {
                        return l.toUpperCase();
                    })];
                };

                var blurIMG;
                if (isIE) {

                    scope.blurFunction = (function (imgWidth, imgHeight) {
                        var bgValues = getProperties(elem[0], 'background-position').split(" ");
                        var marqueeWidth = parseFloat(getProperties(elem[0], 'width'));
                        var xPosition = parseFloat(bgValues[0]),
                            posPercent = xPosition / 100,
                            posDifference = posPercent - 0.5;

                        var blurPosition = (function () {
                            var blurPosX = (marqueeWidth * posDifference) + ((marqueeWidth - imgWidth) * posDifference);
                            return blurPosX;
                        });

                        if (blurIMG) {
                            if (xPosition === 50) {
                                blurIMG[0].querySelector('image').setAttribute('x', 0);
                            } else {
                                blurIMG[0].querySelector('image').setAttribute('x', blurPosition());
                            }
                        }
                    });

                    var blur_bgImg = (function () {
                        var bg = getProperties(elem[0], 'background-image');
                        bg = bg.replace('url("', '').replace('")', '');
                        return bg;
                    });

                    var bgImg = new Image();
                    bgImg.src = blur_bgImg();
                    
                    blurIMG = angular.element('<svg class="blurBg" preserveAspectRatio="xMidYMin slice"><image width=100% height=100% style="filter:url(#blur-effect-1);" x="0" y="0" xlink:href="' + blur_bgImg() + '" /><filter id="blur-effect-1"><feGaussianBlur stdDeviation="8" /></filter></svg>');

                    var imgSize = function () {
                        bgImg.onload = function () {
                            scope.imgWidth = this.width;
                            scope.imgHeight = this.height;

                            blurIMG[0].setAttribute('viewBox', '0 0 '+ scope.imgWidth + ' ' + scope.imgHeight);

                            scope.blurFunction(scope.imgWidth, scope.imgHeight);
                        };
                    };

                    imgSize();

                } else {
                    blurIMG = angular.element('<div class="blurBg"></div>');
                }

                // add blurBg overlay
                elem.prepend(blurIMG);



                var blurIMGCssCalculation = function () {
                    var blur_width = elem[0].offsetWidth,
                        blur_height = elem[0].offsetHeight,
                        bgImg = getProperties(elem[0], 'background-image'),
                        bgPos = getProperties(elem[0], 'background-position'),
                        bgSize = getProperties(elem[0], 'background-size'),
                        overlayY = blurOverlay.offsetTop,
                        overlayX = blurOverlay.offsetLeft,
                        overlayW = blurOverlay.offsetWidth,
                        overlayH = blurOverlay.offsetHeight,
                        newClip = 'rect(' + overlayY + 'px, ' + (overlayW + overlayX) + 'px, ' + (overlayH + overlayY + 10) + 'px, ' + overlayX + 'px)',
                        clipPath = 'inset(' + overlayY + 'px ' + (overlayW + overlayX) + 'px ' + (overlayH + overlayY) + 'px ' + overlayX + 'px)';

                    blurIMG.css({
                        'background-image': bgImg,
                        'background-position': bgPos,
                        'background-size': bgSize,
                        'clip': newClip,
                        'height': blur_height + 10 + 'px',
                        'width': blur_width + 'px'
                    });
                };

                blurIMGCssCalculation();

                angular.element($window).bind('resize', function () {
                    $timeout(function () {
                        blurIMG.removeAttr('style');
                        blurIMGCssCalculation();

                        if (isIE) {
                            scope.blurFunction(scope.imgWidth, scope.imgHeight);
                        }
                    }, 400);
                });
            }
        };
}])

.directive('ddhPromocardGroup', ['$window', '$timeout', function ($window, $timeout) {
    return {
        restrict: 'A',
        scope: {},
        controller: ['$scope', '$element', '$attrs', function (scope, elem, attr) {

            var classNames = attr.ddhPromocardGroup.replace(/\./g, '').split("|");

            function calculateOverlayHeight(selectorClass){

                var promocardsGroup = angular.element(elem);

                var largestHeight = 0;

                for (var i = 0; i < promocardsGroup[0].children.length; i++) {
                    var promocard = promocardsGroup[0].children[i];

                    var promoOverlay = angular.element(promocard.getElementsByClassName(selectorClass));

                    if (promoOverlay.hasClass(selectorClass)){

                        var styles = window.getComputedStyle(promoOverlay[0]);
                    
                        var innerHeight = parseInt(styles.height);

                       if (parseInt(innerHeight) > largestHeight){
                            largestHeight = innerHeight;
                       }

                    }

                }

                for (var i = 0; i < promocardsGroup[0].children.length; i++) {
                    var promocard = promocardsGroup[0].children[i];
                    var promoOverlay = angular.element(promocard.getElementsByClassName(selectorClass));

                    promoOverlay.css({'height': largestHeight + "px"});

                }
        }

        function removeOverlayHeight(selectorClass){

                var promocardsGroup = angular.element(elem);

                var largestHeight = 0;

                for (var i = 0; i < promocardsGroup[0].children.length; i++) {
                    var promocard = promocardsGroup[0].children[i];

                    var promoOverlay = angular.element(promocard.getElementsByClassName(selectorClass));
                    promoOverlay.removeAttr('style');
                }
        }

        for (var i = 0; i<classNames.length; i++){
            calculateOverlayHeight(classNames[i]);
        }

        angular.element($window).bind('resize', function () {
            $timeout(function () {
                for (var i = 0; i<classNames.length; i++){
                    removeOverlayHeight(classNames[i]);
                    calculateOverlayHeight(classNames[i]);
                }
            }, 400);
        });
        }],
         link: function (scope, elem, attr, ctrl) {
         }
    };
}]);
/**
 * @ngdoc directive
 * @name Product selection.att:radioProductSelect
 *
 * @description
 *  <file src="src/radioProductSelect/docs/readme.md" />
 *
 * @usage
 *  <form>
     <fieldset>
     <ul class="radio-product-select" role="radiogroup" data-select-color="orange" radio-group-accessibility>
                  <li class="form-row radio-box">
                  <div class="label-tip">
                    <label for="radiolist1" class="radio" role="radio">
                        <input type="radio" name="radiolist" id="radiolist1" value="option1">
                        <i class="skin"></i>
                        <span>Label text 1</span>
                        <br aria-hidden="true">
                        <span class="p-small">additional label text</span>
                    </label>
                    <span class="tooltip valign-top" ddh-tooltip>
                        <a href="javascript:void(0)" class="icon-tooltip tooltip-element"  data-placement="bottom" role="button" aria-label="Help"  aria-describedby="tooltiptext1" ng-mouseover="">
                            <div class="arrow"></div>
                        </a>
                        <div class="tooltip-wrapper" role="tooltip" aria-live="polite" aria-atomic="false">
                            <div class="tooltip-size-control">
                                <div class="helpertext" tabindex="-1" role="tooltip" id="tooltiptext1">  
                                    <div class="popover-title">A tooltipsForForms is a text explanation to help identify what the user should enter in the text field. Keep it brief.</div>  
                                </div>
                            </div>
                        </div>
                    </span>
                    </div>
                    <div class="product-price">
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due today</span>
                        </div>
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due monthly</span>
                        </div>
                    </div>
                </li>
                <li class="form-row radio-box">
                   <div class="label-tip">
                    <label for="radiolist2" class="radio" role="radio">
                        <input type="radio" name="radiolist" id="radiolist2" value="option2">
                        <i class="skin"></i>
                        <span>Long label text 2</span>
                         <br aria-hidden="true">
                        <span class="p-small">additional label text</span>
                    </label>
                    <span class="tooltip valign-top" ddh-tooltip>
                        <a href="javascript:void(0)" class="icon-tooltip tooltip-element"  data-placement="bottom" role="button" aria-label="Help"  aria-describedby="tooltiptext2" ng-mouseover="">
                            <div class="arrow"></div>
                        </a>
                        <div class="tooltip-wrapper" role="tooltip" aria-live="polite" aria-atomic="false">
                            <div class="tooltip-size-control">
                                <div class="helpertext" tabindex="-1" role="tooltip" id="tooltiptext2">  
                                    <div class="popover-title">A tooltipsForForms is a text explanation to help identify what the user should enter in the text field. Keep it brief.</div>  
                                </div>
                            </div>
                        </div>
                    </span>
                   </div>
                    <div class="product-price">
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due today</span>
                        </div>
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due monthly</span>
                        </div>
                    </div>
                </li>
                <li class="form-row radio-box">
                  <div class="label-tip">
                    <label for="radiolist3" class="radio" role="radio">
                        <input type="radio" name="radiolist" id="radiolist3" value="option3">
                        <i class="skin"></i>
                        <span>Super duper long label text 3</span>
                        <br aria-hidden="true">
                        <span class="p-small">additional label text</span>
                    </label>
                    <span class="tooltip valign-top" ddh-tooltip>
                        <a href="javascript:void(0)" class="icon-tooltip tooltip-element"  data-placement="bottom" role="button" aria-label="Help"  aria-describedby="tooltiptext3" ng-mouseover="">
                            <div class="arrow"></div>
                        </a>
                        <div class="tooltip-wrapper" role="tooltip" aria-live="polite" aria-atomic="false">
                            <div class="tooltip-size-control">
                                <div class="helpertext" tabindex="-1" role="tooltip" id="tooltiptext3">  
                                    <div class="popover-title">A tooltipsForForms is a text explanation to help identify what the user should enter in the text field. Keep it brief.</div>  
                                </div>
                            </div>
                        </div>
                    </span>
                   </div> 
                    <div class="product-price">
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due today</span>
                        </div>
                        <div>
                            <span class="price-medium">$00.00</span>
                            <span class="p-small">Due monthly</span>
                        </div>
                    </div>
                </li>
            </ul>
        </fieldset>
    </form>
   
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/radioProductSelect/docs/demo.html" />
            <file src="src/radioProductSelect/docs/demo.js" />
       </example>
        </section>
 *
 */
angular.module('ddh.att.radioProductSelect', []);
   
/**
 * @ngdoc directive
 * @name Forms.att:radios
 *
 * @description
 *  <file src="src/radios/docs/readme.md" />
 *
 * @usage
 * 
 * <form  name="myForm" novalidate>
      <h3>Radio Group example with radio-group-accessibility directive</h3>
      <br>
        <fieldset role="radiogroup" radio-group-accessibility >
            <div class="form-row" role="radio">
                <label for="optionsRadios1111" class="radio">
                    <input type="radio" ng-model="selectedvalueradioGroup.name" id="optionsRadios1111"  name="optionsRadio11" value="radiovalue1"  
                           required="">
                    <i class="skin"></i>
                    <span>Option radiovalue1</span>
                </label>
            </div>
            <div class="form-row" role="radio">
                <label for="optionsRadios2222" class="radio">
                    <input type="radio" ng-model ="selectedvalueradioGroup.name" id="optionsRadios2222" name="optionsRadio11" value="radiovalue2">
                    <i class="skin"></i>
                    <span>Option radiovalue2</span>
                </label>
            </div>
            <div class="form-row" role="radio">
                <label  for="optionsRadios333333" class="radio">
                    <input type="radio" ng-model ="selectedvalueradioGroup.name" id="optionsRadios333333"  name="optionsRadio11" value="radiovalue3">
                    <i class="skin"></i>
                    <span>Option radiovalue3</span>
            </div>
        </fieldset>
    </form>

 *  <form  name="myForm" novalidate>
      <div class="form-row">
         <label class="radio">
         <input type="radio" role="radio" ng-model ="selectedvalue.name" name="optionsRadios" value="option1"  
            required="">
         <i class="skin"></i>
         <span>Option one</span>
         </label>
     </div>
    </form>
 *
 * @example
    <section id="code">
               <b>HTML + AngularJS</b>
               <example module="ddh.att">
				<file src="src/radios/docs/demo.html" />
                <file src="src/radios/docs/demo.js" />
			   </example>
            </section>
 */
angular.module('ddh.att.radios', ['ddh.att.utilities'])
        .directive('radioGroupAccessibility', ['$timeout','userAgent', function($timeout, userAgent) {
                return {
                    restrict: "A",
                    scope:{
                       refreshRadioGroup: "=",  
                    },
                    link: function(scope, ele, attr) {
                        
                        var roleRadioElement, radioProductSelectElement, radioInputTypeElement;   
                        
                        $timeout(calculateNumberOfRadio);
                        
                        scope.$watch('refreshRadioGroup', function(value) {
                            if (value === true) {
                               addingRoleAttribute();
                               $timeout(calculateNumberOfRadio);
                               scope.refreshRadioGroup = false;
                            }
                            else {
                                return;
                            }
                        } )
                        
                        
                        function calculateNumberOfRadio() {
                            roleRadioElement = ele[0].querySelectorAll('[role="radio"]');
                            
                            radioProductSelectElement = ele[0].querySelectorAll('[role="radiogroup"] li.radio-box');

                            radioInputTypeElement = ele[0].querySelectorAll('input[type="radio"]');
                            
                            for (var i = 0; i < radioInputTypeElement.length; i++) {
                                var isChecked = radioInputTypeElement[i].checked ? 'true' : 'false';
                                var isDisabled = radioInputTypeElement[i].disabled ? 'true' : 'false';
                                var numOfx = i + 1 + ' of ' + radioInputTypeElement.length;
                                angular.element(roleRadioElement[i]).attr({'aria-checked': isChecked, 'aria-disabled': isDisabled, 'data-opNum': numOfx});
                                if(userAgent.notMobile() || (radioProductSelectElement && radioProductSelectElement.length > 0) ){
                                     angular.element(roleRadioElement[i]).removeAttr( "role");
                                }
                               
                                if (radioProductSelectElement.length) {
                                    isChecked === 'true' ? angular.element(radioProductSelectElement[i]).addClass('active') : angular.element(radioProductSelectElement[i]).removeClass('active');
                                 }
                                
                                if (/Android/i.test(navigator.userAgent)) {
                                    angular.element(roleRadioElement[i]).append('<span class="hidden-spoken">. ' + numOfx + '.</span>');
                                }


                                angular.element(radioInputTypeElement[i]).bind('click', radioStateChangeonClick);

                            }
                        }
                        
                        function addingRoleAttribute() {
                          if(radioInputTypeElement){
                            for (var i = 0; i < radioInputTypeElement.length; i++) {
                                if (userAgent.notMobile() || (radioProductSelectElement && radioProductSelectElement.length > 0) ) {
                                    angular.element(roleRadioElement[i]).attr("role","radio");
                                }
                            }
                        }
                        
                        }

                        function radioStateChangeonClick() {
                            for (var i = 0; i < radioInputTypeElement.length; i++) {
                                var isChecked = radioInputTypeElement[i].checked ? 'true' : 'false';
                                var isDisabled = radioInputTypeElement[i].disabled ? 'true' : 'false';
                                if (radioProductSelectElement.length) {
                                    isChecked === 'true' ? angular.element(radioProductSelectElement[i]).addClass('active') : angular.element(radioProductSelectElement[i]).removeClass('active');
                                 }
                                angular.element(roleRadioElement[i]).attr({'aria-checked': isChecked, 'aria-disabled': isDisabled});
                            }

                        }
                    }
                }

            }])
.directive('ddhRadioExpand', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, elem, attr) {

            var timeoutInstance = null;
            var timeoutInstanceRemove = null;
            var msgText = 'Additional Form Displayed ';

            var msgElemString = '<div aria-live="polite"  class="hidden-spoken"></div>';
            
            var msgElem = angular.element(msgElemString);

            scope.$watch(attr.ngModel,function(newValue) {
                if (timeoutInstance) {
                    $timeout.cancel(timeoutInstance);
                }
                if (timeoutInstanceRemove) {
                    $timeout.cancel(timeoutInstanceRemove);
                }
                else {
                    elem.parent().after(msgElem);
                }

                timeoutInstance = $timeout(function () {
                    if(newValue == attr.value) {
                        msgElem.text(msgText);
                    }
                    else {
                        msgElem.text('');
                        msgElem.remove();
                    }
                    timeoutInstanceRemove = $timeout(function () {
                        msgElem.text('');
                        msgElem.remove();
                        timeoutInstanceRemove = null;
                    }, 1000);
                    
                    timeoutInstance = null;
                }, 500);
            });
        }
    };
    }]);;


/**
 * @ngdoc directive
 * @name Forms.att:searchField
 *
 * @description
 *  <file src="src/searchField/docs/readme.md" />
 *
 * @usage
 *  <div ddh-search-field dropdown-list="listdata" on-click-callback="clickFn(value)" class="span12" input-model='typedString' config-obj='keyConfigObj'></div>
 *
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
    <file src="src/searchField/docs/demo.html" />
    <file src="src/searchField/docs/demo.js" />
</example>
</section>
 */

angular.module('ddh.att.searchField', ['ddh.att.utilities', 'ddh.att.position']).filter('ddhFilterInput', [function () {
        return function (list, str, keyArray, displayListKey,isContainsSearch) {
            var res = [];
            var searchLabel;
            var searchCondition;
            
            angular.forEach(list, function (listItem) {
                for (var i = 0; i < keyArray.length; i++) {
                    searchLabel = keyArray[i];
                    
                    if(isContainsSearch){
                        searchCondition = listItem[searchLabel].toLowerCase().indexOf(str.toLowerCase())>-1;
                    }
                    else{
                        searchCondition = listItem[searchLabel].match(new RegExp('^' + str, 'gi'));
                    }
                    
                    if (searchCondition) {
                        res.push({
                            'title': listItem[displayListKey],
                            'valueObj': listItem
                        });
                        break;
                }
            }
        });
            return res;
        };
}]).directive('ddhSearchField', ['$filter', 'ddhFilterInputFilter', 'keymap', '$documentBind', '$isElement', '$document', 'events', '$timeout', function ($filter, ddhFilterInput, keymap, $documentBind, $isElement, $document, events, $timeout) {
        return {
            restrict: 'A',
            scope: {
                dataList: '=dropdownList',
                onClickCallback: '&',
                inputModel: '=',
                configObj: '=',
                objModel: '=',
                inputDeny: '=?',
                disabled:'=?'
            },
            replace: true,
            templateUrl: 'template/searchField/searchField.html',
            controller: ['$scope', function ($scope) {
                this.searchKeyArray = [];
                if ($scope.configObj.searchKeys) {
                    this.searchKeyArray = $scope.configObj.searchKeys;
                }
                if(angular.isUndefined($scope.disabled)){
                    $scope.disabled = false;
                }
                this.triggerInput = function (searchString) {
                    $scope.originalInputModel = searchString;
                    if (searchString === '') {
                        $scope.currentIndex = -1;
                        $scope.filterList = [];
                        $scope.showListFlag = false;
                    } else if (searchString !== '' && !$scope.isFilterEnabled) {
                        $scope.filterList = $filter('ddhFilterInput')($scope.dataList, searchString, this.searchKeyArray, $scope.configObj.displayListDataKey,$scope.configObj.isContainsSearch);
                        $scope.showListFlag = true;
                    }
                };
                this.denyRegex = function() {
                    return $scope.inputDeny;
                };

                $scope._isIphone = function () {
                    return /iPhone/i.test(navigator.userAgent);
                };
                
        }],
            link: function (scope, elem) {

                scope.$watch('filterList.length', function (newVal) {
                    if (newVal !== undefined && newVal !== 0){
                        angular.element(elem.find('div')[1]).empty();
                        if (newVal > scope.configObj.noOfItemsDisplay){
                            scope.suggestionLength = scope.configObj.noOfItemsDisplay;
                        }
                        else {
                            scope.suggestionLength = newVal;
                        }
                        scope.configObj.accessibilityText = "<div>Here are # suggestions. You can <span class='hidden-desktop'> swipe left and right</span> <span class='hidden-phone hidden-desktop'> or</span><span class='hidden-phone'> use up and down arrow key</span> to select below.</div>";
                        if (scope.configObj.accessibilityText){
                            var templateSuggestion = scope.configObj.accessibilityText.replace("#", scope.suggestionLength);
                            angular.element(elem.find('div')[1]).append(templateSuggestion);
                        }
                    }
                });
                
                scope.isFilterEnabled = false;
                scope.showListFlag = false;
                scope.currentIndex = -1;
                scope.setCurrentIdx = function (idx) {
                    scope.currentIndex = idx;
                    if (idx > -1) {
                        scope.inputModel = scope.filterList[idx].title;
                        scope.objModel = scope.filterList[idx];
                    }
                };
                scope.isActive = function (index, dropdownLength) {
                    scope.dropdownLength = dropdownLength;
                    return scope.currentIndex === index;
                };
                scope.selectItem = function (idx) {
                    scope.setCurrentIdx(idx);
                    scope.onClickCallback({
                        value: scope.inputModel,
                        objValue: scope.objModel
                    });
                    scope.showListFlag = false;
                    $timeout(function () {
                        elem.find('input')[0].focus();
                    }, 150);
                    scope.configObj.accessibilityText = '';
                    var templateSuggestion = scope.configObj.accessibilityText;
                    elem.find('div')[1].innerHTML = templateSuggestion;
                };
                scope.startSearch = function () {
                    scope.onClickCallback({
                        value: scope.inputModel,
                        objValue: scope.objModel
                    });
                };
                scope.selectPrev = function () {
                    if (scope.currentIndex > 0 && scope.filterList.length > 0) {
                        scope.currentIndex = scope.currentIndex - 1;
                        scope.setCurrentIdx(scope.currentIndex);
                    } else if (scope.currentIndex === 0) {
                        scope.currentIndex = scope.currentIndex - 1;
                        scope.inputModel = scope.originalInputModel;
                        scope.isFilterEnabled = true;
                    }
                };
                scope.selectNext = function () {
                    if(scope.currentIndex < scope.configObj.noOfItemsDisplay - 1){
                        if (scope.currentIndex < scope.filterList.length - 1) {
                            scope.currentIndex = scope.currentIndex + 1;
                            scope.setCurrentIdx(scope.currentIndex);
                        }
                }
                };
                scope.selectCurrent = function () {
                    scope.selectItem(scope.currentIndex);
                };
                scope.selectionIndex = function (e) {
                    switch (e.keyCode) {
                    case keymap.KEY.DOWN:
                        events.preventDefault(e);
                        scope.isFilterEnabled = true;
                        scope.selectNext();
                        break;
                    case keymap.KEY.UP:
                        events.preventDefault(e);
                        scope.isFilterEnabled = true;
                        scope.selectPrev();
                        break;
                    case keymap.KEY.ENTER:
                        events.preventDefault(e);
                        scope.isFilterEnabled = true;
                        scope.selectCurrent();
                        break;
                    case keymap.KEY.ESC:
                        events.preventDefault(e);
                        scope.isFilterEnabled = false;
                        scope.showListFlag = false;
                        scope.inputModel = '';
                        break;
                    default:
                        scope.isFilterEnabled = false;
                        break;
                    }
                    if (elem[0].querySelector('.filtercontainer')) {
                        elem[0].querySelector('.filtercontainer').scrollTop = (scope.currentIndex - 1) * 35;
                    }
                };
                scope.$watch('filterList', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        scope.currentIndex = -1;
                    }
                });
                scope.blurInput = function () {
                    $timeout(function () {
                        scope.showListFlag = false;
                    }, 150);
                };
                var outsideClick = function (e) {
                    var isElement = $isElement(angular.element(e.target), elem.find('ul').eq(0), $document);
                    if (!isElement && document.activeElement.tagName.toLowerCase() !== 'input') {
                        scope.showListFlag = false;
                        scope.$apply();
                    }
                };
                $documentBind.click('showListFlag', outsideClick, scope);
            }
        };
}])
.directive('ddhSearchInput', [function () {
    return {
        restrict: 'A',
        require: ['ngModel', '^ddhSearchField'],
        link: function (scope, elem, attr, ctrl) {
            var ngModelCtrl = ctrl[0];
            var attSearchBarCtrl = ctrl[1];
            var REGEX = ctrl[1].denyRegex();
            var parser = function (viewValue) {
                attSearchBarCtrl.triggerInput(viewValue);
                return viewValue;
            };
            ngModelCtrl.$parsers.push(parser);

            if (REGEX !== undefined || REGEX !== '') {
                elem.bind('input', function () {
                    var inputString = ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.replace(REGEX, '');
                    if (inputString !== ngModelCtrl.$viewValue) {
                        ngModelCtrl.$setViewValue(inputString);
                        ngModelCtrl.$render();
                        scope.$apply();
                    }
                });
            }
        }
    };
}]);
/**
 * @ngdoc directive
 * @name Forms.att:selectQuantity
 *
 * @description
 *  <file src="src/selectQuantity/docs/readme.md" />
 *
 * @usage
 *  <div ddh-select-quantity select-quantity-id="selectQuantityId_1" min="dataModel.min" max="dataModel.max" step="dataModel.step" ng-model="quantity" quantity-model-key="value" disabled-flag="dataModel.disabledFlag"></div>
 *
 * @example
 * 	<section id="code">
	   <b>HTML + AngularJS</b>
	    <example module="ddh.att">
            <file src="src/selectQuantity/docs/demo.html" />
            <file src="src/selectQuantity/docs/demo.js" />
       </example>
	</section>
 * 
 */
angular.module('ddh.att.selectQuantity', ['ddh.att.utilities'])
    .constant('ddhSelectQuantityConfig', {
        min: 0,
        max: 10,
        step: 1,
        quantityModelKey: 'value',
        disabledFlag: false
    })
    .directive('ddhSelectQuantity', ['keymap', 'ddhSelectQuantityConfig', 'userAgent', function (keymap, ddhSelectQuantityConfig, userAgent) {
        return {
            restrict: 'EA',
            require: '?ngModel',
            transclude: false,
            replace: true,
            scope: {
                min: '=min',
                max: '=max',
                step: '=step',
                selectQuantityId: '@',
                quantity: '=ngModel',
                quantityModelKey: '@',
                disabledFlag: "=?"
            },
            templateUrl: 'template/selectQuantity/selectQuantity.html',
            controller: ['$scope', '$element', '$attrs', function (scope, element, attrs) {

                scope.isMobile = userAgent.isMobile();
                scope.notMobile = userAgent.notMobile();

                scope.min = attrs.min ? scope.min : ddhSelectQuantityConfig.min;
                scope.max = attrs.max ? scope.max : ddhSelectQuantityConfig.max;
                scope.step = attrs.step ? scope.step : ddhSelectQuantityConfig.step;
                scope.quantityModelKey = attrs.quantityModelKey ? scope.quantityModelKey : ddhSelectQuantityConfig.quantityModelKey;
                scope.disabledFlag = attrs.disabledFlag ? scope.disabledFlag : ddhSelectQuantityConfig.disabledFlag;

                if (scope.min < 0) {
                    scope.min = 0;
                }
                if (scope.max > 999) {
                    scope.max = 999;
                }

                scope.isPlusDisabled = function () {
                    return (scope.disabledFlag || scope.quantity[scope.quantityModelKey] >= scope.max);
                };
                scope.isMinusDisabled = function () {
                    return (scope.disabledFlag || scope.quantity[scope.quantityModelKey] <= scope.min);
                };

                scope.getValidateQuantityValue = function (value) {
                    if (value <= scope.min) {
                        return scope.min;
                    } else if (value >= scope.max) {
                        return scope.max;
                    } else {
                        return value;
                    }
                };

                scope.plus = function () {
                    scope.quantity[scope.quantityModelKey] = scope.getValidateQuantityValue(parseInt(scope.quantity[scope.quantityModelKey], 10) + scope.step);
                };
                scope.minus = function () {
                    scope.quantity[scope.quantityModelKey] = scope.getValidateQuantityValue(parseInt(scope.quantity[scope.quantityModelKey], 10) - scope.step);
                };

            }],
            link: function (scope, elem) {

                if (scope.isMobile) {
                    elem.find('input').attr('aria-live', 'polite');
                    elem.find('input').attr('role', 'textbox');
                    elem.find('input').attr('readonly', 'true');
                    elem.find('input').prop('readonly', 'true');
                    elem.find('input').attr('aria-readonly', 'true');
                }

                elem.find('input').bind('keydown', function (e) {
                    if (keymap.isVerticalMovement(e.keyCode)) {
                        e.preventDefault();
                        if (e.keyCode === keymap.KEY.UP) {
                            scope.plus();
                        } else {
                            scope.minus();
                        }
                        scope.$apply();
                    }
                });

                elem.find('input').bind('keyup', function () {
                    if (scope.quantity[scope.quantityModelKey] === null ||
                        scope.quantity[scope.quantityModelKey] === '' ||
                        scope.quantity[scope.quantityModelKey] < scope.min) {
                        scope.quantity[scope.quantityModelKey] = scope.min;
                        scope.$apply();
                    } else if (angular.isUndefined(scope.quantity[scope.quantityModelKey]) || 
                               scope.quantity[scope.quantityModelKey] > scope.max) {
                        scope.quantity[scope.quantityModelKey] = scope.max;
                        scope.$apply();
                    }
                });

                scope.focusHandler = function (evt) {
                    evt.preventDefault();
                    if (scope.notMobile) {
                        elem[0].querySelector('input').focus();
                    }
                };

            }
        };  
    }]);
/**
 * @ngdoc directive
 * @name Forms.att:selectionMenu
 *
 * @description
 *  <file src="src/selectionMenu/docs/readme.md" />
 *
 * @usage
 * <div id="selectorModule4" name="selectorModule4" type="link-menu" label-text="Link selection menu" ddh-dropdown ng-model="selectorModuleValue4.value">
 * <div ddh-dropdown-list option-repeat="d in selectorModuleOptions" value="{{d.value}}">
 *      <span class="module-data">{{d.text}}<span>Help information line2</span></span>
 * </div>
 * <div id="selectorModule4" name="selectorModule4" type="link-menu large" label-text="Link selection menu" ddh-dropdown ng-model="selectorModuleValue4.value">
 * <div ddh-dropdown-list option-repeat="d in selectorModuleOptions" value="{{d.value}}">
 *      <span class="module-data">{{d.text}}<span>Help information line2</span></span>
 * </div>
 *<div id="selectorModule2" name="selectorModule2" type="selector-menu large" label-text="Selector module with complex content" ddh-dropdown ng-model="selectorModuleValue2.value">
 * <div ddh-dropdown-list option-repeat="d in selectorModuleOptions1" value="{{d.value}}">
 *      <span class="module-data">{{d.text}}<span>Help information line2</span><span>Help information line3</span></span>
 * </div>
 *</div>
 *
 *  @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/selectionMenu/docs/demo.html" />
            <file src="src/selectionMenu/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.selectionMenu', ['ddh.att.dropdowns','ddh.att.utilities']);
/**
 * @ngdoc directive
 * @name Layouts.att:separators
 *
 * @description
 *  <file src="src/separators/docs/readme.md" />
 *
 * @usage

 *
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/separators/docs/demo.html" />
 <file src="src/separators/docs/demo.js" />
 </example>
 </section>
 *
 */

angular.module('ddh.att.separators', []);
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:socialFollowUs
 *
 * @description
 *  <file src="src/socialFollowUs/docs/readme.md" />
 *
 * @usage
 *  <!-- Use Markup mentioned -->
 *
 * @example
   <section id="code">
              <b>HTML + AngularJS</b>
              <example module="ddh.att">
				<file src="src/socialFollowUs/docs/demo.html" />
                <file src="src/socialFollowUs/docs/demo.js" />
			   </example>
            </section>
 */
angular.module('ddh.att.socialFollowUs', []);
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:socialShareThis
 *
 * @description
 *  <file src="src/socialShareThis/docs/readme.md" />
 *
 * @usage
 *  <!-- For code Check Demo.html -->
 *
 * @example
   <section id="code">
      <b>HTML + AngularJS</b>
      <example module="ddh.att">
         <file src="src/socialShareThis/docs/demo.html" />
         <file src="src/socialShareThis/docs/demo.js" />
      </example>
   </section>
 */
angular.module('ddh.att.socialShareThis', [])
    .directive('ddhSocialShare', ['$timeout', function ($timeout) {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            scope: {
                ddhSocialShare: '@',
                moveLeft: '='
            },
            templateUrl: 'template/socialShareThis/socialShareThis.html',
            link: function (scope) {
                scope.showIt = false;
                scope.toggleSocialShare = function(e){
                    scope.showIt = !scope.showIt;
					if(scope.showIt) {
						$timeout(function(){
							angular.element(e.target).parent().find('li').eq(0).find('a')[0].focus();	
						},100);						
					};
                };
				
            }
        };
}]);
/**
 * @ngdoc directive
 * @name Charts & graphs.att:strengthMeter
 *
 * @description
 *  <file src="src/strengthMeter/docs/readme.md" />
 *
 * @usage
 *  <div ddh-strength-meter current-state="currentState.val"></div>
 *
 * @example
 * 	<section id="code">
	   <b>HTML + AngularJS</b>
	    <example module="ddh.att">
            <file src="src/strengthMeter/docs/demo.html" />
            <file src="src/strengthMeter/docs/demo.js" />
       </example>
	</section>
 * 
 */
angular.module('ddh.att.strengthMeter', ['ddh.att.lazyLoad'])
    .directive('ddhStrengthMeter', ['ddhLazyLoad', function (ddhLazyLoad) {
        return {
            restrict: 'EA',
            transclude: false,
            replace: true,
            scope: {
                currentState: '='
            },
            templateUrl: 'template/strengthMeter/strengthMeter.html',
            compile: function (elem, attr) {
                ddhLazyLoad.load('stepIndicator', 'css');

                return this.link;
            },
            controller: ['$scope', '$element', '$attrs', function (scope) {

                var ddhStrengthMeterConfig = {
                    'legend': 'Password strength',
                    'states': {
                        'INITIAL': {
                            'index': 0,
                            'title': 'initial',
                            'colorCode': '#cccccc',
                            'description': ''
                        },
                        'UNACCEPTABLE': {
                            'index': 1,
                            'title': 'unacceptable',
                            'colorCode': '#cf2a2a',
                            'description': 'Unacceptable'
                        },
                        'WEAK': {
                            'index': 2,
                            'title': 'weak',
                            'colorCode': '#ea7400',
                            'description': 'Weak'
                        },
                        'FAIR': {
                            'index': 3,
                            'title': 'fair',
                            'colorCode': '#ea7400',
                            'description': 'Fair'
                        },
                        'GOOD': {
                            'index': 4,
                            'title': 'good',
                            'colorCode': '#007a3e',
                            'description': 'Good'
                        },
                        'EXCELLENT': {
                            'index': 5,
                            'title': 'excellent',
                            'colorCode': '#007a3e',
                            'description': 'Excellent'
                        }
                    },
                    'defaultState': 'INITIAL',
                    'timeDelayInMilliSeconds': -1
                };

                scope.legendText = ddhStrengthMeterConfig.legend;
                scope.statesObj = ddhStrengthMeterConfig.states;
                scope.defaultState = ddhStrengthMeterConfig.defaultState;
                scope.timeDelayInMilliSeconds = ddhStrengthMeterConfig.timeDelayInMilliSeconds>=0 ? (ddhStrengthMeterConfig.timeDelayInMilliSeconds+ 'ms') : null;

                scope.noOfSegments = Object.keys(scope.statesObj).length - 1;

                scope.getNumberArray = function (num) {
                    return new Array(num);
                };

                this.getCalculatedWidth = function (currentState) {

                    if (!currentState || !scope.statesObj[currentState]) {
                        currentState = ddhStrengthMeterConfig.defaultState;
                    }

                    return scope.statesObj[currentState].index * (100 / scope.noOfSegments);
                };

                if (!angular.isDefined(scope.currentState)) {
                    scope.currentState = ddhStrengthMeterConfig.defaultState;
                    scope.bgColor = scope.statesObj[scope.currentState].colorCode;
                    scope.currentWidth = this.getCalculatedWidth(scope.currentState);
                }

            }],
            link: function (scope, elem, attr, ctrl) {

                scope.$watch('currentState', function (newVal) {
                    if (newVal && scope.statesObj[newVal]) {
                        scope.bgColor = scope.statesObj[newVal].colorCode;
                        scope.currentWidth = ctrl.getCalculatedWidth(scope.currentState);
                    } else {
                        scope.bgColor = scope.statesObj[scope.defaultState].colorCode;
                        scope.currentWidth = ctrl.getCalculatedWidth();
                    }
                });

            }
        };
    }]);
/**
 * @ngdoc directive
 * @name Buttons, links & UI controls.att:switches
 *
 * @description
 *  <file src="src/switches/docs/readme.md" />
 *
 * @usage
 *  
 *  <!-- On / Off Toggle switch -->
 *  <label for="switch1" class="btn-switch-label">
 *  	<span aria-hidden="true">Voicemail is</span>
 *  	<input type="checkbox" role="switch" id="switch1" ddh-switches ng-model="switch1.value" aria-label="Voicemail is {{switch1.value?'On':'Off'}}">
 *  </label>
 *  
 *  <!-- On / Off Toggle switch and DISABLED -->
 *  <label for="switch2" class="btn-switch-label">
 *  	<span aria-hidden="true">Voicemail is</span>
 *  	<input type="checkbox" role="switch" id="switch1" ddh-switches ng-model="switch1.value" ng-disabled="true" aria-disabled="true" aria-label="Voicemail is {{switch1.value?'On':'Off'}}. Disabled">
 *  </label> 
 *
 * @example
 *  <section id="code">
        <b>HTML + AngularJS</b>
        <example module="ddh.att">
            <file src="src/switches/docs/demo.js" />
            <file src="src/switches/docs/demo.html" />
        </example>
    </section>
 */
angular.module('ddh.att.switches', ['ddh.att.utilities'])
    .directive('ddhSwitches', ['$compile', '$templateCache', 'keymap', 'events', function ($compile, $templateCache, keymap, events) {
        return {
            restrict: 'EA',
            require: ['ngModel'],
            link: function (scope, element, attrs, ctrl) {
                var ngModelController = ctrl[0];        
                element.parent().bind("keydown", function (e) {
                    if (!attrs.disabled && (e.keyCode === keymap.KEY.ENTER)) {                        
                        ngModelController.$setViewValue(!ngModelController.$viewValue);
                        element.prop("checked", ngModelController.$viewValue);
						events.preventDefault(e);
                    }
                });
                element.wrap('<div class="btn-switch">');
                if (navigator.userAgent.match(/iphone|iPad/i)){
					element.attr("aria-checked", ngModelController.$viewValue);
					element.attr("aria-live", "polite");
                }
				else if(navigator.userAgent.match(/Android/i)) {
					element.attr("aria-pressed", ngModelController.$viewValue);
					element.attr("aria-live", "polite");
				}
                else {
					element.attr("aria-checked", ngModelController.$viewValue);
                }
                scope.$watch(attrs.ngModel, function (newValue) {
					 if(element.attr("aria-checked")){
						element.attr("aria-checked", newValue); 
					 }
					 else {
						 element.attr("aria-pressed", newValue);
					 }                        
                });
                var templateSwitch = angular.element($templateCache.get("template/switches/switches.html"));
                if (angular.isDefined(attrs.typeSpanish)) {
                    templateSwitch = angular.element($templateCache.get("template/switches/switches-spanish.html"));
                }
                templateSwitch = $compile(templateSwitch)(scope);
                element.parent().append(templateSwitch);
                element.bind("focus", function (e) {
                    element.parent().addClass('focused');
                });
                element.bind("blur", function (e) {
                    element.parent().removeClass('focused');
                });
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name Tabs, tables & accordions.att:tables
 *
 * @description
 *  <file src="src/tables/docs/readme.md" />
 *
 * @usage
 *   
 Table
 <table ddh-table table-data="tableData" search-string="searchString">
    <thead ddh-table-row type="header">
        <tr>
            <th ddh-table-header key="requestId" default-sort="a" id="col1">Header 1</th>
            <th ddh-table-header key="requestType" sortable="false" id="col2">Header 2</th>
        </tr>
    </thead>
    <tbody ddh-table-row type="body" row-repeat="rowData in tableData">
        <tr>
            <td ddh-table-body id="rowheader{{$index}}" headers="col1" ng-bind="rowData['requestId']"> </td>
            <td ddh-table-body ng-bind="rowData['requestType']"></td>
        </tr>
    </tbody>
 </table>

 Accordion table with No color in coloumn2
    <ddh-accordion id="act1" class="tiny-accordion iconleft accordion-table-layout" no-color-column2 close-others="false" scroll-top="false" total-elements="5">
        <ddh-accordion-table column1="Account changes" column2="$100.00" no-color-column2>
            <div>
                <div class="faux-table-cell">
                    <strong>Monthly plan charges</strong>
                </div>
                <div class="faux-table-cell">
                </div>
            </div>
        </ddh-accordion-table>
    </ddh-accordion>

 Accordion table
    <ddh-accordion id="act1" class="tiny-accordion iconleft accordion-table-layout" close-others="false" scroll-top="false" total-elements="5">
        <ddh-accordion-table column1="Account changes" column2="$100.00">
            <div>
                <div class="faux-table-cell">
                    <strong>Monthly plan charges</strong>
                </div>
                <div class="faux-table-cell">
                </div>
            </div>
        </ddh-accordion-table>
    </ddh-accordion> 
 *
 * @example
 *  <section id="code">
        <example module="ddh.att">
            <file src="src/tables/docs/demo.html" />
            <file src="src/tables/docs/demo.js" />
       </example>
    </section>
 *
 */
angular.module('ddh.att.tables', ['ddh.att.utilities','ddh.att.lazyLoad'])
    .constant('ddhTableConfig', {
        defaultSortPattern: false, // true for descending & false for ascending
        highlightSearchStringClass: 'tablesorter-search-highlight',
        zebraStripCutOff: 6, // > zebraStripCutOff
        tableBreakpoints: [ // breakpoints are >= min and < max
            {
                min: 0,
                max: 480,
                columns: 2
            },
            {
                min: 480,
                max: 768,
                columns: 3
            },
            {
                min: 768,
                max: 1025,
                columns: 5
            },
            {
                min: 1025,
                max: 1921,
                columns: 7
            }
        ]
    })
    .directive('ddhTable', ['$filter', '$window', 'ddhTableConfig', '$timeout', function ($filter, $window, ddhTableConfig, $timeout) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                tableData: "=",
                viewPerPage: "=",
                currentPage: "=",
                totalPage: "=",
                searchCategory: "=",
                searchString: "=",
                searchCriteria: "=",
                nextSort: '='
            },
            require: 'ddhTable',
            templateUrl: 'template/tables/ddhTable.html',
            controller: ['$scope', '$attrs', function ($scope, $attrs) {
                this.headers = [];
                this.currentSortIndex = null;
                this.responsive = $scope.responsive = $attrs.responsive;
                this.isSummary = $scope.isSummary = $attrs.isSummary;
                this.maxTableColumns = -1;
                this.totalTableColums = 0;
                this.active = $scope.active = false;
                this.responsiveRowScopes = [];
                this.hideColumnPriority = [];
                this.hiddenColumn = [];
                this.setIndex = function (headerScope, priority) {
                    this.headers.push(headerScope);
                    if (this.responsive) {
                        this.totalTableColums++;
                        if (!isNaN(priority)) {
                            this.hideColumnPriority[priority] = this.totalTableColums - 1;
                        } else {
                            this.hideColumnPriority[this.totalTableColums - 1] = this.totalTableColums - 1;
                        }
                    }
                    return this.totalTableColums - 1;
                };
                this.getIndex = function (headerName) {
                    for (var i = 0; i < this.headers.length; i++) {
                        if (this.headers[i].headerName === headerName) {
                            return this.headers[i].index;
                        }
                    }
                    return null;
                };
                this.setTbodyScope = function (tbodyScope) {
                    $scope.tbodyScope = tbodyScope;
                };
                this.setResponsiveRow = function (responsiveRowScope) {
                    this.responsiveRowScopes.push(responsiveRowScope);
                };
                $scope.nextSort = '';
                this.sortData = function (columnIndex, reverse, externalSort) {
                    if ($scope.tbodyScope && $scope.tbodyScope !== undefined) {
                        $scope.tbodyScope.columnIndex = columnIndex;
                        $scope.tbodyScope.reverse = reverse;
                    }
                    this.currentSortIndex = columnIndex;
                    if (externalSort === true) {
                        if (!reverse) {
                            $scope.nextSort = 'd';
                        } else {
                            $scope.nextSort = 'a';
                        }
                    }
                    $scope.currentPage = 1;
                    this.resetSortPattern();
                };
                this.getSearchString = function () {
                    return $scope.searchString;
                };
                this.resetSortPattern = function () {
                    for (var i = 0; i < this.headers.length; i++) {
                        var currentScope = this.headers[i];
                        if (currentScope.index !== this.currentSortIndex) {
                            currentScope.resetSortPattern();
                        }
                    }
                };

                $scope.$watch('nextSort', function (val) {
                    if ($scope.$parent && $scope.$parent !== undefined) {
                        $scope.$parent.nextSort = val;
                    }

                });
            }],
            link: function (scope, elem, attr, ctrl) {
                scope.searchCriteria = {};
                scope.tableBreakpoints = attr.tableConfig ? scope.$parent.$eval(attr.tableConfig) : angular.copy(ddhTableConfig.tableBreakpoints);
                scope.$watchCollection('tableData', function (value) {
                    if (value && !isNaN(value.length)) {
                        scope.totalRows = value.length;
                    }
                });
                scope.$watch('currentPage', function (val) {
                    if (scope.tbodyScope && scope.tbodyScope !== undefined) {
                        scope.tbodyScope.currentPage = val;
                    }

                });
                scope.$watch('viewPerPage', function (val) {
                    if (scope.tbodyScope && scope.tbodyScope !== undefined) {
                        scope.tbodyScope.viewPerPage = val;
                    }
                });
                scope.$watch('totalRows', function (val) {
                    if (scope.tbodyScope && scope.tbodyScope !== undefined) {
                        if (val > ddhTableConfig.zebraStripCutOff) {
                            scope.tbodyScope.zebraStripFlag = true;
                        } else {
                            scope.tbodyScope.zebraStripFlag = false;
                        }
                    }
                });
                scope.$watch(function () {
                    return scope.totalRows / scope.viewPerPage;
                }, function (value) {
                    if (!isNaN(value)) {
                        scope.totalPage = Math.ceil(value);
                        scope.currentPage = 1;
                    }
                });
                var searchValCheck = function (val) {
                    if (angular.isDefined(val) && val !== null && val !== "") {
                        return true;
                    }
                };
                var setSearchCriteria = function (v1, v2) {
                    if (searchValCheck(v1) && searchValCheck(v2)) {
                        var index = ctrl.getIndex(v2);
                        scope.searchCriteria = {};
                        if (index !== null) {
                            scope.searchCriteria[index] = v1;
                        }
                    } else if (searchValCheck(v1) && (!angular.isDefined(v2) || v2 === null || v2 === "")) {
                        scope.searchCriteria = {
                            $: v1
                        };
                    } else {
                        scope.searchCriteria = {};
                    }
                };
                if (attr.searchCriteria === undefined) {
                    scope.$watch('searchCategory', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            setSearchCriteria(scope.searchString, newVal);
                        }
                    });
                    scope.$watch('searchString', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            setSearchCriteria(newVal, scope.searchCategory);
                        }
                    });
                }
                scope.$watchCollection('searchCriteria', function (val) {
                    if (scope.tbodyScope && scope.tbodyScope !== undefined) {
                        scope.tbodyScope.searchCriteria = val;
                    }
                    scope.totalRows = scope.tableData && ($filter('filter')(scope.tableData, val, false)).length || 0;
                    scope.currentPage = 1;
                });
                var window = angular.element($window);
                var findMaxTableColumns = function () {
                    var windowWidth;
                    windowWidth = $window.innerWidth;
                    ctrl.maxTableColumns = -1;
                    for (var i in scope.tableBreakpoints) {
                        if (windowWidth >= scope.tableBreakpoints[i].min && windowWidth < scope.tableBreakpoints[i].max) {
                            ctrl.maxTableColumns = scope.tableBreakpoints[i].columns;
                            break;
                        }
                    }
                    if (ctrl.maxTableColumns > -1 && ctrl.totalTableColums > ctrl.maxTableColumns) {
                        ctrl.active = scope.active = true;
                    } else {
                        ctrl.active = scope.active = false;
                    }
                    for (var i in ctrl.responsiveRowScopes) {
                        ctrl.responsiveRowScopes[i].setActive(ctrl.active);
                    }
                };
                var findHiddenColumn = function () {
                    var columnDiffenence = ctrl.maxTableColumns > -1 ? ctrl.totalTableColums - ctrl.maxTableColumns : 0;
                    ctrl.hiddenColumn = [];
                    if (columnDiffenence > 0) {
                        var tempHideColumnPriority = angular.copy(ctrl.hideColumnPriority);
                        for (var i = 0; i < columnDiffenence; i++) {
                            ctrl.hiddenColumn.push(tempHideColumnPriority.pop());
                        }
                    }
                };
                var resizeListener = function () {
                    findMaxTableColumns();
                    findHiddenColumn();
                };
                if (ctrl.responsive && !ctrl.isSummary) {
                    window.bind('resize', function () {
                        resizeListener();
                        scope.$apply();
                    });
                    $timeout(function () {
                        resizeListener();
                    }, 100);
                }
            }
        };
    }])
    .directive('ddhTableRow', [function () {
        return {
            restrict: 'EA',
            scope: true,
            require: '^ddhTable',
            compile: function (elem, attr) {
                if (attr.type === 'header') {
                    angular.noop();
                } else if (attr.type === 'body') {
                    var html = elem.children();
                    if (attr.rowRepeat) {
                        html.attr('ng-repeat', attr.rowRepeat.concat(" | orderBy : columnIndex : reverse | filter : searchCriteria : false | ddhLimitTo : viewPerPage : viewPerPage*(currentPage-1)"));
                    }
                    html.attr('ng-class', "{'odd': $odd && zebraStripFlag}");
                    html.attr('ddh-responsive-row', '{{$index}}');
                    elem.append(html);
                }

                return function (scope, elem, attr, ctrl) {
                    if (attr.type === 'body') {
                        ctrl.setTbodyScope(scope);
                    }
                };
            }
        };
    }])
    .directive('ddhTableHeader', ['ddhTableConfig', '$timeout', 'userAgent', 'ddhLazyLoad', function (ddhTableConfig, $timeout, userAgent, ddhLazyLoad) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                sortable: '@',
                defaultSort: '@',
                index: '@key'
            },
            require: '^ddhTable',
            templateUrl: function (elem, attr) {
                if (attr.sortable === 'false') {
                    return 'template/tables/ddhTableHeaderUnsortable.html';
                } else {
                    ddhLazyLoad.load('icon-arrows', 'css');
                    return 'template/tables/ddhTableHeaderSortable.html';
                }
            },
            link: function (scope, elem, attr, ctrl) {
                var reverse = ddhTableConfig.defaultSortPattern;
                scope.headerName = elem.text();
                scope.headerId = elem.attr('id');
                scope.sortPattern = null;
                var priority = parseInt(attr.priority, 10);
                scope.columnIndex = ctrl.setIndex(scope, priority);

                scope.isHidden = function () {
                    return (ctrl.hiddenColumn.indexOf(scope.columnIndex) > -1);
                };

                scope.isMobile = false;
                if (userAgent.isMobile()){
                    scope.isMobile = true;
                }

                scope.$watch(function () {
                    return elem.text();
                }, function (value) {
                    scope.headerName = value;
                });
                scope.sort = function (sortType) {
                    if (typeof sortType === 'boolean') {
                        reverse = sortType;
                    }
                    ctrl.sortData(scope.index, reverse, false);
                    scope.sortPattern = reverse ? 'descending' : 'ascending';
                    reverse = !reverse;
                };
                scope.$watch(function () {
                    return ctrl.currentSortIndex;
                }, function (value) {
                    if (value !== scope.index) {
                        scope.sortPattern = null;
                    }
                });

                if (scope.sortable === undefined || scope.sortable === 'true' || scope.sortable === true) {
                    scope.sortable = 'true';
                } else if (scope.sortable === false || scope.sortable === 'false') {
                    scope.sortable = 'false';
                }

                if (scope.sortable !== 'false') {
                    if (scope.defaultSort === 'A' || scope.defaultSort === 'a') {
                        $timeout(function () {
                            scope.sort(false);
                        }, 100);
                    } else if (scope.defaultSort === 'D' || scope.defaultSort === 'd') {
                        $timeout(function () {
                            scope.sort(true);
                        }, 100);
                    }
                }
                scope.resetSortPattern = function () {
                    reverse = ddhTableConfig.defaultSortPattern;
                };
            }
        };
    }])
    .directive('ddhResponsiveRow', ['$templateCache', '$timeout', '$compile', function ($templateCache, $timeout, $compile) {
        return {
            restrict: 'EA',
            scope: true, 
            require: '^ddhTable',
            controller: ['$scope', function ($scope) {
                this.rowValues = $scope.rowValues = [];
                $scope.headerClass = {};
                $scope.bodyClass = {};
                $scope.summaryContent;
                this.setRowValues = function (rowValue) {
                    this.rowValues.push(rowValue);
                };
                this.setSummaryContentValue = function (contentValue) {
                    $scope.summaryContent = contentValue;
                };
                var columnIndexCounter = -1;
                this.getIndex = function () {
                    columnIndexCounter++;
                    return columnIndexCounter;
                };
                this.setHeaderClass = function (columnIndex, classNames) {
                    $scope.headerClass[columnIndex] = classNames;
                };
                this.setBodyClass = function (columnIndex, classNames) {
                    $scope.bodyClass[columnIndex] = classNames;
                };
            }],
            link: function (scope, elem, attr, ctrl) {
                if (ctrl.responsive) {
                    scope.rowIndex = attr.ddhResponsiveRow;
                    scope.active = false;
                    scope.expandFlag = false;
                    scope.headerValues = ctrl.headers;
                    ctrl.setResponsiveRow(scope);
                    elem.attr('class', 'data-row');
                    var firstTd = elem.find('td').eq(0);
                    scope.setActive = function (activeFlag) {
                        if (ctrl.isSummary && (angular.isUndefined(scope.summaryContent) || (scope.summaryContent.length === 1 && scope.summaryContent[0].innerHTML ===""))){
                            elem.addClass('inactive-table-header');
                        }
                        else {
                            activeFlag = true;
                        }

                        scope.active = activeFlag;

                        if (scope.active) {
                            elem.addClass('has-button');
                        } else {
                            elem.removeClass('has-button');
                        }
                    };
                    scope.toggleExpandFlag = function (expandFlag) {
                        if (angular.isDefined(expandFlag)) {
                            scope.expandFlag = expandFlag;
                        } else {
                            scope.expandFlag = !scope.expandFlag;
                        }
                        if (scope.expandFlag) {
                            elem.addClass('opened');
                            if (ctrl.isSummary){
                                calculateTableCellLines();
                            }
                        } else {
                            elem.removeClass('opened');
                        }
                    };
                    firstTd.attr('scope', 'row');
                    firstTd.attr('role', 'rowheader');
                    firstTd.addClass('col-1');
                    scope.$on('$destroy', function () {
                        elem.next().remove();
                    });
                    $timeout(function () {
                        scope.firstTdId = firstTd.attr('id');
                        var firstTdContent = firstTd.html();
                        var toggleButtonTemplate = '<span ng-show="!active">' + firstTdContent + '</span><button type="button" aria-describedby="sup-actNum{{$id}}" aria-expanded="{{expandFlag}}" ng-show="active" ng-click="toggleExpandFlag()"><i ng-class="{\'icon-accordion-plus\': !expandFlag, \'icon-accordion-minus\': expandFlag}" aria-hidden="true"></i>' + firstTdContent + '</button><span id="sup-actNum{{$id}}" style="display:none">{{expandFlag && "Hide row below." || "Show row below."}}</span>';
                        toggleButtonTemplate = $compile(toggleButtonTemplate)(scope);
                        firstTd.html('');
                        firstTd.prepend(toggleButtonTemplate);
                        var template;

                        if (ctrl.isSummary){
                            template = $templateCache.get('template/tables/ddhResponsiveRowSummary.html');
                        }
                        else {
                            template = $templateCache.get('template/tables/ddhResponsiveRow.html');
                        }

                        template = $compile(template)(scope);
                        elem.after(template);
                        scope.setActive(ctrl.active);
                    }, 100);
                    
                    function calculateTableCellLines(){
                        $timeout(function () {

                            var fauxTableCell = elem.parent()[0].querySelectorAll('.accordion-content .faux-table-cell');
                            for (var i = 0; i < fauxTableCell.length; i++){
                                var cellHeight = fauxTableCell[i].clientHeight - 17;
                                angular.element(fauxTableCell[i]).css("background-position", "0px " + cellHeight + "px");
                            }

                        }, 50);
                    }
                }
            }
        };
    }])
// below directive is to hide responsive table-row completely as height 0 is still read by NVDA
	.directive('toggleFlag', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                scope.$watch('active && expandFlag', function(val){
					if(val){
						elem.removeAttr('style');
					}
					else {
						$timeout(function(){
							//removed display after animation completes :)
							elem.css({'display':'none'});
						},300);						
					}
				});
            }
        };
    }])
    .directive('ddhResponsiveList', ['$templateCache', '$timeout', '$compile', function ($templateCache, $timeout, $compile) {
        return {
            restrict: 'EA',
            require: '^ddhTable',
            link: function (scope, elem, attr, ctrl) {
                scope.columnIndex = parseInt(attr.ddhResponsiveList, 10);
                scope.isVisible = function () {
                    return (ctrl.hiddenColumn.indexOf(scope.columnIndex) > -1);
                };
            }
        };
    }])
    .directive('ddhTableBody', ['$filter', '$timeout', 'ddhTableConfig', function ($filter, $timeout, ddhTableConfig) {
        return {
            restrict: 'EA',
            require: ['^ddhTable', '?^ddhResponsiveRow'],
            scope: true,
            replace: true,
            transclude: true,
            templateUrl: 'template/tables/ddhTableBody.html',
            link: function (scope, elem, attr, ctrl) {
                var ddhTableCtrl = ctrl[0];
                var ddhResponsiveRowCtrl = ctrl[1];
                scope.isSummary = ddhTableCtrl.isSummary;
                var highlightSearchStringClass = ddhTableConfig.highlightSearchStringClass;
                var searchString = "";
                var responsiveTableHeaderClass = attr.ddhResponsiveTableHeaderClass || '';
                var responsiveTableBodyClass = attr.ddhResponsiveTableBodyClass || '';
                var wrapElement = function (elem) {
                    var text = elem.text();
                    elem.html($filter('ddhHighlight')(text, searchString, highlightSearchStringClass));
                };
                var traverse = function (elem) {
                    var innerHtml = elem.children();
                    if (innerHtml.length > 0) {
                        for (var i = 0; i < innerHtml.length; i++) {
                            traverse(innerHtml.eq(i));
                        }
                    } else {
                        wrapElement(elem);
                        return;
                    }
                };
                var clearWrap = function (elem) {
                    var elems = elem.find('*');
                    for (var i = 0; i < elems.length; i++) {
                        if (elems.eq(i).attr('class') && elems.eq(i).attr('class').indexOf(highlightSearchStringClass) !== -1) {
                            var text = elems.eq(i).text();
                            elems.eq(i).replaceWith(text);
                        }
                    }
                };
                if (ddhResponsiveRowCtrl) {
                    scope.columnIndex = ddhResponsiveRowCtrl.getIndex();
                    ddhResponsiveRowCtrl.setHeaderClass(scope.columnIndex, responsiveTableHeaderClass);
                    ddhResponsiveRowCtrl.setBodyClass(scope.columnIndex, responsiveTableBodyClass);
                    scope.isHidden = function () {
                        return (ddhTableCtrl.hiddenColumn.indexOf(scope.columnIndex) > -1);
                    };
                }
                $timeout(function () {
                    var actualHtml = elem.children();
                    scope.$watch(function () {
                        return ddhTableCtrl.getSearchString();
                    }, function (val) {
                        searchString = val;
                        clearWrap(elem);
                        if (actualHtml.length > 0) {
                            traverse(elem);
                        } else {
                            wrapElement(elem);
                        }
                    });
                    if (ddhResponsiveRowCtrl) {
                        ddhResponsiveRowCtrl.setRowValues(elem.html());
                    }
                }, 50);
            }
        };
    }])
    .directive('ddhSummaryTableContent', [function () {
    return {
        restrict: 'EA',
        require: '^ddhResponsiveRow',
        transclude: true,
        replace: true,
        template: '',
        compile: function (elem, attr, transclude) {
            return function link(scope, elem, attr, ctrl) {
                if (ctrl) {
                    ctrl.setSummaryContentValue(transclude(scope, function () {}));
                }
                elem.remove();
            };
        }
    };
    }])
    .directive('ddhTableSort', ['ddhTableConfig', function (ddhTableConfig) {
        return {
            restrict: 'EA',
            replace: true,
            require: '^ddhTable',
            link: function (scope, elem, attr, ctrl) {
                var initialSort = '',
                    nextSort = '';
                initialSort = attr.initialSort;

                scope.sortTable = function (msg) {
                    if (nextSort.length > 0) {

                        if (nextSort === 'd' || nextSort === 'D') {
                            ctrl.sortData(msg, true, true);
                            nextSort = 'a';
                        } else {
                            ctrl.sortData(msg, false, true);
                            nextSort = 'd';
                        }
                    } else if (initialSort.length > 0) {

                        if (initialSort === 'd' || initialSort === 'D') {
                            ctrl.sortData(msg, true, true);
                            nextSort = 'a';
                        } else {
                            ctrl.sortData(msg, false, true);
                            nextSort = 'd';
                        }
                    }

                };
            }
        };
    }]);

/**
 * @ngdoc directive
 * @name Tabs, tables & accordions.att:tabs
 *
 * @description
 *  <file src="src/tabs/docs/readme.md" />
 */

angular.module('ddh.att.tabs', ['ddh.att.utilities'])
    .directive('ddhTabset', function () {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            scope: {
                tabIdSelected: '='
            },
            templateUrl: 'template/tabs/ddhTabset.html',
            controller: ['$scope', function ($scope) {

                this.setTabIdSelected = function (tab) {
                    $scope.tabIdSelected = tab.id;
                };

                this.getTabIdSelected = function () {
                    return $scope.tabIdSelected;
                };
            }]
        };
    })
    .directive('ddhTab', ['keymap', function (keymap) {
        return {
            restrict: 'EA',
            transclude: true,
            replace: true,
            require: '^ddhTabset',
            scope: {
                tabItem: "="
            },
            templateUrl: 'template/tabs/ddhTab.html',
            controller: [function(){}],
            link: function (scope, element, attr, ddhTabsetCtrl) {

                if (scope.tabItem && !scope.tabItem.disabled) {
                    scope.tabItem.disabled = false;
                }

                scope.isTabActive = function () {
                    return (scope.tabItem.id === ddhTabsetCtrl.getTabIdSelected());
                };

                scope.clickTab = function () {
                    if (attr.disabled) {
                        return;
                    }
                    ddhTabsetCtrl.setTabIdSelected(scope.tabItem);
                };
            }
        };
    }]);
/**
 * @ngdoc directive
 * @name Forms.att:termsAndConditions
 *
 * @description
 *  <file src="src/termsAndConditions/docs/readme.md" />
 *
 * @usage
 *              <h2 class="heading-medium">Simple agreement with optional title and description</h2>
                 <p>This sentence lets users know the benefits to agreeing.</p>
                 <ul class="bullet">
                    <li><a href="javascript:void(0)">Read agreement 1 here</a></li>
                    <li><a href="javascript:void(0)">Read agreement 2 here</a></li>
                 </ul>
                 <div class="form-row">
                    <label for="terms1" class="checkbox">
                       <input id="terms1" type="checkbox" ng-model="cboption.value1" aria-checked="{{cboption.value1}}">
                       <i class="skin"></i>
                       <span>I have read and agree to the AT&amp;T Terms of Service</span>
                    </label>
                 </div>
                 
                 <br aria-hidden="true">
                 <hr class="hr-nomargin" aria-hidden="true" tabindex="-1">
                 
                 <h2 class="heading-medium">Detailed summary</h2>
                 <p>This is a summarized legal disclosure. Here we're explaining in brief the legal agreement. Quisque posuere auctor velit eu tristique. Fusce sit amet augue quam. Nulla pharetra a ex ut pharetra. Nunc at velit magna. Suspendisse et convallis nulla, id porttitor enim. Ut dictum eleifend nunc. <a href="javascript:void(0)">Read the full legal agreement</a></p>
                 <div class="form-row">
                    <label for="terms2" class="checkbox">
                       <input id="terms2" type="checkbox" ng-model="cboption.value2" aria-checked="{{cboption.value2}}">
                       <i class="skin"></i>
                       <span>I have read and agree to the AT&amp;T Terms of Service</span>
                    </label>
                 </div>
                 
                 <br aria-hidden="true">
                 <hr class="hr-nomargin" aria-hidden="true" tabindex="-1">
                 
                 <h2 class="heading-medium">Multiple agreements with detailed summary</h2>
                 <p>Nam quis dui id elit fringilla varius. Maecenas euismod faucibus nisi, vel commodo sed. Vivamus sit fingilla diam. In at nunc ligula. Sed imperdiet porta dui eget varius. Sed non elementum neque. Aenean vitae neque id elit interdum.</p>
                 <h3 class="heading-medium">Legal agreement 1</h3>
                 <p>This is a summarized legal disclosure. Here we're explaining in brief the legal agreement. <a href="javascript:void(0)">Read the full legal agreement</a></p>
                 <h3 class="heading-medium">Legal agreement 2</h3>
                 <p>This is a summarized legal disclosure. Here we're explaining in brief the legal agreement. <a href="javascript:void(0)">Read the full legal agreement</a></p>
                 <h3 class="heading-medium">Legal agreement 3</h3>
                 <p>This is a summarized legal disclosure. Here we're explaining in brief the legal agreement. <a href="javascript:void(0)">Read the full legal agreement</a></p>
                 <div class="form-row">
                    <label for="terms3" class="checkbox">
                       <input id="terms3" type="checkbox" ng-model="cboption.value3" aria-checked="{{cboption.value3}}">
                       <i class="skin"></i>
                       <span>I have read and agree to the AT&amp;T Terms of Service</span>
                    </label>
                 </div>
                 <ul class="bullet">
                    <li><a href="javascript:void(0)">Legal agreement 1</a></li>
                    <li><a href="javascript:void(0)">Legal agreement 2</a></li>
                    <li><a href="javascript:void(0)">Legal agreement 3</a></li>
                 </ul>
                 <div class="cta-button-group nodots align-left">
                    <button class="btn btn-primary-functional" type="button">Submit</button>
                    <button class="btn btn-secondary" type="button">Save cart</button>                  
                </div>

 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/termsAndConditions/docs/demo.html" />
 <file src="src/termsAndConditions/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.termsAndConditions',[]);
      
/**
 * @ngdoc directive
 * @name Forms.att:textArea
 *
 * @description
 *  <file src="src/textArea/docs/readme.md" />
 *
 * @usage
 *  <textarea ddh-reset ddh-reset-textarea ng-model="textAreaModel" ng-disabled="disabled" ng-trim="false" placeholder="{{placeholderText}}" rows="{{textAreaRows}}" maxlength="{{textAreaMaxlength}}" role="textarea"></textarea>
 *
 * @example
    <section id="code">
        <b>HTML + AngularJS</b>
        <example module="ddh.att">
            <file src="src/textArea/docs/demo.html" />
            <file src="src/textArea/docs/demo.js" />
        </example>
    </section>
 */
angular.module('ddh.att.textArea', ['ddh.att.utilities'])

.directive('ddhResetTextarea', [ function () {
    return {
        restrict: 'A',
        require: 'ddhReset',
        link: function (scope, element, attrs, ctrl) {

            var resetButton = ctrl.getResetButton();
            
            var computeScrollbarAndAddClass = function () {
                if (element.prop('scrollHeight') > element[0].clientHeight) {
                    element.addClass('hasScrollbar');
                } else {
                    element.removeClass('hasScrollbar');
                }
            };
            
            computeScrollbarAndAddClass();

            element.on('focus keyup', function(){
                computeScrollbarAndAddClass();
            });
        }
    };
}]);

/**
 * @ngdoc directive
 * @name Forms.att:textFields
 *
 * @description
 *  <file src="src/textFields/docs/readme.md" />
 *
 * @usage
 *  <!-- See below examples for link implementation -->
 *
 * @example
 <section id="code">
    <b>HTML + AngularJS</b>
    <example module="ddh.att">
        <file src="src/textFields/docs/demo.html" />
        <file src="src/textFields/docs/demo.js" />
    </example>
 </section>
 */
angular.module('ddh.att.textFields', ['ddh.att.utilities']);

/**
 * @ngdoc directive
 * @name Forms.att:tooltipsForForms
 *
 * @description
 *  <file src="src/tooltipsForForms/docs/readme.md" />
 *
 * @usage
 <div class="tooltip" ddh-tooltip>
 <a href="javascript:void(0)" class="icon-tooltip tooltip-element"  data-placement="top" role="button" aria-label="Help">
 <div class="arrow"></div>
 </a>
 <div class="tooltip-wrapper" role="tooltip" aria-live="polite" aria-atomic="false">
 <div class="tooltip-size-control" style="left: 220px;">
 <div class="helpertext" tabindex="-1" aria-hidden="true" role="tooltip">  
 <div class="popover-title">This is an optional heading:</div>  
 <div class="popover-content">
 <p>This unfolds only when user taps the help button. This is just plain ol' text that should wrap nicely - but keep it short please.</p>
 <strong class="hidden-spoken">Double tap to close help message.</strong>
 </div>
 </div>
 </div>
 </div>
 </div> 
 
 ** On-Focus ** 
 <div class="field-group tooltip-onfocus"  ddh-tooltip>
 <input type="text" class="span12" id="onfocustip1" placeholder="Example: you@att.net">
 <button class="reset-field" type="button" aria-label="Reset text field"></button>
 <div class="helpertext" id="tooltipContent1" role="tooltip" tabindex="-1">
 <div class="popover-title">What is this?</div>
 <div class="popover-content">
 <p>This is a text explanation to help identify what the user should enter in the text field. Keep it brief.</p>
 <p>This could also be an image or text/image combo. This unfolds automatically when the user taps into the field.</p>
 </div>
 </div>                  
 </div>
 
 ** On-click ** 
 <div class="field-group tooltip-onclick"  ddh-tooltip>
 <input type="text" class="span12" id="onclicktip2" placeholder="Example: you@att.net">
 <button class="reset-field" type="button" aria-label="Reset text field"></button>
 <button id="tooltipButton2" class="btn icon-tooltip tooltip-element" data-toggle="button" aria-label="Email help"></button>
 <div class="helpertext" id="tooltipContent2" role="tooltip">
 <div class="popover-title">Please enter your email address.</div>
 <div class="popover-content">
 <p>This is a text explanation to help identify what the user should enter in the text field.</p>
 </div>
 </div>
 </div> 
 
 *
 * @example
 <example module="ddh.att">
 <file src="src/tooltipsForForms/docs/demo.html" />
 <file src="src/tooltipsForForms/docs/demo.js" />
 </example>
 */
angular.module('ddh.att.tooltipsForForms', ['ddh.att.utilities', 'ddh.att.lazyLoad'])
        .directive('ddhTooltip', ['$document', '$window', '$isElement', 'userAgent', 'ddhLazyLoad', function ($document, $window, $isElement, userAgent, ddhLazyLoad) {
                return  {
                    restrict: 'A',
                    compile: function (elem, attr) {
                        ddhLazyLoad.load('tooltip', 'css');

                        return this.link;
                    },
                    link: function (scope, elem, attr, ctrl) {
                        var icon = elem[0].querySelector('a.tooltip-element');
                        var btnIcon = elem[0].querySelector('.btn.tooltip-element');
                        var tooltipText = elem[0].querySelector('.helpertext');
                        var tooltipWrapper = elem[0].querySelector('.tooltip-size-control');
                        var tipID = angular.element(tooltipText).attr('id');
                        if (elem.hasClass('tooltip-onfocus')) {
                            var inputElm = angular.element(elem[0].querySelector("input"));
                            var textAreaElm = angular.element(elem[0].querySelector("textarea"));
                        }
                        angular.element(icon).attr({'aria-expanded': false});
                        angular.element(btnIcon).attr({'aria-expanded': false});
                        var calcTooltip = function () {
                            if (!elem.hasClass('tooltip active')) {
                                if (elem.hasClass('tooltip-onfocus')) {
                                    angular.element(elem[0].querySelector("input")).triggerHandler('focusout');
                                }
                                if (elem.hasClass('tooltip-onclick')) {
                                    return false;
                                }
                                angular.element(icon).removeClass('active');
                                angular.element(icon).attr({'aria-expanded': true});
                                angular.element(icon).attr({'aria-describedby': tipID});
                                angular.element(tooltipText).attr({'aria-hidden': false});
                                elem.addClass('active');

                                var tooltipIconPos = angular.element(icon).prop('offsetLeft'),
                                        tooltipPosition = angular.element(tooltipText).prop('offsetWidth') / 2,
                                        tipOffset = (tooltipIconPos - 30) - tooltipPosition,
                                        maxRightPos = (($window.innerWidth - 72) - (tooltipPosition * 2)) - 14.5;

                                if ($window.innerWidth >= '768') {
                                    if (tipOffset < 0) {// if icon on far left side of page
                                        tipOffset = 15;
                                    }
                                    else if (tooltipIconPos.left > maxRightPos) {// if icon is far right side of page
                                        tipOffset = maxRightPos;
                                    }
                                    else {// if tooltip in the middle somewhere
                                        tipOffset = tipOffset;
                                    }
                                    angular.element(tooltipWrapper).css({left: tipOffset + 'px'});
                                }
                            }
                        };
                        
                        // TOOLTIP LINK ONCLICK AND FOCUS
                        angular.element(icon).on('click mouseover mouseout focus blur', function (e) {
                            if (!(userAgent.isMobile() && (e.type=='mouseover' || e.type =='mouseout'))){
                                if (e.type == 'mouseover') {
                                    calcTooltip();
                                }
                                else if (e.type == 'mouseout' && elem.hasClass('active')) {
                                    if (!elem.hasClass('activeClick')) {
                                        angular.element(tooltipText).attr({
                                            'aria-hidden': true,
                                            'tabindex': '-1'
                                        });
                                        elem.removeClass('active');
                                        angular.element(icon).attr({'aria-expanded': 'false'});
                                        angular.element(icon).removeAttr('aria-describedby');
                                    } else if (elem.hasClass('activeClick') && navigator.userAgent.match(/iphone/i)) {
                                        elem.removeClass('active activeClick');
                                        angular.element(icon).attr({'aria-expanded': 'false'});
                                        angular.element(icon).removeAttr('aria-describedby');
                                    }
                                }

                                else {
                                    if (elem.hasClass('activeClick')) {
                                        angular.element(icon).attr({'aria-expanded': false});
                                        angular.element(tooltipText).attr({'aria-hidden': true});
                                        angular.element(icon).removeAttr('aria-describedby');
                                        elem.removeClass('activeClick active');
                                        e.preventDefault();
                                    }
                                    else if (e.type == 'click') {
                                        elem.addClass('activeClick');
                                        calcTooltip();
                                        e.preventDefault();
                                    }
                                    else {
                                        angular.element(icon).on('keydown', function (e) {
                                            if (e.keyCode == '32') {
                                                (elem.hasClass('active')) ? elem.removeClass('active') : elem.addClass('value');
                                                angular.element(icon).triggerHandler('click');
                                                e.preventDefault();
                                            } else if (e.keyCode == '27') {
                                                (elem.hasClass('active')) ? elem.removeClass('active activeClick') : elem.addClass('value');
                                            }
                                        });
                                        e.preventDefault();
                                    }
                                }
                                e.preventDefault();
                            }
                        });

                        // TOOLTIP BUTTON INSIDE A TEXT FIELD
                        angular.element(btnIcon).on('click', function (e) {
                            var $this = angular.element(this);
                            if ($this.hasClass('active') && elem.hasClass('tooltip-onclick')) {
                                elem.removeClass('active');
                                $this.removeClass('active');
                                angular.element(tooltipText).removeAttr('aria-live');
                                $this.attr({'aria-expanded': 'false'});
                                $this.removeAttr('aria-describedby');
                            } else {
                                elem.addClass('active');
                                $this.addClass('active');
                                $this.attr({'aria-expanded': 'true', 'aria-describedby': tipID});
                                angular.element(tooltipText).attr({'aria-live': 'polite'});
                            }
                        });

                        angular.element(btnIcon).on('keydown', function (e) {
                            var $this = angular.element(this);
                            if (e.keyCode == '27'){
                                if ($this.hasClass('active') && elem.hasClass('tooltip-onclick')) {
                                    elem.removeClass('active');
                                    $this.removeClass('active');
                                    angular.element(tooltipText).removeAttr('aria-live');
                                    $this.attr({'aria-expanded': 'false'});
                                    $this.removeAttr('aria-describedby');
                                }
                            }
                        });

                        angular.element(elem).on('focusout', function (e) {
                            var $this = angular.element(btnIcon);
                            if (angular.element(e.relatedTarget).parent()[0] !== elem[0]){
                                if ($this.hasClass('active') && elem.hasClass('tooltip-onclick')) {
                                    elem.removeClass('active');
                                    $this.removeClass('active');
                                    angular.element(tooltipText).removeAttr('aria-live');
                                    $this.attr({'aria-expanded': 'false'});
                                    $this.removeAttr('aria-describedby');
                                }
                            }
                        });

                        // close all tooltips if clicking something else
                        $document.bind('click', function (e) {
                            if (elem.hasClass('active') || angular.element(elem[0].querySelector('.tooltip-element')).hasClass('active')) {
                                var isElement = $isElement(angular.element(e.target), elem, $document);
                                if (!isElement) {
                                    elem.removeClass('active');
                                    angular.element(elem[0].querySelector('.tooltip-element')).removeClass('active');
                                    angular.element(tooltipText).removeAttr('aria-live');
                                    angular.element(elem[0].querySelector('.tooltip-element')).attr({
                                        'aria-expanded': 'false'
                                    });
                                    angular.element(elem[0].querySelector('.tooltip-element')).removeAttr('aria-describedby');
                                }
                            }
                        });

                        // TOOLTIP TRIGGERED AUTOMATICALLY INSIDE A TEXT FIELD
                        angular.element(inputElm).on('focus', function (e) {
                            var allTooltip = $document[0].querySelectorAll('[class*="tooltip"]');
                            for (var i = 0; i < allTooltip.length; i++) {
                                if (angular.element(allTooltip[i]).hasClass('active')) {
                                    angular.element(allTooltip[i]).triggerHandler('click');
                                }
                            };


                            var currentDescribedByValue = angular.element(this).attr('aria-describedby');

                            if (currentDescribedByValue === undefined){
                                angular.element(this).attr({'aria-describedby': tipID});
                            }
                            else {
                                angular.element(this).attr({'aria-describedby': currentDescribedByValue + ' ' + tipID});
                            }

                            angular.element(tooltipText).css('display', 'block');
                            angular.element(tooltipText).attr({'aria-live': 'polite'});
                            elem.addClass('active');
                        });
                        
                        angular.element(inputElm).on('blur', function (e) {
                            elem.removeClass('active');
                            angular.element(tooltipText).css('display', 'none');
                            angular.element(tooltipText).removeAttr('aria-live');

                            if (angular.element(this).attr('aria-describedby') === undefined){

                            }

                            else if ((spaceIndex = angular.element(this).attr('aria-describedby').lastIndexOf(' ')) >= 0){

                                var describedByValue = angular.element(this).attr('aria-describedby').slice(0, spaceIndex);

                                angular.element(this).attr('aria-describedby', describedByValue);

                            }
                            else {
                                angular.element(this).removeAttr('aria-describedby');
                            }
                        });

                        angular.element(inputElm).on('keydown', function (e) {
                            if (e.keyCode == '27'){
                                elem.removeClass('active');
                                angular.element(tooltipText).css('display', 'none');
                                angular.element(tooltipText).removeAttr('aria-live');

                                if (angular.element(this).attr('aria-describedby') === undefined){

                                }

                                else if ((spaceIndex = angular.element(this).attr('aria-describedby').lastIndexOf(' ')) >= 0){

                                    var describedByValue = angular.element(this).attr('aria-describedby').slice(0, spaceIndex);

                                    angular.element(this).attr('aria-describedby', describedByValue);

                                }
                                else {
                                    angular.element(this).removeAttr('aria-describedby');
                                }
                            }
                        });

                        // TOOLTIP TRIGGERED AUTOMATICALLY INSIDE A TEXTAREA
                        angular.element(textAreaElm).on('focus', function (e) {
                            var allTooltip = $document[0].querySelectorAll('[class*="tooltip"]');
                            for (var i = 0; i < allTooltip.length; i++) {
                                if (angular.element(allTooltip[i]).hasClass('active')) {
                                    angular.element(allTooltip[i]).triggerHandler('click');
                                }
                            };
                            elem.addClass('active');
                            angular.element(tooltipText).css('display', 'block');
                            angular.element(tooltipText).attr({'aria-live': 'polite'});

                            var currentDescribedByValue = angular.element(this).attr('aria-describedby');

                            if (currentDescribedByValue === undefined){
                                angular.element(this).attr({'aria-describedby': tipID});
                            }
                            else {
                                angular.element(this).attr({'aria-describedby': currentDescribedByValue + ' ' + tipID});
                            }


                        });
                        angular.element(textAreaElm).on('blur', function (e) {
                            elem.removeClass('active');
                            angular.element(tooltipText).css('display', 'none');
                            angular.element(tooltipText).removeAttr('aria-live');
                            if (angular.element(this).attr('aria-describedby') === undefined){

                            }

                            else if ((spaceIndex = angular.element(this).attr('aria-describedby').lastIndexOf(' ')) >= 0){

                                var describedByValue = angular.element(this).attr('aria-describedby').slice(0, spaceIndex);

                                angular.element(this).attr('aria-describedby', describedByValue);

                            }
                            else {
                                angular.element(this).removeAttr('aria-describedby');
                            }
                        });

                        angular.element(textAreaElm).on('keydown', function (e) {
                            if (e.keyCode == '27'){
                                elem.removeClass('active');
                                angular.element(tooltipText).css('display', 'none');
                                angular.element(tooltipText).removeAttr('aria-live');
                                if (angular.element(this).attr('aria-describedby') === undefined){

                                }

                                else if ((spaceIndex = angular.element(this).attr('aria-describedby').lastIndexOf(' ')) >= 0){

                                    var describedByValue = angular.element(this).attr('aria-describedby').slice(0, spaceIndex);

                                    angular.element(this).attr('aria-describedby', describedByValue);

                                }
                                else {
                                    angular.element(this).removeAttr('aria-describedby');
                                }
                            }
                        });


                    }
                };
            }]);
/**
 * @ngdoc directive
 * @name Progress & usage indicators.att:usageBar
 *
 * @description
 *  <file src="src/usageBar/docs/readme.md" />
 *
 * @usage
 * <div class="progress progress-success" ddh-usage-bar="{{usageBarVal3}}" role="progressbar" aria-valuetext="40% usage"> </div>
 * 
    <div class="progress" ddh-usage-bar="{{usageBarVal2}}" is-animated='true' role="progressbar" aria-valuetext="20% usage"> </div>
        <span class="hidden-spoken">20% usage with animation</span> 

        <div class="usage-bar">
            <div class="usage-text"><i class="cssIcon-error valign-top"></i> 1/2 increments</div>
            <div class="usage-text text-right"><b>{{usageBarIncrementedVal1}}%</b> used</div>
        </div>
        <div class="progress increment progress-thin" ddh-usage-bar="{{usageBarIncrementedVal1}}" no-of-segments='2' bar-type-class='bar-success' ms-delay='5000' is-animated="true" role="progressbar" aria-valuetext="100% of the first half. 10% of the second half. 60% total used."></div>
        <div class="usage-bar">
            <div class="usage-text">Additional description text</div>
        </div>

 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/usageBar/docs/demo.html" />
 <file src="src/usageBar/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.usageBar', ['ddh.att.utilities', 'ddh.att.lazyLoad']).
        directive('ddhUsageBar', ['$window', '$timeout', 'ddhLazyLoad', function($window, $timeout, ddhLazyLoad) {
                return {
                    restrict: 'A',
                    scope: {
                        noOfSegments: '=',
                        barTypeClass: '@?',
                        msDelay: '=?'
                    },
                    templateUrl: 'template/usageBar/usageBar.html',
                    compile: function (elem, attr) {
                        ddhLazyLoad.load('progressBar', 'css');

                        return this.link;
                    },
                    link: function(scope, ele, attr) {

                        if (!(angular.isNumber(scope.noOfSegments) && scope.noOfSegments > 0)) {
                            scope.noOfSegments = 1;
                        }

                        scope.barsArray = [];

                        for (var i=0; i < scope.noOfSegments; i++) {
                            scope.barsArray.push({showItem : true});
                        }

                        if (!angular.isNumber(scope.msDelay)) {
                            scope.msDelay = 5000;
                        }
                        
                        var transition = 'width ' + scope.msDelay + 'ms';

                        var animateStyle = {
                            '-webkit-transition': transition,
                            '-moz-transition': transition,
                            '-ms-transition': transition,
                            '-o-transition': transition,
                            transition: transition
                        };

                        if (attr.isAnimated) {
                            for (var i = 0; i < scope.barsArray.length; i++) {
                                angular.forEach(animateStyle, function(value, key) {
                                    scope.barsArray[i][key] = value;
                                });
                            }
                        }

                        $timeout(function() {                            
                            var percentDivEach = 100/scope.noOfSegments;
                            
                            var fullBars = Math.floor(attr.ddhUsageBar / percentDivEach);
                            var cutOffBarWidth = attr.ddhUsageBar % percentDivEach;
                            var i=0;
                            while(i < fullBars) {
                                scope.barsArray[i].width = percentDivEach + '%';
                                scope.barsArray[i].showItem = true;
                                i++;
                            }
                            if(cutOffBarWidth > 0) {
                                scope.barsArray[i].width = cutOffBarWidth + '%';
                                scope.barsArray[i].showItem = true;
                                i++;
                            }
                            while(i < scope.barsArray.length) {
                                scope.barsArray[i].showItem = false;
                                i++;
                            }
                        });
                    }

                };

            }]);
     
angular.module("template/breadcrumbs/breadcrumbs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/breadcrumbs/breadcrumbs.html",
    "<div role=\"navigation\" aria-label=\"You are here on {{current}}\">\n" +
    "    <ul class=\"breadcrumb\">\n" +
    "   <li ng-repeat=\"i in linkObj\">\n" +
    "       <a href=\"javascript:void(0)\" ng-if=\"!i.active || i.active===undefined\">{{i.title}}</a><span ng-if=\"i.active\" class=\"breadcrumb-active\"><span class=\"hidden-spoken\">Current: {{i.title}}</span><span aria-hidden=\"true\">{{i.title}}</span></span></li>\n" +
    " </ul> \n" +
    "</div>");
}]);

angular.module("template/calendar/datepicker-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/calendar/datepicker-popup.html",
    "<div id=\"datepicker\" class=\"datepicker dropdown-menu\" ng-class=\"{'datepicker-dropdown datepicker-orient-top': !inline, 'datepicker-orient-left': !inline && orientation === 'left', 'datepicker-orient-right': !inline && orientation === 'right'}\" ng-style=\"{position: inline && 'relative', 'z-index': inline && '0', top: !inline && position.top + 'px' || 0, left: !inline && position.left + 'px'}\" style=\"display: block;\" aria-hidden=\"false\" role=\"dialog\" aria-label=\"{{datepickerLabel}}\" aria-labelledby=\"month\" tabindex=\"-1\" ddh-key type=\"table\" columns=\"7\">\n" +
    "    <div class=\"datepicker-days\" style=\"display: block;\">\n" +
    "        <div ng-repeat=\"header in headers\" class=\"text-left heading-fixed-width\" ddh-append-element=\"header\"></div>\n" +
    "        <table class=\"table-condensed\" role=\"presentation\">\n" +
    "            <thead>\n" +
    "                <tr role=\"presentation\">\n" +
    "                    <th id=\"prev\" class=\"prev\" tabindex=\"0\" ddh-accessibility-click=\"13,32\" aria-label=\"Previous Month\" role=\"button\" ddh-element-focus=\"!disablePrev && getFocus\" ng-style=\"{visibility: visibilityPrev}\" ng-click=\"!disablePrev && move(-1)\"><i class=\"icon-left\" aria-hidden=\"true\"></i></th>\n" +
    "                    <th id=\"month\" tabindex=\"-1\" aria-label=\"{{title}}\" class=\"datepicker-switch\" colspan=\"{{rows[0].length - 2}}\">{{title}}</th>\n" +
    "                    <th id=\"next\" class=\"next\" tabindex=\"0\" ddh-accessibility-click=\"13,32\" ddh-element-focus=\"disablePrev && getFocus\" aria-label=\"Next Month\" role=\"button\" ng-style=\"{visibility: visibilityNext}\" ng-click=\"!disableNext && move(1)\"><i class=\"icon-right\" aria-hidden=\"true\"></i></th>\n" +
    "                </tr>\n" +
    "                <tr ng-show=\"labels.length > 0\" role=\"presentation\">\n" +
    "                    <th id=\"{{label.post}}\" class=\"dow\" ng-repeat=\"label in labels\" aria-hidden=\"true\"><span aria-hidden=\"true\">{{label.pre}}</span></th>\n" +
    "                </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"row in rows\" role=\"presentation\">\n" +
    "                    <td headers=\"{{dt.header}}\" ddh-key-item=\"dt.focusable\" ddh-accessibility-click=\"13,32\" ddh-element-focus=\"disablePrev && disableNext && getFocus && (dt.selected || dt.firstFocus || dt.fromDate || dt.dateRange)\" tabindex=\"{{(!(dt.focusable && (dt.selected || dt.firstFocus || dt.fromDate || currFocus)) && -1) || 0}}\" aria-hidden=\"{{(!dt.focusable && true) || false}}\" role=\"{{(dt.focusable && 'button') || ''}}\" aria-label=\"{{(dt.focusable && dt.date | date : 'EEEE d') || ''}}\" aria-describedby=\"{{(dt.focusable && dt.selected && !dt.dateRange && !dt.dueDate && legendSelected) || ''}}{{(dt.focusable && dt.dueDate && !dt.selected && legendDue) || ''}}{{(dt.focusable && dt.selected && !dt.dateRange && dt.dueDate && legendDueSelected) || ''}}\" aria-selected=\"{{(dt.focusable && (dt.selected || dt.dateRange) && true) || false}}\" ng-repeat=\"dt in row\" class=\"day magic\" ng-class=\"{'active': dt.focusable && dt.selected && !dt.dateRange, 'start-date': dt.focusable && (dt.fromDate || (range === 'start' && dt.selected)), 'between-date': dt.focusable && !dt.fromDate && !dt.selected && dt.dateRange, 'end-date': dt.focusable && dt.selected && dt.dateRange, 'old': dt.oldMonth, 'new': dt.nextMonth, 'disabled': dt.disabled, 'due-date': dt.dueDate, 'late-fee': dt.pastDue, 'startdate-alone': dt.focusable && ((range === 'start' && dt.selected) || (range === 'end' && dt.fromDate && !dt.dateRange))}\" ng-focus=\"currFocus=true; trapFocus();\" ng-blur=\"currFocus=false; trapFocus();\" title=\"{{(dt.focusable && dt.dueDate && legendMessage) || ''}}\" ng-click=\"!ngDisabled && !dt.disabled && select(dt.date)\" ng-keydown=\"changeMonthOnArrow($event)\">\n" +
    "                        <div aria-hidden=\"true\" tabindex=\"-1\" class=\"show-date\" ng-if=\"!(dt.oldMonth || dt.nextMonth)\">{{dt.label}}</div>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "            <tfoot aria-hidden=\"true\">\n" +
    "                <tr ng-repeat=\"footer in footers\">\n" +
    "                    <th colspan=\"7\" class=\"text-left\" style=\"width: 278px;\" ddh-append-element=\"footer\"></th>\n" +
    "                </tr>\n" +
    "            </tfoot>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/calendar/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/calendar/datepicker.html",
    "<div>\n" +
    "    <span class=\"icon-calendar span12\" ng-class=\"{'disabled': ngDisabled}\" ng-transclude></span>\n" +
    "</div>");
}]);

angular.module("template/colorAndDataCapacity/capacityItem.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/colorAndDataCapacity/capacityItem.html",
    "<button role=\"radio\" type=\"button\" ddh-key-item  class=\"btn btn-medium\" ng-class=\"{'active': ddhColorAndDataCapacityItem.id === ddhColorAndDataCapacityCtrl.getActiveItem()}\" aria-label=\"{{ddhColorAndDataCapacityItem.id}}\" aria-checked=\"{{ddhColorAndDataCapacityItem.id === ddhColorAndDataCapacityCtrl.getActiveItem()}}\" tabindex=\"{{(!ddhColorAndDataCapacityCtrl.getActiveItem() || ddhColorAndDataCapacityItem.id=== ddhColorAndDataCapacityCtrl.getActiveItem())?0:-1}}\">\n" +
    "    <i ng-if=\"selectorType == 'color'\" class=\"btn-fill\" ng-attr-style=\"background-color:{{ddhColorAndDataCapacityItem.colorCode}}\"></i>\n" +
    "    <div ng-if=\"selectorType == 'color'\" class=\"colors-off-msg\" aria-hidden=\"true\" style=\"display: none;\">{{ddhColorAndDataCapacityItem.id}}</div>\n" +
    "    <span ng-if=\"selectorType == 'data'\">{{ddhColorAndDataCapacityItem.id}}</span>\n" +
    "</button>");
}]);

angular.module("template/colorAndDataCapacity/capacityWrapper.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/colorAndDataCapacity/capacityWrapper.html",
    "<div role=\"radiogroup\" ddh-key prev=\"37,38\" next=\"39,40\" circular-traversal class=\"btn-group\" ng-transclude></div>");
}]);

angular.module("template/dropdownVariations/ddhDropdownVariations.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/dropdownVariations/ddhDropdownVariations.html",
    "<div class=\"form-row\">\n" +
    "    <label for=\"select3cc\">Dropdown with optgroup</label>\n" +
    "    <span class=\"selectWrap\"><input type=\"hidden\" id=\"select3cc-value\" class=\"awd-select-value\" value=\"a1xxxc\">\n" +
    "       <button id=\"select3cc\" class=\"awd-select isWrapped closed\" aria-expanded=\"false\" aria-haspopup=\"true\" role=\"combobox\" value=\"a1xxxc\">Bank account ending 1234</button><div id=\"select3cc-wrapper\" class=\"selectWrapper\"><ul class=\"awd-select-list\" id=\"select3cc-dropdown\" tabindex=\"-1\" aria-labeledby=\"select3cc-button\" style=\"display: none;\">\n" +
    "       <li class=\"optgroup-wrapper\" aria-selected=\"false\">Late payment arrangements\n" +
    "          <ul class=\"optgroup\"><li value=\"6xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">Mail payment by 12/15</li><li value=\"7xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">In-store by 12/19</li><li value=\"8xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">Call by 12/19</li></ul>\n" +
    "        </li>\n" +
    "       <li class=\"optgroup-wrapper\" aria-selected=\"false\">Online payment options\n" +
    "          <ul class=\"optgroup\"><li value=\"1xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"true\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\" selected=\"selected\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">Bank account ending 1234</li><li value=\"2xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">Card ending 4567</li><li value=\"3xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">New bank account</li><li value=\"4xxxc\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/retail/autopay.svg\">New credit/debit card</li></ul>\n" +
    "       </li>\n" +
    "       <li value=\"a1xxxc\" aria-selected=\"true\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\" selected=\"selected\">Bank account ending 1234</li>\n" +
    "       <li value=\"a2xxxc\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\">Card ending 4567</li>\n" +
    "    </ul></div></span>\n" +
    " </div>\n" +
    "<div class=\"form-row\">\n" +
    "    <label for=\"big1\">Dropdown with images</label>\n" +
    "    <span class=\"selectWrap large\"><input type=\"hidden\" id=\"big1-value\" class=\"awd-select-value\"><button class=\"awd-select large isWrapped closed\" id=\"big1\" aria-expanded=\"false\" aria-haspopup=\"true\" role=\"combobox\">Select</button><div id=\"big1-wrapper\" class=\"selectWrapper\"><ul class=\"awd-select-list\" id=\"big1-dropdown\" tabindex=\"-1\" aria-labeledby=\"big1-button\" style=\"display: none;\">\n" +
    "\n" +
    "       <li value=\"big1a\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/directv.svg\" aria-selected=\"true\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\" selected=\"selected\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/directv.svg\">Lynksys-WRT54G Wireless-G</li>\n" +
    "       <li value=\"big1b\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/cctv.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/cctv.svg\">DLink-DI-624 Wireless-G Broadband</li>\n" +
    "       <li value=\"big1c\" data-img-src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/gps.svg\" aria-selected=\"false\" class=\"awd-select-list-item\" tabindex=\"0\" role=\"option\"><img src=\"../styles/att/rwd/1.0.0/css/images/svg/master/devices/gps.svg\">Cisco-RV110 W Wireless</li>\n" +
    "    </ul></div></span>\n" +
    " </div>");
}]);

angular.module("template/dropdowns/ddhDropdownDesktop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/dropdowns/ddhDropdownDesktop.html",
    "<span ddh-key prev=\"38\" next=\"40\" enable-search ng-class=\"{'large': (dropdownSize === 'large'), 'disabled': (disabled), 'selectWrap': (isInputDropdown || (dropdownType === 'menu')), 'selectionMenu': (dropdownType === 'selector-menu'), 'linkSelectionMenu': (dropdownType === 'link-menu')}\">\n" +
    "    <input ddh-dropdown-toggle ddh-dropdown-validation ng-disabled=\"disabled\" type=\"text\" id=\"{{dropdownId}}\" name=\"{{dropdownName}}\" class=\"awd-select isWrapped\" ng-required=\"dropdownRequired\" ng-model=\"currentSelected.text\" role=\"combobox\" aria-owns=\"listbox{{$id}}\" aria-expanded=\"{{toggleFlag}}\" ng-click=\"toggleDropdown()\" ng-focus=\"focused=true\" ng-blur=\"setBlur(); focused=false\" ng-class=\"{'active': toggleFlag, 'closed': !toggleFlag, 'large': (dropdownSize === 'large'), 'focused':focused}\" style=\"width:100%;\" value=\"{{currentSelected.text}}\" ng-show=\"isInputDropdown\" aria-describedby=\"{{dropdownDescribedBy}}\" readonly=\"readonly\">\n" +
    "    <button type=\"button\" ddh-dropdown-toggle ng-disabled=\"disabled\" aria-label=\"{{labelText}} {{currentSelected.label}}\" aria-expanded=\"{{toggleFlag}}\" aria-haspopup=\"true\" ng-click=\"toggleDropdown()\" ng-blur=\"setBlur()\" ng-class=\"{'active opened': toggleFlag, 'closed': !toggleFlag, 'large': (dropdownSize === 'large'), 'awd-select isWrapped': (dropdownType === 'menu'), 'selectMenu': (dropdownType !== 'menu')}\" ng-bind-html=\"currentSelected.text\" ng-show=\"!isInputDropdown\"></button>\n" +
    "    <div ng-class=\"{'selectWrapper': (isInputDropdown || (dropdownType === 'menu')), 'menuWrapper': (!isInputDropdown && (dropdownType !== 'menu'))}\">\n" +
    "        <div id=\"listbox{{$id}}\" ng-class=\"{'awd-select-list': (isInputDropdown || (dropdownType === 'menu')), 'awd-menu-list': (!isInputDropdown && (dropdownType !== 'menu'))}\" tabindex=\"-1\" ddh-collapse=\"!toggleFlag\">\n" +
    "            <ul class=\"optionalClass\" role=\"{{isInputDropdown?'listbox':'menu'}}\" tabindex=\"-1\" aria-label=\"Choose options\"></ul>\n" +
    "            <ul class=\"menu-optinalcta\" ng-if=\"optionalCta\" tabindex=\"-1\" aria-hidden=\"false\">\n" +
    "                <li class=\"menu-list-item\" ddh-key-item ddh-key-item-order=\"LAST\" tabindex=\"-1\" role=\"menuitem\" ddh-accessibility-click=\"13,32\" ddh-cta-focus ng-focus=\"onFocus()\" ddh-append-element=\"optionalCta\">\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <span ng-if=\"!isInputDropdown && isMobile\" style=\"color:transparent;position:absolute;\" tabindex=\"0\" ng-focus=\"toggleDropdown(false)\">Close</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <i class=\"icon-down\" aria-hidden=\"true\"></i>\n" +
    "</span>");
}]);

angular.module("template/dropdowns/ddhDropdownGroupDesktop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/dropdowns/ddhDropdownGroupDesktop.html",
    "<li ddh-dropdown-group-desktop ng-class=\"{'optgroup-wrapper': (isInputDropdown || (dropdownType === 'menu')), 'menu-groups': (!isInputDropdown && (dropdownType !== 'menu'))}\">{{groupHeader}}\n" +
    "    <ul ng-class=\"{'optgroup': (isInputDropdown || (dropdownType === 'menu')), 'menu-groupitem': (!isInputDropdown && (dropdownType !== 'menu'))}\" role=\"{{isInputDropdown?'group':''}}\" aria-label=\"{{groupHeader}}\"></ul>\n" +
    "</li>");
}]);

angular.module("template/dropdowns/ddhDropdownListDesktop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/dropdowns/ddhDropdownListDesktop.html",
    "<li ddh-dropdown-list-desktop ddh-key-item=\"!disabled\" ddh-accessibility-click=\"13,9\" ddh-selected=\"currentSelected.value === dropdownListValue\" aria-selected=\"{{currentSelected.value === dropdownListValue}}\" ng-class=\"{'awd-select-list-item': (isInputDropdown || (dropdownType === 'menu')), 'menu-list-item': (!isInputDropdown && (dropdownType !== 'menu'))}\" tabindex=\"0\" role=\"{{isInputDropdown?'option':'menuitem'}}\" ng-click=\"selectDropdownItem()\" ng-focus=\"highlightDropdown()\"></li>");
}]);

angular.module("template/expandCollapse/expandCollapse-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/expandCollapse/expandCollapse-group.html",
    "<div>\n" +
    "    <div id=\"{{acId}}tab{{index}}\" class=\"toggle-header\" ddh-accessibility-click=\"32\"  aria-expanded=\"{{isOpen}}\" aria-controls=\"{{acId}}panel{{index}}\" ng-class=\"{opened: isOpen, closed: !isOpen}\" role=\"tab\" tabindex=\"-1\" ng-click=\"toggle()\" aria-setsize=\"{{tSize()}}\" aria-posinset=\"{{index+1}}\" ddh-accordion-transclude=\"heading\" ng-focus=\"onfocus()\">\n" +
    "        <i class=\"icon-accordion-{{(isOpen)?'minus':'plus'}}\"></i>         \n" +
    "        <span>{{heading}} <span class=\"hidden-spoken\" ng-if=\"isOpen && isMobile\">Expanded</span><span class=\"hidden-spoken\" ng-if=\"!isOpen && isMobile\">Collapsed</span></span>\n" +
    "    </div>\n" +
    "    <div class=\"accordion-content\" aria-labelledby=\"{{acId}}tab{{index}}\" id=\"{{acId}}panel{{index}}\" aria-hidden=\"{{!isOpen}}\" ddh-collapse=\"!isOpen\" role=\"tabpanel\" ng-class=\"{'make-all-white': onDark, 'has-nested': hasNested}\"><span ng-transclude></span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/expandCollapse/expandCollapse-table.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/expandCollapse/expandCollapse-table.html",
    "<div>\n" +
    "    <div id=\"{{acId}}tab{{index}}\" class=\"toggle-header summary-table-old\" ddh-accessibility-click=\"32\"  aria-expanded=\"{{isOpen}}\" aria-controls=\"{{acId}}panel{{index}}\" ng-class=\"{opened: isOpen, closed: !isOpen}\" role=\"tab\" tabindex=\"-1\" ng-click=\"toggle()\" aria-setsize=\"{{tSize()}}\" aria-posinset=\"{{index+1}}\">\n" +
    "        <div class=\"faux-table-cell\" >\n" +
    "			<i class=\"icon-accordion-{{(isOpen)?'minus':'plus'}}\"></i>\n" +
    "           	<span ng-bind-html=\"column1 | ddhUnsafe\"></span>\n" +
    "        </div>\n" +
    "        <div class=\"faux-table-cell\" ng-style=\"colorStyle\">\n" +
    "           <span>{{column2}}</span>\n" +
    "        </div>                        \n" +
    "    </div>\n" +
    "    <div class=\"accordion-content\" aria-labelledby=\"{{acId}}tab{{index}}\" id=\"{{acId}}panel{{index}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" ddh-collapse=\"!isOpen\" ng-transclude>                                 \n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/expandCollapse/expandCollapse.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/expandCollapse/expandCollapse.html",
    "<div ng-transclude role=\"tablist\" aria-multiselectable=\"{{!isMultiselect}}\"></div>");
}]);

angular.module("template/filmstrip/ddhFilmstrip.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/filmstrip/ddhFilmstrip.html",
    "<div class=\"filmstrip span12\" ng-class=\"{'no-header': !filmstripHeading}\">\n" +
    "    <h3 id=\"{{fsId}}_fs_heading\" class=\"header\" ng-if=\"filmstripHeading\" ng-bind=\"filmstripHeading\"></h3>	\n" +
    "    <label id=\"fs_info\" style=\"display: none;\">Use left and right arrow to navigate Press enter to activate</label>\n" +
    "    <label id=\"fs_info_mobile\" style=\"display: none;\">Swipe to navigate Double tap to activate</label>\n" +
    "    <button aria-controls=\"{{fsId}}_fs_list\" aria-label=\"scroll left\" type=\"button\" class=\"btn-circular left-arrow \" ng-hide=\"filmstripType === 'flex-justify'\" ng-click=\"moveleft()\">\n" +
    "        <div class=\"btn btn-secondary\"><i class=\"icon-left\" aria-hidden=\"true\"></i></div>\n" +
    "    </button>	\n" +
    "    <div class=\"filmstrip-wrapper\">\n" +
    "        <ul class=\"contents\" id=\"{{fsId}}_fs_list\" ng-class=\"{'row flex-justify': filmstripType === 'flex-justify'}\" role=\"listbox\" aria-labelledby=\"{{fsId}}_fs_heading\" aria-describedby=\"{{isMobile ? 'fs_info_mobile' : 'fs_info' }}\" tabindex=\"-1\" ng-transclude>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <button aria-controls=\"{{fsId}}_fs_list\" aria-label=\"scroll right\" type=\"button\" class=\"btn-circular right-arrow \" ng-hide=\"filmstripType === 'flex-justify'\" ng-click=\"moveright()\">\n" +
    "        <div class=\"btn btn-secondary\"><i class=\"icon-right\" aria-hidden=\"true\"></i></div>\n" +
    "    </button>	\n" +
    "</div>");
}]);

angular.module("template/filmstrip/ddhFilmstripContent.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/filmstrip/ddhFilmstripContent.html",
    "<li id=\"{{cFsId}}_fs_item{{fsIndex}}\" class=\"item\" role=\"option\" ng-transclude aria-selected=\"{{isSelected}}\"></li>\n" +
    "");
}]);

angular.module("template/filters/ddhFiltersSimple.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/filters/ddhFiltersSimple.html",
    "<div tabindex=\"-1\" class=\"fixed-230 filter-container\" ng-class=\"{'slide-in':(!largeViewport && displayComponent)}\" ng-style=\"{'display': (largeViewport || displayComponent)?'block':'none'}\" ng-attr-role=\"{{!largeViewport && 'dialog' || ''}}\" aria-hidden=\"{{!displayComponent}}\">\n" +
    "    <div class=\"filters\">\n" +
    "\n" +
    "        <div class=\"filter-header\">\n" +
    "            <h2 id=\"filtersMainHeading\" tabindex=\"-1\">{{mainHeading}}</h2>\n" +
    "            <div class=\"corner-button hidden-desktop\">\n" +
    "                <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"hideFiltersPanel($event)\"></button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"filter-selected\" ng-style=\"{'display': selectedFiltersArray.length?'block':'none'}\" role=\"region\" aria-labelledby=\"selectedFilters\">\n" +
    "            <span id=\"selectedFilters\" tabindex=\"-1\">{{selectedFiltersHeading}}</span>\n" +
    "            <a href=\"\" role=\"button\" ng-click=\"clearAllFilterSelection(selectedFiltersArray)\" class=\"pull-right clear-all-filters\">Clear all</a>\n" +
    "            <div class=\"filter-selected-group\">\n" +
    "                <div class=\"filter-selected-badge\" ng-repeat=\"selectedFilter in availableFiltersArray | filtersSelectedItemsFilter as selectedFiltersArray\"><span>{{selectedFilter.filterDisplayText}}<button type=\"button\" ng-click=\"removeFilter(selectedFilter)\" class=\"icon-controls-optionsoff\" aria-label=\"remove filter selection {{selectedFilter.filterDisplayText}}\"></button></span></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/filtersComplex/ddhfiltersComplex.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/filtersComplex/ddhfiltersComplex.html",
    "<div id=\"filter_container_simple\" tabindex=\"-1\" class=\"fixed-230 filter-container filter-docked\" ng-class=\"{'slide-in':(!largeViewport && displayComponent),'filter-landscape':mediumViewport,}\" ng-style=\"{'display': (largeViewport || displayComponent)?'block':'none'}\" ng-attr-role=\"{{!largeViewport && 'dialog'|| ''}}\" aria-hidden=\"{{!displayComponent}}\">\n" +
    "    <div class=\"filters\" ng-style=\"setHeight\">\n" +
    "        <div class=\"filter-header\">\n" +
    "            <h2 id=\"filtersMainHeading\" tabindex=\"-1\">{{mainHeading}}</h2>\n" +
    "        </div>\n" +
    "        <div class=\"filter-selected\" ng-style=\"{'display': selectedFiltersArray.length?'block':'none'}\" role=\"region\" aria-labelledby=\"selectedFilters\">\n" +
    "            <span id=\"selectedFilters\" tabindex=\"-1\">{{selectedFiltersHeading}}</span>\n" +
    "            <a href=\"\" role=\"button\" ng-click=\"clearAllFilterSelection(selectedFiltersArray)\" class=\"pull-right clear-all-filters\">Clear all</a>\n" +
    "            <div class=\"filter-selected-group\">\n" +
    "                <div class=\"filter-selected-badge\" ng-repeat=\"selectedFilter in selectedFiltersArray\"><span>{{selectedFilter.filterDisplayText}}<button type=\"button\" ng-click=\"removeFilter(selectedFilter)\" class=\"icon-controls-optionsoff\" aria-label=\"remove filter selection {{selectedFilter.filterDisplayText}}\"></button></span></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <ng-transclude></ng-transclude>\n" +
    "    </div>\n" +
    "    <div class=\"docked-button-group\">\n" +
    "        <div class=\"cta-button-group nowrap nodots centered no-pad\">\n" +
    "            <button class=\"btn btn-primary-functional btn-fullwidth btn-apply-filters\" type=\"button\" ng-click=\"applyFilter($event)\">Apply</button>\n" +
    "            <button class=\"btn btn-secondary btn-fullwidth btn-cancel-filters\" type=\"button\" ng-click=\"cancelFilter($event)\" ng-blur=\"showCancelMsg = false; $parent.showCancelMsg = false;\">Cancel</button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/leftNavigation/leftNavigation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/leftNavigation/leftNavigation.html",
    "<ul class=\"fixed-230-subnav TOGGLE\">\n" +
    "    <li ng-repeat=\"menu in filteredItems = (menuData| filter:searchFor)\">\n" +
    "        <a class=\"unlinked\" href=\"javascript:void(0);\" ddh-nav-p ng-class=\"{'active': menu.isOpen}\">\n" +
    "            {{menu.name}}\n" +
    "            <i aria-hidden=\"true\" ng-class=\"menu.isOpen ? 'icon-expanded' : 'icon-collapsed'\"></i>\n" +
    "        </a> \n" +
    "        <ul role=\"region\" aria-label=\"{{menu.name}}\" ddh-collapse=\"!menu.isOpen\">\n" +
    "            <li ng-repeat=\"menuItem in menu.menuItems\">\n" +
    "                <a href=\"{{menuItem.href}}\" ng-click=\"onClick(menuItem)\" ddh-nav-c ng-class=\"{'active':(($index == $parent.$parent.openCIdx && $parent.$index == $parent.$parent.openPIdx) || menuItem.boldTxt)}\">\n" +
    "                    {{menuItem.name}}\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </li>\n" +
    "</ul>");
}]);

angular.module("template/marquees/marquee.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/marquees/marquee.html",
    "<div class=\"att-marquee\">\n" +
    "    <div class=\"marquee-wrapper\">\n" +
    "        <div class=\"marquee-reel marquee-control {{transitionClass}}\" ng-transclude>            \n" +
    "        </div>\n" +
    "    </div>    \n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("template/marquees/marqueeImagesWrapper.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/marquees/marqueeImagesWrapper.html",
    "<div>\n" +
    "	<ng-transclude></ng-transclude>\n" +
    "	<button class=\"btn-circular marquee-arrow-left disabled\" aria-label=\"Previous\" aria-controls=\"marquee_contents\" tabindex=\"{{leftSwipe ? 0 : -1}}\" aria-disabled=\"{{!leftSwipe}}\" ng-click=\"mslide(0)\"></button>\n" +
    "	<button class=\"btn-circular marquee-arrow-right\" aria-label=\"Next\" aria-controls=\"marquee_contents\" tabindex=\"{{rightSwipe ? 0 : -1}}\" aria-disabled=\"{{!rightSwipe}}\" ng-click=\"mslide(1)\"></button>\n" +
    "</div>");
}]);

angular.module("template/marquees/marqueeTabs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/marquees/marqueeTabs.html",
    "<div class=\"marquee-control-nav\">\n" +
    "    <div class=\"control-nav-wrapper span12\">\n" +
    "        <button type=\"button\" class=\"marquee-nav-prev-page disabled\" aria-controls=\"marquee-nav\" aria-label=\"navigation items, previous page\">          \n" +
    "        </button>\n" +
    "        <ng-transclude style=\"margin:0\"></ng-transclude>\n" +
    "        <button type=\"button\" class=\"marquee-nav-next-page\" aria-controls=\"marquee-nav\" aria-label=\"navigation items, next page\">       \n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/modalsAndAlerts/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modalsAndAlerts/backdrop.html",
    "<div class=\"modal-backdrop fade hidden-by-modal\" aria-hidden=\"true\" tabindex=\"-1\"></div>");
}]);

angular.module("template/modalsAndAlerts/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modalsAndAlerts/window.html",
    "<div class=\"modalwrapper active {{windowClass}}\" ng-class=\"{'modal-landscape': isModalLandscape}\" role=\"dialog\" tabindex=\"-1\" modal-wrapper>\n" +
    "    <div class=\"modal fade {{sizeClass}}\" ng-transclude></div>\n" +
    "</div>");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/pagination/pagination.html",
    "<div>\n" +
    "    <div class=\"pagi-skip-btn\" tabindex=\"-1\" role=\"navigation\" aria-label=\"Customer Data Pages\">\n" +
    "        <span id=\"firstskiphidden{{$id}}\" class=\"visible-phone empty\" aria-hidden=\"false\" tabindex=\"-1\">&nbsp;</span>\n" +
    "        <a href=\"#secondskiphidden{{$id}}\" class=\"btn-skip pagi-hidden-spoken visible-phone\" tabindex=\"{{isMobile && totalPages > 10 ? '0' : '-1'}}\" aria-hidden=\"{{isMobile && totalPages > 10 ? 'false' : 'true'}}\" aria-label=\"Skip paginations links - forward\" ng-click=\"moveFocus(true, $event)\" ng-focus=\"displaySkipLink(true)\" ng-blur=\"hideSkipLink(true)\">Skip additional pages</a>\n" +
    "        <div class=\"pagination-holder clearfix\">\n" +
    "            <div class=\"pagination\">\n" +
    "                <ul ng-if=\"!isMobile && totalPages > 1\">\n" +
    "                    <li ng-if=\"totalPages > 10\"><a aria-label=\"{{currentPage  <= 1 ? 'Previous Page Disabled': 'Previous Page'}}\" tabindex=\"{{currentPage  <= 1 ? '-1': '0'}}\" ddh-accessibility-click=\"13,32\" role=\"link\" href=\"javascript:void(0)\" class=\"prev\" ng-click=\"prev($event)\" ng-class=\"currentPage <= 1 ? 'disabled': '' \"><i class=\"icon-left\"></i></a></li>\n" +
    "                    <li ng-if=\"totalPages > 10 && currentPage > 6\"><a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"Page 1{{checkSelectedPage(page) ? ' selected' : '' }}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-accessibility-click=\"13,32\" ng-click=\"selectPage(1, $event)\">1</a></li>\n" +
    "                    <li ng-if=\"totalPages > 10 && currentPage > 6\"><a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"Page 2{{checkSelectedPage(page) ? ' selected' : '' }}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-accessibility-click=\"13,32\" ng-click=\"selectPage(2, $event)\">2</a></li>\n" +
    "                    <li class=\"disabled \" ng-if=\"totalPages > 10 && currentPage > 6\">\n" +
    "                        <span class=\"ellipse\">...<span class=\"hidden-spoken\"  tabindex=\"-1\">more pages</span></span>\n" +
    "                    </li>\n" +
    "                    <li ng-repeat=\"page in pages\" ng-class=\"{'active': checkSelectedPage(page)}\">\n" +
    "                        <a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"{{checkSelectedPage(page) ? ' Active' : '' }} Page {{page}}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-accessibility-click=\"13,32\" ng-click=\"!checkSelectedPage(page) && selectPage(page, $event)\">{{page}}</a>\n" +
    "                    </li>\n" +
    "                    <li class=\"disabled \" ng-if=\"totalPages > 10 && currentPage <= totalPages - 5\">\n" +
    "                        <span class=\"ellipse\">...<span class=\"hidden-spoken\"  tabindex=\"-1\">more pages</span></span>\n" +
    "                    </li>\n" +
    "                    <li ng-if=\"totalPages > 10 && currentPage <= totalPages - 5\"><a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"Page {{totalPages-1}}{{checkSelectedPage(page) ? ' selected' : '' }}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-accessibility-click=\"13,32\" ng-click=\"selectPage(totalPages-1, $event)\">{{totalPages-1}}</a></li>\n" +
    "                    <li ng-if=\"totalPages > 10 && currentPage <= totalPages - 5\"><a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"Page {{totalPages}}{{checkSelectedPage(page) ? ' selected' : '' }}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-accessibility-click=\"13,32\" ng-click=\"selectPage(totalPages, $event)\">{{totalPages}}</a></li>\n" +
    "                    <li ng-if=\"totalPages > 10\"><a aria-label=\"{{currentPage >= totalPages? 'Next Page Disabled': 'Next Page'}}\" tabindex=\"{{currentPage >= totalPages? '-1': '0'}}\" aria-hidden=\"false\" role=\"link\" href=\"javascript:void(0)\" class=\"next\" ddh-accessibility-click=\"13,32\" ng-click=\"next($event)\" ng-class=\"currentPage >= totalPages ? 'disabled' :'' \"><i class=\"icon-right\"></i></a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "                <span class=\"input\" ng-show=\"totalPages > 10 && showInput === true\">\n" +
    "			<label for=\"goto\">Go to page:</label>\n" +
    "			<input type=\"number\" role=\"textbox\" style=\"width:40px\" id=\"goto\" ng-change=\"onChange()\" ng-keypress=\"gotoKeyClick($event)\" only-digits=\"\" placeholder=\"\" maxlength=\"2\" ng-model=\"gotoPage\" aria-label=\"enter user input page number then tab to submit\">\n" +
    "			<button disabled=\"\" type=\"button\" class=\"btn-circular\" ng-click=\"gotoBtnClick()\" aria-label=\"Submit\">\n" +
    "				<span class=\"btn btn-small btn-secondary\">\n" +
    "					<i class=\"icon-right\"></i>\n" +
    "					</span>\n" +
    "                </button>\n" +
    "                </span>\n" +
    "                <ul ng-if=\"isMobile && totalPages > 1\" ng-class=\"isMobile ? 'mobile-view': '' \">\n" +
    "                    <li ng-repeat=\"page in pages\" ng-class=\"{'active': checkSelectedPage(page)}\">\n" +
    "                        <a tabindex=\"0\" href=\"javascript:void(0)\" aria-label=\"{{checkSelectedPage(page) ? ' selected' : '' }} Page {{page}}\" aria-selected=\"{{checkSelectedPage(page)}}\" ddh-element-focus=\"isFocused(page)\" ddh-accessibility-click=\"13,32\" ng-click=\"!checkSelectedPage(page) && selectPage(page, $event)\">{{page}}</a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <a href=\"#firstskiphidden{{$id}}\" class=\"btn-skip pagi-hidden-spoken visible-phone\" tabindex=\"{{isMobile && totalPages > 10 ? '0' : '-1'}}\" aria-hidden=\"{{isMobile && totalPages > 10 ? 'false' : 'true'}}\" aria-label=\"Skip paginations links - backward\" ng-click=\"moveFocus(false, $event)\" ng-focus=\"displaySkipLink(false)\" ng-blur=\"hideSkipLink(false)\">Skip additional pages</a>\n" +
    "        <span id=\"secondskiphidden{{$id}}\" class=\"visible-phone empty\" tabindex=\"-1\" aria-hidden=\"false\">&nbsp;</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/productTile/productTileContainer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/productTile/productTileContainer.html",
    "<div class=\"tile-container\">\n" +
    "    <div class=\"product-title-rating\">\n" +
    "        <h2 class=\"product-name\">\n" +
    "            <a href=\"{{item.productDetailUrl}}\" id=\"{{item.productId}}_{{$index}}\" aria-describedby=\"{{item.productId}}\">{{item.productName}}</a>\n" +
    "        </h2>\n" +
    "        <ddh-star-rating  avg=\"item.starRating.avg\" reviews=\"item.starRating.review\" rating-text=\"{{item.starRating.ratingText}}\" rating-url=\"{{item.starRating.starRatingUrl}}\" rating-id=\"{{item.starRating.ratingId}}\"  ng-if=\"item.starRating\">\n" +
    "            <span class=\"anchr final-rating\" aria-hidden=\"true\">{{item.starRating.ratingLabel}}</span>\n" +
    "            <span class=\"anchr rev-divider total-reviews hidden-phone\" aria-hidden=\"true\">{{item.starRating.reviewLabel}}</span>\n" +
    "        </ddh-star-rating>\n" +
    "    </div>\n" +
    "    <a href=\"{{item.productDetailUrl}}\" class=\"product-img\">\n" +
    "        <img ng-src=\"{{item.imgSrc}}\" alt=\"{{item.productName}} Details\" title=\"\" />\n" +
    "        <div class=\"product-badge-secondary\" ng-if=\"!!item.secondaryBadgeText\">{{item.secondaryBadgeText| limitTo:11}}</div>\n" +
    "    </a>\n" +
    "    <!-- color selector directive-->\n" +
    "<!--    commented Out temporarily\n" +
    "    <div ddh-color-and-data-capacity=\"item.colorPallete.activeColorIdSelected\" ddh-key prev=\"37,38\" next=\"39,40\" circular-traversal class=\"color-swatch\" data-select-color=\"orange\" role=\"radiogroup\">\n" +
    "            <button ddh-color-and-data-capacity-item=\"i\" ddh-key-item ng-focus=\"$parent.activeColorIdDefault = i.id\" ng-repeat=\"i in item.colorPallete.colorItems\" type=\"button\" class=\"color-btn\" ng-class=\"{'active': i.id === item.colorPallete.activeColorIdSelected}\" role=\"radio\" aria-label=\"{{i.id}}\" tabindex=\"{{(!item.colorPallete.activeColorIdSelected|| i.id===item.colorPallete.activeColorIdSelected)?0:-1}}\" aria-checked=\"{{i.id === item.colorPallete.activeColorIdSelected}}\">\n" +
    "                <i ng-attr-style=\"background-color:{{i.colorCode}}\"></i>\n" +
    "                <div class=\"colors-off-msg\" aria-hidden=\"true\" style=\"display: none;\">{{i.id}}</div>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "-->\n" +
    "    <div class=\"color-swatch\" role=\"region\" aria-label=\"color available\">\n" +
    "        <i ng-repeat=\"i in item.colorPallete.colorItems\" ng-attr-style=\"background-color:{{i.colorCode}}\" role=\"img\" aria-label=\"{{i.id}}\"></i>\n" +
    "    </div>\n" +
    "    <div ng-transclude></div>        \n" +
    "</div>");
}]);

angular.module("template/productTile/productTiles.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/productTile/productTiles.html",
    "<div class=\"product-tile\">\n" +
    "    <div class=\"product-badge\" id=\"{{item.productId}}\">{{item.primaryBadgeText| limitTo:24}}</div>\n" +
    "    <div ng-transclude class=\"product-container\"></div>\n" +
    "</div>");
}]);

angular.module("template/searchField/searchField.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/searchField/searchField.html",
    "<div class=\"search-bar\">\n" +
    "    <input type=\"search\" class=\"input-searchfield\" id=\"{{configObj.labelId}}\" ddh-search-input ng-model=\"inputModel\" ng-attr-aria-label=\"{{_isIphone() ? 'Enter one or two letters in the search field for a list of suggestions.':'Enter one or two letters in the search field for a list of suggestions. ' + configObj.ghostText}}\" ng-disabled=\"disabled\" ddh-reset ng-keydown=\"selectionIndex($event)\" placeholder=\"{{configObj.ghostText}}\" style=\"width:100%\" maxlength=\"{{configObj.maxLength}}\" ng-class=\"{'suggestion-expanded':showListFlag && ((filterList.length > 0 && !configObj.display) || configObj.display)}\"/>\n" +
    "    <div class=\"search-suggestion-wrapper\" ng-if=\"filterList.length >=0\" ng-show=\"showListFlag && ((filterList.length > 0 && !configObj.display) || configObj.display)\">\n" +
    "        <ul class=\"search-suggestion-list\" role=\"listbox\">      \n" +
    "            <li class=\"no-result\" ng-if=\"filterList.length == 0 && configObj.display\">{{configObj.resultText}}</li>\n" +
    "            <li class=\"search-suggestion-item\" ng-if=\"filterList.length\" ng-repeat=\"item in filterList | limitTo:configObj.noOfItemsDisplay track by $index\" ng-class=\"{active:isActive($index,filterList.length)}\" ng-click=\"selectItem($index,item.title)\" aria-selected=\"{{isActive($index,filterList.length)}}\">\n" +
    "                {{item.title}}\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "    <button class=\"btn-search\" ng-disabled=\"disabled\" ng-click=\"startSearch()\" ddh-accessibility-click=\"13,32\" aria-label=\"Search\" ng-focus=\"showListFlag = false\" type=\"button\"><i class=\"icon-controls-magnifyingglass\"></i></button>\n" +
    "    <div class=\"hidden-spoken\" id=\"msg-reader\" aria-live=\"assertive\" tabindex=\"-1\" role=\"status\" aria-relevant=\"additions\"></div>\n" +
    "</div>");
}]);

angular.module("template/selectQuantity/selectQuantity.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/selectQuantity/selectQuantity.html",
    "<div class=\"btn-group btn-quantity-toggle\" ng-class=\"{'disabled': disabledFlag}\">\n" +
    "    <button type=\"button\" tabindex=\"{{isMobile?'0':'-1'}}\" aria-hidden=\"{{notMobile}}\" class=\"btn btn-secondary btn-prev icon-subtractminimize\" ng-click=\"minus();focusHandler($event)\" aria-label=\"Remove {{step}}\" aria-controls=\"{{selectQuantityId}}\" ng-class=\"{'disabled': isMinusDisabled()}\" ng-disabled=\"isMinusDisabled()\" aria-disabled=\"{{isMinusDisabled()}}\"></button>\n" +
    "    <input class=\"btn pull-left\" id=\"{{selectQuantityId}}\" type=\"tel\" ddh-only-digits maxlength=\"3\" min={{min}} max={{max}} data-max-quantity=\"{{max}}\" ng-model=\"quantity[quantityModelKey]\" value=\"{{quantity[quantityModelKey]}}\" aria-label=\"{{isMobile?quantity[quantityModelKey]:'Select Quantity'}}\" role=\"spinbutton\" aria-live=\"off\" aria-valuetext=\"Quantity {{quantity[quantityModelKey]}}\" aria-valuenow=\"{{quantity[quantityModelKey]}}\" aria-valuemin=\"{{min}}\" aria-valuemax=\"{{max}}\" ng-disabled=\"disabledFlag\">\n" +
    "    <button type=\"button\" tabindex=\"{{isMobile?'0':'-1'}}\" aria-hidden=\"{{notMobile}}\" class=\"btn btn-secondary btn-next icon-add-maximize\" ng-click=\"plus();focusHandler($event)\" aria-label=\"Add {{step}}\" aria-controls=\"{{selectQuantityId}}\" ng-class=\"{'disabled': isPlusDisabled()}\" ng-disabled=\"isPlusDisabled()\" aria-disabled=\"{{isPlusDisabled()}}\"></button>\n" +
    "</div>");
}]);

angular.module("template/socialShareThis/socialShareThis.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/socialShareThis/socialShareThis.html",
    "<div class=\"social-share-this\" ng-class=\"{'pull-left':moveLeft}\">\n" +
    "    <a href=\"javascript:void(0)\" aria-expanded=\"{{showIt}}\" ddh-accessibility-click=\"32\" ng-click=\"toggleSocialShare($event)\" role=\"button\" class=\"share-this standalone-link small\">\n" +
    "        <i class=\"icon-social-share-this\"></i>\n" +
    "        {{ddhSocialShare}}\n" +
    "    </a>\n" +
    "    <div id=\"shareIcons_id_{{$id}}\" role=\"region\" aria-label=\"{{ddhSocialShare}}\" aria-atomic=\"false\" class=\"share-icons\" aria-hidden=\"{{!showIt}}\" ng-class=\"{active: showIt}\">\n" +
    "        <div class=\"social-arrow\"></div>\n" +
    "        <div ng-transclude></div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("template/starRating/starRating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/starRating/starRating.html",
    "<a class=\"starrating-wrap\" aria-labelledby=\"{{ratingId}}\" ng-class=\"{'disabled':disabled === 'true'}\">\n" +
    "    <span class=\"hidden-spoken\" id=\"{{ratingId}}\">{{CATOText}}</span>\n" +
    "    <div class=\"svgwrap\">\n" +
    "        <img class=\"emptystar\" src='data:image/svg+xml,base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii01MCAyNiAxMDAgMjAiPgogICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNFQTc0MDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0tNDEuNiAyNy41bDIuNiA1LjYgNS44LjgtNC4yIDQuMiAxIDYuMS01LjEtMi44LTUuMyAyLjggMS02LjEtNC4yLTQuMiA1LjgtLjggMi42LTUuNnptMjAuOSAwbDIuNiA1LjYgNS44LjgtNC4yIDQuMiAxIDYuMS01LjEtMi44LTUuMyAyLjggMS02LjEtNC4xLTQuMiA1LjgtLjggMi41LTUuNnptMjAuNyAwbDIuNiA1LjYgNS45LjgtNC4yIDQuMiAxIDYuMS01LjEtMi44LTUuMyAyLjggMS02LjEtNC4yLTQuMiA1LjgtLjhMMCAyNy41em0yMC45IDBsMi42IDUuNiA1LjkuOC00LjIgNC4yLjkgNi4xLTUuMS0yLjgtNS4zIDIuOCAxLTYuMS00LjItNC4yIDUuOC0uOCAyLjYtNS42em0yMC44IDBsMi42IDUuNiA1LjguOC00LjIgNC4yIDEgNi4xLTUuMS0yLjgtNS4zIDIuOCAxLTYuMS00LjItNC4yIDUuOC0uOCAyLjYtNS42eiIvPgo8L3N2Zz4='>\n" +
    "        <img class=\"filledstar hidden\" src='data:image/svg+xml,base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii01MCAyNiAxMDAgMjAiPgogICA8cGF0aCBmaWxsPSIjRUE3NDAwIiBzdHJva2U9IiNFQTc0MDAiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTS00MS42IDI3LjVsMi42IDUuNiA1LjguOC00LjIgNC4yIDEgNi4xLTUuMS0yLjgtNS4zIDIuOCAxLTYuMS00LjItNC4yIDUuOC0uOCAyLjYtNS42em0yMC45IDBsMi42IDUuNiA1LjguOC00LjIgNC4yIDEgNi4xLTUuMS0yLjgtNS4zIDIuOCAxLTYuMS00LjEtNC4yIDUuOC0uOCAyLjUtNS42em0yMC43IDBsMi42IDUuNiA1LjkuOC00LjIgNC4yIDEgNi4xLTUuMS0yLjgtNS4zIDIuOCAxLTYuMS00LjItNC4yIDUuOC0uOEwwIDI3LjV6bTIwLjkgMGwyLjYgNS42IDUuOS44LTQuMiA0LjIuOSA2LjEtNS4xLTIuOC01LjMgMi44IDEtNi4xLTQuMi00LjIgNS44LS44IDIuNi01LjZ6bTIwLjggMGwyLjYgNS42IDUuOC44LTQuMiA0LjIgMSA2LjEtNS4xLTIuOC01LjMgMi44IDEtNi4xLTQuMi00LjIgNS44LS44IDIuNi01LjZ6Ii8+Cjwvc3ZnPg=='>\n" +
    "    </div>\n" +
    "    <span ng-transclude aria-hidden=\"{{disabled === 'true' ? 'true':'false'}}\" style=\"display:inherit\"></span>\n" +
    "</a>");
}]);

angular.module("template/stepIndicator/stepIndicator.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/stepIndicator/stepIndicator.html",
    "<div class=\"step-indicator\">\n" +
    "    <h1 class=\"step-heading\" ng-if=\"stepIndicatorHeading\"> \n" +
    "        {{stepIndicatorHeading}}\n" +
    "    </h1>\n" +
    "\n" +
    "    <ul class=\"steps\">\n" +
    "        <li ng-class=\"{'step-done':$index < currentIndex - 1 ,'step-on':$index == currentIndex - 1}\" \n" +
    "            ng-repeat=\"stepsItem in stepsItemsObject\"><div aria-hidden=\"true\" class=\"step-text\" data-sm-text=\"{{stepsItem.dataMobile}}\" \n" +
    "                                                     data-large-text=\"{{stepsItem.dataDesktop}}\">{{stepsItem.text}}</div>\n" +
    "            <span class=\"hidden-spoken\">\n" +
    "                {{(($index < currentIndex - 1) || stepsItemsObject.length == currentIndex)? stepsItem.dataMobile+' '+stepsItem.text+'. '+'Completed.':''}} \n" +
    "                {{(($index == currentIndex - 1) && stepsItemsObject.length != currentIndex)? stepsItem.dataMobile+' '+stepsItem.text+'. '+'Current step.':''}}\n" +
    "                {{($index > currentIndex - 1)? stepsItem.dataMobile+' '+stepsItem.text+'. '+'Remaining step.':''}}\n" +
    "            </span>\n" +
    "        </li>\n" +
    "\n" +
    "    </ul>\n" +
    "</div>\n" +
    "\n" +
    "<ng-transclude></ng-transclude>");
}]);

angular.module("template/strengthMeter/strengthMeter.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/strengthMeter/strengthMeter.html",
    "<div class=\"strength-meter-container\">\n" +
    "    <div class=\"strength-meter-gauge\">\n" +
    "        <span class=\"strength-meter-gauge-fill strength-meter-animate\" ng-style=\"{'width': currentWidth+'%', 'background-color': bgColor, 'transition-duration': timeDelayInMilliSeconds}\"></span>\n" +
    "        <div class=\"strength-meter-divider\">\n" +
    "            <span ng-repeat=\"i in getNumberArray(noOfSegments) track by $index\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"strength-meter-content\" aria-live=\"assertive\">{{legendText}}: <span class=\"strength-meter-content-state\">{{statesObj[currentState].description}}</span></div>\n" +
    "</div>");
}]);

angular.module("template/switches/switches-spanish.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/switches/switches-spanish.html",
    "<div class=\"switch-overlay\" aria-hidden=\"true\">\n" +
    "    <span class=\"btn-slider-on\"><span class=\"hidden-spoken\">seleccione para hacer </span><i class=\"activo\">Activo</i></span>\n" +
    "    <span class=\"switch-handle\"></span>\n" +
    "    <span class=\"btn-slider-off\"><span class=\"hidden-spoken\">seleccione para hacer </span><i class=\"inactivo\">Inactivo</i></span>\n" +
    "</div>");
}]);

angular.module("template/switches/switches.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/switches/switches.html",
    "<div class=\"switch-overlay\" aria-hidden=\"true\">\n" +
    "    <span class=\"btn-slider-on\">On</span>\n" +
    "    <span class=\"switch-handle\"></span>\n" +
    "    <span class=\"btn-slider-off\">Off</span>\n" +
    "</div>");
}]);

angular.module("template/tables/ddhResponsiveRow.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhResponsiveRow.html",
    "<tr class=\"data-row-list\" toggle-flag>\n" +
    "	<td colspan=\"{{headerValues.length}}\" headers=\"{{headerValues[0].headerId}} {{firstTdId}}\">\n" +
    "		<div ddh-collapse=\"!(active && expandFlag)\">\n" +
    "			<ul class=\"bullet\">\n" +
    "				<li ddh-responsive-list=\"{{$index}}\" ng-show=\"isVisible()\" ng-repeat=\"headerValue in headerValues\">\n" +
    "					<div ng-class=\"headerClass[$index]\">{{headerValue.headerName}}</div>\n" +
    "					<div ng-class=\"bodyClass[$index]\" ddh-append-element=\"rowValues[$index]:compile\"></div>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "		</div>\n" +
    "	</td>\n" +
    "</tr>");
}]);

angular.module("template/tables/ddhResponsiveRowSummary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhResponsiveRowSummary.html",
    "<tr class=\"data-row-list accordion-content\">\n" +
    "	<td colspan=\"{{headerValues.length}}\" headers=\"{{headerValues[0].headerId}} {{firstTdId}}\"  toggle-flag>\n" +
    "		<div ddh-collapse=\"!(active && expandFlag)\" ddh-append-element=\"summaryContent\">\n" +
    "		</div>\n" +
    "	</td>\n" +
    "</tr>");
}]);

angular.module("template/tables/ddhTable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhTable.html",
    "<table ng-class=\"{'striped': !responsive && tbodyScope.zebraStripFlag, 'unique-table': responsive && active && !isSummary, 'summary-table': isSummary}\" ng-transclude></table>");
}]);

angular.module("template/tables/ddhTableBody.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhTableBody.html",
    "<td ng-class=\"{'faux-table-cell': isSummary}\" ng-hide=\"isHidden()\" ng-transclude></td>");
}]);

angular.module("template/tables/ddhTableHeaderSortable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhTableHeaderSortable.html",
    "<th scope=\"col\" role=\"columnheader\" aria-sort=\"{{(sortPattern !== null && sortPattern) || 'none'}}\" ddh-accessibility-click=\"13,32\" ng-click=\"(sortable !== false) && sort();\" ng-hide=\"isHidden()\">\n" +
    "    <a href=\"javascript:void(0)\" role=\"button\">\n" +
    "        <span ng-transclude></span>\n" +
    "        <i aria-hidden=\"{{isMobile? 'false': 'true'}}\" role=\"img\" aria-label=\"{{(sortable !== false && ((sortPattern === 'ascending' && 'ascending') || (sortPattern === 'descending' && 'descending'))) || ''}} {{(sortable !== false && ': activate to sort') || ''}} {{(sortable !== false && ((sortPattern === 'ascending' && 'descending') || (sortPattern === 'descending' && 'ascending'))) || ''}}\" ng-class=\"{'icon-arrows-sort-up active': sortPattern === 'ascending', 'icon-arrows-sort-down active': sortPattern === 'descending'}\" aria-live=\"polite\"></i>\n" +
    "    </a>\n" +
    "</th>");
}]);

angular.module("template/tables/ddhTableHeaderUnsortable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tables/ddhTableHeaderUnsortable.html",
    "<th scope=\"col\" role=\"columnheader\" aria-sort=\"none\" ng-hide=\"isHidden()\" ng-transclude></th>");
}]);

angular.module("template/tabs/ddhTab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/ddhTab.html",
    "<li role=\"tab\" aria-selected=\"{{isTabActive()}}\" aria-controls=\"{{tabPanelId}}\" class=\"tab\" \n" +
    "    ng-class=\"{'active': isTabActive()}\" ng-click=\"clickTab()\" ng-hide=\"tabItem.disabled\">\n" +
    "    <a href=\"javascript:void(0)\"  tabindex=\"{{(isTabActive() && tabItem.disabled)?-1:0}}\"\n" +
    "       ng-disabled=\"tabItem.disabled\" aria-expanded=\"{{(isTabActive() && !tabItem.disabled)}}\" \n" +
    "       ddh-accessibility-click=\"13,32\" ng-transclude></a>\n" +
    "    <span class=\"hidden-spoken\" ng-if=\"isTabActive()\">Active tab</span>\n" +
    "</li>");
}]);

angular.module("template/tabs/ddhTabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/ddhTabset.html",
    "<ul class=\"tabs promo-tabs\" role=\"tablist\" ng-transclude></ul>");
}]);

angular.module("template/usageBar/usageBar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/usageBar/usageBar.html",
    "<div class=\"bar {{barTypeClass}}\" ng-style=\"item\" ng-repeat=\"item in barsArray\" ng-if=\"item.showItem\"></div>");
}]);
